export const kaData = {
        "locale": {
        "home_instavc_build": "ಸಂಸ್ಥೆಗಳು ಮತ್ತು ಉದ್ಯೋಗಿಗಳ ನಡುವೆ ಅರ್ಥಪೂರ್ಣ ಸಂಬಂಧಗಳನ್ನು ಬೆಳೆಸಿಕೊಳ್ಳಿ",
        "home_instavc_conference_platform": " ಸರಿಸಾಟಿಯಿಲ್ಲದ ಬಳಕೆದಾರರೊಂದಿಗೆ ಸಮ್ಮೇಳನ ವೇದಿಕೆಗಳ ಅನುಭವ  ",
        "home_instavc_start_conference": "  ಕಾನ್ಫರೆನ್ಸ್ ಪ್ರಾರಂಭಿಸಿ | ಕಾನ್ಫರೆನ್ಸ್ ಸೇರಿ | ಇನ್‌ಸ್ತ ಕಾನ್ಫರೆನ್ಸ್ ",
        "home_instavc_Hippa": "ಹಿಪಾಎ ಅರ್ಹ ಮತ್ತು ಪಿಸಿಐ ಡಿಎಸ್ಎಸ್, ಎಸ್ಒಸಿ, ಐಎಸ್ಒ / ಐಇಸಿ 27001, ಐಎಸ್ಒ / ಇಐಸಿ 27017, ಐಎಸ್ಒ / ಇಐಸಿ 27018, ಮತ್ತು ಐಎಸ್ಒ 9001 ಕಂಪ್ಲೈಂಟ್. ",
        "home_instavc_copyrights": "ಬಿ) 2018 ಬಿ 7 ಇನ್‌ಸ್ಟಾವಿಸಿ ಬಿ 7 ಪೀಪಲ್‌ಲಿಂಕ್ ಯೂನಿಫೈಡ್ ಕಮ್ಯುನಿಕೇಷನ್ಸ್ ಪ್ರೈ. ಲಿಮಿಟೆಡ್",
        "home_instavc_terms_agree": "ನಾನು ಒಪ್ಪುತ್ತೇನೆ",
        "home_instavc_terms": "ನಿಯಮಗಳು ಮತ್ತು ಷರತ್ತುಗಳು",
        "instavc_login": "ಲಾಗ್ ಇನ್",
        "instavc_login_email": "ಇಮೇಲ್",
        "instavc_login_password": "ಪಾಸ್ವರ್ಡ್",
        "instavc_login_button": "ಲಾಗ್ ಇನ್",
        "instavc_login_forgotpassword": "ಪಾಸ್ವರ್ಡ್ ಮರೆತಿರುವಿರಾ?",
        "instavc_login_have_account": "ಖಾತೆ ಇಲ್ಲವೇ?",
        "instavc_login_signup": "ಸೈನ್ ಅಪ್",
        "instavc_signup": "ಸೈನ್ ಅಪ್",
        "instavc_signup_firstname": "ಮೊದಲ ಹೆಸರು",
        "instavc_signup_lastname": "ಕೊನೆಯ ಹೆಸರು",
        "instavc_signup_email": "ಇಮೇಲ್",
        "instavc_signup_password": "ಪಾಸ್ವರ್ಡ್",
        "instavc_signup_cpassword": "ಪಾಸ್ವರ್ಡ್ ದೃಢೀಕರಿಸಿ",
        "instavc_signup_button": "ಸೈನ್ ಅಪ್",
        "instavc_signup_already_have_account": "ಈಗಾಗಲೇ ಖಾತೆ ಇದೆಯೇ?",
        "instavc_signup_login": "ಲಾಗ್ ಇನ್",
        "instavc_signup_fname_error": "ಮೊದಲ ಹೆಸರು ವರ್ಣಮಾಲೆಗಳಾಗಿರಬೇಕು",
        "instavc_signup_lname_error": "ಕೊನೆಯ ಹೆಸರು ವರ್ಣಮಾಲೆಗಳಾಗಿರಬೇಕು",
        "instavc_signup_email_error": "ಇಮೇಲ್ ಸರಿಯಾದ ಸ್ವರೂಪದಲ್ಲಿರಬೇಕು",
        "instavc_signup_password_error": "ಪಾಸ್ವರ್ಡ್ ಆರು ಅಕ್ಷರಗಳಷ್ಟು ಉದ್ದವಾಗಿರಬೇಕು ಮತ್ತು ಸಂಯೋಜನೆಯಾಗಿರಬೇಕು ದೊಡ್ಡಕ್ಷರ, ಒಂದು ಸಣ್ಣಕ್ಷರ, ಒಂದು ಅಂಕೆ ಮತ್ತು ಒಂದು ವಿಶೇಷ ಅಕ್ಷರ ",
        "instavc_signup_cpassword_error": "ಪಾಸ್ವರ್ಡ್ ಮೇಲಿನ ಪಾಸ್ವರ್ಡ್ಗೆ ಹೊಂದಿಕೆಯಾಗಬೇಕು ಎಂದು ಖಚಿತಪಡಿಸಿ",
        "instavc_forgotpassword_link": "ನಿಮ್ಮ ನೋಂದಾಯಿತ ಇಮೇಲ್‌ಗೆ ನಾವು ನಿಮಗೆ ಲಿಂಕ್ ಕಳುಹಿಸುತ್ತೇವೆ. ಲಿಂಕ್ ಅನ್ನು ಕ್ಲಿಕ್ ಮಾಡಿ ಮತ್ತು ನಿಮ್ಮ ಹೊಸ ಪಾಸ್ವರ್ಡ್ ಅನ್ನು ಹೊಂದಿಸಿ",
        "instavc_forgotpassword_email": "ನಿಮ್ಮ ನೋಂದಾಯಿತ ಇಮೇಲ್ ವಿಳಾಸವನ್ನು ನಮೂದಿಸಿ",
        "instavc_forgotpassword": "ಪಾಸ್ವರ್ಡ್ ಮರೆತಿರುವಿರಾ",
        "instavc_forgotpassword_button": "ಪಾಸ್ವರ್ಡ್ ಮರೆತುಹೋಗಿದೆ",
        "instavc_confirmpass_heading": "ಫಾರ್ಮ್ ಅನ್ನು ಭರ್ತಿ ಮಾಡುವ ಹೊಸ ಪಾಸ್‌ವರ್ಡ್ ರಚಿಸಿ.",
        "instavc_confirmpass_verificationcode": "ಪರಿಶೀಲನಾ ಕೋಡ್ ನಮೂದಿಸಿ",
        "instavc_confirmpass_newpassword": "ಹೊಸ ಪಾಸ್‌ವರ್ಡ್ ನಮೂದಿಸಿ",
        "instavc_confirmpass_retypepassword": "ಹೊಸ ಪಾಸ್‌ವರ್ಡ್ ಅನ್ನು ಮತ್ತೆ ಟೈಪ್ ಮಾಡಿ",
        "instavc_confirmpass_button": "ಹೊಸ ಪಾಸ್‌ವರ್ಡ್ ರಚಿಸಿ",
        "instavc_forgotpassword_signin": "ಸೈನ್ ಇನ್",
        "instavc_forgotpassword_passwordcreated": "ಅಭಿನಂದನೆಗಳು! ನಿಮ್ಮ ಹೊಸ ಪಾಸ್‌ವರ್ಡ್ ಅನ್ನು ರಚಿಸಲಾಗಿದೆ, ನೀವು ಈಗ ಇನ್ಸ್ತಾವಿಸಿ ಗೆ ಸೈನ್ ಇನ್ ಮಾಡಬಹುದು. ",
        "instavc_dashboard": "ಡ್ಯಾಶ್‌ಬೋರ್ಡ್",
        "instavc_dashboard_schedule": "ಸಭೆಗಳನ್ನು ನಿಗದಿಪಡಿಸಿ",
        "instavc_dashboard_meetinglist": "ಹಿಂದಿನ ಸಭೆಗಳು",
        "instavc_dashboard_conferenceplatform": "ಸಾಟಿಯಿಲ್ಲದ ಬಳಕೆದಾರರೊಂದಿಗೆ ಸಮ್ಮೇಳನ ವೇದಿಕೆಗಳು ಅನುಭವ ",
        "instavc_dashboard_SC_room": "ಸಮ್ಮೇಳನವನ್ನು ಪ್ರಾರಂಭಿಸಿ",
        "instavc_dashboard_SC_roomlist": "ನಿಮ್ಮ ನಿಗದಿತ ಸಭೆಯನ್ನು ಆಯ್ಕೆ ಮಾಡುವ ಮೂಲಕ",
        "instavc_dashboard_startconference": "ಕಾನ್ಫರೆನ್ಸ್ ಪ್ರಾರಂಭಿಸಿ",
        "instavc_dashboard_JC": "ಸಮ್ಮೇಳನಕ್ಕೆ ಸೇರಿ",
        "instavc_dashboard_JC_ID": "ಕಾನ್ಫರೆನ್ಸ್ ಐಡಿ ಅಥವಾ ಪರಿಶಿಷ್ಟ ಮೂಲಕ",
        "instavc_dashboard_JC_button": "ಕಾನ್ಫರೆನ್ಸ್ ಸೇರಿ",
        "instavc_dashboard_SC": "ಸಮ್ಮೇಳನವನ್ನು ಪ್ರಾರಂಭಿಸಿ",
        "instavc_dashboard_SC_p2p": "ನಿಮ್ಮ ಪಟ್ಟಿಯಿಂದ ಕೊಠಡಿಯನ್ನು ಆರಿಸುವ ಮೂಲಕ",
        "instavc_dashboard_instaconference": " ಇನ್‌ಸ್ತ ಕಾನ್ಫರೆನ್ಸ್",
        "instavc_dashboard_buynow": "ಈಗ ಖರೀದಿಸಿ",
        "instavc_dashboard_myprofile": "ನನ್ನ ಪ್ರೊಫೈಲ್",
        "instavc_dashboard_settings": "ಸೆಟ್ಟಿಂಗ್‌ಗಳು", 
        "instavc_dashboard_myadmin": "ನನ್ನ ನಿರ್ವಹಣೆ",
        "instavc_dashboard_affiliate": "ನನ್ನ ಅಂಗಸಂಸ್ಥೆ",
        "instavc_dashboard_logout": "ಲಾಗ್ ಔಟ್",
        "conference_myrooms": "ನನ್ನ ಕೊಠಡಿಗಳು",
        "conference_myrooms_host": "ಹೋಸ್ಟ್",
        "conference_myrooms_roomhost": "ನೀವು ಈ ಕೋಣೆಗೆ ಹೋಸ್ಟ್.",
        "conference_myrooms_search": "ಹುಡುಕಿ ...",
        "conference_myrooms_hostuser": "ಹೋಸ್ಟ್ ಬಳಕೆದಾರ",
        "conference_myrooms_gotopremium": "ಪ್ರೀಮಿಯಂಗೆ ಹೋಗಿ",
        "conference_myrooms_buynow": "ಈಗ ಖರೀದಿಸಿ",
        "conference_myrooms_renewal": "ನವೀಕರಣ",
        "conference_setup":"ಸೆಟಪ್",
        "conference_myrooms_renewnow": "ಈಗ ನವೀಕರಿಸಿ",
        //"conference_myrooms_hosts": "ಹೋಸ್ಟ್",
        "conference_myrooms_join": "ಸೇರಿ",
        "conference_myrooms_setup":  "ರೂಮ್ ಸೆಟಪ್",
        "conference_myrooms_sethost_email": "ನಿಮ್ಮನ್ನು ಹೋಸ್ಟ್ ಆಗಿ ಹೊಂದಿಸಿ, ಅಥವಾ ಬಳಕೆದಾರರ ಇಮೇಲ್ ವಿಳಾಸವನ್ನು ನಮೂದಿಸ ಅವನನ್ನು / ಅವಳನ್ನು ಆತಿಥೇಯರನ್ನಾಗಿ ಮಾಡಲು. ",
        "conference_myrooms_selfhost": "ನಿಮ್ಮನ್ನು ಹೋಸ್ಟ್ ಆಗಿ ಹೊಂದಿಸಿ",
        "conference_myrooms_otherhost":"ಅಥವಾ - ನೀವು ಯಾವುದೇ ಬಳಕೆದಾರರನ್ನು ಹೋಸ್ಟ್ ಆಗಿ ಮಾಡಲು ಬಯಸಿದರೆ, ಅವನ / ಅವಳನ್ನು ನಮೂದಿಸಿ ಇಮೇಲ್ ವಿಳಾಸ.",
        "conference_myrooms_email":"ಇಮೇಲ್ ವಿಳಾಸ",
        "Cancel": "ರದ್ದುಮಾಡು",
        "conference_myrooms_apply":"ಅನ್ವಯಿಸು",
        "view_schedule_myrooms": "ನನ್ನ ಕೊಠಡಿಗಳು",
        "view_schedule_search": "ಹುಡುಕಿ ...",
        "view_schedule_schedule": "ವೇಳಾಪಟ್ಟಿ",
        "view_schedule_calender": "ಈ ಕೋಣೆಯ ವೇಳಾಪಟ್ಟಿಗಳನ್ನು ಪರಿಶೀಲಿಸುವ ಕ್ಯಾಲೆಂಡರ್ ಕೆಳಗೆ ಇದೆ",
        "video_recordings": "ವೀಡಿಯೊ ರೆಕಾರ್ಡಿಂಗ್",
        "view_recordings_search": "ಹುಡುಕಿ ",
        "view_recordings_month": "ಈ ತಿಂಗಳು",
        "view_recordings_week": "ಕೊನೆಯ 7 ದಿನಗಳು",
        "view_recordings_today": "ಇಂದು",
        "no_recordings": "ಇನ್ನೂ ರೆಕಾರ್ಡಿಂಗ್ ಇಲ್ಲ!",
        "no_recordings_message": "ಇಲ್ಲಿ ಯಾವುದೇ ವೀಡಿಯೊಗಳಿಲ್ಲ, ಇದೀಗ.",
        "no_recordings_startmessage": "ನೀವು ರೆಕಾರ್ಡಿಂಗ್ ಪ್ರಾರಂಭಿಸಿದ ನಂತರ ನಿಮ್ಮ ಎಲ್ಲಾ ವೀಡಿಯೊಗಳನ್ನು ಇಲ್ಲಿ ವೀಕ್ಷಿಸಬಹುದು.",
        "stop_recording": "ನೀವು ಈ ರೆಕಾರ್ಡಿಂಗ್ ಅನ್ನು ನಿಲ್ಲಿಸಲು ಬಯಸುವಿರಾ?",
        "stop_recording_agree": "ಒಪ್ಪುತ್ತೇನೆ",
        "stop_recording_disagree": "ಒಪ್ಪುವುದಿಲ್ಲ",
        "conference_in_use": "ಕಾನ್ಫರೆನ್ಸ್ ಬಳಕೆಯಲ್ಲಿದೆ",
        "conference_mode" : "ಕಾನ್ಫರೆನ್ಸ್ ಮೋಡ್",
        "large_conference_mode": "ದೊಡ್ಡ ಕಾನ್ಫರೆನ್ಸ್ ಮೋಡ್",
        "conference_setup_configuration": "ಸಂರಚನೆ",
        "conference_setup_generateid": "ಮೀಟಿಂಗ್ ಐಡಿ ಕಂಡುಬಂದಿಲ್ಲ, ಒಂದನ್ನು ರಚಿಸಿ!",
        "conference_setup_regenerate": "ಪುನರುತ್ಪಾದನೆ",
        "conference_setup_meetingid": "ಮೀಟಿಂಗ್ ಐಡಿ",
        "conference_setup_camera": "ಫೇಸ್‌ಟೈಮ್ ಎಚ್‌ಡಿ ಕ್ಯಾಮೆರಾ",
        "conference_setup_defaultmicrophone": "ಡೀಫಾಲ್ಟ್ - ಆಂತರಿಕ ಮೈಕ್ರೊಫೋನ್ (ಅಂತರ್ನಿರ್ಮಿತ)",
        "conference_setup_microphone": "ಆಂತರಿಕ ಮೈಕ್ರೊಫೋನ್ (ಅಂತರ್ನಿರ್ಮಿತ)",
        "conference_setup_volume":"ಸಂಪುಟ",
        "conference_setup_videomode": "ವೀಡಿಯೊ ಮೋಡ್",
        "conference_setup_forward": "ಫಾರ್ವರ್ಡ್",
        "conference_setup_mix": "ಮಿಕ್ಸ್",
        "conference_setup_invite":"ಆಹ್ವಾನಿಸು",
        "conference_setup_invitepeople": "ಜನರನ್ನು ಆಹ್ವಾನಿಸಿ",
        "conference_setup_invitefriends": "ಸಹಯೋಗಿಸಲು ನಿಮ್ಮ ಸ್ನೇಹಿತರು ಮತ್ತು ಸಹೋದ್ಯೋಗಿಗಳನ್ನು ಆಹ್ವಾನಿಸಿ..",
        "conference_setup_invite_directlink": "ನಿಮ್ಮ ಕೋಣೆಗೆ ನೇರ ಲಿಂಕ್",
        "conference_setup_invite_sharelink": "ನಿಮ್ಮ ಪಾಲ್ಗೊಳ್ಳುವವರು ಸೇರಲು ಈ ಲಿಂಕ್ ಅನ್ನು ಹಂಚಿಕೊಳ್ಳಿ ನಿಮ್ಮ ಅಧಿವೇಶನ ",
        "conference_setup_invite_link": "https://connect.instavc.com/conference-ಅತಿಥಿ / eddca0fc7adcdc61a24dabe02597412a36bb96dac7302f3cedb6aac50169d58614eb46b940b556a9 / f ",
        "conference_setup_invitebyemail":"ಮೇಲ್ ಮೂಲಕ ಆಹ್ವಾನಿಸಿ",
        "conference_setup_invite_enteremail": "ನಿಮ್ಮ ಭಾಗವಹಿಸುವವರನ್ನು ಆಹ್ವಾನಿಸಲು ಆದ್ಯತೆಯ ಇಮೇಲ್ ವಿಳಾಸವನ್ನು ನಮೂದಿಸಿ ",
        "conference_setup_invite_emailid": "ಇಮೇಲ್ ವಿಳಾಸ", 
        "conference_setup_invite_close": "ಮುಚ್ಚಿ",
        "conference_setup_invite_button": "ಆಹ್ವಾನಿಸು",
        "conference_setup_advancesettings": "ಅಡ್ವಾನ್ಸ್ ಸೆಟ್ಟಿಂಗ್ಸ್",
        "conference_setup_changeresolution": "ರೆಸಲ್ಯೂಶನ್ ಆಯ್ಕೆಮಾಡಿ",
        "conference_setup_lowbandwidth": "ಕಡಿಮೆ ಬ್ಯಾಂಡ್‌ವಿಡ್ತ್",
        "conference_setup_poornetwork":"ಕಳಪೆ ನೆಟ್ವರ್ಕ್",
        "conference_setup_vga": "ವಿಜಿಎ - (640x480)",
        "conference_setup_vga_graphics": "ವಿಡಿಯೋ ಗ್ರಾಫಿಕ್ಸ್ ಅರೇ (ವಿಜಿಎ) ವಿಡಿಯೋ ರೆಸಲ್ಯೂಶನ್",
        "conference_setup_hd1080": "ಎಚ್ ಡಿ 1080ಪೀ-(1920x1080)",
        "conference_setup_fhd": "ಪೂರ್ಣ ಹೈ ಡೆಫಿನಿಷನ್ (ಎಫ್ಹೆಚ್ಡಿ) ವಿಡಿಯೋ ರೆಸಲ್ಯೂಶನ್",
        "conference_setup_4k": "4 ಕೆ - (3840x2160)",
        "conference_setup_4k_fhd": "ಪೂರ್ಣ ಹೈ ಡೆಫಿನಿಷನ್ (ಎಫ್ಹೆಚ್ಡಿ) ವಿಡಿಯೋ ರೆಸಲ್ಯೂಶನ್",
        "conference_setup_sif": "ಎಸ್ಐಎಫ್ - (320x240)",
        "conference_setup_sif_vr": "ಎಸ್ಐಎಫ್ ವಿಡಿಯೋ ರೆಸಲ್ಯೂಶನ್",
        "conference_setup_hd720": "ಎಚ್ ಡಿ  720ಪಿ-(1280 x 720)",
        "conference_setup_hd720_vr": "ಹೈ ಡೆಫಿನಿಷನ್ (ಎಚ್ಡಿ) ವಿಡಿಯೋ ರೆಸಲ್ಯೂಶನ್",
        "conference_setup_2k": "2 ಕೆ - (2048x1080)",
        "conference_setup_2k_fhd": "ಪೂರ್ಣ ಹೈ ಡೆಫಿನಿಷನ್ (ಎಫ್ಹೆಚ್ಡಿ) ವಿಡಿಯೋ ರೆಸಲ್ಯೂಶನ್",
        "conference_setup_broadcastoptions": "ಪ್ರಸಾರ ಆಯ್ಕೆಗಳು",
        "conference_setup_enable": "ಸಕ್ರಿಯಗೊಳಿಸಿ",
        "conference_setup_disable": "ನಿಷ್ಕ್ರಿಯಗೊಳಿಸಿ",
        "conference_setup_reportquality":"ಧ್ವನಿ ಮತ್ತು ವೀಡಿಯೊ ಕರೆಗಳನ್ನು ಸುಧಾರಿಸಲು ಸಹಾಯ ಮಾಡಲು ಗುಣಮಟ್ಟದ ಅಂಕಿಅಂಶಗಳನ್ನು ವರದಿ ಮಾಡಿ ",
        "conference_setup_havetroubleshoot": "ನೀವು ಕಾನ್ಫರೆನ್ಸ್ ನಿವಾರಣೆಯನ್ನು ಹೊಂದಲು ಬಯಸುವಿರಾ, ನಂತರ ಇಲ್ಲಿ ಲಿಂಕ್ ಅನ್ನು ಕ್ಲಿಕ್ ಮಾಡಿ ",
        "conference_setup_conferencetroubleshoot": "ಕಾನ್ಫರೆನ್ಸ್ ಟ್ರೋಬಲ್ಶೂಟರ್",
        "conference_troubleshoot": "ನಿವಾರಣೆ",
        "conference_troubleshoot_faq":"ಎಫ್ಏಕ್ಯೂ",
        "conference_troubleshoot_emailreport": "ಇಮೇಲ್ ವರದಿ",
        "conference_troubleshoot_gotoconference": "ಕಾನ್ಫರೆನ್ಸ್ಗೆ ಹೋಗಿ",
        "conference_troubleshoot_os": "ಆಪರೇಟಿಂಗ್ ಸಿಸ್ಟಮ್",
        "conference_troubleshoot_version": "ಆವೃತ್ತಿ",
        "conference_troubleshoot_browser": "ಬ್ರೌಸರ್",
        "conference_troubleshoot_chromeversion": "ಕ್ರೋಮ್ ಆವೃತ್ತಿ",
        "conference_troubleshoot_privatebrowsing": "ಖಾಸಗಿ ಬ್ರೌಸಿಂಗ್",
        "conference_troubleshoot_displayresolution": "ನಿರ್ಣಯಗಳನ್ನು ಪ್ರದರ್ಶಿಸಿ",
        "conference_troubleshoot_aspectratio":"ಆಕಾರ ಅನುಪಾತವನ್ನು ಪ್ರದರ್ಶಿಸಿ",
        "conference_troubleshoot_hasspeakers": "ಸಿಸ್ಟಮ್ ಸ್ಪೀಕರ್‌ಗಳನ್ನು ಹೊಂದಿದೆಯೇ?",
        "conference_troubleshoot_foundspeaker": "ಸ್ಪೀಕರ್ ಸಾಧನಗಳು ಕಂಡುಬಂದಿವೆ",
        "conference_troubleshoot_hasmicrophone": "ಸಿಸ್ಟಮ್ ಮೈಕ್ರೊಫೋನ್ ಹೊಂದಿದೆಯೇ?",
        "conference_troubleshoot_foundmicrophone": "ಮೈಕ್ರೊಫೋನ್ ಸಾಧನಗಳು ಕಂಡುಬಂದಿವೆ",
        "conference_troubleshoot_haswebcam": "ಸಿಸ್ಟಮ್ ವೆಬ್ಕ್ಯಾಮ್ ಹೊಂದಿದೆ?",
        "conference_troubleshoot_foundcameras": "ಕ್ಯಾಮೆರಾ ಸಾಧನಗಳು ಕಂಡುಬಂದಿವೆ",
        "conference_troubleshoot_webcampermission": "ವೆಬ್‌ಸೈಟ್ ವೆಬ್‌ಕ್ಯಾಮ್ ಅನುಮತಿಗಳನ್ನು ಹೊಂದಿದೆ?",
        "conference_troubleshoot_microphonepermission": "ವೆಬ್‌ಸೈಟ್ ಮೈಕ್ರೊಫೋನ್ ಅನುಮತಿಗಳನ್ನು ಹೊಂದಿದೆ?",
        "conference_troubleshoot_getUsermedia":"ಈ ಪುಟದಲ್ಲಿ ಬಳಕೆದಾರ ಮಾಧ್ಯಮವನ್ನು ಪಡೆಯಲು ಬ್ರೌಸರ್ ಅನುಮತಿಸುತ್ತದೆಯೇ?",
        "conference_troubleshoot_changeoutput_audiodevice": "ನೀವು ಔಟ್‌ಪುಟ್ ಆಡಿಯೊ ಸಾಧನಗಳನ್ನು ಬದಲಾಯಿಸಬಹುದೇ?",
        "conference_troubleshoot_changecamera_resolution": "ಹೊಸ ಕಾನ್ಫರೆನ್ಸ್ ವಿನಂತಿಯನ್ನು ಮಾಡದೆಯೇ ನೀವು ಕ್ಯಾಮೆರಾ ರೆಸಲ್ಯೂಶನ್ ಅನ್ನು ಬದಲಾಯಿಸಬಹುದೇ? ",
        "conference_troubleshoot_supportwebrtc": "ಬ್ರೌಸರ್ ವೆಬ್‌ಆರ್‌ಟಿಸಿಯನ್ನು ಬೆಂಬಲಿಸುತ್ತದೆ (1.0 ಅಥವಾ 1.1)?",
        "conference_troubleshoot_supportortc": "ಬ್ರೌಸರ್ ಓರ್ಟೀಸೀ (ವೆಬ್‌ಆರ್‌ಟಿಸಿ 1.1) ಅನ್ನು ಬೆಂಬಲಿಸುತ್ತದೆ?",
        "conference_troubleshoot_turnserver": "ಟರ್ನ್ ಸರ್ವರ್ ತಲುಪಬಹುದೇ?",
        "conference_troubleshoot_turn":"ಟರ್ನ್: 139.59.64.172: 443",
        "conference_troubleshoo_coturn" :"ಟರ್ನ್: ಕೋಟೂರ್ಞ್.ಇನ್‌ಸ್ಟ್ವವೀಸೀ.ಕಾಮ್: 443",
        "conference_troubleshoot_replacetracks": "ಗೆಳೆಯರೊಂದಿಗೆ ಮರು ಮಾತುಕತೆ ನಡೆಸದೆ ನೀವು ಟ್ರ್ಯಾಕ್‌ಗಳನ್ನು ಬದಲಾಯಿಸಬಹುದೇ?",
        "conference_troubleshoot_record_remoteaudio": "ನಿಮ್ಮ ಬ್ರೌಸರ್ ರಿಮೋಟ್ ಆಡಿಯೊವನ್ನು ರೆಕಾರ್ಡ್ ಮಾಡಬಹುದೇ ಅಥವಾ ವೆಬ್ ಆಡಿಯೊ ಏಪೀಐ ನಲ್ಲಿ ರಿಮೋಟ್ ಆಡಿಯೊ ಸ್ಟ್ರೀಮ್ ಅನ್ನು ಪ್ರಕ್ರಿಯೆಗೊಳಿಸಬಹುದೇ? ",
        "conference_troubleshoot_browsersupports_websocketapi":"ಬ್ರೌಸರ್‌ಗಳು ವೆಬ್‌ಸಾಕೆಟ್ಸ್ ಏಪೀಐ ಅನ್ನು ಬೆಂಬಲಿಸುತ್ತವೆ",
        "conference_troubleshoot_blockwebsocket": "ವೆಬ್‌ಸಾಕೆಟ್ ಸರ್ವರ್ ಪ್ರವೇಶಿಸಲಾಗದ ಕಾರಣ ನಿಮ್ಮ ಸಿಸ್ಟಮ್ ವೆಬ್‌ಸಾಕೆಟ್ ಪ್ರೋಟೋಕಾಲ್ ಅನ್ನು ನಿರ್ಬಂಧಿಸಿದೆ? ಇಲ್ಲ",
        "conference_troubleshoot_supportwebaudioapi": "ಬ್ರೌಸರ್ ವೆಬ್ ಆಡಿಯೊ ಏಪೀಐ ಅನ್ನು ಬೆಂಬಲಿಸುತ್ತದೆ?",
        "conference_troubleshoot_supportsctp": "ಬ್ರೌಸರ್ ಎಸ್ಸಿಟಿಪಿ ಡೇಟಾ ಚಾನೆಲ್ಗಳನ್ನು ಬೆಂಬಲಿಸುತ್ತದೆ?",
        "conference_troubleshoot_supportsrtp": "ಬ್ರೌಸರ್ ಆರ್ಟಿಪಿ ಡೇಟಾ ಚಾನೆಲ್ಗಳನ್ನು ಬೆಂಬಲಿಸುತ್ತದೆ?",
        "conference_troubleshoot_support_screencapturing":  "ಈ ಪುಟವು ಸ್ಕ್ರೀನ್ ಕ್ಯಾಪ್ಚರಿಂಗ್ ಏಪೀಐ ಅನ್ನು ಬೆಂಬಲಿಸುತ್ತದೆ?",
        "conference_troubleshoot_support_multimonitor": "ಯಾವುದೇ ಮಾನಿಟರ್‌ನ ಬಹು-ಮಾನಿಟರ್ ಆಯ್ಕೆ ಮತ್ತು ಸೆರೆಹಿಡಿಯುವ ಪರದೆಯನ್ನು ಬ್ರೌಸರ್ ಬೆಂಬಲಿಸುತ್ತದೆಯೇ?",
        "conference_troubleshoot_mobiledevice":"ಇದು ಮೊಬೈಲ್ ಸಾಧನವೇ?",
        "conference_troubleshoot_supportscreencap_canvas": "ಕ್ಯಾನ್ವಾಸ್‌ನಿಂದ ಸ್ಕ್ರೀನ್ ಸೆರೆಹಿಡಿಯುವಿಕೆಯನ್ನು ಬ್ರೌಸರ್ ಬೆಂಬಲಿಸುತ್ತದೆಯೇ?",
        "conference_troubleshoot_supportscreencap_video":"ವೀಡಿಯೊದಿಂದ ಸ್ಕ್ರೀನ್ ಸೆರೆಹಿಡಿಯುವಿಕೆಯನ್ನು ಬ್ರೌಸರ್ ಬೆಂಬಲಿಸುತ್ತದೆಯೇ?",
        "conference_troubleshoot_supportpromisses": "ಬ್ರೌಸರ್ ಭರವಸೆಗಳನ್ನು ಬೆಂಬಲಿಸುತ್ತದೆಯೇ?",
        "conference_troubleshoot_ipaddress": "ಐಪಿ ವಿಳಾಸಗಳನ್ನು ತೋರಿಸಲು ಕ್ಲಿಕ್ ಮಾಡಿ",
        "conference_troubleshoot_stunserver":  "ಸ್ಟನ್ ಸರ್ವರ್ ತಲುಪಬಹುದೇ?",
        "cancel": "ರದ್ದುಮಾಡು",
        "instavc_conference_revoke_fromhost": "ಹೋಸ್ಟ್ನಿಂದ ಹಿಂತೆಗೆದುಕೊಳ್ಳಿ",
        "instavc_conference_startvideoconf_button": "ವೀಡಿಯೊ ಕಾನ್ಫರೆನ್ಸ್ ಪ್ರಾರಂಭಿಸಿ",
        "instavc_conference_loading": "ನಿಮ್ಮ ಪರದೆಯನ್ನು ಲೋಡ್ ಮಾಡಲಾಗುತ್ತಿದೆ ದಯವಿಟ್ಟು ಕಾಯಿರಿ",
        "instavc_conference_authenticating": "ಆತೆಂಟಿಕೇಟಿಂಗ್ ಇಂಟೂ ಇನ್ಸ್ತಾವ್ಕ್ ಸರ್ವರ್ ....",
        "instavc_conference_joinconference": "ಸಮ್ಮೇಳನಕ್ಕೆ ಸೇರುವುದು",
        "instavc_conference_publishyourvideo": "ನಿಮ್ಮ ವೀಡಿಯೊವನ್ನು ಪ್ರಕಟಿಸಲಾಗುತ್ತಿದೆ",
        "instavc_conference_publishyouraudio": "ನಿಮ್ಮ ಆಡಿಯೊವನ್ನು ಪ್ರಕಟಿಸಲಾಗುತ್ತಿದೆ",
        "instavc_conference_settings": "ಸೆಟ್ಟಿಂಗ್ಗಳು",
        "instavc_conference_setting": "ಕಾನ್ಫರೆನ್ಸ್ ಸೆಟ್ಟಿಂಗ್ಗಳು",
        "instavc_conference_setting_source": "ಮೂಲ",
        "instavc_conference_setting_camera": "ಕ್ಯಾಮೆರಾ",
        "instavc_conference_audioinputs": "ಆಡಿಯೊ ಇನ್ಪುಟ್ಗಳು",
        "instavc_conference_setting_apply": "ಅನ್ವಯಿಸು",
        "instavc_conference_setting_resolution": "ರೆಸಲ್ಯೂಶನ್",
        "instavc_conference_setting_qr": " ಕ್ಯೂಆರ್ (ಬೇಟ)",
        "instavc_conference_whiteboard": "ವೈಟ್ಬೋರ್ಡ್",
        "instavc_conference_screenshare": "ಪರದೆ ಹಂಚಿಕೆ",
        "instavc_conference_presenter": "ಪ್ರೆಸೆಂಟರ್",
        "instavc_conference_stopshare": "ಹಂಚಿಕೆಯನ್ನು ನಿಲ್ಲಿಸಿ",
        "instavc_conf_install_Screenshare": "ಸ್ಕ್ರೀನ್ಶೇರ್ ಸ್ಥಾಪಿಸಿ",
        "instavc_conference_videosync": "ಒಟ್ಟಿಗೆ ವೀಕ್ಷಿಸಿ",
        "instavc_conference_videourl": "ವೀಡಿಯೊ ಯೂಆರ್ಲ್",
        "instavc_conference_enter_videourl": "ವೀಡಿಯೊ ಯೂಆರ್ಲ್ ಅನ್ನು ನಮೂದಿಸಿ",
        "instavc_conference_videourl_note": "ಗಮನಿಸಿ: ಸಕ್ರಿಯ ಭಾಗವಹಿಸುವವರು ಮಾತ್ರ ಈ ವೀಡಿಯೊವನ್ನು ವೀಕ್ಷಿಸಬಹುದು, ತಡವಾಗಿ ಸೇರುವವರು ವೀಡಿಯೊವನ್ನು ನೋಡಲಾಗುವುದಿಲ್ಲ",
        "instavc_conf_recordings": "ರೆಕಾರ್ಡಿಂಗ್",
        "instavc_conference_sharecontent": "ನಿಮ್ಮ ಪರದೆಯನ್ನು ಹಂಚಿಕೊಳ್ಳಿ",
        "instavc_conference_sharecontent_screen": "ಕನೆಕ್ಟ್.ಇನ್‌ಸ್ಟ್ ವೀಸೀ.ಕಾಮ್ ನಿಮ್ಮ ಪರದೆಯ ವಿಷಯಗಳನ್ನು ಹಂಚಿಕೊಳ್ಳಲು ಬಯಸಿದೆ. ನೀವು ಹಂಚಿಕೊಳ್ಳಲು ಬಯಸುವದನ್ನು ಆರಿಸಿ",
        "instavc_conference_shareentire_screen": "ನಿಮ್ಮ ಸಂಪೂರ್ಣ ಪರದೆ",
        "instavc_conference_sharescreen_applicationwindow": "ಅಪ್ಲಿಕೇಶನ್ ವಿಂಡೋ",
        "instavc_conference_sharescreen_chrometab": "ಕ್ರೋಮ್ ಟ್ಯಾಬ್",
        "instavc_conference_sharescreen_share": "ಹಂಚಿಕೊಳ್ಳಿ",
        "instavc_conf_sharescreen": "ನೀವು ನಿಮ್ಮ ಪರದೆಯನ್ನು ಹಂಚಿಕೊಳ್ಳುತ್ತಿದ್ದೀರಿ!",
        "instavc_conf_share_otherparticipants": "ಇತರ ಭಾಗವಹಿಸುವವರು ನಿಮ್ಮ ಪರದೆಯಲ್ಲಿ ಅಪ್ಲಿಕೇಶನ್ಗಳು ಮತ್ತು ದಾಖಲಾತಿಗಳನ್ನು ನೋಡಬಹುದು",
        "instavc_stopsharing": "ಹಂಚಿಕೆಯನ್ನು ನಿಲ್ಲಿಸಿ",
        "instavc_conference_chat": "ಚಾಟ್",
        "instavc_conference_additional_camera": "ಹೆಚ್ಚುವರಿ ಕ್ಯಾಮೆರಾ",
        "instavc_conference_sharescreen_groupchat": "ಗುಂಪು ಚಾಟ್",
        "instavc_conference_sharescreen_GC": "ಜೀಸೀ",
        "instavc_conference_entermessage": "ಏನಾದರೂ ಹೇಳಿ!",
        "instavc_conference_adddevice": "ಸಾಧನಗಳನ್ನು ಸೇರಿಸಿ",
        "instavc_conference_adddevice_addcamera": "ಕ್ಯಾಮೆರಾ ಸೇರಿಸಿ",
        "instavc_conference_adddevice_source": "ಮೂಲ",
        "instavc_conference_adddevice_camera": "ಕ್ಯಾಮೆರಾ",
        "instavc_conference_adddevice_cameraname": "ಫೇಸ್ಟೈಮ್ ಏಚ್ ಡೀ ಕ್ಯಾಮೆರಾ",
        "instavc_conference_adddevice_close": "ಮುಚ್ಚಿ",
        "instavc_conference_adddevice_publish": "ಪ್ರಕಟಿಸಿ",
        "instavc_conference_info": "ಮಾಹಿತಿ",
        "questions": "ಪ್ರಶ್ನೆಗಳು",
        "instavc_conference_askquestions": "ಪ್ರಶ್ನೆಗಳನ್ನು ಕೇಳಿ",
        "instavc_conference_info_meetingid": "ವೈಯಕ್ತಿಕ ಸಭೆ ಐಡೀ",
        "instavc_conference_fullscreen": "ಪೂರ್ಣ ಪರದೆ",
        "conference_setup_invitepeoplel":"ಜನರನ್ನು ಆಹ್ವಾನಿಸಿ",
        "conference_setup_invite_linktojoin":"https://connect.instavc.com/conferenceguest/93ac2135d88727ca29061b4b6bf9477bc8f285a8121ff580649512abad353fbc6751a134d56438f7/f",
        "conference_setup_invite_byemail": "ಮೇಲ್ ಮೂಲಕ ಆಹ್ವಾನಿಸಿ",
        "instavc_conference_participants": "ಭಾಗವಹಿಸುವವರು",
        "instavc_conference_participants_search": "ಹುಡುಕಿ ...",
        "instavc_conference_participant": "ಭಾಗವಹಿಸುವವರು",
        "instavc_conference_participants_muteall": "ಎಲ್ಲವರನ್ನು ಮ್ಯೂಟ್ ಮಾಡಿ",
        "instavc_conference_participants_unmuteall": "ಎಲ್ಲವರನ್ನು ಅನ್ಮ್ಯೂಟ್ ಮಾಡಿ",
        "instavc_conference": "ಸಮ್ಮೇಳನ",
        "instavc_conf_more": "ಹೆಚ್ಚು",
        "instavc_conference_picturesmode": "ಈ ವೀಡಿಯೊ ಪಿಕ್ಚರ್-ಇನ್-ಪಿಕ್ಚರ್ ಮೋಡ್ನಲ್ಲಿ ಪ್ಲೇ ಆಗುತ್ತಿದೆ",
        "instavc_conference_mediastreams_stats": "ಮಾಧ್ಯಮ ಸ್ಟ್ರೀಮ್ ಅಂಕಿಅಂಶಗಳು",
        "instavc_conference_mediastreams_audio": "ಆಡಿಯೋ",
        "instavc_conference_mediastreams_audio_send": "ಕಳುಹಿಸು",
        "instavc_conference_mediastreams_audio_codec": "ಕೋಡೆಕ್",
        "instavc_conference_mediastreams_audio_rates": "ದರಗಳು (ಕೆಬಿಪಿಎಸ್)",
        "instavc_conference_mediastreams_audio_lost": "ಕಳೆದುಹೋಯಿತು",
        "instavc_conference_mediastreams_audio_fraction": "ಭಿನ್ನರಾಶಿ",
        "instavc_conference_mediastreams_video": "ವಿಡಿಯೋ",
        "instavc_conference_mediastreams_video_send": "ಕಳುಹಿಸು",
        "instavc_conference_mediastreams_video_codec": "ಕೋಡೆಕ್",
        "instavc_conference_mediastreams_video_rates": "ದರಗಳು (ಕೆಬಿಪಿಎಸ್)",
        "instavc_conference_mediastreams_video_lost": "ಕಳೆದುಹೋಯಿತು",
        "instavc_conference_mediastreams_video_fraction": "ಭಿನ್ನರಾಶಿ",
        "instavc_conference_resolution": "ರೆಸಲ್ಯೂಶನ್",
        "instavc_conference_framerate": "ಫ್ರೇಮ್ ದರ",
        "instavc_conference_nack": "ನ್ಯಾಕ್",
        "instavc_conference_pli": "ಪಿಎಲ್ಐ",
        "instavc_conference_bw": "ಲಭ್ಯವಿರುವ ಬಿಡಬ್ಲ್ಯೂ",
        "instavc_conference_audiomuted": "ಆಡಿಯೋ ಮ್ಯೂಟ್ ಮಾಡಲಾಗಿದೆ",
        "instavc_conference_microphonemuted": "ನಿಮ್ಮ ಮೈಕ್ರೊಫೋನ್ ಮ್ಯೂಟ್ ಮಾಡಲಾಗಿದೆ",
        "join_conference_join_meetinginvitation": "ಸಭೆ ಆಮಂತ್ರಣಗಳಿಗೆ ಸೇರಿ",
        "join_conference_search": "ಹುಡುಕಿ ...",
        "join_conference_meeting details": "ಸಭೆಯ ಹೆಸರು \ನ್ ಆಹ್ವಾನಿಸಿದವರು: \ನ್ ಆಹ್ವಾನಿತ ಹೆಸರು",
        "join_conference_join": "ಸೇರಿ",
        "join_conference_nomeetings": "ಸಭೆಗಳಿಲ್ಲ",
        "join_conference_noupcomingmeetings": "ಓಹ್! ನಿಮಗೆ ಇನ್ನೂ ಮುಂಬರುವ ಸಭೆಗಳಿಲ್ಲ!",
        "insta_conference_mycontacts": "ನನ್ನ ಸಂಪರ್ಕಗಳು",
        "insta_conference_search": "ಹುಡುಕಿ ...",
        "insta_conference_typemessage": "ಸಂದೇಶವನ್ನು ಟೈಪ್ ಮಾಡಿ",
        "insta_conference_addcontact": "ಸಂಪರ್ಕವನ್ನು ಸೇರಿಸಿ",
        "insta_conference_enteremail": "ಮೇಲ್ ಐಡೀ ನಮೂದಿಸಿ",
        "insta_conference_add": "ಸೇರಿಸಿ",
        "insta_conference_nouserfound": "ಈ ಇಮೇಲ್ ವಿಳಾಸದೊಂದಿಗೆ ಅಂತಹ ಬಳಕೆದಾರರು ಕಂಡುಬಂದಿಲ್ಲ",
        "instavc_conf_callnot_allowed": "ನೀವು ಈಗಾಗಲೇ ಕರೆಯಲ್ಲಿದ್ದಾಗ ಇತರ ಬಳಕೆದಾರರನ್ನು ಕರೆಯಲು ಸಾಧ್ಯವಿಲ್ಲ",
        "insta_conference_pendingapproval": "ಅನುಮೋದನೆ ಬಾಕಿ ಉಳಿದಿದೆ",
        "insta_conference_out goingvideocall": "ಹೊರಹೋಗುವ ವೀಡಿಯೊ ಕರೆ",
        "insta_conference_calling": "ಕರೆ ಮಾಡಲಾಗುತ್ತಿದೆ ....",
        "insta_conference_incomingvideocall": "ಒಳಬರುವ ವೀಡಿಯೊ ಕರೆ",
        "insta_conference_calldecline": "ಅವನತಿ",
        "insta_conference_callaccept": "ಸ್ವೀಕರಿಸಿ",
        "insta_conference_instavcalert": "ಕನೆಕ್ಟ್.ಇನ್ಸ್ತವೀಸೀ.ಕಾಮ್ ಅನುಮತಿಸಲು ಬಯಸಿದೆ",
        "insta_conference_usemicrophone": "ನಿಮ್ಮ ಮೈಕ್ರೊಫೋನ್ ಬಳಸಿ",
        "insta_conference_usecamera": "ನಿಮ್ಮ ಕ್ಯಾಮೆರಾ ಬಳಸಿ",
        "insta_conference_blockdevices": "ನಿರ್ಬಂಧಿಸು",
        "insta_conference_allowdevices": "ಅನುಮತಿಸು",
        "instavc_schedulemeeting_createmeeting": "ಹೊಸ ಸಭೆ ರಚಿಸಿ / ತಿದ್ದು",
        "instavc_schedulewebinar_createmeeting": "ಹೊಸ ವೆಬ್ನಾರ್ ರಚಿಸಿ / ತಿದ್ದು",
        "instavc_schedulemeeting_meetingname": "ನಿಮ್ಮ ಸಭೆಗೆ ಹೆಸರನ್ನು ನೀಡಿ",
        "instavc_schedulemeeting_selectnames_tomeeting": "ನಿಮ್ಮ ಸಭೆಗಾಗಿ ಒಂದು ಕೊಠಡಿಯನ್ನು ಆರಿಸಿ",
        "instavc_schedulemeeting_setduration": "ಅವಧಿ ನಿಗದಿತಪಡಿಸಿ ",
        "instavc_schedulemeeting_15min": "15 ನಿಮಿಷಗಳು",
        "instavc_schedulemeeting_30min": "30 ನಿಮಿಷಗಳು",
        "instavc_schedulemeeting_60min": "60 ನಿಮಿಷಗಳು",
        "instavc_schedulemeeting_setcustom": "ಸೆಟ್ ಕಸ್ಟಮ್ ",
        "instavc_schedulemeeting_customduration": "ಕಸ್ಟಮ್ ಅವಧಿ",
        "instavc_schedulemeeting_minutes": "ನಿಮಿಷಗಳು",
        "instavc_schedulemeeting_setconfpassword": "ನಿಮ್ಮ ಕಾನ್ಫರೆನ್ಸ್ ಪಾಸ್ವರ್ಡ್ ಅನ್ನು ಹೊಂದಿಸಿ",
        "instavc_schedulemeeting_typepassword": "ನಿಮ್ಮ ಸಭೆಗಾಗಿ ಪಾಸ್ವರ್ಡ್ ಟೈಪ್ ಮಾಡಿ",
        "instavc_schedulemeeting_conferencecolor": "ನಿಮ್ಮ ಕಾನ್ಫರೆನ್ಸ್ ಐಕಾನ್ಗೆ ಬಣ್ಣ ನೀಡಿ",
        "instavc_schedulemeeting_invitepeople": "ಈ ಸಭೆಗೆ ಜನರನ್ನು ಆಹ್ವಾನಿಸಿ",
        "instavc_schedulemeeting_search": "ಹುಡುಕಿ ...",
        "instavc_schedulemeeting_SM": "ಎಸ್ ಎಮ್",
        "instvc_SM_message": "ಅಧಿಕೃತ ಬಳಕೆದಾರ ಪರವಾನಗಿ ಹೊಂದಿರುವ ಬಳಕೆದಾರರ ಸಂಖ್ಯೆ ಪರವಾನಗಿ ಪಡೆದ ಮಿತಿಯನ್ನು ಮೀರಿದೆ. ನೀವು ಹೆಚ್ಚಿನ ಜನರನ್ನು ಆಹ್ವಾನಿಸಲು ಬಯಸಿದರೆ ನೀವು ಮಾಡಬಹುದು",
        "instavc_SM_message_href": "ಪ್ರೀಮಿಯಂಗೆ ಹೋಗಿ",
        "instavc_schedulemeeting_notify": "ಈ ಸಭೆಯ ಬಗ್ಗೆ ಆಯ್ದ ಜನರಿಗೆ ತಿಳಿಸಿ",
        "instavc_schedulemeeting_addreminder": "ಜ್ಞಾಪನೆ ಸೇರಿಸಿ ",
        "instavc_schedulemeeting_add": "ಸೇರಿಸಿ",
        "instavc_schedulemeeting_addmeetingreminder": "ಮೀಟಿಂಗ್ ಜ್ಞಾಪನೆ ಸೇರಿಸಿ",
        "instavc_schedulemeeting_adddatetime": "ದಿನಾಂಕ ಪಿಕ್ಕರ್, ಸಮಯ ಪಿಕ್ಕರ್",
        "instavc_schedulemeeting_apply": "ಅನ್ವಯಿಸು",
        "instavc_schedulemeeting_name": "ದಯವಿಟ್ಟು ಸಭೆಯ ಹೆಸರನ್ನು ನಮೂದಿಸಿ",
        "instavc_schedulemeeting_selectroom": "ದಯವಿಟ್ಟು ಕೊಠಡಿಯನ್ನು ಆರಿಸಿ",
        "instavc_schedulemeeting_selectduration": "ದಯವಿಟ್ಟು ಅವಧಿಯನ್ನು ಆರಿಸಿ",
        "instavc_recuring_schedule": "ಮರುಕಳಿಸುವ ವೇಳಾಪಟ್ಟಿ",
        "instavc_schedulemeeting_nothinginreminders": "ಜ್ಞಾಪನೆಗಳಲ್ಲಿ ಏನೂ ಇಲ್ಲ",
        "instavc_schedulemeeting_createbutton": "ರಚಿಸಿ",
        "instavc_schedulemeeting_createdsuccessfully": "ವೇಳಾಪಟ್ಟಿ ಯಶಸ್ವಿಯಾಗಿ ರಚಿಸಲಾಗಿದೆ",
        "instavc_meetinglist_calender": "ಕ್ಯಾಲೆಂಡರ್",
        "instavc_meetinglist_selecteddates": "ನೀವು  ಆಯ್ದ ದಿನಾಂಕಗಳು",
        "instavc_meetinglist_schedulecreted": "ವೇಳಾಪಟ್ಟಿಗಳನ್ನು ರಚಿಸಲಾಗಿದೆ",
        "instavc_meetinglist_pastchedule": "ಹಿಂದಿನ ವೇಳಾಪಟ್ಟಿ",
        "instavc_meetinglist": "ಸಭೆಗಳ ಪಟ್ಟಿ",
        "instavc_meetinglist_meetingdetils": "ಸಭೆಯ ಹೆಸರು, ಸಭೆಯ ಸಮಯ, ಸಂಘಟಿತರಿಂದ",
        "instavc_meetinglist_search": "ಹುಡುಕಿ ...",
        "instavc_meetinglist_deleterecuring": "ಮರುಕಳಿಸುವ ವೇಳಾಪಟ್ಟಿಯನ್ನು ಅಳಿಸಿ",
        "instavc_meetinglist_alow_deleterecuring": "ನೀವು ಪ್ರಸ್ತುತ ವೇಳಾಪಟ್ಟಿಯನ್ನು ಅಥವಾ ಮರುಕಳಿಸುವಿಕೆಯ ಎಲ್ಲಾ ವೇಳಾಪಟ್ಟಿಗಳನ್ನು ಮಾತ್ರ ಅಳಿಸಲು ಬಯಸುವಿರಾ?",
        "instavc_meetinglist_schedule_series": "ಸರಣಿಯ ಎಲ್ಲಾ ಇತರ ವೇಳಾಪಟ್ಟಿಗಳು ಉಳಿಯುತ್ತವೆ:",
        "instavc_meetinglist_schedule_seriesdelete": "ಸರಣಿಯ ಎಲ್ಲಾ ವೇಳಾಪಟ್ಟಿಗಳನ್ನು ಅಳಿಸಲಾಗುತ್ತದೆ:",
        "instavc_meetinglist_allrecuringsch": "ಎಲ್ಲಾ ಮರುಕಳಿಸುವ ವೇಳಾಪಟ್ಟಿಗಳು",
        "instavc_meetinglist_cancelchanges": "ಬದಲಾವಣೆಗಳನ್ನು ರದ್ದುಮಾಡು",
        "instavc_meetinglist_noschedules": "ವೇಳಾಪಟ್ಟಿಗಳಿಲ್ಲ",
        "instavc_ml_schedulemessage": "ಸಭೆಯ ವೇಳಾಪಟ್ಟಿಯನ್ನು ಇನ್ನೂ ರಚಿಸಲಾಗಿಲ್ಲ! \ನ್ ಕೆಳಗಿನ ಬಟನ್ ಕ್ಲಿಕ್ ಮಾಡುವ ಮೂಲಕ ನಿಮ್ಮ ವೇಳಾಪಟ್ಟಿಯನ್ನು ರಚಿಸಿ.",
        "instavc_create_schedule": "ವೇಳಾಪಟ್ಟಿಯನ್ನು ರಚಿಸಿ",
        "instavc_meetinglist_currentschedule": "ಪ್ರಸ್ತುತ ವೇಳಾಪಟ್ಟಿ",
        "instavc_meetinglist_join": "ಸೇರಿ",
        "instavc_meetinglist_buynow": "ಈಗ ಖರೀದಿಸಿ",
        "instavc_dashboard_chooseplan": "ಯೋಜನೆಯನ್ನು ಆರಿಸಿ",
        "instavc_package_smbplan": " ಎಸ್ಎಮ್ಬ ಬೀ ಯೋಜನೆಗಳು",
        "instavc_package_smbplan_host": "(ಹೋಸ್ಟ್ ಆಧಾರಿತ ಪರವಾನಗಿ)",
        "instavc_package_smbplandescription": "ಒಂದು ಕೋಣೆಯಲ್ಲಿ ಒಂದು ಸಮಯದಲ್ಲಿ ಕೇವಲ 1 ಹೋಸ್ಟ್ ಇರಬಹುದು. ಖರೀದಿದಾರನು ಹೋಸ್ಟ್ ಖಾತೆಯನ್ನು ರಚಿಸಬಹುದು ಅಥವಾ ಬದಲಾಯಿಸಬಹುದು, ಅವರು ಕೊಠಡಿಯನ್ನು ನಿಯಂತ್ರಿಸಬಹುದು. ಕರೆ ಸಮಯದಲ್ಲಿ ಹೋಸ್ಟ್ ಪ್ರವೇಶಗಳನ್ನು ಹಂಚಿಕೊಳ್ಳಲಾಗುವುದಿಲ್ಲ. ಹೋಸ್ಟ್ ಸಮ್ಮೇಳನಕ್ಕೆ ಸೇರುವವರೆಗೆ ಎಲ್ಲಾ ಇತರ ಬಳಕೆದಾರರು ಸಂವಹನ ನಡೆಸಲು ಸಾಧ್ಯವಿಲ್ಲ. ",
        "instavc_package_basic": "ಮೂಲ",
        "instavc_package_hostuser_smb": "1 ಹೋಸ್ಟ್ ಮತ್ತು",
        "instavc_package_hostuser_smb_users": "ಬಳಕೆದಾರರು",
        "instavc_package_currency": "$",
        "instavc_package_permonth": "/ ತಿಂಗಳು",
        "instavc_package_bill_smb": "ವಾರ್ಷಿಕವಾಗಿ ಬಿಲ್ ಮಾಡಲಾಗಿದೆ",
        "instavc_package_include_smb": "ಈ ಪ್ಯಾಕೇಜ್ ಇದರೊಂದಿಗೆ ಒಳಗೊಂಡಿದೆ",
        "instavc_package_specifictions_Whiteboard": "ವೈಟ್ಬೋರ್ಡ್",
        "instavc_package_specifictions_Screen": "ಪರದೆ ಹಂಚಿಕೆ",
        "instavc_package_specifictions_nChat": "ಚಾಟ್",
        "instavc_package_specifictions_Recording": "ರೆಕಾರ್ಡಿಂಗ್",
        "instavc_package_specifictions_PresenterMode": "ಪ್ರೆಸೆಂಟರ್ ಮೋಡ್",
        "instavc_package_buynowbutton": "ಈಗ ಖರೀದಿಸಿ",
        "instavc_package_fullfeatures_smb": "ಪೂರ್ಣ ವೈಶಿಷ್ಟ್ಯಗಳು",
        "instavc_package_billinginfo": "ಬಿಲ್ಲಿಂಗ್ ಮಾಹಿತಿ",
        "instavc_package_billinginfo_name": "ಹೆಸರು",
        "instavc_package_billinginfo_orginazation": "ಸಂಸ್ಥೆ",
        "instavc_package_biilinginfo_gstin": "ಜಿಎಸ್ಟಿಎನ್",
        "Save": "ಉಳಿಸು",
        "instavc_package_billinginfo_edit": "ತಿದ್ದು",
        "instavc_package_billingdetails": "ಬಿಲ್ಲಿಂಗ್ ವಿವರಗಳು",
        "instavc_package_billingdetails_firstname": "ಮೊದಲ ಹೆಸರು",
        "instavc_package_billingdetails_lastname": "ಕೊನೆಯ ಹೆಸರು",
        "instavc_package_billingdetails_address": "ವಿಳಾಸ",
        "instavc_package_billingdetails_zip": "ಜಿಪ್",
        "instavc_package_shippinginfo": "ಶಿಪ್ಪಿಂಗ್ ಮಾಹಿತಿ",
        "instavc_package_shippinginfo_edit": "ತಿದ್ದು",
        "instavc_package_shippingdetails": "ಶಿಪ್ಪಿಂಗ್ ವಿವರಗಳು",
        "instavc_package_shippingdetails_firstname": "ಮೊದಲ ಹೆಸರು",
        "instavc_package_shippingdetails_lastname": "ಕೊನೆಯ ಹೆಸರು",
        "instavc_package_shippingdetails_address": "ವಿಳಾಸ",
        "instavc_package_shippingdetails_zip": "ಜಿಪ್",
        "instavc_package_cartsummary": "ಕಾರ್ಟ್ ಸಾರಾಂಶ",
        "instavc_package_hostbase": "ಹೋಸ್ಟ್ ಆಧಾರಿತ ಪರವಾನಗಿ (ಪರವಾನಗಿ ಹೆಸರು)",
        "instavc_package_smbplan_basic": "ಎಸ್ಎಮ್ ಬೀ ಯೋಜನೆ - ಮೂಲ",
        "instavc_package_plandetails": "1 ವರ್ಷಕ್ಕೆ 4 144.02 ಬಿಲ್ ಮಾಡಲಾಗಿದೆ ಮತ್ತು ತಿಂಗಳಿಗೆ $ 13",
        "instavc_package_term": "ಟರ್ಮ್",
        "instavc_package_1year": "1 ವರ್ಷ",
        "instavc_package_2years": "2 ವರ್ಷಗಳು",
        "instavc_package_3years": "3 ವರ್ಷಗಳು",
        "instavc_package_4years": "4 ವರ್ಷಗಳು",
        "instavc_package_5years": "5 ವರ್ಷಗಳು",
        "instavc_package_subtotal": "ಉಪಮೊತ್ತ",
        "instavc_package_taxes": "ತೆರಿಗೆಗಳು ಮತ್ತು ಶುಲ್ಕಗಳು (ಜಿಎಸ್ಟಿ + 18%)",
        "instavc_package_launchoffer": "ಲಾಂಚ್ ಆಫರ್",
        "instavc_package_promo": "ಪ್ರೋಮೋ ಯಶಸ್ವಿಯಾಗಿ ಅನ್ವಯಿಸಲಾಗಿದೆ",
        "instavc_package_remove": "ತೆಗೆದುಹಾಕಿ",
        "instavc_package_havepromocode": "ಪ್ರೋಮೋ ಕೋಡ್ ಇದೆಯೇ? ಇಲ್ಲಿ ಅನ್ವಯಿಸಿ",
        "instavc_package_entercouponcode": "ದಯವಿಟ್ಟು ಮಾನ್ಯವಾದ ಕೂಪನ್ ಕೋಡ್ ಅನ್ನು ನಮೂದಿಸಿ",
        "instavc_package_total": "ಒಟ್ಟು",
        "instavc_package_offerdisclaimer": "ಆಫರ್ ಹಕ್ಕುತ್ಯಾಗವನ್ನು ವೀಕ್ಷಿಸಿ",
        "instavc_package_paynow": "ಈಗ ಪಾವತಿಸಿ",
        "instavc_package_payment_instavclicense": "ಪೀಪಲ್‌ಲಿಂಕ್ ಯೂನಿಫೈಡ್ ಕಮ್ಯೂನಿಕೇಶನ್ಸ್  ಇನ್‌ಸ್ಟಾವಿಸಿ ಪರವಾನಗಿಗಾಗಿ ಪಾವತಿ",
        "instavc_package_phone": "ಫೋನ್",
        "instavc_package_entervalid_contactnumber": "ದಯವಿಟ್ಟು ಮಾನ್ಯವಾದ ಸಂಪರ್ಕ ಸಂಖ್ಯೆಯನ್ನು ನಮೂದಿಸಿ",
        "instavc_package_email": "ಇಮೇಲ್",
        "instavc_package_enteremail": "ದಯವಿಟ್ಟು ಮಾನ್ಯವಾದ ಇಮೇಲ್ ಐಡಿಯನ್ನು ನಮೂದಿಸಿ. ಉದಾಹರಣೆ: you@example.com",
        "instavc_package_paybycard": "ಕಾರ್ಡ್ ಮೂಲಕ ಪಾವತಿಸಿ",
        "instavc_package_securedbyrazorpay": "ರೇಜರ್ಪೇನಿಂದ ಸುರಕ್ಷಿತವಾಗಿದೆ",
        "instavc_package_card": "ಕಾರ್ಡ್",
        "instavc_package_enterotp": "ಉಳಿಸಿದ ಕಾರ್ಡ್ಗಳನ್ನು ಪ್ರವೇಶಿಸಲು xxxxxxxxx ನಲ್ಲಿ ಕಳುಹಿಸಲಾದ ಒಟಿಪಿ ಅನ್ನು ನಮೂದಿಸಿ",
        "instavc_package_resendotp": "ಒಟಿಪಿ ಅನ್ನು ಮರುಹೊಂದಿಸಿ",
        "instavc_package_skipsavedcards": "ಉಳಿಸಿದ ಕಾರ್ಡ್ಗಳನ್ನು ಬಿಟ್ಟುಬಿಡಿ",
        "instavc_package_enter_otp": "ದಯವಿಟ್ಟು ಒಟಿಪಿ ಅನ್ನು ನಮೂದಿಸಿ",
        "instavc_package_skipthesavedcards": "ಉಳಿಸಿದ ಕಾರ್ಡ್ಗಳನ್ನು ಬಿಟ್ಟುಬಿಡಿ",
        "instavc_package_cardnumber": "ಕಾರ್ಡ್ ಸಂಖ್ಯೆ",
        "instavc_package_entervalid_cardnumber": "ದಯವಿಟ್ಟು ಮಾನ್ಯವಾದ ಕಾರ್ಡ್ ಸಂಖ್ಯೆಯನ್ನು ನಮೂದಿಸಿ",
        "instavc_package_expiry": "ಅವಧಿ",
        "instavc_package_cardholdername": "ಕಾರ್ಡ್ ಹೊಂದಿರುವವರ ಹೆಸರು",
        "instavc_package_cvv": "ಸಿ.ವಿ.ವಿ.",
        "instavc_package_3digitcode": "ಇದು ನಿಮ್ಮ ಕಾರ್ಡ್ನ ಹಿಂಭಾಗದಲ್ಲಿ ಮುದ್ರಿಸಲಾದ 3 ಅಂಕಿಯ ಕೋಡ್",
        "instavc_package_pay": "ಪಾವತಿ",
        "instavc_package_remembercard": "ಕಾರ್ಡ್ ನೆನಪಿಡಿ",
        "instavc_package_medium": "ಮಧ್ಯಮ",
        "instavc_package_hostuser_medium": "1 ಹೋಸ್ಟ್ ಮತ್ತು 50 ಬಳಕೆದಾರರು",
        "instavc_package_month_medium": "$15 / ತಿಂಗಳು",
        "instavc_package_bill_medium": "ವಾರ್ಷಿಕವಾಗಿ ಬಿಲ್ ಮಾಡಲಾಗುತ್ತದೆ + ಜಿಎಸ್ಟಿ 18%",
        "instavc_package_include_medium": "ಈ ಪ್ಯಾಕೇಜ್ ಇದರೊಂದಿಗೆ ಒಳಗೊಂಡಿದೆ",
        "instavc_package_specifictions_medium": "ವೈಟ್ಬೋರ್ಡ್ \ n ಸ್ಕ್ರೀನ್ ಶೇರ್ \ n ಚಾಟ್ \ n ರೆಕಾರ್ಡಿಂಗ್ \ n ಪ್ರತಿನಿಧಿ ಮೋಡ್",
        "instavc_package_buynow_medium": "ಈಗ ಖರೀದಿಸಿ",
        "instavc_package_fullfeatures_medium": "ಪೂರ್ಣ ವೈಶಿಷ್ಟ್ಯಗಳು",
        "instavc_package_advanced": "ಸುಧಾರಿತ",
        "instavc_package_hostuser_advanced": "1 ಹೋಸ್ಟ್ ಮತ್ತು 100 ಬಳಕೆದಾರರು",
        "instavc_package_month_advanced": "$16 / month",
        "instavc_package_bill_advanced": "ವಾರ್ಷಿಕವಾಗಿ ಬಿಲ್ ಮಾಡಲಾಗುತ್ತದೆ + ಜಿಎಸ್ಟಿ 18%",
        "instavc_package_include_advanced": "ಈ ಪ್ಯಾಕೇಜ್ ಇದರೊಂದಿಗೆ ಒಳಗೊಂಡಿದೆ",
        "instavc_package_specifictions_advanced": "ವೈಟ್ಬೋರ್ಡ್ \ n ಸ್ಕ್ರೀನ್ ಶೇರ್ \ n ಚಾಟ್ \ n ರೆಕಾರ್ಡಿಂಗ್ \ n ಪ್ರತಿನಿಧಿ ಮೋಡ್",
        "instavc_package_buynow_advanced": "ಈಗ ಖರೀದಿಸಿ",
        "instavc_package_fullfeatures_advanced": "ಪೂರ್ಣ ವೈಶಿಷ್ಟ್ಯಗಳು",
        "instavc_package_virtualmcu": "ವರ್ಚುವಲ್ ಎಂಸಿಯು ಪರವಾನಗಿ",
        "instavc_package_virtualmcu_room": "(ಕೊಠಡಿ ಆಧಾರಿತ ಪರವಾನಗಿ)",
        "instavc_package_vmcudetails": "ಒಂದು ಕೋಣೆಯಲ್ಲಿ ಒಂದು ಸಮಯದಲ್ಲಿ ಕೇವಲ 1 ಹೋಸ್ಟ್ ಇರಬಹುದು. ಖರೀದಿದಾರನು ಹೋಸ್ಟ್ ಖಾತೆಯನ್ನು ರಚಿಸಬಹುದು ಅಥವಾ ಬದಲಾಯಿಸಬಹುದು, ಅವರು ಕೊಠಡಿಯನ್ನು ನಿಯಂತ್ರಿಸಬಹುದು. ಕರೆ ಸಮಯದಲ್ಲಿ ಹೋಸ್ಟ್ ಪ್ರವೇಶಗಳನ್ನು ಹಂಚಿಕೊಳ್ಳಲಾಗುವುದಿಲ್ಲ. ಹೋಸ್ಟ್ ಸಮ್ಮೇಳನಕ್ಕೆ ಸೇರುವವರೆಗೆ ಎಲ್ಲಾ ಇತರ ಬಳಕೆದಾರರು ಸಂವಹನ ನಡೆಸಲು ಸಾಧ್ಯವಿಲ್ಲ. ",
        "instavc_package_instavc": "ಇನ್ಸ್ತವೀಸೀ",
        "instavc_package_silver": "ಸ್ಲಿವರ್",
        "instavc_package_userrooms_silver_users": "ಬಳಕೆದಾರರು",
        "instavc_package_userrooms_silver_rooms": "ಕೊಠಡಿಗಳು",
        "instavc_package_month_silver": "$281 / ತಿಂಗಳು",
        "instavc_package_bill_silver": "ವಾರ್ಷಿಕವಾಗಿ ಬಿಲ್ ಮಾಡಲಾಗುತ್ತದೆ + ಜಿಎಸ್ಟಿ 18%",
        "instavc_package_include_silver": "ಈ ಪ್ಯಾಕೇಜ್ ಇದರೊಂದಿಗೆ ಒಳಗೊಂಡಿದೆ",
        "instavc_package_specifictions_silver": "ವೈಟ್ಬೋರ್ಡ್ \ n ಸ್ಕ್ರೀನ್ ಶೇರ್ \ n ಚಾಟ್ \ n ರೆಕಾರ್ಡಿಂಗ್ \ n ಪ್ರತಿನಿಧಿ ಮೋಡ್",
        "instavc_package_buynow_silver": "ಈಗ ಖರೀದಿಸಿ",
        "instavc_package_fullfeatures_silver": "ಪೂರ್ಣ ವೈಶಿಷ್ಟ್ಯಗಳು",
        "instavc_package_gold": " ಗೋಲ್ಡ್",
        "instavc_package_userrooms_gold": "200 ಬಳಕೆದಾರರು - 30 ಕೊಠಡಿಗಳು",
        "instavc_package_month_gold": "$467 / ತಿಂಗಳು",
        "instavc_package_bill_gold": "ವಾರ್ಷಿಕವಾಗಿ ಬಿಲ್ ಮಾಡಲಾಗುತ್ತದೆ + ಜಿಎಸ್ಟಿ 18%",
        "instavc_package_include_gold": "ಈ ಪ್ಯಾಕೇಜ್ ಇದರೊಂದಿಗೆ ಒಳಗೊಂಡಿದೆ",
        "instavc_package_specifictions_gold": "ವೈಟ್ಬೋರ್ಡ್ \ n ಸ್ಕ್ರೀನ್ ಶೇರ್ \ n ಚಾಟ್ \ n ರೆಕಾರ್ಡಿಂಗ್ \ n ಪ್ರತಿನಿಧಿ ಮೋಡ್",
        "instavc_package_buynow_gold": "ಈಗ ಖರೀದಿಸಿ",
        "instavc_package_fullfeatures_gold": "ಪೂರ್ಣ ವೈಶಿಷ್ಟ್ಯಗಳು",
        "instavc_package_platinum": "ಪ್ಲ್ಯಾಟಿನಮ್",
        "instavc_package_userrooms_platinum": "500 ಬಳಕೆದಾರರು - 50 ಕೊಠಡಿಗಳು",
        "instavc_package_month_platinum": "$ 933 / ತಿಂಗಳು",
        "instavc_package_bill_platinum": "ವಾರ್ಷಿಕವಾಗಿ ಬಿಲ್ ಮಾಡಲಾಗುತ್ತದೆ + ಜಿಎಸ್ಟಿ 18%",
        "instavc_package_include_platinum": "ಈ ಪ್ಯಾಕೇಜ್ ಇದರೊಂದಿಗೆ ಒಳಗೊಂಡಿದೆ",
        "instavc_package_specifictions_platinum": "ವೈಟ್ಬೋರ್ಡ್ \ n ಸ್ಕ್ರೀನ್ ಶೇರ್ \ n ಚಾಟ್ \ n ರೆಕಾರ್ಡಿಂಗ್ \ n ಪ್ರತಿನಿಧಿ ಮೋಡ್",
        "instavc_package_buynow_platinum": "ಈಗ ಖರೀದಿಸಿ",
        "instavc_package_fullfeatures_platinum": "ಪೂರ್ಣ ವೈಶಿಷ್ಟ್ಯಗಳು",
        "instavc_package_legacybaselicense": "ಲೆಗಸಿ ಆಧಾರಿತ ಪರವಾನಗಿ",
        "instavc_package_licensebased_ports": "ಪೋರ್ಟ ಸಂಖ್ಯೆಯನ್ನು ಆಧರಿಸಿ ಪರವಾನಗಿ",
        "instavc_package_hardwareendpoint": "ಹಾರ್ಡ್ವೇರ್ ಎಂಡ್ಪಾಯಿಂಟ್ನೊಂದಿಗೆ ಇನ್ಸ್ತವೀಸೀ",
        "instavc_package_webrtcconf_legacysupport": "ವೆಬ್ಆರ್ಟಿಸಿ ಕಾನ್ಫರೆನ್ಸಿಂಗ್ ವಿತ್ ಲೆಗಸಿ ಸಪೋರ್ಟ್ಸ್",
        "instavc_package_sip": "ಎಸ್‌ಐಪಿ / ಬಿಎಫ್‌ಸಿಪಿ ಬೆಂಬಲ",
        "instavc_package_chh323": "ಸೀ ಏಚ್ ಏಚ್323 / ಏಚ್.239 ಬೆಂಬಲ",
        "instavc_package_contactus": "ನಮ್ಮನ್ನು ಸಂಪರ್ಕಿಸಿ",
        "instavc_myprofile_dashboard": "ಡ್ಯಾಶ್ಬೋರ್ಡ್",
        "instavc_myprofile_settings": "ಸೆಟ್ಟಿಂಗ್ಗಳು",
        "instavc_myprofile": "ನನ್ನ ಪ್ರೊಫೈಲ್",
        "instavc_myprofile_personaldetail": "ವೈಯಕ್ತಿಕ ವಿವರಗಳು",
        "instavc_myprofile_personaldetails_name": "ಹೆಸರು",
        "instavc_myprofile_personaldetails_email": "ಇಮೇಲ್",
        "instavc_myprofile_personaldetails_phoneno": "ಫೋನ್ ಸಂಖ್ಯೆ",
        "instavc_myprofile_personaldetails_address": "ವಿಳಾಸ",
        "instavc_myprofile_personaldetails_city": "ನಗರ",
        "instavc_myprofile_edit": "ತಿದ್ದು",
        "instavc_myprofile_personaldetails": "ವೈಯಕ್ತಿಕ ವಿವರಗಳು",
        "instavc_myprofile_firstname": "ಮೊದಲ ಹೆಸರು",
        "instavc_myprofile_lastname": "ಕೊನೆಯ ಹೆಸರು",
        "instavc_myprofile_email": "ಇಮೇಲ್",
        "instavc_myprofile_phoneno": "ಫೋನ್ ಸಂಖ್ಯೆ",
        "instavc_myprofile_professionaldetails": "ವೃತ್ತಿಪರ ವಿವರಗಳು",
        "instavc_myprofile_position": "ಸ್ಥಾನ",
        "instavc_myprofile_professionaldetails_email": "ಇಮೇಲ್",
        "instavc_myprofile_professionaldetails_phoneno": "ಫೋನ್ ಸಂಖ್ಯೆ",
        "instavc_myprofile_professionaldetails_address": "ವಿಳಾಸ",
        "instavc_myprofile_professionaldetails_branch": "ಶಾಖೆ",
        "instavc_myprofile_professionaldetails_edit": "ತಿದ್ದು",
        "instavc_myprofile_officialdetails": "ಅಧಿಕೃತ ವಿವರಗಳು",
        "instavc_myprofile_officialdetails_position": "ಸ್ಥಾನ",
        "instavc_myprofile_officialdetails_email": "ಇಮೇಲ್",
        "instavc_myprofile_officialdetails_phoneno": "ಫೋನ್ ಸಂಖ್ಯೆ",
        "instavc_myprofile_officialdetails_branch": "ಶಾಖೆ",
        "instavc_myprofile_officialdetails_address": "ವಿಳಾಸ",
        "instavc_myprofile_contactinfo": "ಸಂಪರ್ಕ ಮಾಹಿತಿ",
        "instavc_myprofile_contactinformation": "ಸಂಪರ್ಕ ಮಾಹಿತಿ",
        "instavc_myprofile_add": "ಸೇರಿಸಿ",
        "instavc_myprofile_contactinformation_address": "ವಿಳಾಸ",
        "instavc_myprofile_contactinformation_city": "ನಗರ / ಪಟ್ಟಣ",
        "instavc_myprofile_contactinformation_zip": "ಜಿಪ್",
        "instavc_myprofile_contactinformation_landmark": "ಹೆಗ್ಗುರುತು",
        "instavc_myprofile_address": "ವಿಳಾಸ",
        "instavc_myprofile_landmark": "ಹೆಗ್ಗುರುತು",
        "instavc_myprofile_delete": "ಎಚ್ಚರಿಕೆ",
        "instavc_myprofile_deletealert": "ಇದನ್ನು ಅಳಿಸಲು ನೀವು ಖಚಿತವಾಗಿ ಬಯಸುವಿರಾ?",
        "instavc_myprofile_disagree": "ಒಪ್ಪುವುದಿಲ್ಲ",
        "instavc_myprofile_agree": "ಒಪ್ಪುತ್ತೇನೆ",
        "instavc_myprofile_websitelinks": "ವೆಬ್ಸೈಟ್ ಲಿಂಕ್",
        "instavc_myprofile_website_add": "ಸೇರಿಸಿ",
        "instavc_myprofile_website": "ವೆಬ್ಸೈಟ್",
        "instavc_myprofile_websiteexample": "ಏಚ್ಟೀಟೀಪೀಸ್:// ಡಬ್ಲ್ಯೂಡಬ್ಲ್ಯೂಡಬ್ಲ್ಯೂ.ಗೂಗಲ್. ಕಾಮ್",
        "instavc_myprofile_sociallinks": "ಸಾಮಾಜಿಕ ಲಿಂಕ್ಗಳು",
        "instavc_myprofile_sociallinks_add": "ಸೇರಿಸಿ",
        "instavc_myprofile_sociallink": "ಸಾಮಾಜಿಕ ಲಿಂಕ್ಗಳು",
        "instavc_myprofile_sociallinks_example": "ಏಚ್ ಟೀಟೀಪೀಸ್:// ಡಬ್ಲ್ಯೂಡಬ್ಲ್ಯೂಡಬ್ಲ್ಯ.ಫೇಸ್ ಬುಕ್.ಕಾಮ್",
        "instavc_myprofile_basicinfo": "ಮೂಲ ಮಾಹಿತಿ",
        "instavc_myprofile_basicinfo_add": "ಸೇರಿಸಿ",
        "instavc_myprofile_basicinfo_dob": " ಡ್ಓಬೀ",
        "instavc_myprofile_basicinfo_gender": "ಲಿಂಗ",
        "instavc_myprofile_basicinformation": "ಮೂಲ ಮಾಹಿತಿ",
        "instavc_myprofile_basicinformation_dob": "ಹುಟ್ಟಿದ ದಿನಾಂಕ",
        "instavc_myprofile_basicinformation_gender": "ಲಿಂಗ",
        "instavc_myprofile_basicinformation_deletealert": "ಎಚ್ಚರಿಕೆ \ n ಇದನ್ನು ಅಳಿಸಲು ನೀವು ಖಚಿತವಾಗಿ ಬಯಸುವಿರಾ?",
        "instavc_myprofile_basicinformation_disagree": "ನಿಷ್ಕ್ರಿಯಗೊಳಿಸಿ",
        "instavc_myprofile_basicinformation_agree": "ಒಪ್ಪುತ್ತೇನೆ",
        "instavc_myprofile_uploadnewavatar": "ಹೊಸ ಅವತಾರವನ್ನು ಅಪ್ಲೋಡ್ ಮಾಡಿ",
        "instavc_myprofile_cropimage": "ಕ್ರಾಪ್ ಇಮೇಜ್",
        "instavc_myprofile_locale": "ಲೊಕೇಲ್",
        "instavc_myprofile_localesettings": "ಲೊಕೇಲ್ ಸೆಟ್ಟಿಂಗ್ಸ್",
        "instavc_myprofile_preferredlanguage": "ಆದ್ಯತೆಯ ಭಾಷೆ:",
        "instavc_myprofile_language": "ಇಂಗ್ಲಿಷ್",
        "instavc_settings": "ಸೆಟ್ಟಿಂಗ್ಗಳು",
        "instavc_settings_changepassword": "ಪಾಸ್ವರ್ಡ್ ಬದಲಾಯಿಸಿ",
        "instavc_settings_changepass": "ಪಾಸ್ವರ್ಡ್ ಬದಲಾಯಿಸಿ",
        "instavc_settings_currentpassword": "ಪ್ರಸ್ತುತ ಪಾಸ್ವರ್ಡ್ ಟೈಪ್ ಮಾಡಿ",
        "instavc_settings_newpassword": "ಹೊಸ ಪಾಸ್ವರ್ಡ್ ಟೈಪ್ ಮಾಡಿ",
        "instavc_settings_enter_currentpassword": "ದಯವಿಟ್ಟು ಪ್ರಸ್ತುತ ಪಾಸ್ವರ್ಡ್ ಅನ್ನು ನಮೂದಿಸಿ",
        "instavc_settings_enter_newpassword": "ದಯವಿಟ್ಟು ಹೊಸ ಪಾಸ್ವರ್ಡ್ ನಮೂದಿಸಿ",
        "instavc_settings_help": "ಸಹಾಯ",
        "instavc_settings_affiliate": "ಅಂಗಸಂಸ್ಥೆಯಾಗು",
        "instavc_settings_support": "ಬೆಂಬಲ ಕೇಂದ್ರ",
        "instavc_settings_newticket": "ಹೊಸ ಟಿಕೆಟ್ ತೆರೆಯಿರಿ",
        "instavc_settings_ticketstatus": "ಟಿಕೆಟ್ ಸ್ಥಿತಿಯನ್ನು ಪರಿಶೀಲಿಸಿ",
        "instavc_settings_troubleshoot": "ನಿವಾರಣೆ",
        "instavc_legacy_dailout": "ಡೈಯಲ್ ಔಟ್",
        "instavc_legacy_stats": "ಅಂಕಿಅಂಶಗಳು",
        "instavc_legacy_dail_in_detail": "ವಿವರಗಳನ್ನು ಡಯಲ್ ಮಾಡಿ",
        "instavc_legacy_h323_endpoint": " ಏಚ್.323 ಎಂಡ್ ಪಾಯಿಂಟ್",
        "instavc_legacy_sip_endpoint": "ಸಿಪ್ ಎಂಡ್ ಪಾಯಿಂಟ್",
        "instavc_admin_users": "ಬಳಕೆದಾರರು",
        "instavc_admin_username": "ಬಳಕೆದಾರಹೆಸರು",
        "instavc_admin_user_accountstatus": "ಖಾತೆ ಸ್ಥಿತಿ",
        "instavc_admin_user_confirmed": "ದೃಢಪಡಿಸಲಾಗಿದೆ",
        "instavc_admin_user_unconfirmed": "ದೃಢಪಡಿಸಲಿಲ್ಲ",
        "instavc_admin_user_resetall": "ಎಲ್ಲವನ್ನೂ ಮರುಹೊಂದಿಸಿ",
        "instavc_admin_user_sync": "ಸಿಂಕ್",
        "instavc_admin_user_status": "ಸ್ಥಿತಿ",
        "instavc_admin_user_phonenumber": "ಫೋನ್ ಸಂಖ್ಯೆ",
        "instavc_admin_user_created": "ರಚಿಸಲಾಗಿದೆ",
        "instavc_admin_user_all": "ಎಲ್ಲ",
        "instavc_admin_groups": "ಗುಂಪುಗಳು",
        "instavc_admin_addmore": "ಇನ್ನಷ್ಟು ಸೇರಿಸಿ",
        "instavc_admin_group_peoplelink": "ಕ್ವೀನ್ಸ್,ಗೋಲಿವ್, ಪೀಪಲ್ಲಿಂಕ್",
        "instavc_admin_select_plan": "ಯೋಜನೆಯನ್ನು ಆರಿಸಿ",
        "instavc_admin_lastmodified": "ಕೊನೆಯದಾಗಿ ಮಾರ್ಪಡಿಸಲಾಗಿದೆ",
        "instavc_admin_email_verified": "ಇಮೇಲ್ ಪರಿಶೀಲಿಸಲಾಗಿದೆ",
        "instavc_admin_verified": "ಪರಿಶೀಲಿಸಲಾಗಿದೆ",
        "instavc_admin_Unverified": "ಪರಿಶೀಲಿಸಲಾಗಿಲ್ಲ",
        "instavc_admin_licenses": "ಪರವಾನಗಿಗಳು",
        "instavc_admin_addlicense": "ಪರವಾನಗಿಗಳನ್ನು ಸೇರಿಸಿ",
        "instavc_admin_defaultroom": "ಡೀಫಾಲ್ಟ್ ರೂಮ್",
        "instavc_admin_hostlicense": "ಹೋಸ್ಟ್ ಆಧಾರಿತ ಪರವಾನಗಿ",
        "instavc_admin_roomlicense": "ಕೊಠಡಿ ಆಧಾರಿತ ಪರವಾನಗಿ",
        "instavc_admin_virtualmcu": "ವರ್ಚುವಲ್ ಎಂಸಿಯು ಆಧಾರಿತ ಪರವಾನಗಿ",
        "instavc_admin_enterprise": "ಎಂಟರ್ಪ್ರೈಸ್ ಪರವಾನಗಿ",
        "instavc_mcuserver": "ಎಂಸಿಯು ಸರ್ವರ್",
        "instavc_mculink": "ಹ್ ಟಿ ಟಿ ಪಿ ಸ್://ಆ ಡಬ್ಲ್ಯೂ ಸ್ ಮ್ ಸಿ ಉ.ಇನ್ಸ್ಟಾವ್ಕ್.ಕಾಮ್",
        "instavc_admin_expirydate": "ಮುಕ್ತಾಯ ದಿನಾಂಕ",
        "instavc_admin_settings": "ನಿರ್ವಹಣೆ ಸೆಟ್ಟಿಂಗ್ಗಳು",
        "instavc_default_offer": "ರೆಫರಲ್ಗಾಗಿ ಡೀಫಾಲ್ಟ್ ಆಫರ್",
        "instavc_enter_coupon_code": "ಕೂಪನ್ ಕೋಡ್ ನಮೂದಿಸಿ",
        "instavc_current_partshare": "ಪ್ರಸ್ತುತ ಪಾಲುದಾರ ಹಂಚಿಕೆ",
        "instavc_share_value": "ಮೌಲ್ಯವನ್ನು ಹಂಚಿಕೊಳ್ಳಿ",
        "instavc_affliate_share": "ಪ್ರಸ್ತುತ ಅಂಗಸಂಸ್ಥೆ ಹಂಚಿಕೆ",
        "instavc_enter_share": "ಹಂಚಿಕೆ ಮೌಲ್ಯವನ್ನು ನಮೂದಿಸಿ (%)",
        "instavc_roomname": "ಕೋಣೆಯ ಹೆಸರು",
        "instavc_room_ten": "ಹತ್ತು",
        "instavc_room_twenty": "ಇಪ್ಪತ್ತು",
        "instavc_room_thirty": "ಮೂವತ್ತು",
        "instavc_room_hostbased": "ಹೋಸ್ಟ್ ಆಧಾರಿತ",
        "instavc_virtualmcu": "ವರ್ಚುವಲ್ ಎಂಸಿಯು",
        "instavc_rooms_enterprises": "ಎಂಟರ್ಪ್ರೈಸ್",
        "instavc_roomid": "ರೂಮ್ ಐಡಿ",
        "instavc_roomtype": "ಕೊಠಡಿ ಪ್ರಕಾರ",
        "instavc_room_options": "ಕೊಠಡಿ ಆಯ್ಕೆಗಳು",
        "instavc_commercetype": "ವಾಣಿಜ್ಯ ಪ್ರಕಾರ",
        "instavc_free": "ಉಚಿತ",
        "instavc_poc": "ಪಿಒಸಿ",
        "instavc_commerce": "ವಾಣಿಜ್ಯ",
        "instavc_createdAt": "ರಚಿಸಲಾಗಿದೆ",
        "instavc_useraccess": "ಬಳಕೆದಾರ ಪ್ರವೇಶ",
        "instavc_peoplelinkroom": "ಪೀಪಲ್ಲಿಂಕ್ ರೂಮ್",
        "instavc_inputlimit": "ಇನ್ಪುಟ್ ಮಿತಿ",
        "instavc_participant_limit": "ಭಾಗವಹಿಸುವವರ ಮಿತಿ",
        "instavc_adduser": "ಬಳಕೆದಾರರನ್ನು ಸೇರಿಸಿ",
        "instavc_searchbyname": "ಹೆಸರಿನಿಂದ ಹುಡುಕಿ",
        "instavc_manage_plans": "ಯೋಜನೆಗಳು / ಉತ್ಪನ್ನಗಳನ್ನು ನಿರ್ವಹಿಸಿ",
        "instavc_new_plans": "ಹೊಸ ಯೋಜನೆ / ಉತ್ಪನ್ನ",
        "instavc_allplan_list": "ಎಲ್ಲಾ ಯೋಜನೆಗಳ ಪಟ್ಟಿ",
        "instavc_sortby": "ವಿಂಗಡಿಸಿ",
        "instavc_active": "ಸಕ್ರಿಯ",
        "instavc_inactive": "ನಿಷ್ಕ್ರಿಯ",
        "instavc_create_plan": "ಹೊಸ ಯೋಜನೆಯನ್ನು ರಚಿಸಿ",
        "instavc_plan_name": "ಯೋಜನೆಯ ಹೆಸರು",
        "instavc_enteramount": "ಮೊತ್ತವನ್ನು ನಮೂದಿಸಿ (ಕನಿಷ್ಠ: ಐನ್ ರ್ 100)",
        "instavc_select_product": "ಉತ್ಪನ್ನವನ್ನು ಆರಿಸಿ",
        "instavc_host_room": "1 ಹೋಸ್ಟ್ / ರೂಮ್",
        "instavc_multiroom": "ಮಲ್ಟಿ ಹೋಸ್ಟ್ / ರೂಮ್",
        "instavc_legacyrooms": "ಲೆಗಸಿ ರೂಮ್",
        "instavc_number_hosts": "ಆತಿಥೇಯರ ಸಂಖ್ಯೆ",
        "instavc_number_participants": "ಭಾಗವಹಿಸುವವರ ಸಂಖ್ಯೆ",
        "instavc_number_room": "ಕೊಠಡಿಗಳ ಸಂಖ್ಯೆ",
        "instavc_subscriptiom_period": "ಚಂದಾದಾರಿಕೆ ಅವಧಿ",
        "instavc_sub_yearly": "ವಾರ್ಷಿಕ",
        "instavc_sub_monthly": "ಮಾಸಿಕ",
        "instavc_sub_weekly": "ಸಾಪ್ತಾಹಿಕ",
        "instavc_setinterval": "ಮಧ್ಯಂತರವನ್ನು ಹೊಂದಿಸಿ",
        "instavc_type": "ಕೌಟುಂಬಿಕತೆ",
        "instavc_subscription": "ಚಂದಾದಾರಿಕೆ",
        "instavc_ontime": "ಒಂದು ಬಾರಿ",
        "instavc_description": "ವಿವರಣೆ",
        "instavc_planid": "ಯೋಜನೆ ಐಡೀ",
        "instavc_orders": "ಆದೇಶಗಳು",
        "instavc_orderid": "ಆರ್ಡರ್ ಐಡಿ",
        "instavc_none": "ಯಾವುದೂ ಇಲ್ಲ",
        "instavc_customer": "ಗ್ರಾಹಕ",
        "instavc_build_anually": "ವಾರ್ಷಿಕವಾಗಿ ನಿರ್ಮಿಸಿ",
        "instavc_recurring_billing": "ಮರುಕಳಿಸುವ ಬಿಲ್ಲಿಂಗ್",
        "instavc_next_due": "ಮುಂದಿನ ಕಾರಣ",
        "instavc_invoice_details": "ಇನ್ವಾಯ್ಸ್ ವಿವರ",
        "instavc_recurring_payment": "ಮರುಕಳಿಸುವ ಪಾವತಿ",
        "instavc_todays_sale": "ಇಂದಿನ ಮಾರಾಟ",
        "instavc_total_order": "ಒಟ್ಟು ಆದೇಶಗಳು",
        "instavc_total_rooms": "ಒಟ್ಟು ಕೊಠಡಿಗಳು",
        "instavc_current_conference": "ಪ್ರಸ್ತುತ ಸಮಾವೇಶಗಳು",
        "instavc_current_user": "ಪ್ರಸ್ತುತ ಬಳಕೆದಾರರು",
        "instavc_live_broadcast": "ಲೈವ್ ಪ್ರಸಾರಗಳು",
        "instavc_loading_chart": "ಚಾರ್ಟ್ ಲೋಡ್ ಆಗುತ್ತಿದೆ",
        "instavc_view": "ವೀಕ್ಷಿಸಿ",
        "instavc_coupon_info": "ಕೂಪನ್ ಮಾಹಿತಿ",
        "instavc_new_coupon": "ಹೊಸ ಕೂಪನ್",
        "instavc_create_coupon": "ಹೊಸ ಕೂಪನ್ ರಚಿಸಿ",
        "instavc_coupon_code": "ಕೂಪನ್ ಕೋಡ್",
        "instavc_company_code": "ಕಂಪನಿ ಕೋಡ್",
        "instavc_select_plan": "ಯೋಜನೆಗಳನ್ನು ಆರಿಸಿ",
        "instavc_discount": "ರಿಯಾಯಿತಿ",
        "instavc_activestatus": "ಸಕ್ರಿಯ ಸ್ಥಿತಿ",
        "instavc_usage": "ಬಳಕೆ",
        "instavc_activeusage": "ಸಕ್ರಿಯ ಬಳಕೆ",
        "instavc_singleuse": "ಏಕ ಬಳಕೆ",
        "instavc_multiuse": "ಬಹು ಬಳಕೆ",
        "instavc_first_page": "ಮೊದಲ ಪುಟ",
        "instavc_previosu_page": "ಹಿಂದಿನ ಪುಟ",
        "instavc_next_page": "ಮುಂದಿನ ಪುಟ",
        "instavc_last_page": "ಕೊನೆಯ ಪುಟ",
        "instavc_plan": "ಯೋಜನೆ",
        "instavc_request_withdrawal": "ಹಿಂತೆಗೆದುಕೊಳ್ಳುವಿಕೆಯನ್ನು ವಿನಂತಿಸಿ",
        "instavc_withdraw": "ಹಿಂತೆಗೆದುಕೊಳ್ಳಿ",
        "instavc_account": "ಖಾತೆ",
        "instavc_verification": "ಪರಿಶೀಲನೆ",
        "instavc_withdraw_history": "ಇತಿಹಾಸವನ್ನು ಹಿಂತೆಗೆದುಕೊಳ್ಳಿ",
        "instavc_add_bank": "ವಾಪಸಾತಿಗಾಗಿ ಬ್ಯಾಂಕ್ ಖಾತೆಯನ್ನು ಸೇರಿಸಿ",
        "instavc_bank_description" : "ನಿಮ್ಮ ಹಣಕಾಸಿನ ಮಾಹಿತಿಯನ್ನು ಗೌಪ್ಯವಾಗಿಡುವ ಮೂಲಕ ನಾವು ನಿಮ್ಮ ಬ್ಯಾಂಕ್ ಖಾತೆಯನ್ನು ರಕ್ಷಿಸುತ್ತೇವೆ. ಈ ಖಾತೆಯಿಂದ ಹಿಂಪಡೆಯಲು ನಾವು ವಿನಂತಿಯನ್ನು ಸ್ವೀಕರಿಸಿದಾಗಲೆಲ್ಲಾ ನಾವು ನಿಮಗೆ ಸ್ಥಿತಿಯನ್ನು ಇಮೇಲ್ ಮಾಡುತ್ತೇವೆ. ವಾಪಸಾತಿ ವೈಫಲ್ಯಗಳು ಮತ್ತು ರಿಟರ್ನ್ ಮೊತ್ತವನ್ನು ತಪ್ಪಿಸಲು, ಈ ಖಾತೆಯ ಹೆಸರು ನಿಮ್ಮ ಬ್ಯಾಂಕ್ ಖಾತೆಯ ಹೆಸರಿಗೆ ಹೊಂದಿಕೆಯಾಗಬೇಕು. ನಿಮ್ಮ ಬ್ಯಾಂಕಿನ ನೀತಿಗಳು ಮತ್ತು ರಜಾ ವೇಳಾಪಟ್ಟಿಗಳನ್ನು ಅವಲಂಬಿಸಿ ವರ್ಗಾವಣೆಯನ್ನು ಪೂರ್ಣಗೊಳಿಸಲು ಸ್ವಲ್ಪ ಸಮಯ ತೆಗೆದುಕೊಳ್ಳಬಹುದು",
        "instavc_bank_accountnumber": "ಬ್ಯಾಂಕ್ ಖಾತೆ ಸಂಖ್ಯೆ",
        "instavc_enter_accountnumber": "ನಿಮ್ಮ ಖಾತೆ ಸಂಖ್ಯೆಯನ್ನು ನಮೂದಿಸಿ",
        "instavc_account_name": "ಖಾತೆದಾರರ ಹೆಸರು",
        "instavc_per_bank_account": "ಬ್ಯಾಂಕ್ ಖಾತೆಯ ಪ್ರಕಾರ",
        "instavc_ifsc": "ಐಎಫ್‌ಎಸ್‌ಸಿ ಕೋಡ್",
        "instavc_bankname": "ಬ್ಯಾಂಕ್ ಹೆಸರು",
        "instavc_branchname": "ಬ್ಯಾಂಕ್ ಶಾಖೆಯ ಹೆಸರು",
        "instavc_confirmdetails": "ವಿವರಗಳನ್ನು ದೃಢೀಕರಿಸಿ",
        "instavc_pandetails": "ದಯವಿಟ್ಟು ನಿಮ್ಮ ಪ್ಯಾನ್ ಪ್ರಕಾರ ಕೆಳಗಿನ ವಿವರಗಳನ್ನು ನೀಡಿ",
        "instavc_enter_pan": "ಪ್ಯಾನ್ ಪ್ರಕಾರ ನಿಮ್ಮ ಹೆಸರನ್ನು ನಮೂದಿಸಿ",
        "instavc_fathername": "ತಂದೆಯ ಹೆಸರು",
        "instavc_enter_fathername": "ತಂದೆಯ ಹೆಸರನ್ನು ನಮೂದಿಸಿ",
        "instavc_pannumber": "ಪ್ಯಾನ್ ಸಂಖ್ಯೆ",
        "instavc_panexampe": "ಉದಾ: ಬೀ ನ್ ಜ಼್ ಪೀ ಎಮ್2501  ಜೀ",
        "instavc_upload_pan_copy": "ಪ್ಯಾನ್ ನಕಲನ್ನು ಅಪ್ಲೋಡ್ ಮಾಡಿ",
        "instavc_save_details": "ವಿವರಗಳನ್ನು ಉಳಿಸಿ",
        "instavc_sales": "ಮಾರಾಟ",
        "instavc_transactionid": "ವಹಿವಾಟು ಐಡಿ",
        "instavc_date": "ದಿನಾಂಕ",
        "instavc_amount": "ಮೊತ್ತ",
        "instavc_setaccount_withdraw": "ವಾಪಸಾತಿಗೆ ಮೊದಲು ಖಾತೆ ವಿವರಗಳನ್ನು ಹೊಂದಿಸಿ",
        "instavc_first_withdraw": "ನೀವು ಮೊದಲ ಬಾರಿಗೆ ಹಿಂತೆಗೆದುಕೊಳ್ಳಲು ಬಳಕೆದಾರರಾಗಿದ್ದರೆ, ನೀವು ಖಾತೆಯ ವಿವರಗಳನ್ನು ಭರ್ತಿ ಮಾಡಬೇಕು ಮತ್ತು ಮುಂದಿನ ಟ್ಯಾಬ್‌ಗಳಲ್ಲಿ ಪ್ಯಾನ್ ಕಾರ್ಡ್ ವಿವರಗಳನ್ನು ಬಳಸಿಕೊಂಡು ನಿಮ್ಮ ಖಾತೆಯನ್ನು ಪರಿಶೀಲಿಸಬೇಕು. ಪರಿಶೀಲನೆಯೊಂದಿಗೆ ನೀವು ಪೂರ್ಣಗೊಳಿಸಿದ ನಂತರ, ನಿಮ್ಮ ಲಭ್ಯವಿರುವ ಬಾಕಿ ಮೊತ್ತದಿಂದ ಹಿಂತೆಗೆದುಕೊಳ್ಳಲು ನೀವು ವಿನಂತಿಸಲು ಮುಂದುವರಿಯಬಹುದು. ",
        "instavc_accountdetails": "ಖಾತೆ ವಿವರಗಳನ್ನು ಭರ್ತಿ ಮಾಡಿ",
        "instavc_available_balance": "ಲಭ್ಯವಿರುವ ಬ್ಯಾಲೆನ್ಸ್",
        "instavc_amount_withdraw": "ಹಿಂತೆಗೆದುಕೊಳ್ಳುವ ಮೊತ್ತ",
        "instavc_enteramount_withdraw": "ನೀವು ಹಿಂತೆಗೆದುಕೊಳ್ಳಲು ಬಯಸುವ ಮೊತ್ತವನ್ನು ನಮೂದಿಸಿ",
        "instavc_select_payment_mode": "ಪಾವತಿ ಮೋಡ್ ಆಯ್ಕೆಮಾಡಿ",
        "instavc_paypal_payment": "ಪೇಪಾಲ್ ಪಾವತಿ",
        "instavc_bank_transaction": "ಬ್ಯಾಂಕ್ ವ್ಯವಹಾರ",
        "instavc_paypalfee": "ಪೇಪಾಲ್ ಶುಲ್ಕ",
        "instavc_totalamount_withdraw": "ಹಿಂತೆಗೆದುಕೊಳ್ಳುವ ಒಟ್ಟು ಮೊತ್ತ",
        "instavc_sendrequest": "ವಿನಂತಿಯನ್ನು ಕಳುಹಿಸಿ",
        "instavc_no_request_withdraw": "ಹಿಂತೆಗೆದುಕೊಳ್ಳುವಿಕೆಗೆ ಇನ್ನೂ ಯಾವುದೇ ವಿನಂತಿಗಳಿಲ್ಲ!",
        "instavc_start_process_withdraw": "ಕೆಳಗಿನಿಂದ ಹಿಂತೆಗೆದುಕೊಳ್ಳಲು ನೀವು ಪ್ರಕ್ರಿಯೆಯನ್ನು ಪ್ರಾರಂಭಿಸಬಹುದು.",
        "instavc_request_withdraw_now": "ಈಗ ಹಿಂತೆಗೆದುಕೊಳ್ಳಲು ವಿನಂತಿ",
        "instavc_current_commission": "ಪ್ರಸ್ತುತ ಆಯೋಗ",
        "instavc_from": "ನಿಂದ",
        "instavc_to": "ಗೆ",
        "instavc_today": "ನಿಂದ",
        "instavc_last7days": "ಕೊನೆಯ 7 ದಿನಗಳು",
        "instavc_lastmonth": "ಈ ತಿಂಗಳು",
        "instavc_paid_customers": "ಪಾವತಿಸಿದ ಗ್ರಾಹಕರು",
        "instavc_share_referral_link": "ನಿಮ್ಮ ಉಲ್ಲೇಖಿತ ಲಿಂಕ್ ಅನ್ನು ಸ್ನೇಹಿತರೊಂದಿಗೆ ಹಂಚಿಕೊಳ್ಳಿ",
        "instavc_copylink": "ಲಿಂಕ್ ನಕಲಿಸಿ",
        "instavc_minimum_payout": "ಕನಿಷ್ಠ ಪಾವತಿ",
        "instavc_referral_signup": "ರೆಫರಲ್ ಸೈನ್ ಅಪ್ಗಳು",
        "instavc_referral_clicks": "ರೆಫರಲ್ ಕ್ಲಿಕ್ಗಳು",
        "instavc_paid": "ಪಾವತಿಸಲಾಗಿದೆ",
        "instavc_unpaid": "ಪಾವತಿಸಲಾಗಿಲ್ಲ",
        "instavc_totalearned": "ಒಟ್ಟು ಗಳಿಸಿದ",
        "instavc_myreferral": "ನನ್ನ ಉಲ್ಲೇಖಗಳು",
        "instavc_viewall": "ಎಲ್ಲವನ್ನೂ ವೀಕ್ಷಿಸಿ",
        "instavc_mysales": "ನನ್ನ ಮಾರಾಟ",
        "instavc_sms_mfa": "ಎಸ್‌ಎಂಎಸ್ ಎಂಎಫ್‌ಎ ಸ್ಥಿತಿ",
        "instavc_facebook": "ಫೇಸ್ಬುಕ್",
        "instavc_twitter": "ಟ್ವಿಟರ್",
        "instavc_linkedin": "ಲಿಂಕ್ಡ್ಇನ್",
        "instavc_referred_users": "ಉಲ್ಲೇಖಿತ ಬಳಕೆದಾರರು",
        "instavc_created_date": "ರಚಿಸಿದ ದಿನಾಂಕ",
        "instavc_myearnings": "ನನ್ನ ಗಳಿಕೆಗಳು",
        "instavc_earnings": "ಗಳಿಕೆಗಳು",
        "instavc_commission_share": "ಆಯೋಗದ ಹಂಚಿಕೆ",
        "instavc_commission_percentage": "ಆಯೋಗದ ಶೇಕಡಾವಾರು",
        "instavc_coupon_offers": "ಕೂಪನ್ಗಳು / ಕೊಡುಗೆಗಳು",
        "instavc_my_referral_account": "ನನ್ನ ರೆಫರಲ್ ಖಾತೆ",
        "instavc_req_withdraw": "ಹಿಂತೆಗೆದುಕೊಳ್ಳಲು ವಿನಂತಿ",
        "instavc_authenticating": "ಆತೆಂಟಿಕೇಟಿಂಗ್ ಟು ಇನ್‌ಸ್ತವೀಸೀ   ಸರ್ವರ್...",
        "instavc_join_access_media": "ಸೇರಿಕೊಂಡರು .. ಮಾಧ್ಯಮ ಸಾಧನಗಳನ್ನು ಪ್ರವೇಶಿಸಲಾಗುತ್ತಿದೆ ...",
        "instavc_publish_success": "ಪ್ರಕಟಣೆ ಯಶಸ್ವಿಯಾಗಿದೆ",
        "instavc_recieves": 'ಸ್ವೀಕರಿಸುತ್ತದೆ',
        "instavc_host_screenshare": "ನೀವು ಪರದೆ / ಡಾಕ್ಯುಮೆಂಟ್ ಹಂಚಿಕೆಗಾಗಿ ಹೋಸ್ಟ್ ಆಗಬೇಕು ಅಥವಾ",
        "instavc_request_sharescreen": "ಪರದೆ / ಡಾಕ್ಯುಮೆಂಟ್ ಹಂಚಿಕೆಗಾಗಿ ಪ್ರವೇಶವನ್ನು ವಿನಂತಿಸಿ",
        "instavc_note": "ಗಮನಿಸಿ",
        "instavc_filesize": "ಫೈಲ್ ಗಾತ್ರವು 10ಎಂಬಿ ಗಿಂತ ಹೆಚ್ಚಿರಬಾರದು",
        "instavc_become_host": "ಹೋಸ್ಟ್ ಆಗಲು ವೀಡಿಯೊದಲ್ಲಿನ ಡಾಟ್ ಓವರ್‌ಫ್ಲೋ ಮೆನು ಐಕಾನ್ ಕ್ಲಿಕ್ ಮಾಡಿ",
        "instavc_clicklink": "ಪಾಪ್ಅಪ್ನಲ್ಲಿ ಹೋಸ್ಟ್ ಲಿಂಕ್ ಆಗಲು ಕ್ಲಿಕ್ ಮಾಡಿ ಮತ್ತು ಹೋಸ್ಟ್ ಪಾಸ್ವರ್ಡ್ ಅನ್ನು ನಮೂದಿಸಿ ಮತ್ತು ಹೋಸ್ಟ್ ಬಟನ್ ಆಗಲು ಕ್ಲಿಕ್ ಮಾಡಿ",
        "instavc_doc_share": "ಡಾಕ್ಯುಮೆಂಟ್ ಹಂಚಿಕೆ",
        "instavc_search_host": "ಹೋಸ್ಟ್ಗಾಗಿ ಕಾಯಲಾಗುತ್ತಿದೆ",
        "instavc_night_for_host": "ದಯವಿಟ್ಟು ಈ ಸಭೆಯನ್ನು ಪ್ರಾರಂಭಿಸಲು ಹೋಸ್ಟ್ ಕಾಯಿರಿ",
        "instavc_open_black_dialog": "ಕಪ್ಪು ಸಂವಾದವನ್ನು ತೆರೆಯಿರಿ",
        "instavc_open_white_dialog": "ಬಿಳಿ ಸಂವಾದವನ್ನು ತೆರೆಯಿರಿ",
        "instavc_dail_detail": "ಡಯಲ್ - ಇನ್ - ವಿವರಗಳು",
        "instavc_request_access": "ಪ್ರವೇಶವನ್ನು ವಿನಂತಿಸಿ",
        "instavc_inordder_enable": "ಸಕ್ರಿಯಗೊಳಿಸಲು",
        "instavc_host_permission": "ನಿಮಗೆ ಹೋಸ್ಟ್ನಿಂದ ಪ್ರವೇಶ ಅನುಮತಿ ಬೇಕು",
        "instavc_host_to_permit": "(ಹೋಸ್ಟ್) ಗೆ ಅನುಮತಿ",
        "instavc_alternate_content": "ಪರ್ಯಾಯ ವಿಷಯ",
        "instavc_meeting_room": "ಸಭೆ ಕೊಠಡಿ",
        "instavc_host_left_conference": "ಆತಿಥೇಯರು ಸಮ್ಮೇಳನವನ್ನು ತೊರೆದರು!",
        "instavc_conf_end": "ಸಮ್ಮೇಳನವು ಸ್ವಯಂಚಾಲಿತವಾಗಿ ಕೊನೆಗೊಳ್ಳುತ್ತದೆ",
        "instavc_seconds": "ಸೆಕೆಂಡ್ಸ್",
        "instavc_nighting_msg": "ಕಾಯುತ್ತಿದ್ದಕ್ಕಾಗಿ ಧನ್ಯವಾದಗಳು. ಹೋಸ್ಟ್ ಸೇರಿದಾಗ ನಾವು ಸಭೆಯನ್ನು ಪ್ರಾರಂಭಿಸುತ್ತೇವೆ",
        "instavc_let_hostname": "ನೀವು ಕಾಯುತ್ತಿರುವುದನ್ನು ಹೋಸ್ಟ್ಗೆ ತಿಳಿಸಲು ನೀವು ಬಯಸುವಿರಾ?",
        "instavc_exitconf": "ಸಮ್ಮೇಳನದಿಂದ ನಿರ್ಗಮಿಸಿ",
        "instavc_host_left": "ಹೋಸ್ಟ್ ಲೆಫ್ಟ್...",
        "instavc_end_host_msg": "ಹೋಸ್ಟ್ ಈ ಸಭೆಯನ್ನು ಕೊನೆಗೊಳಿಸಿದೆ. ಭಾಗವಹಿಸಿದ್ದಕ್ಕಾಗಿ ಧನ್ಯವಾದಗಳು.",
        "instavc_close_conf": "ಯೂ ಕ್ಯಾನ್ ಗೊ ಬ್ಯಾಕ್ ಟು ಹೋಮ್ (ಆರ್) ಕ್ಲೋಸ್ ದ ಅಪ್ಲಿಕೇಶನ್.",
        "instavc_gohome": "ಗೊ ಟು ಹೋಮ್",
        "instavc_hand_raised": "ಕೈ ಎತ್ತಲಾಗಿದೆ",
        "instavc_ask": "ಕೇಳಿ",
        "instavc_protocal": "ಪ್ರೊಟೊಕಾಲ್",
        "instavc_bitrate": "ಬಿಟ್ರೇಟ್",
        "instavc_confirm_details": "ನಿಮ್ಮ ವಿವರಗಳನ್ನು ಖಚಿತಪಡಿಸಿ",
        "instavc_enter_info_conf": "ಸಮ್ಮೇಳನವನ್ನು ಪ್ರಾರಂಭಿಸುವ ಮೊದಲು ದಯವಿಟ್ಟು ನಿಮ್ಮ ಮಾಹಿತಿಯನ್ನು ನಮೂದಿಸಿ.",
        "instavc_have_acc": "ನೀವು ಈಗಾಗಲೇ ಖಾತೆಯನ್ನು ಹೊಂದಿದ್ದರೆ?",
        "instavc_host_access": "ಹೋಸ್ಟ್ ಪ್ರವೇಶ",
        "instavc_host_pass": "ಹೋಸ್ಟ್ ಪಾಸ್ವರ್ಡ್ ನಮೂದಿಸಿ",
        "instavc_becomehost": "ಹೋಸ್ಟ್ ಆಗಿ",
        "instavc_permit_screenshare": "ಸ್ಕ್ರೀನ್ ಹಂಚಿಕೊಳ್ಳಲು ಅನುಮತಿ",
        "instavc_allow_access": "ವೈಟ್ಬೋರ್ಡ್ ಪ್ರವೇಶವನ್ನು ಅನುಮತಿಸಿ",
        "instavc_request_permission": "ಹೆಚ್ಚುವರಿ ಅನುಮತಿಗಳನ್ನು ಕೋರಿದೆ",
        "instavc_deny": "ನಿರಾಕರಿಸು",
        //"instavc_planid": "ಪ್ಲ್ಯಾನ್ಐಡ್",
        "instavc_customeremail": "ಗ್ರಾಹಕರ ಇಮೇಲ್",
        "instavc_orderlink": 'ಆರ್ಡರ್ ಲಿಂಕ್',
        "instavc_customerid": " ಗ್ರಾಹಕರ ಐಡಿ",
        "instavc_selectpackage": "ಪ್ಯಾಕೇಜ್ ಆಯ್ಕೆಮಾಡಿ",
        "instavc_host_package": "ಹೋಸ್ಟ್ ಆಧಾರಿತ ಪ್ಯಾಕೇಜ್",
        "instavc_virtualbase_mcu": "ವರ್ಚುವಲ್ ಎಂಸಿಯು ಆಧಾರಿತ",
        "instavc_plans_product": "ಯೋಜನೆಗಳು / ಉತ್ಪನ್ನಗಳು",
        "instavc_nodata": "ಡೇಟಾ ಲಭ್ಯವಿಲ್ಲ",
        "instavc_nodata_msg": "ಓಹ್! ಇದೀಗ ನಿಮಗೆ ತೋರಿಸಲು ಯಾವುದೇ ಡೇಟಾ ಲಭ್ಯವಿಲ್ಲ.",
        "instavc_basicplan": "ಮೂಲ ಯೋಜನೆ",
        "instavc_host_participants": " 1 ಹೋಸ್ಟ್ ವಿತ್ 30 ಪಾರ್ಟಿಸಿಪೆಂಟ್ಸ್",
        "instavc_link": "ಲಿಂಕ್",
        "instavc_cancel_order": "ಆದೇಶವನ್ನು ರದ್ದುಮಾಡು",
        "instavc_per": "ಪರ್",
        "instavc_user_email": "ಬಳಕೆದಾರ ಇಮೇಲ್",
        "instavc_owner": "ಮಾಲೀಕ",
        "instavc_user": "ಬಳಕೆದಾರ",
        "instavc_default_users": "ಡಿಫಾಲ್ಟ್ ಆಫರ್ಸ್",
        "instavc_system_settings": "ಸಿಸ್ಟಮ್ ಸೆಟ್ಟಿಂಗ್ಗಳು",
        "instavc_expires": "ಅವಧಿ ಮೀರುತ್ತದೆ",
        "instavc_start_VC": "ವೀಡಿಯೊ ಕಾನ್ಫರೆನ್ಸ್ ಪ್ರಾರಂಭಿಸಿ",
        "instavc_start_AC": "ಆಡಿಯೋ ಸಮ್ಮೇಳನವನ್ನು ಪ್ರಾರಂಭಿಸಿ",
        "instavc_date_error": "ಪ್ರಾರಂಭ ದಿನಾಂಕ ಮತ್ತು ಸಮಯವು ಪ್ರಸ್ತುತ ಸಮಯಕ್ಕಿಂತ ಹೆಚ್ಚಾಗಿರಬೇಕು",
        "instavc_browser_update": "ಬ್ರೌಸರ್ ನವೀಕರಣ ಅಗತ್ಯವಿದೆ",
        "instavc_browser_note": "ನೀವು ಬ್ರೌಸರ್ ನೇಮ್ ನ ಹಳೆಯ ಆವೃತ್ತಿಯನ್ನು ಬಳಸುತ್ತಿರುವುದನ್ನು ನಾವು ಗಮನಿಸಿದ್ದೇವೆ, ಅದು ಈಗ ಬೆಂಬಲಿತವಾಗಿಲ್ಲ.",
        "instavc_browser_msg": "ಇನ್ಸ್ತ ವೀಸೀ.ಕಾಮ್ ಗೆ ಬ್ರೌಸರ್ ನೇಮ್ ಅಥವಾ ಇತರ ಯಾವುದೇ ಆಧುನಿಕ ಬ್ರೌಸರ್ಗಳ ನವೀಕರಿಸಿದ ಆವೃತ್ತಿ ಅಗತ್ಯವಿದೆ.",
        "instavc_browser_upgrade": "ಉತ್ತಮ ಅನುಭವಕ್ಕಾಗಿ ದಯವಿಟ್ಟು ಈ ಬ್ರೌಸರ್ಗಳ ಯಾವುದೇ ಇತ್ತೀಚಿನ ಆವೃತ್ತಿಗಳಿಗೆ ಅಪ್ಗ್ರೇಡ್ ಮಾಡಿ.",
        "instavc_googlechrome": "ಗೂಗಲ್ ಕ್ರೋಮ್",
        "instavc_gc_version74": "ಆವೃತ್ತಿ 74",
        "instavc_mfirefox": "ಮೊಜಿಲ್ಲಾ ಫೈರ್ಫಾಕ್ಸ್",
        "instavc_mff_version": "ಆವೃತ್ತಿ 66",
        "instavc_opera": "ಒಪೇರಾ",
        "instavc_opera_version": "ಆವೃತ್ತಿ 60.0+",
        "instavc_microsoftedge": "ಮೈಕ್ರೋಸಾಫ್ಟ್ ಎಡ್ಜ್",
        "instavc_ms_version": "ಆವೃತ್ತಿ 44+",
        "instavc_safari": "ಆಪಲ್ ಸಫಾರಿ",
        "instavc_safari_version": "ಆವೃತ್ತಿ 12.1",
        "instavc_contact_msg": "ಈಗಾಗಲೇ ನವೀಕರಿಸಲಾಗಿದೆ, ಆದರೆ ಇನ್ನೂ ಸಮಸ್ಯೆ ಇದೆ? ನಮ್ಮನ್ನು ಸಂಪರ್ಕಿಸಿ",
        "instavc_camera_busy": "ಕ್ಯಾಮೆರಾ ಕಾರ್ಯನಿರತವಾಗಿದೆ ಎಂದು ತೋರುತ್ತದೆ!",
        "instavc_close_camera": "ದಯವಿಟ್ಟು ಎಲ್ಲಾ ಅಪ್ಲಿಕೇಶನ್ಗಳನ್ನು ಮುಚ್ಚಿ ಮತ್ತೆ ಪ್ರಯತ್ನಿಸಿ.",
        "instavc_resolution": "ರೆಸಲ್ಯೂಶನ್ ಬೆಂಬಲಿಸುವುದಿಲ್ಲ!",
        "instavc_camera_notsupport": "ನಿಮ್ಮ ಕ್ಯಾಮೆರಾ ಈ ರೆಸಲ್ಯೂಶನ್ ಅನ್ನು ಬೆಂಬಲಿಸುವುದಿಲ್ಲ.",
        "instavc_camera_reconfig": "ನಿಮ್ಮ ಸೆಟ್ಟಿಂಗ್ಗಳನ್ನು ಕಡಿಮೆ ರೆಸಲ್ಯೂಶನ್ನೊಂದಿಗೆ ಮರು ಸಂರಚಿಸಿ ಮತ್ತು ಮತ್ತೆ ಪ್ರಯತ್ನಿಸಿ.",
        "instavc_change_resolution": "ರೆಸಲ್ಯೂಶನ್ ಬದಲಾಯಿಸಿ",
        "instavc_confirmation": "ದೃಢೀಕರಣ",
        "instavc_yes": "ಹೌದು",
        "instavc_delete_room": "ಕೊಠಡಿಯನ್ನು ಅಳಿಸಲು ನೀವು ಖಚಿತವಾಗಿ ಬಯಸುವಿರಾ?",
        "instavc_delete_license": "ಪರವಾನಗಿಯನ್ನು ಅಳಿಸಲು ನೀವು ಖಚಿತವಾಗಿ ಬಯಸುವಿರಾ?",
        "instavc_help": "ನಿಮಗೆ ಸಹಾಯ ಮಾಡಲು ನಾವು ಇಲ್ಲಿದ್ದೇವೆ",
        "instavc_browse_questions": "ಹೆಚ್ಚಾಗಿ ಕೇಳಲಾಗುವ ಪ್ರಶ್ನೆಗಳ ಮೂಲಕ ಬ್ರೌಸ್ ಮಾಡಿ.",
        "instavc_os": "ಆಪರೇಟಿಂಗ್ ಸಿಸ್ಟಮ್",
        "instavc_macos": "ಮ್ಯಾಕ್ ಒಎಸ್ ಎಕ್ಸ್ ಆವೃತ್ತಿ:",
        "instavc_chrome_version": "ಕ್ರೋಮ್ ಆವೃತ್ತಿ:",
        "instavc_private_browsing": "ಖಾಸಗಿ ಬ್ರೌಸಿಂಗ್?",
        "instavc_faq_no": "ಇಲ್ಲ",
        "instavc_display_resolution": "ಇನ್ಸ್ತ ವೀಸೀ_ಡಿಸ್‌ಪ್ಲೇ_ರೆಸಲ್ಯೂಶನ್",
        "instavc_aspect_ratio": "ಆಕಾರ ಅನುಪಾತವನ್ನು ಪ್ರದರ್ಶಿಸಿ",
        "instavc_sys_hasspeakers": "ಸಿಸ್ಟಮ್ ಸ್ಪೀಕರ್ಗಳನ್ನು ಹೊಂದಿದೆ?",
        "instavc_found_speakers": "ಸ್ಪೀಕರ್ ಸಾಧನಗಳು ಕಂಡುಬಂದಿವೆ: 2",
        "instavc_speakers1": "ಸ್ಪೀಕರ್ 1",
        "instavc_speakers2": "ಸ್ಪೀಕರ್ 2",
        "instavc_sys_have_microphone": "ಸಿಸ್ಟಮ್ ಮೈಕ್ರೊಫೋನ್ ಹೊಂದಿದೆ?",
        "instavc_found_microphone": "ಮೈಕ್ರೊಫೋನ್ ಸಾಧನಗಳು ಕಂಡುಬಂದಿವೆ: 2",
        "instavc_microphone1": "ಮೈಕ್ರೊಫೋನ್ 1",
        "instavc_microphone2": "ಮೈಕ್ರೊಫೋನ್ 2",
        "instavc_has_webcam": "ಸಿಸ್ಟಮ್ ವೆಬ್ಕ್ಯಾಮ್ ಹೊಂದಿದೆ?",
        "instavc_found_speakers1": "ಸ್ಪೀಕರ್ ಸಾಧನಗಳು ಕಂಡುಬಂದಿವೆ: 1",
        "instavc_camera1": "ಕ್ಯಾಮೆರಾ 1",
        "instavc_webcam_permission": "ವೆಬ್‌ಸೈಟ್ ವೆಬ್‌ಕ್ಯಾಮ್ ಅನುಮತಿಗಳನ್ನು ಹೊಂದಿದೆಯೇ?",
        "instavc_microphone_permission": "ವೆಬ್‌ಸೈಟ್ ಮೈಕ್ರೊಫೋನ್ ಅನುಮತಿಗಳನ್ನು ಹೊಂದಿದೆಯೇ?",
        "instavc_browser_allows": "ಈ ಪುಟದಲ್ಲಿ ಬಳಕೆದಾರ ಮಾಧ್ಯಮವನ್ನು ಪಡೆಯಲು ಬ್ರೌಸರ್ ಅನುಮತಿಸುತ್ತದೆಯೇ?",
        "instavc_change_output_device": "ನೀವು ಔಟ್‌ಪುಟ್ ಆಡಿಯೊ ಸಾಧನಗಳನ್ನು ಬದಲಾಯಿಸಬಹುದೇ?",
        "instavc_change_camera_resolutions": "ಹೊಸ ಬಳಕೆದಾರ ಬಳಕೆದಾರ ವಿನಂತಿಗಳನ್ನು ಮಾಡದೆ ನೀವು ಕ್ಯಾಮೆರಾ ನಿರ್ಣಯಗಳನ್ನು ಬದಲಾಯಿಸಬಹುದೇ?",
        "instavc_browser_support_webrtc": "ಬ್ರೌಸರ್ ವೆಬ್ಆರ್ಟಿಸಿಯನ್ನು ಬೆಂಬಲಿಸುತ್ತದೆ (ಒಂದೋ 1.0 ಅಥವಾ 1.1)?",
        "instavc_browser_support_ortc": "ಬ್ರೌಸರ್ ಒ ಆರ್ ಟಿ ಸಿ(ವೆಬ್ಆರ್ಟಿಸಿ 1.1) ಅನ್ನು ಬೆಂಬಲಿಸುತ್ತದೆ?",
        "instavc_initial_setup": "ನಿಮ್ಮ ಆರಂಭಿಕ ಸೆಟಪ್ ಪ್ರಕ್ರಿಯೆಗೊಳ್ಳುತ್ತಿರುವಾಗ ದಯವಿಟ್ಟು ಕಾಯಿರಿ!",
        "instavc_close_browser": "ಈ ಸಮಯದಲ್ಲಿ ನಿಮ್ಮ ಬ್ರೌಸರ್ ಅನ್ನು ಮುಚ್ಚಬೇಡಿ ಅಥವಾ ಹಿಂದಿನ ಗುಂಡಿಯನ್ನು ಬಳಸಬೇಡಿ.",
        "instavc_whoops": "ಓಹ್!",
        "instavc_nonet_msg": "ಇಂಟರ್ನೆಟ್ ಸಂಪರ್ಕವಿಲ್ಲ. ದಯವಿಟ್ಟು ನಿಮ್ಮ ಸಂಪರ್ಕವನ್ನು ಪರಿಶೀಲಿಸಿ ಅಥವಾ ಮತ್ತೆ ಪ್ರಯತ್ನಿಸಿ.",
        "instavc_nosearch": "ಯಾವುದೇ ಹುಡುಕಾಟ ಫಲಿತಾಂಶಗಳು ಕಂಡುಬಂದಿಲ್ಲ",
        "instavc_noserchmsg": "ನಿಮ್ಮ ಹುಡುಕಾಟಕ್ಕೆ ಹೊಂದಿಕೆಯಾಗುವ ಯಾವುದೇ ಐಟಂ ನಮಗೆ ಸಿಗುತ್ತಿಲ್ಲ.",
        "instavc_nosearch_filter": "ನೀವು ಹುಡುಕುತ್ತಿರುವುದನ್ನು ಕಂಡುಹಿಡಿಯಲು ನಿಮ್ಮ ಹುಡುಕಾಟ ಅಥವಾ ಫಿಲ್ಟರ್ ಅನ್ನು ಹೊಂದಿಸಲು ಪ್ರಯತ್ನಿಸಿ.",
        "instavc_gotohoem_page": "ಮುಖಪುಟಕ್ಕೆ ಹೋಗಿ",
        "instavc_pageloading": "ಪುಟ ಲೋಡ್ ಆಗುತ್ತಿದೆ ... ದಯವಿಟ್ಟು ನಿರೀಕ್ಷಿಸಿ!",
        "instavc_process": "ಪ್ರಕ್ರಿಯೆ ...",
        "instavc_session_timeout": "ಸೆಷನ್ ಕಾಲಾವಧಿ",
        "instavc_session_inactivity": "ನಿಷ್ಕ್ರಿಯತೆಯಿಂದಾಗಿ ನಿಮ್ಮ ಅಧಿವೇಶನವು ಸಮಯ ಮೀರಿದೆ.",
        "instavc_session_msg": "ದಯವಿಟ್ಟು ಸೈನ್ ಇನ್ ಆಗಲು ಆಯ್ಕೆಮಾಡಿ.",
        "instavc_session_reconnect": "ಮರುಸಂಪರ್ಕಿಸು",
        "instavc_site_notreached": 'ಈ ಸೈಟ್ ಅನ್ನು ತಲುಪಲಾಗುವುದಿಲ್ಲ!',
        "instavc_site_webaddress": "ನಿಮಗೆ ಸರಿಯಾದ ವೆಬ್ ವಿಳಾಸ ಸಿಕ್ಕಿದೆಯೆ ಎಂದು ಖಚಿತಪಡಿಸಿಕೊಳ್ಳಿ",
        "instavc_check_internet": "ನಿಮ್ಮ ನೆಟ್ವರ್ಕ್ ಪರಿಶೀಲಿಸಿ",
        "instavc_search_url": "ಇತರ ಬ್ರೌಸರ್ನಲ್ಲಿ ಯೂ ರ್ ಲ್ ಗಾಗಿ ಹುಡುಕಿ",
        "instavc_goto": "ಗೆ ಹೋಗಿ",
        "instavc_request_for_access": "ಪ್ರವೇಶಕ್ಕಾಗಿ ವಿನಂತಿ",
        "instavc_start_collabrate": "ವೈಟ್ಬೋರ್ಡ್ನಲ್ಲಿ ಸಹಯೋಗವನ್ನು ಪ್ರಾರಂಭಿಸಲು",
        "instavc_large_conference_mode": 'ಇದರ "ದೊಡ್ಡ ಸಮ್ಮೇಳನ" ಮೋಡ್, ಹೋಸ್ಟ್ ನಿಮಗೆ ಅನುಮತಿ ನೀಡುವವರೆಗೆ ನೀವು ಇತರರೊಂದಿಗೆ ಮಾತನಾಡಲು ಅಥವಾ ವೀಕ್ಷಿಸಲು ಸಾಧ್ಯವಿಲ್ಲ',
        "instavc_allow_participants": 'ಇದರ "ದೊಡ್ಡ ಸಮ್ಮೇಳನ" ಮೋಡ್, ಭಾಗವಹಿಸುವವರನ್ನು ಮಾತನಾಡಲು ನೀವು ಹಸ್ತಚಾಲಿತವಾಗಿ ಅನುಮತಿಸಬೇಕು',
        "instavc_buy_premium": "ಈ ವೈಶಿಷ್ಟ್ಯಗಳನ್ನು ಅನ್ಲಾಕ್ ಮಾಡಲು ಪ್ರೀಮಿಯಂ ಖರೀದಿಸಿ",
        "instavc_alert_tryagain": "ಏನೋ ತಪ್ಪಾಗಿದೆ, ದಯವಿಟ್ಟು ಮತ್ತೆ ಪ್ರಯತ್ನಿಸಿ",
        "instavc_enter_name": "ನಿಮ್ಮ ಹೆಸರನ್ನು ನಮೂದಿಸಿ",
        "instavc_confirm": "ಕನ್ಫರ್ಮ್",
        "instavc_ok": "ಸರಿ",
        "instavc_askquestion": "ಪ್ರಶ್ನೆಯನ್ನು ಕೇಳಿ ...",
        "instavc_recieve": "ಸ್ವೀಕರಿಸಿ",
        "instavc_delay": "ವಿಳಂಬ (ಎಮೆಸ್)",
        "instavc_audio_opus": "ಆಡಿಯೋ / ಓಪಸ್",
        "instavc_video_vp8": "ವೀಡಿಯೊ / ವಿಪಿ 8",
        "instavc_browser_not_support_incall": 'ಕರೆ ಸಮಯದಲ್ಲಿ ರೆಸಲ್ಯೂಶನ್ ಬದಲಾವಣೆಯನ್ನು ನಿಮ್ಮ ಬ್ರೌಸರ್ ಬೆಂಬಲಿಸುವುದಿಲ್ಲ!',
        "instavc_failed_toPublish": "ವೀಡಿಯೊ ಪ್ರಕಟಿಸಲು ವಿಫಲವಾಗಿದೆ",
        "instavc_publish_fail": "ಪ್ರಕಟಣೆ ವಿಫಲವಾಗಿದೆ",
        "instavc_video_cant_publish": "ಬಳಕೆದಾರರ ಮಿತಿ ತಲುಪುವ ಕಾರಣ ವೀಡಿಯೊವನ್ನು ಪ್ರಕಟಿಸಲಾಗುವುದಿಲ್ಲ",
        "instavc_failed_joinConference": 'ಸಮ್ಮೇಳನದಲ್ಲಿ ಸೇರಲು ವಿಫಲವಾಗಿದೆ',
        "instavc_mute_audio": "ರಿಮೋಟ್ ಆಡಿಯೊ ಮ್ಯೂಟ್ ಆಗಿದ್ದರೆ ನೀವು ಮ್ಯೂಟ್ / ಅನ್‌ಮ್ಯೂಟ್  ಮಾಡಲು ಸಾಧ್ಯವಿಲ್ಲ",
        "instavc_remote_audio_muted": "ರಿಮೋಟ್ ಆಡಿಯೋ ಮ್ಯೂಟ್ ಮಾಡಲಾಗಿದೆ!",
        "instavc_enter_conferenceid": "ನಿಮ್ಮ ಕಾನ್ಫರೆನ್ಸ್ ಐಡಿ ಅನ್ನು ನಮೂದಿಸಿ",
        "instavc_share_screen": "ಸ್ಕ್ರೀನ್ ಹಂಚಿಕೊಳ್ಳಿ",
        "instavc_sharing_your_screen": "ನಿಮ್ಮ ಸ್ಕ್ರೀನ್ಯನ್ನು ಹಂಚಿಕೊಳ್ಳಲಾಗುತ್ತಿದೆ ...",
        "instavc_stop": "ನಿಲ್ಲಿಸು",
        "instavc_back": "ಹಿಂದೆ",
        "instavc_choose_plan": "ಕೆಳಗಿನ ಪಟ್ಟಿಯಿಂದ ನಿಮ್ಮ ಯೋಜನೆಯನ್ನು ಆರಿಸಿ",
        "instavc_have_promotionalcode": "ಪ್ರಚಾರ ಕೋಡ್ / ಪಾಲುದಾರ ಕೋಡ್ ಇದೆಯೇ?",
        "instavc_contact_pricing": "ಬೆಲೆಗಾಗಿ ನಮ್ಮನ್ನು ಸಂಪರ್ಕಿಸಿ",
        "instavc_payment_failed": 'ಪಾವತಿ ವಿಫಲವಾಗಿದೆ',
        "instavc_payment_error": 'ದುರದೃಷ್ಟವಶಾತ್ ನಿಮ್ಮ ಪಾವತಿಯನ್ನು ನಿರ್ವಹಿಸುವಾಗ ದೋಷ ಸಂಭವಿಸಿದೆ.',
        "instavc_contact_support": "ಯಾವುದೇ ಸಹಾಯ ಅಗತ್ಯವಿದ್ದರೆ ದಯವಿಟ್ಟು ನಮ್ಮ ಬೆಂಬಲ ತಂಡವನ್ನು ಸಂಪರ್ಕಿಸಿ.",
        "instavc_tryagain": "ಮತ್ತೆ ಪ್ರಯತ್ನಿಸಿ",
        "instavc_payment_success": "ಪಾವತಿ ಯಶಸ್ವಿಯಾಗಿದೆ",
        "instavc_thanks_for_payment": "ನಿಮ್ಮ ಪಾವತಿಗೆ ಧನ್ಯವಾದಗಳು!",
        "instavc_payment_processed": 'ನಿಮ್ಮ ಪಾವತಿಯನ್ನು ಯಶಸ್ವಿಯಾಗಿ ಪ್ರಕ್ರಿಯೆಗೊಳಿಸಲಾಗಿದೆ. ಸ್ವಯಂಚಾಲಿತ ಪಾವತಿ ರಶೀದಿ ',
        "instavc_mail_sent": 'ಶೀಘ್ರದಲ್ಲೇ ನಿಮ್ಮ ನೋಂದಾಯಿತ ಇಮೇಲ್ ವಿಳಾಸಕ್ಕೆ ಕಳುಹಿಸಲಾಗುವುದು',
        "instavc_goto_homepage": "ಮುಖಪುಟಕ್ಕೆ ಹಿಂತಿರುಗಿ",
        "instavc_want_toend_call": "ಕರೆಯನ್ನು ಕೊನೆಗೊಳಿಸಲು ಬಯಸುವಿರಾ?",
        "instavc_exit_window": 'ಈ ವಿಂಡೋವನ್ನು ಮುಚ್ಚುವುದರಿಂದ ನಿಮ್ಮ ಕರೆಯಿಂದ ನಿರ್ಗಮಿಸುತ್ತದೆ. ಈ ಕರೆಯನ್ನು ಕೊನೆಗೊಳಿಸಲು ನೀವು ಖಚಿತವಾಗಿ ಬಯಸುವಿರಾ? ',
        "instavc_create_room": "ಕೊಠಡಿ ರಚಿಸಿ",
        "instavc_userlimit": "ಬಳಕೆದಾರ ಮಿತಿ",
        "instavc_edit_room": "ಕೊಠಡಿ ತಿದ್ದಿ ",
        "instavc_update": 'ನವೀಕರಿಸಿ',
        "instavc_manage_license": 'ಪರವಾನಗಿಗಳನ್ನು ನಿರ್ವಹಿಸಿ',
        "instavc_package": "ಪ್ಯಾಕೇಜ್",
        "instavc_no_of_rooms": "ಕೊಠಡಿಗಳ ಸಂಖ್ಯೆ",
        "instavc_no_of_users": "ಬಳಕೆದಾರರ ಸಂಖ್ಯೆ",
        "instavc_purchasedOn": "ಖರೀದಿಸಲಾಗಿದೆ",
        "instavc_expiredon": "ಅವಧಿ ಮೀರಿದೆ",
        "instavc_or": "ಅಥವಾ",
        "instavc_otherhost_email": "ನೀವು ಯಾವುದೇ ಬಳಕೆದಾರರನ್ನು ಹೋಸ್ಟ್ ಆಗಿ ಮಾಡಲು ಬಯಸಿದರೆ, ಅವನ / ಅವಳ ಇಮೇಲ್ ವಿಳಾಸವನ್ನು ನಮೂದಿಸಿ.",
        "instavc_set_host_password": 'ಹೋಸ್ಟ್ ಪಾಸ್ವರ್ಡ್ ಹೊಂದಿಸಿ',
        "instavc_host_password": 'ಹೋಸ್ಟ್ ಪಾಸ್ವರ್ಡ್',
        "instavc_access_room": 'ಈ ಕೊಠಡಿಯನ್ನು ಬೇರೆ ಯಾರು ಪ್ರವೇಶಿಸಬಹುದು?',
        "instavc_select_user_host": "ಅವನನ್ನು / ಅವಳನ್ನು ಹೋಸ್ಟ್ ಮಾಡಲು ಪಟ್ಟಿಯಿಂದ ಯಾವುದೇ ಬಳಕೆದಾರರನ್ನು ಆಯ್ಕೆ ಮಾಡಿ.",
        "instavc_prologin": "ಇನ್ಸ್ ವೀಸೀ ಪ್ರೊ ಲಾಗಿನ್",
        "instavc_start": "ಪ್ರಾರಂಭಿಸು",
        "instavc_enter_website": "ದಯವಿಟ್ಟು ವೆಬ್ಸೈಟ್ ಹೆಸರನ್ನು ನಮೂದಿಸಿ",
        "instavc_enter_valid_email": 'ದಯವಿಟ್ಟು ಮಾನ್ಯವಾದ ಇಮೇಲ್ ಅನ್ನು ನಮೂದಿಸಿ',
        "instavc_enter_valid_phone": 'ದಯವಿಟ್ಟು ಮಾನ್ಯವಾದ ಫೋನ್ ಸಂಖ್ಯೆಯನ್ನು ನಮೂದಿಸಿ',
        "instavc_field_required": 'ಈ ಕ್ಷೇತ್ರ ಅಗತ್ಯವಿದೆ',
        "instavc_invitedby": "ಆಹ್ವಾನಿಸಲಾಗಿದೆ",
        "instavc_storage": "ಸಂಗ್ರಹಣೆ",
        "affiliate_approve" : "ಅನುಮೋದಿಸಲಾಗಿದೆ",
        "affiliate_pending" :  "ಬಾಕಿ",
        "affiliate_rejected" :  "ತಿರಸ್ಕರಿಸಲಾಗಿದೆ",
        "affiliate_user_status" : "ಬಳಕೆದಾರರ ಸ್ಥಿತಿ",
        "commission_other" : "ಇತರೆ ಆಯೋಗಗಳು",
        "add_commission": "ಆಯೋಗಗಳನ್ನು ಸೇರಿಸಿ",
        "delete_commission": "ನೀವು ಆಯೋಗವನ್ನು ಅಳಿಸಲು ಬಯಸುವಿರಾ",
        "update_commission": "ಆಯೋಗಗಳನ್ನು ನವೀಕರಿಸಿ",
        "name" :  "ಹೆಸರು",
        "offer_value" : "ಆಫರ್ ಮೌಲ್ಯ",
        "add" : "ಸೇರಿಸಿ",
        "update" : "ನವೀಕರಿಸಿ",
        "affiliates" : "ಅಂಗಸಂಸ್ಥೆಗಳು",
        "status" : "ಸ್ಥಿತಿ",
        "status_change_message": "ನೀವು ಸ್ಥಿತಿಯನ್ನು ಬದಲಾಯಿಸಲು ಬಯಸುವಿರಾ?",
        "approve" : 'ಅನುಮೋದಿಸು',
        "reject" : "ತಿರಸ್ಕರಿಸಿ",
        "commissions" :"ಆಯೋಗಗಳು",
        "withdraw_data" : "ಡೇಟಾವನ್ನು ಹಿಂತೆಗೆದುಕೊಳ್ಳಿ",
        "withdraw_amount" : 'ಮೊತ್ತವನ್ನು ಹಿಂತೆಗೆದುಕೊಳ್ಳಿ',
        "payment_method": "ಪಾವತಿ ವಿಧಾನ",
        "payment_method" : "ಪಾವತಿ ಶುಲ್ಕ",
        "total_amount_withdraw": "ಹಿಂತೆಗೆದುಕೊಳ್ಳುವ ಒಟ್ಟು ಮೊತ್ತ",
        "total_earnings" : "ಒಟ್ಟು ಗಳಿಕೆಗಳು",
        "pending_amount" :  "ಬಾಕಿ ಉಳಿದಿರುವ ಮೊತ್ತ",
        "paid_amount" : "ಪಾವತಿಸಿದ ಮೊತ್ತ",
        "unpaid_amount" : "ಪಾವತಿಸದ ಮೊತ್ತ",
        "request_withdraw": "ವಿನಂತಿಸಿದ ಮೊತ್ತವನ್ನು ಹಿಂತೆಗೆದುಕೊಳ್ಳಲಾಗಿದೆ",
        "english": "ಇಂಗ್ಲಿಷ್",
        "french" : "ಫ್ರೆಂಚ್",
        "portuguese":  "ಪೋರ್ಚುಗೀಸ್",
        "hindi": "ಹಿಂದಿ",
        "gujarati": "ಗುಜರಾತಿ",
        "kannada": "ಕನ್ನಡ",
        "marathi": "ಮರಾಠಿ",
        "tamil": "ತಮಿಳು",
        "telugu": "ತೆಲುಗು",
        "urdu": "ಉರ್ದು",
        "spanish": "ಸ್ಪ್ಯಾನಿಷ್",
        "malyalam": "ಮಲ್ಯಾಲಂ",
        "italian": "ಇಟಾಲಿಯನ್",
        "bangla" : "ಬಾಂಗ್ಲಾ",
        "room" : "ಕೊಠಡಿ",
        "create" :  'ರಚಿಸು',
        "repeat" : "ಪುನರಾವರ್ತಿಸು",
        "daily" : "ದೈನಂದಿನ",
        "repeat_every" : "ಪ್ರತಿಯೊಂದನ್ನು ಪುನರಾವರ್ತಿಸಿ",
        "repeat_on" : "ಪುನರಾವರ್ತಿಸಿ",
        "repeat_by" : "ಇದನ್ನು ಪುನರಾವರ್ತಿಸಿ",
        "ends" :"ಕೊನೆಗೊಳ್ಳುತ್ತದೆ",
        "after" : "ನಂತರ",
        "occurences" : "ಘಟನೆಗಳು",
        "on" : "ಆನ್",
        "summary" : "ಸಾರಾಂಶ",
        "repeats" : "ಪುನರಾವರ್ತನೆಗಳು",
        "withdraws" : "ಹಿಂತೆಗೆದುಕೊಳ್ಳುತ್ತದೆ",
        "every" : "ಪ್ರತಿ",
        "days" : "ದಿನಗಳು",
        "weeks" :"ವಾರಗಳು",
        "months":"ತಿಂಗಳು",
        "onday" : "ದಿನದಂದು",
        "years" : "ವರ್ಷಗಳು",
        "times": "ಬಾರಿ",
        "until" :"ತನಕ",
        "past_meeting_list": "ಹಿಂದಿನ ಸಭೆ ಪಟ್ಟಿ",
        "organised_by" : "ಇವರಿಂದ ಸಂಘಟಿಸಲಾಗಿದೆ",
        "delete" : "ಅಳಿಸು",
        "join": "ಸೇರಿ",
        "to" : "ಗೆ",
        "enter_password": "ಪಾಸ್ವರ್ಡ್ ನಮೂದಿಸಿ",
        "submit" : "ಸಲ್ಲಿಸು",
        "enter_passwordmessage": "ದಯವಿಟ್ಟು ಪಾಸ್ವರ್ಡ್ ನಮೂದಿಸಿ",
        "delete_message": "ನೀವು ಅಳಿಸಲು ಬಯಸುವಿರಾ",
        "meeting_permanent": "ಶಾಶ್ವತವಾಗಿ ಭೇಟಿಯಾಗುವುದು?",
        "day" : "ದಿನ",
        "password_message": "ಪಾಸ್ವರ್ಡ್ ತಪ್ಪಾಗಿದೆ",
        "timezone" :  "ಸಮಯ ವಲಯ",
        "by": "ಇವರಿಂದ",
        "weekdays" : ['ಸನ್', 'ಮ್ಯಾನ್', 'ಟ್ಯೂ', 'ವೆಡ್', 'ಟ್ಯೂ', 'ಫ್ರ್ಐ', 'ಸ್ಯಾಟ್'],
        "allweek" : ['ಭಾನುವಾರ', 'ಸೋಮವಾರ', 'ಮಂಗಳವಾರ', 'ಬುಧವಾರ', 'ಗುರುವಾರ', 'ಶುಕ್ರವಾರ', 'ಶನಿವಾರ'],
        "day_month": "ತಿಂಗಳ ದಿನ",
        "day_week" : "ವಾರದ ದಿನ",
        "week": "ವಾರ",
        "month": "ತಿಂಗಳು",
        "year": "ವರ್ಷ",
        "enterpassword": "ದಯವಿಟ್ಟು ನಿಮ್ಮ ಹೊಸ ಪಾಸ್ವರ್ಡ್ ಅನ್ನು ನಮೂದಿಸಿ ಮತ್ತು ಪಾಸ್ವರ್ಡ್ ಅನ್ನು ದೃಢೀಕರಿಸಿ",
        "passwordmessage": "ಪಾಸ್ವರ್ಡ್ ಮತ್ತು ಖಚಿತಪಡಿಸಿದಾ ಪಾಸ್ವರ್ಡ್  ಎರಡೂ ಒಂದೇ ಆಗಿರಬೇಕು",
        "passwordupdate": "ಪಾಸ್ವರ್ಡ್ ಯಶಸ್ವಿಯಾಗಿ ನವೀಕರಿಸಲಾಗಿದೆ",
        "numeric" :  ['ಮೊದಲ', 'ಎರಡನೇ', 'ಮೂರನೇ', 'ನಾಲ್ಕನೇ', 'ಐದನೇ'],
        "verify_email": "ನಿಮ್ಮ ಇಮೇಲ್ ಪರಿಶೀಲಿಸಿ",
        "confirm_code" :  "ಅನುಸರಣೆ ಕೋಡ್",
        "verify_msg": "ದಯವಿಟ್ಟು ಕೋಡ್ಗಾಗಿ ನಿಮ್ಮ ಮೊಬೈಲ್ ಅನ್ನು ಪರಿಶೀಲಿಸಿ.",
        "verify" : "ಪರಿಶೀಲಿಸಿ",
        "not_recieved": "ಸ್ವೀಕರಿಸಲಾಗಿಲ್ಲವೇ?",
        "resend_otp" : "ಒಟಿಪಿಯನ್ನು ಮರುಹೊಂದಿಸಿ",
        "start_browsing": "ಬ್ರೌಸಿಂಗ್ ಪ್ರಾರಂಭಿಸಿ",
        "become_affiliate": "ಅಂಗಸಂಸ್ಥೆಯಾಗು",
        "affiliate" : "ಅಂಗಸಂಸ್ಥೆ",
        "verify_mobile": "ನಿಮ್ಮ ಮೊಬೈಲ್ ಪರಿಶೀಲಿಸಿ",
        "instavc_allow_DocumentAccess": "ಡಾಕ್ಯುಮೆಂಟ್-ಹಂಚಿಕೆಯನ್ನು ಅನುಮತಿಸಿ",
        "instavc_allow_Notes": "ಟಿಪ್ಪಣಿಗಳನ್ನು ಅನುಮತಿಸಿ",
        //common - CameraResolution
        "camera_not_access": "ಈ ಕೆಳಗಿನ ಒಂದು ಕಾರಣದಿಂದ ಕ್ಯಾಮೆರಾವನ್ನು ಪ್ರವೇಶಿಸಲಾಗುವುದಿಲ್ಲ:",
        "camera_not_access_reason1": "ರೆಸಲ್ಯೂಶನ್ ಸೆಟ್ಟಿಂಗ್ಗಳು ಈ ಪ್ರದರ್ಶನದೊಂದಿಗೆ ಹೊಂದಿಕೆಯಾಗುವುದಿಲ್ಲ. ನಿಮ್ಮ ಸೆಟ್ಟಿಂಗ್ಗಳನ್ನು ಕಡಿಮೆ ರೆಸಲ್ಯೂಶನ್ನೊಂದಿಗೆ ಕಾನ್ಫಿಗರ್ ಮಾಡಿ ಮತ್ತು ಮತ್ತೆ ಪ್ರಯತ್ನಿಸಿ.",
        "camera_not_access_reason2": "ನಿಮ್ಮ ಕ್ಯಾಮೆರಾವನ್ನು ವಿಭಿನ್ನ ಅಪ್ಲಿಕೇಶನ್ನಿಂದ ಬಳಸಲಾಗುತ್ತಿದೆ, ದಯವಿಟ್ಟು ಎಲ್ಲಾ ಅಪ್ಲಿಕೇಶನ್ಗಳನ್ನು ಮುಚ್ಚಿ ಮತ್ತು ಲಿಂಕ್ ಅನ್ನು ಕ್ಲಿಕ್ ಮಾಡುವ ಮೂಲಕ ಮತ್ತೆ ಪ್ರಯತ್ನಿಸಿ.",
        //Containers	
        //content - components - assignQuestionnaire	
        "asgnQue_Assign_Question": "ಪ್ರಶ್ನಾವಳಿಯನ್ನು ನಿಗದಿಪಡಿಸಿ",
        "asgnQue_assigned_question": "ನಿಯೋಜಿಸಲಾದ ಪ್ರಶ್ನಾವಳಿ",
        //assignQuestList
        "quslsit_assig_que_list": "ನಿಯೋಜಿಸಲಾದ ಪ್ರಶ್ನಾವಳಿ ಪಟ್ಟಿ",
        "quslsit_question_lists": "ಪ್ರಶ್ನಾವಳಿ ಪಟ್ಟಿಗಳು",
        "quslsit_add_new_question": "ಹೊಸ ಪ್ರಶ್ನಾವಳಿಯನ್ನು ಸೇರಿಸಿ",
        "quslsit_no_question_assign": "ಯಾವುದೇ ಪ್ರಶ್ನಾವಳಿಯನ್ನು ಇನ್ನೂ ನಿಯೋಜಿಸಲಾಗಿಲ್ಲ!",
        "quslsit_assign_new_ques": "ಮೇಲಿನ ನಿಯೋಜಿತ ಪ್ರಶ್ನಾವಳಿ ಗುಂಡಿಯನ್ನು ಕ್ಲಿಕ್ ಮಾಡಲು ಹೊಸ ಪ್ರಶ್ನಾವಳಿಯನ್ನು ನಿಯೋಜಿಸಿ",
        //model-assign-Questionnaire
        "select_questionnaire": "ಪ್ರಶ್ನಾವಳಿಯನ್ನು ಆರಿಸಿ",
        "duration" : "ಅವಧಿ",
        "time_limit" : "ಸಮಯ ಮಿತಿ",
        "show_results": "ಫಲಿತಾಂಶಗಳನ್ನು ತೋರಿಸು",
        "save" : "ಉಳಿಸು",
        // viewAssigned
        "content_group": "ವಿಷಯ ಗುಂಪು",
        "list_assigned_ques": "ನಿಯೋಜಿಸಲಾದ ಪ್ರಶ್ನೆಗಳ ಪಟ್ಟಿ:",
        "mins" :"ನಿಮಿಷಗಳು",
        "marks" : "ಅಂಕಗಳು",
        //AssignedQuestions	
        "asgQues_5_Marks": "(5 ಅಂಕಗಳು)",
        "asgQues_answers": "ಉತ್ತರಗಳು",
        "asgQues_no_questions": "ಪ್ರಶ್ನೆಗಳಿಲ್ಲ!",

        //content - components - contentGrade	
        //GradeSetting	
        "grdSet_GPA_calculation": "ಶೇಕಡಾವಾರು ಜಿಪಿಎ ಲೆಕ್ಕಾಚಾರ",
        "grdSet_GPA_cal_msg" : "ಶೇಕಡಾವಾರು 100% ಆಗಿದೆ, ಅದು 100 ಅಂಕಗಳನ್ನು ಹೊರತುಪಡಿಸಿ ಏನೂ ಅಲ್ಲ. ಆದ್ದರಿಂದ ಶೇಕಡಾ 25 ರಷ್ಟು ಅಂಕಗಳು ಜಿಪಿಎ ವ್ಯವಸ್ಥೆಯಲ್ಲಿ 1 ಪಾಯಿಂಟ್‌ಗೆ ಸಮಾನವಾಗಿರುತ್ತದೆ. ಜಿಪಿಎ ಸೂತ್ರದ ಶೇಕಡಾವಾರು ನಿಮ್ಮ ಶೇಕಡಾವಾರು ಪ್ರಮಾಣವನ್ನು 100 ರಿಂದ ಭಾಗಿಸಿ 4 ರಿಂದ ಗುಣಿಸಿ. ನಿಮ್ಮ ಶೇಕಡಾವಾರು 75% ಆಗಿದ್ದರೆ ನಿಮ್ಮ ದರ್ಜೆಯು (75/100) * 4 = 3 ಆಗಿರುತ್ತದೆ.",
        "grdSet_grade_point": "ಗ್ರೇಡ್ ಪಾಯಿಂಟ್ಗಳು ಇದ್ದರೆ",
        //managegrade
        "mngGrd_grades": "ಶ್ರೇಣಿಗಳು",
        "mngGrd_modify": "ಮಾರ್ಪಡಿಸು",
        "mngGrd_save_grades": "ಶ್ರೇಣಿಗಳನ್ನು ಉಳಿಸಿ",
        "mngGrd_modify_grades": "ಶ್ರೇಣಿಗಳನ್ನು ಮಾರ್ಪಡಿಸಿ",
        "mngGrd_grade_info": "ಗ್ರೇಡ್ ಮಾಹಿತಿ",
        //content - components - ContentParticipants	
        //components-admnAnsView
        "admnAns_answer_list_for_question": "ಈ ವಿಷಯ ಗುಂಪಿನ ಎಲ್ಲಾ ಪ್ರಶ್ನಾವಳಿಗಳ ಉತ್ತರಗಳ ಪಟ್ಟಿಯನ್ನು ಕೆಳಗೆ ನೀಡಲಾಗಿದೆ.",
        //components-participants
        "prtcpt_certification": "ಪ್ರಮಾಣೀಕರಣಗಳು:",
        "prtcpt_other_content_group": "ಇತರ ವಿಷಯ ಗುಂಪುಗಳಲ್ಲಿ",
        "prtcpt_sales": "ಮಾರಾಟ",
        "prtcpt_marketing": "ಮಾರ್ಕೆಟಿಂಗ್",
        "prtcpt_human_resource": "ಮಾನವ ಸಂಪನ್ಮೂಲ",
        //manageparticipants
        "mngPrtcpt_add_participants": "ಭಾಗವಹಿಸುವವರನ್ನು ಸೇರಿಸಿ",
        "mngPrtcpt_participants_list": "ಭಾಗವಹಿಸುವವರ ಪಟ್ಟಿಗಳು",
        "mngPrtcpt_import_participants": "ಭಾಗವಹಿಸುವವರನ್ನು ಆಮದು ಮಾಡಿ",
        "mngPrtcpt_download_sample": "ಮಾದರಿಯನ್ನು ಡೌನ್ಲೋಡ್ ಮಾಡಿ",
        "mngPrtcpt_no_participants_added": "ಭಾಗವಹಿಸುವವರನ್ನು ಇನ್ನೂ ಸೇರಿಸಲಾಗಿಲ್ಲ!",
        "mngPrtcpt_add_new_participant": "ಹೊಸ ಪಾಲ್ಗೊಳ್ಳುವವರನ್ನು ಸೇರಿಸಿ, ಸೇರಿಸಲು ಮೇಲಿನ ಪಾಲ್ಗೊಳ್ಳುವವರ ಬಟನ್ ಕ್ಲಿಕ್ ಮಾಡಿ",
        //modal-add-participants
        "addPrtcpt_select_participants": "ಭಾಗವಹಿಸುವವರನ್ನು ಆರಿಸಿ",
        "addPrtcpt_model_add_participants": "ಭಾಗವಹಿಸುವವರನ್ನು ಸೇರಿಸಿ",
        // partipantGradeView
        "prtcptGrde_participant_grade": "ಭಾಗವಹಿಸುವವರ ಗ್ರೇಡ್ ವಿವರಗಳು",
        "prtcptGrde_grade_participants_list": "ಭಾಗವಹಿಸುವವರ ಪಟ್ಟಿ",
        //content - components - ContentQuestionnaire	
        //managequestionnaire	
        "mngQuesnr_create_questionnaire": "ಪ್ರಶ್ನಾವಳಿಯನ್ನು ರಚಿಸಿ",
        "questionnaire_list" : "ಪ್ರಶ್ನಾವಳಿ ಪಟ್ಟಿ",
        //managequestions
        "mngQues_question_details": "ಪ್ರಶ್ನಾವಳಿ ವಿವರಗಳು",
        "mngQues_no_question_created": "ಇನ್ನೂ ಯಾವುದೇ ಪ್ರಶ್ನೆಯನ್ನು ರಚಿಸಲಾಗಿಲ್ಲ!",
        "mngQues_create_new_question": "ಹೊಸ ಪ್ರಶ್ನೆಯನ್ನು ರಚಿಸಿ, ರಚಿಸಲು ಮೇಲಿನ ಕ್ಲಿಕ್ ಕ್ಲಿಕ್ ಬಟನ್ ಕ್ಲಿಕ್ ಮಾಡಿ",
        //modal-create-quest-group
        "mdlGrp_questionnaire_name": "ಪ್ರಶ್ನಾವಳಿ ಹೆಸರು",
        "mdlGrp_update": "ನವೀಕರಿಸಿ",
        "mdlGrp_create": "ರಚಿಸಿ",
        //modal-create-questions
        "mdlCrtQues_question_type": "ಪ್ರಶ್ನೆ ಪ್ರಕಾರ",
        "mdlCrtQues_sel_question_type": "ಪ್ರಶ್ನೆ ಪ್ರಕಾರವನ್ನು ಆರಿಸಿ",
        "mdlCrtQues_single_sel_multiple_choice": "ಏಕ ಆಯ್ಕೆ ಬಹು ಆಯ್ಕೆ",
        "mdlCrtQues_multiselect_multiple_choice": "ಮಲ್ಟಿಸೆಲೆಕ್ಟ್ ಮಲ್ಟಿಪಲ್ ಚಾಯ್ಸ್",
        "mdlCrtQues_ture_false": "ನಿಜ / ತಪ್ಪು",
        "mdlCrtQues_enter_answer_choice": "ಉತ್ತರ ಆಯ್ಕೆಗಳನ್ನು ನಮೂದಿಸಿ, ಮತ್ತು ಯಾವ ಉತ್ತರ ಸರಿಯಾಗಿದೆ ಎಂದು ಗುರುತಿಸಿ",
        "mdlCrtQues_add_another_choice": "+ ಮತ್ತೊಂದು ಆಯ್ಕೆಯನ್ನು ಸೇರಿಸಿ",
        // viewQuestionnaire
        "viewQues_add_questions": "ಪ್ರಶ್ನೆಗಳನ್ನು ಸೇರಿಸಿ",
        "viewQues_no_question_created": "ಇನ್ನೂ ಯಾವುದೇ ಪ್ರಶ್ನೆಯನ್ನು ರಚಿಸಲಾಗಿಲ್ಲ!",
        "viewQues_create_new_question": "ಹೊಸ ಪ್ರಶ್ನೆಯನ್ನು ರಚಿಸಿ, ರಚಿಸಲು ಮೇಲಿನ ಕ್ಲಿಕ್ ಕ್ಲಿಕ್ ಬಟನ್ ಕ್ಲಿಕ್ ಮಾಡಿ",
        //content - components - createContent
        // createcontent
        "crteContent_create_New_content": "ಹೊಸ ವಿಷಯವನ್ನು ರಚಿಸಿ",
        "crteContent_update_content": "ವಿಷಯವನ್ನು ನವೀಕರಿಸಿ",
        "crteContent_save_content": "ವಿಷಯವನ್ನು ಉಳಿಸಿ",
        "crteContent_content_list": "ವಿಷಯ ಪಟ್ಟಿಗಳು",
        "edit_content": "ವಿಷಯವನ್ನು ತಿದ್ದು",
        "crteContent_create_content": "ವಿಷಯವನ್ನು ರಚಿಸಿ",
        "crteContent_create_your_content_like": "ಚಿತ್ರಗಳು, ವೀಡಿಯೊ ಫೈಲ್ಗಳು, ಆಡಿಯೊ ಫೈಲ್ಗಳು ಮತ್ತು ಡಾಕ್ಯುಮೆಂಟ್ಗಳಂತಹ ಮಾಧ್ಯಮವನ್ನು ಸೇರಿಸುವ ಮೂಲಕ ನಿಮ್ಮ ವಿಷಯವನ್ನು ರಚಿಸಿ.",
        "crteContent_upload_document": "ಡಾಕ್ಯುಮೆಂಟ್ಗಳನ್ನು ಅಪ್ಲೋಡ್ ಮಾಡಿ",
        "crteContent_upload_media": "ಮಾಧ್ಯಮವನ್ನು ಅಪ್ಲೋಡ್ ಮಾಡಿ",
        "crteContent_document": "ಡಾಕ್ಯುಮೆಂಟ್ಸ್",
        "crteContent_media_files": "ಮಾಧ್ಯಮ ಫೈಲ್ಗಳು",
        //view-content
        "viewCon_content_view": "ವಿಷಯ ವೀಕ್ಷಣೆ",
        "viewCon_content_list": "ವಿಷಯ ಪಟ್ಟಿಗಳು",
        "viewCon_View_content": "ವಿಷಯವನ್ನು ವೀಕ್ಷಿಸಿ",
        "viewCon_enable": "ಸಕ್ರಿಯಗೊಳಿಸಿ:",
        "viewCon_document": "ಡಾಕ್ಯುಮೆಂಟ್ಸ್",
        "viewCon_media_files": "ಮಾಧ್ಯಮ ಫೈಲ್ಗಳು",
        //content - components - contentRow	
        "conRow_by": "ಇವರಿಂದ:",
        //content - components - managecontent	
        "create_new_content": "ವಿಷಯವನ್ನು ರಚಿಸಿ",
        "mngCon_all": "ಎಲ್ಲ",
        "mngCon_content_list": "ವಿಷಯ ಪಟ್ಟಿಗಳು",
        "mngCon_no_content_created": "ಇನ್ನೂ ಯಾವುದೇ ವಿಷಯವನ್ನು ರಚಿಸಲಾಗಿಲ್ಲ!",
        "mngCon_create_new_content": "ಹೊಸ ವಿಷಯವನ್ನು ರಚಿಸಿ, ರಚಿಸಲು ಮೇಲಿನ ವಿಷಯವನ್ನು ರಚಿಸಿ ಬಟನ್ ಕ್ಲಿಕ್ ಮಾಡಿ",
        //content - components - model-access-right	
        "mdlAccRight_share_access": "ಇತರ ಬೋಧಕರೊಂದಿಗೆ ಪ್ರವೇಶವನ್ನು ಹಂಚಿಕೊಳ್ಳಿ",
        "mdlAccRight_type_id_add": "ಇಮೇಲ್ ಐಡಿ ಟೈಪ್ ಮಾಡಿ ಮತ್ತು ಸೇರಿಸಿ",
        "mdlAccRight_no_instructor_added": "ಇನ್ನೂ ಯಾವುದೇ ಬೋಧಕರನ್ನು ಸೇರಿಸಲಾಗಿಲ್ಲ!.",
        "mdlAccRight_add_people_from_addressbok": "ನಿಮ್ಮ ವಿಳಾಸ ಪುಸ್ತಕದಿಂದ ಅಥವಾ ಇಮೇಲ್ ವಿಳಾಸವನ್ನು ಟೈಪ್ ಮಾಡುವ ಮೂಲಕ ಜನರನ್ನು ಸೇರಿಸಿ.",
        "mdlAccRight_contacts": "ಸಂಪರ್ಕಗಳು",
        "mdlAccRight_add_contacts": "ನಿಮ್ಮ ವಿಳಾಸ ಪುಸ್ತಕ ಸಂಪರ್ಕಗಳಿಂದ ವಿಷಯ ಗುಂಪಿಗೆ ಸಂಪರ್ಕಗಳನ್ನು ಸೇರಿಸಿ",
        "mdlAccRight_no_contacts_added": "ಯಾವುದೇ ಸಂಪರ್ಕಗಳನ್ನು ಇನ್ನೂ ಸೇರಿಸಲಾಗಿಲ್ಲ!.",
        //content - components - model-confirm-delete	
        "mdlConfDel_confirmation": "ದೃಢೀಕರಣ",
        "mdlConfDel_are_you_sure_delete": "ನೀವು ಇದನ್ನು ಅಳಿಸಲು ಖಚಿತವಾಗಿ ಬಯಸುವಿರಾ",
        "mdlConfDel_delete": "ಅಳಿಸು",
        //content - components - model-create-content-group	
        "mdlCrtConGrp_alert_enter_group_title": "ದಯವಿಟ್ಟು ಗುಂಪು ಶೀರ್ಷಿಕೆಯನ್ನು ನಮೂದಿಸಿ",
        "mdlCrtConGrp_alert_enter_group_description": "ದಯವಿಟ್ಟು ಗುಂಪು ವಿವರಣೆಯನ್ನು ನಮೂದಿಸಿ",
        "mdlCrtConGrp_group_name": "ಗುಂಪಿನ ಹೆಸರು",
        //content - components - model-upload-doc
        "mdlUpldoc_alert_enter_title_doc": "ದಯವಿಟ್ಟು ಡಾಕ್ಯುಮೆಂಟ್ನ ಶೀರ್ಷಿಕೆಯನ್ನು ನಮೂದಿಸಿ",
        "mdlUpldoc_upload_document": "ಡಾಕ್ಯುಮೆಂಟ್ಗಳನ್ನು ಅಪ್ಲೋಡ್ ಮಾಡಿ",
        "mdlUpldoc_document_title": "ಡಾಕ್ಯುಮೆಂಟ್ ಶೀರ್ಷಿಕೆ",
        "mdlUpldoc_upload_doc_from_system": "ನಿಮ್ಮ ಸಿಸ್ಟಮ್ನಿಂದ ಡಾಕ್ಯುಮೆಂಟ್ ಅನ್ನು ಅಪ್ಲೋಡ್ ಮಾಡಿ, ಅದು .ಪಿಡಿಎಫ್, ಎಕ್ಸೆಲ್, ಪದ ಡಾಕ್ಯುಮೆಂಟ್ ಅನ್ನು ಬೆಂಬಲಿಸುತ್ತದೆ.",
        "mdlUpldoc_upload_doc": "ಡಾಕ್ಯುಮೆಂಟ್ ಅಪ್ಲೋಡ್",
        "mdlUpldoc_added_doc": "ಡಾಕ್ಯುಮೆಂಟ್ಗಳನ್ನು ಸೇರಿಸಲಾಗಿದೆ",
        //content - components - model-upload-media
        "mdlUplMedia_alert_enter_title_media": "ದಯವಿಟ್ಟು ಮಾಧ್ಯಮದ ಶೀರ್ಷಿಕೆಯನ್ನು ನಮೂದಿಸಿ",
        "mdlUplMedia_alert_enter_title_url": "ದಯವಿಟ್ಟು ಶೀರ್ಷಿಕೆ ಮತ್ತು ಯೂ ರ್ ಲ್ ಅನ್ನು ನಮೂದಿಸಿ",
        "mdlUplMedia_alert_enter_youtube_vimeo_url": "ದಯವಿಟ್ಟು ಮಾನ್ಯ ಮತ್ತು URL ಅನ್ನು ನಮೂದಿಸಿ (ಯುಟ್ಯೂಬ್ / ವಿಮಿಯೋ)",
        "mdlUplMedia_upload_media": "ಮಾಧ್ಯಮವನ್ನು ಅಪ್ಲೋಡ್ ಮಾಡಿ",
        "mdlUplMedia_upload_url": "ಯೂ ರ್ ಲ್ ಅನ್ನು ಅಪ್ಲೋಡ್ ಮಾಡಿ",
        "mdlUplMedia_Upload_media_system": "ಮಾಧ್ಯಮವನ್ನು ಅಪ್ಲೋಡ್ ಮಾಡಿ ನಿಮ್ಮ ಸಿಸ್ಟಮ್ ಅನ್ನು ರೂಪಿಸುತ್ತದೆ, ಇದು .ಜ್ ಪೀ ಜೀ, .ಪೀ ನ್ ಜೀ, .ಜ್ ಪೀಈ ಜೀ, .ಮ್ ಪೀ3, .ಮ್ ಪೀ4 ಅನ್ನು ಬೆಂಬಲಿಸುತ್ತದೆ",
        "mdlUplMedia_add_media_url": "ಮಾಧ್ಯಮವನ್ನು ಲಗತ್ತಿಸಲು ಮಾಧ್ಯಮ ಯೂ ರ್ ಲ್ ವಿಳಾಸವನ್ನು ಸೇರಿಸಿ",
        "mdlUplMedia_upload_media_url": "ಮಾಧ್ಯಮ ಯೂ ರ್ ಲ್ ಅನ್ನು ಅಪ್ಲೋಡ್ ಮಾಡಿ",
        "mdlUplMedia_upload_youtube_url": "ಗಮನಿಸಿ: ಯುಟ್ಯೂಬ್ ಯೂ ರ್ ಲ್ ಗಳನ್ನು ಅಪ್ಲೋಡ್ ಮಾಡಿ",
        "mdlUplMedia_Add_media_file": "ಮಾಧ್ಯಮ ಫೈಲ್ಗಳನ್ನು ಸೇರಿಸಲಾಗಿದೆ",// ವಿಷಯ - ನಿರ್ವಹಣಾ ವಿಷಯ - ಸೂಚ್ಯಂಕ
        // "mngContent_content": "ವಿಷಯ",
        "mngContent_participants": "ಭಾಗವಹಿಸುವವರು",
        "mngContent_grade_settings": "ಗ್ರೇಡ್ ಸೆಟ್ಟಿಂಗ್ಗಳು",
        // ವಿಷಯ - ಸೂಚ್ಯಂಕ
        "content_all_content_group": "ಎಲ್ಲಾ ವಿಷಯ ಗುಂಪುಗಳು",
        "create_new_group": "ಗುಂಪನ್ನು ರಚಿಸಿ",
        "content_no_group_created": "ಇನ್ನೂ ಯಾವುದೇ ಗುಂಪುಗಳನ್ನು ರಚಿಸಲಾಗಿಲ್ಲ!",
        "content_create_new_group": "ಹೊಸ ಗುಂಪನ್ನು ರಚಿಸಿ, ರಚಿಸಲು ರಚಿಸಲು ಮೇಲಿನ ಕ್ಲಿಕ್ ಮಾಡಿ ಬಟನ್ ಕ್ಲಿಕ್ ಮಾಡಿ",
        // ವಿಷಯ ಹಂಚಿಕೆ - ವಿಷಯ ಪಟ್ಟಿ
        "conList_all_group": "ಎಲ್ಲಾ ಗುಂಪುಗಳು",
        "conList_content_list": "ವಿಷಯ ಪಟ್ಟಿಗಳು",
        "conList_no_content_created": "ಇನ್ನೂ ಯಾವುದೇ ವಿಷಯವನ್ನು ರಚಿಸಲಾಗಿಲ್ಲ!",
        // ವಿಷಯ ಹಂಚಿಕೆ - ಗುಂಪು ಪಟ್ಟಿ
        "grpList_all_content_group": "ಎಲ್ಲಾ ವಿಷಯ ಗುಂಪುಗಳು",
        "grpList_no_group_created": "ಇನ್ನೂ ಯಾವುದೇ ಗುಂಪುಗಳನ್ನು ರಚಿಸಲಾಗಿಲ್ಲ!",
        // ವಿಷಯ ಹಂಚಿಕೆ - ಪ್ರಶ್ನೆ ಸ್ಟೆಪ್ಪರ್
        "queStepper_cant_skip": " ಒಂದು ಹಂತವನ್ನು ನೀವು ಬಿಟ್ಟುಬಿಡಲು ಸಾಧ್ಯವಿಲ್ಲ.",
        "queStepper_back": "ಹಿಂದೆ",
        "queStepper_next": "ಮುಂದೆ",
        "queStepper_skip": "ಬಿಟ್ಟುಬಿಡಿ",
        "queStepper_finish": "ಮುಕ್ತಾಯ",
        "queStepper_submit_next": "ಸಲ್ಲಿಸಿ ಮತ್ತು ಮುಂದೆ",
        // ವಿಷಯ ಹಂಚಿಕೆ - ಶೋಕಾಂಟೆಂಟ್
        "conList_content_list": "ವಿಷಯ ಪಟ್ಟಿ",
        "showCont_document": "ಡಾಕ್ಯುಮೆಂಟ್ಸ್",
        "showCont_previous": "ಹಿಂದಿನ",
        "showCont_next": "ಮುಂದೆ",
        "showCont_have_completed_topic": "ನಾನು ಈ ವಿಷಯದಲ್ಲಿ ವಿಷಯಗಳನ್ನು ಪೂರ್ಣಗೊಳಿಸಿದ್ದೇನೆ",
        // ವಿಷಯ ಹಂಚಿಕೆ - ಶೋಮೀಡಿಯಾ
        "showMedia_page": "ಪುಟ",
        "showMedia_of": "ನ",
        "showMedia_previous": "ಹಿಂದಿನ",
        // ವಿಷಯ ಹಂಚಿಕೆ - ಪ್ರದರ್ಶನಗಳು
        "showQues_min_left": "ನಿಮಿಷ ಎಡ",
        "showQues_completed_test": "ಈ ಪ್ರಶ್ನಾವಳಿಯಲ್ಲಿ ನೀವು ಪರೀಕ್ಷೆಯನ್ನು ಪೂರ್ಣಗೊಳಿಸಿದ್ದೀರಿ.",
        "showQues_go_back_content_group": "ವಿಷಯ ಗುಂಪಿಗೆ ಹಿಂತಿರುಗಿ",
        // ವಿಷಯ ಹಂಚಿಕೆ - ವೀಕ್ಷಣೆ ಬಳಕೆದಾರ ಸ್ಕೋರ್
        "viewUserScore_view_score": "ಸ್ಕೋರ್ ವೀಕ್ಷಿಸಿ",
        "viewUserScore_total_marks": "ಒಟ್ಟು ಅಂಕಗಳು:",
        "viewUserScore_scored_marks": "ಸ್ಕೋರ್ ಮಾಡಿದ ಅಂಕಗಳು:",
        "viewUserScore_GPA_score": "ನಿಮ್ಮ ಜಿಪಿಎ ಸ್ಕೋರ್:",
        "viewUserScore_below_list_of_answer": "ಈ ವಿಷಯ ಗುಂಪಿನ ಎಲ್ಲಾ ಪ್ರಶ್ನಾವಳಿಗಳ ಉತ್ತರಗಳ ಪಟ್ಟಿಯನ್ನು ಕೆಳಗೆ ನೀಡಲಾಗಿದೆ.",
        "viewUserScore_ans Answer": "ಉತ್ತರಿಸಲಾಗಿದೆ",
        "viewUserScore_correct_answer": "ಸರಿಯಾದ ಉತ್ತರ",
        // ವೇಳಾಪಟ್ಟಿ - ಘಟಕಗಳು
        // ConfirmCancelInvite
        "confCancle_confirmation": "ದೃಢೀಕರಣ",
        "confCancle_are_you_sure": "ನಿಮಗೆ ಖಚಿತವಾಗಿದೆಯೇ?",
        "confCancle_delete_user": "ಬಳಕೆದಾರರನ್ನು ಅಳಿಸಿ",
        // ವೇಳಾಪಟ್ಟಿ ಅಳಿಸುವಿಕೆಯನ್ನು ದೃಢೀಕರಿಸಿ
        "confSche_are_you_sure_delete": "ಈ ವೇಳಾಪಟ್ಟಿಯನ್ನು ಅಳಿಸಲು ನೀವು ಖಚಿತವಾಗಿ ಬಯಸುವಿರಾ?",
        "confSche_no": "ಇಲ್ಲ",
        // ಪಾಸ್ಟ್ಮೀಟಿಂಗ್ಟೆಮ್
        // "pastMtnItem_rn": "ಆರ್.ಎನ್",
        // "pastMtnItem_room_name": "ಕೋಣೆಯ ಹೆಸರು:",
        // "pastMtnItem_webinar_list": "ವೆಬ್ನಾರ್ ಪಟ್ಟಿ",
        // "pastMtnItem_list_webinar": "ವೆಬ್ನಾರ್ಗಳ ಪಟ್ಟಿ ಕೆಳಗೆ ಇದೆ.",
        // "pastMtnItem_today": "ಇಂದು",
        // "pastMtnItem_webinar_title_falls": "ವೆಬ್ನಾರ್ ಶೀರ್ಷಿಕೆ ಇಲ್ಲಿ ಬೀಳುತ್ತದೆ",
        // "pastMtnItem_view": "ವೀಕ್ಷಿಸಿ",
        // "pastMtnItem_upcoming": "ಮುಂಬರುವ",
        // ವೇಳಾಪಟ್ಟಿ ವೀಕ್ಷಣೆ
        // "scheView_edit_content": "ವಿಷಯವನ್ನು ಸಂಪಾದಿಸಿ",
        "scheView_scheduled_by": "ಇವರಿಂದ ನಿಗದಿಪಡಿಸಲಾಗಿದೆ:",
        "scheView_delete": "ಅಳಿಸು",
        "scheView_download_calander": "ಕ್ಯಾಲೆಂಡರ್ ಡೌನ್ಲೋಡ್ ಮಾಡಿ",
        "scheView_invite_participants": "ಭಾಗವಹಿಸುವವರನ್ನು ಆಹ್ವಾನಿಸಿ",
        "scheView_start_conference": "ಸಮ್ಮೇಳನವನ್ನು ಪ್ರಾರಂಭಿಸಿ",
        "scheView_event_details": "ಈವೆಂಟ್ ವಿವರಗಳು",
        "scheView_room_name": "ಕೋಣೆಯ ಹೆಸರು",
        "scheView_minutes": "ನಿಮಿಷಗಳು",
        "scheView_conference_password": "ಕಾನ್ಫರೆನ್ಸ್ ಪಾಸ್ವರ್ಡ್",
        "scheView_settings": "ಸೆಟ್ಟಿಂಗ್ಗಳು",
        "scheView_webinar_event": "ವೆಬ್ನಾರ್ ಈವೆಂಟ್",
        "scheView_list_webinar": "ಈ ವೆಬ್ನಾರ್ ಈವೆಂಟ್ ಅನ್ನು ಇನ್ಸ್ತ ವೀ ಸೀ.ಕಾಮ್/ವೆಬೀನಆರ್ ನಲ್ಲಿ ಪಟ್ಟಿ ಮಾಡಿ ಮತ್ತು ನೋಂದಣಿಗಳನ್ನು ಸ್ವೀಕರಿಸಿ.",
        "scheView_guest_login_anonymous": "ಅತಿಥಿ ಅನಾಮಧೇಯವಾಗಿ ಲಾಗ್ ಇನ್ ಮಾಡಬಹುದು",
        "scheView_allow_invities": "ಸಮ್ಮೇಳನಕ್ಕೆ ಸೇರಲು ಕೇವಲ ಆಹ್ವಾನಗಳನ್ನು ಅನುಮತಿಸಿ",
        "scheView_enable_webinar_chat": "ವೆಬ್ನಾರ್ ಚಾಟ್ ಅನ್ನು ಸಕ್ರಿಯಗೊಳಿಸಿ",
        "scheView_enable_hand_rise": "ವೆಬ್ನಾರ್ನಲ್ಲಿ ಕೈ ಎತ್ತುವಿಕೆಯನ್ನು ಸಕ್ರಿಯಗೊಳಿಸಿ",
        "scheView_list_of_people_invited": "ಆಹ್ವಾನಿತ ಜನರ ಪಟ್ಟಿ ಕೆಳಗೆ",
        "scheView_alert_err_to_join": "ಸೇರಲು ದೋಷ",
        // ವೆಬ್ನಾರ್ ವಿವರಗಳು
        "webnrDtls_upcoming_webinar_room": "ಈ ಕೋಣೆಗೆ ಮುಂಬರುವ ವೆಬ್ನಾರ್ ಕೆಳಗೆ ನೀಡಲಾಗಿದೆ.",
        // ವೆಬ್ನಾರ್ 1
        // ವೆಬ್ನಾರ್ 2
        // ವೆಬ್ನಾರ್ 3
        "webnrDtls_webinar_details": "ವೆಬ್ನಾರ್ ವಿವರಗಳು",
        "webnrDtls_webinar_list": "ವೆಬ್ನಾರ್ಗಳ ಪಟ್ಟಿ",
        "webnrDtls_webinar_title": "ವೆಬ್ನಾರ್ ಶೀರ್ಷಿಕೆ",
        "webnrDtls_webinar_title_falls": "ವೆಬ್ನಾರ್ ಶೀರ್ಷಿಕೆ ಇಲ್ಲಿ ಬರುತ್ತದೆ",
        "webnrDtls_get_more_joining": "ಈ ವೆಬ್ನಾರ್ಗೆ ಸೇರುವ ಮೂಲಕ ಇನ್ನಷ್ಟು ಪಡೆಯಿರಿ.",
        "webnrDtls_join_webinar": "ವೆಬ್ನಾರ್ಗೆ ಸೇರಿ",
        // ವೆಬ್ನಾರ್ಲಿಸ್ಟ್
        "webnrList_webinar_list": "ವೆಬ್ನಾರ್ ಪಟ್ಟಿ",
        "webnrList_below_list_of_webinar": "ವೆಬ್ನಾರ್ಗಳ ಪಟ್ಟಿ ಕೆಳಗೆ ಇದೆ.",
        "webnrList_today": "ಇಂದು",
        "webnrList_webinar_title_falls": "ವೆಬ್ನಾರ್ ಶೀರ್ಷಿಕೆ ಇಲ್ಲಿ ಬೀಳುತ್ತದೆ",
        "webnrList_view": "ವೀಕ್ಷಿಸಿ",
        "webnrList_upcoming": "ಮುಂಬರುವ",
        // ವೇಳಾಪಟ್ಟಿ -
        //ವಿಳಾಸ ಪುಸ್ತಕ
        "addBook_address_book": "ವಿಳಾಸ ಪುಸ್ತಕ",
        "addBook_contact": "ಸಂಪರ್ಕಗಳು",
        "addBook_add_contact_to_meeting": "ನಿಮ್ಮ ವಿಳಾಸ ಪುಸ್ತಕ ಸಂಪರ್ಕಗಳಿಂದ ಸಭೆಗೆ ಸಂಪರ್ಕಗಳನ್ನು ಸೇರಿಸಿ",
        // ಸಭೆ ಪಟ್ಟಿ
        "meetingList_past_meetings": "ಹಿಂದಿನ ಸಭೆಗಳು",
        "meetingList_past_meetings_list": "ಹಿಂದಿನ ಸಭೆಗಳ ಪಟ್ಟಿ",
        "meetingList_room_name": "ಕೋಣೆಯ ಹೆಸರು:",
        "meetingList_view_content": "ವಿಷಯವನ್ನು ವೀಕ್ಷಿಸಿ",
        "meetingList_recording": "ರೆಕಾರ್ಡಿಂಗ್",
        "meetingList_view": "ವೀಕ್ಷಿಸಿ",
                // ವೇಳಾಪಟ್ಟಿ ಆಹ್ವಾನಿಸಿ 
        "scheInvt_err_invalid_id": "ಅಮಾನ್ಯ ಇಮೇಲ್ ಐಡಿ",
        "scheInvt_invite_participants": "ಭಾಗವಹಿಸುವವರನ್ನು ಆಹ್ವಾನಿಸಿ",
        "scheInvt_address_book": "ವಿಳಾಸ ಪುಸ್ತಕ",
        "scheInvt_invite_people_to_meeting": "ಈ ಸಭೆಗೆ ಜನರನ್ನು ಆಹ್ವಾನಿಸಿ. ನಿಮ್ಮ ವಿಳಾಸ ಪುಸ್ತಕದಿಂದ ಜನರನ್ನು ಸೇರಿಸಿ, ಅಥವಾ ಇಮೇಲ್ ವಿಳಾಸವನ್ನು ಟೈಪ್ ಮಾಡುವ ಮೂಲಕ.",
        "scheInvt_start": "ಪ್ರಾರಂಭವಾಗುತ್ತದೆ @",
        "scheInvt_below_list_of_answer": "ಈ ವಿಷಯ ಗುಂಪಿನ ಎಲ್ಲಾ ಪ್ರಶ್ನಾವಳಿಗಳ ಉತ್ತರಗಳ ಪಟ್ಟಿಯನ್ನು ಕೆಳಗೆ ನೀಡಲಾಗಿದೆ.",
        "scheInvt_host": "ಹೋಸ್ಟ್:",
        "scheInvt_minutes": "ನಿಮಿಷಗಳು",
        // ವೆಬ್ನಾರ್ 1
        "scheInvt_add": "ಸೇರಿಸಿ",
        "scheInvt_no_participants_added": "ಭಾಗವಹಿಸುವವರನ್ನು ಸೇರಿಸಲಾಗಿಲ್ಲ",
        "scheInvt_add_ppl_to_meetings": "ನಿಮ್ಮ ವಿಳಾಸ ಪುಸ್ತಕದಿಂದ ಭಾಗವಹಿಸುವವರಾಗಿ ಈ ಸಭೆಗೆ ಜನರನ್ನು ಸೇರಿಸಿ, ಅಥವಾ ಹುಡುಕಾಟದ ಮೂಲಕ ಸೇರಿಸಿ.",
        "scheInvt_send_invitation": "ಆಹ್ವಾನವನ್ನು ಕಳುಹಿಸಿ",
        "scheInvt_send_passcodes": "ಪಾಸ್ಕೋಡ್ಗಳನ್ನು ಪ್ರತ್ಯೇಕ ಮೇಲ್ನಲ್ಲಿ ಕಳುಹಿಸಿ.",
        // ಆಹ್ವಾನ - ಘಟಕ - ಆಹ್ವಾನಿತ ವ್ಯಕ್ತಿ
        "invitBody_invite_only_upto": "ನೀವು 10 ಜನರನ್ನು ಮಾತ್ರ ಆಹ್ವಾನಿಸಬಹುದು",
        "invitBody_invite_ppl_meeting_email_add": "ಈ ಸಭೆಗೆ ಜನರನ್ನು ಆಹ್ವಾನಿಸಿ, ನಿಮ್ಮ ವಿಳಾಸ ಪುಸ್ತಕದಿಂದ ಜನರನ್ನು ಸೇರಿಸಿ, ಅಥವಾ ಇಮೇಲ್ ವಿಳಾಸದ ಮೂಲಕ ಸೇರಿಸಿ.",
        "invitBody_copy": "ನಕಲಿಸಿ",
        "invitBody_enter_emailid": "ಇಮೇಲ್ ಐಡಿ ನಮೂದಿಸಿ",
        "invitBody_close": "ಮುಚ್ಚು",
        "invitBody_send_invitation": "ಆಹ್ವಾನವನ್ನು ಕಳುಹಿಸಿ",
        // ಡಾಕ್ಯುಮೆಂಟ್ ಶೇರ್
        // ಸೂಚ್ಯಂಕ, ಜೆ.ಎಸ್
        "docShare_doc_sharing": "ಡಾಕ್ಯುಮೆಂಟ್ ಹಂಚಿಕೆ",
        "docShare_upload_doc_system_pdf": "ನಿಮ್ಮ ಸಿಸ್ಟಮ್ನಿಂದ ಡಾಕ್ಯುಮೆಂಟ್ ಅನ್ನು ಅಪ್ಲೋಡ್ ಮಾಡಿ, ಅದು .ಪಿಡಿಎಫ್, ಎಕ್ಸೆಲ್, ಪದ ಡಾಕ್ಯುಮೆಂಟ್ ಅನ್ನು ಬೆಂಬಲಿಸುತ್ತದೆ.",
        "docShare_upload_doc": "ಡಾಕ್ಯುಮೆಂಟ್ ಅಪ್ಲೋಡ್",
        "docShare_no_doc": "ದಾಖಲೆಗಳಿಲ್ಲ",
        "docShare_no_doc_in_list": "ಪಟ್ಟಿಗೆ ಇನ್ನೂ ಯಾವುದೇ ದಾಖಲೆಗಳನ್ನು ಸೇರಿಸಲಾಗಿಲ್ಲ.",
        "docShare_add_doc": "ಡಾಕ್ಯುಮೆಂಟ್ಗಳನ್ನು ಸೇರಿಸಲಾಗಿದೆ",
        "docShare_alert_title_doc": "ದಯವಿಟ್ಟು ಡಾಕ್ಯುಮೆಂಟ್ನ ಶೀರ್ಷಿಕೆಯನ್ನು ನಮೂದಿಸಿ",
        "docShare_alert_something_went_wrong": "ಏನೋ ತಪ್ಪಾಗಿದೆ ದಯವಿಟ್ಟು ಮತ್ತೆ ಪ್ರಯತ್ನಿಸಿ",
        // ಘಟಕಗಳು - ಪರ್ಮಿಟ್ಡಾಕ್ಶೇರ್
        "permDocShr_permit_doc_share_access": "ಡಾಕ್ಯುಮೆಂಟ್ ಹಂಚಿಕೆ ಪ್ರವೇಶವನ್ನು ಅನುಮತಿಸಿ",
        "permDocShr_req_permission_doc_share": "ಡಾಕ್ಯುಮೆಂಟ್ ಹಂಚಿಕೆಯನ್ನು ಪ್ರವೇಶಿಸಲು ಅನುಮತಿಯನ್ನು ಕೋರಿದೆ.",
        "permDocShr_deny": "ನಿರಾಕರಿಸು",
        "permDocShr_allow": "ಅನುಮತಿಸು",
        // ಘಟಕಗಳು - ವಿನಂತಿ ಡಾಕ್ ಶೇರ್
        "reqDocShr_req_doc_share_access": "ಡಾಕ್ಯುಮೆಂಟ್ ಹಂಚಿಕೆ ಪ್ರವೇಶವನ್ನು ವಿನಂತಿಸಿ",
        "reqDocShr_access_permission_host": "ಡಾಕ್ಯುಮೆಂಟ್ ಹಂಚಿಕೆಯನ್ನು ಸಕ್ರಿಯಗೊಳಿಸಲು, ನಿಮಗೆ ಹೋಸ್ಟ್ನಿಂದ ಪ್ರವೇಶ ಅನುಮತಿ ಬೇಕು.",
        "reqDocShr_permission_start_doc_share": "(ಹೋಸ್ಟ್) ಡಾಕ್ಯುಮೆಂಟ್ ಹಂಚಿಕೆಯನ್ನು ಪ್ರಾರಂಭಿಸಲು ಅನುಮತಿ.",
        "reqDocShr_doc_share": "ಡಾಕ್ಯುಮೆಂಟ್ ಹಂಚಿಕೆ!",
        // ಘಟಕಗಳು - ಶೋ ಡಾಕ್ಯುಮೆಂಟ್ ವೀಕ್ಷಣೆ
        "showDocViewback": "ಹಿಂದೆ",
        "showDocViewdoc_title_name": "ಡಾಕ್ಯುಮೆಂಟ್ ಶೀರ್ಷಿಕೆ ಹೆಸರು",
        "showDocViewnext": "ಮುಂದೆ",
        "showDocViewprevious": "ಹಿಂದಿನ",
        // ಪ್ರಸಾರ -
        // ಬೋರಾಡ್ಕಾಸ್ಟ್ಸ್ಕ್ರೀನ್ಶೇರ್
        "borcstScreen_alert_unsupported": "ಬೆಂಬಲಿಸದ ಆಟದ ಆದೇಶವನ್ನು ವಿನಂತಿಸಲಾಗಿದೆ. ಬೆಂಬಲಿತ ಸ್ವರೂಪಗಳು ವೆಬ್ಆರ್ಟಿಸಿ ಮತ್ತು ಎಚ್ಎಲ್ಎಸ್. ಪ್ಲೇಓರ್ಡರ್ = ವೆಬ್ಆರ್ಟಿಸಿ, ಎಚ್ಎಲ್ಎಸ್",
        "borcstScreen_alert_no_stream_spec": "ಯಾವುದೇ ಸ್ಟ್ರೀಮ್ ಅನ್ನು ನಿರ್ದಿಷ್ಟಪಡಿಸಲಾಗಿಲ್ಲ. ದಯವಿಟ್ಟು? ಐಡ್ = {ಸ್ಟ್ರೀಮ್_ಐಡ್ ಯೂ ರ್ ಲ್ ಅನ್ನು ಯೂ ರ್ ಲ್ ಗೆ ಸೇರಿಸಿ",
        "borcstScreen_Plz_enable_js": "ಈ ವೀಡಿಯೊವನ್ನು ವೀಕ್ಷಿಸಲು ದಯವಿಟ್ಟು ಜಾವಾಸ್ಕ್ರಿಪ್ಟ್ ಅನ್ನು ಸಕ್ರಿಯಗೊಳಿಸಿ, ಮತ್ತು ವೆಬ್ ಬ್ರೌಸರ್ಗೆ ಅಪ್ಗ್ರೇಡ್ ಮಾಡುವುದನ್ನು ಪರಿಗಣಿಸಿ",
        "borcstScreen_support_HTML5": "ಏಚ್ ಟ್ ಮ್ ಲ್5 ವೀಡಿಯೊವನ್ನು ಬೆಂಬಲಿಸುತ್ತದೆ",
        "borcstScreen_steam_play_when_live": "ವೀಡಿಯೊ ಸ್ಟ್ರೀಮ್ ಲೈವ್ ಆಗಿರುವಾಗ ಪ್ಲೇ ಆಗುತ್ತದೆ",
        // ಪ್ರಸಾರ
        "borcstScreen_alert_unsupported" : "ಬೆಂಬಲಿಸದ ಆಟದ ಆದೇಶವನ್ನು ವಿನಂತಿಸಲಾಗಿದೆ. ಬೆಂಬಲಿತ ಸ್ವರೂಪಗಳು ವೆಬ್ಆರ್ಟಿಸಿ ಮತ್ತು ಎಚ್ಎಲ್ಎಸ್. ಪ್ಲೇಓರ್ಡರ್ = ವೆಬ್ಆರ್ಟಿಸಿ, ಎಚ್ಎಲ್ಎಸ್ ಅನ್ನು ಬಳಸಿ",
        "borcstScreen_alert_no_stream_spec" :"ಯಾವುದೇ ಸ್ಟ್ರೀಮ್ ಅನ್ನು ನಿರ್ದಿಷ್ಟಪಡಿಸಲಾಗಿಲ್ಲ. ದಯವಿಟ್ಟು ಯೂ ರ್ ಲ್ಗೆ ಸೇರಿಸಿ?  ಐಡ್ = {ಸ್ಟ್ರೀಮ್_ಐಡ್ ಯೂ ರ್ ಲ್ ಸೇರಿಸಿ ಅನ್ನು ಸೇರಿಸಿ",
        "broadcast_enter_your_name" : "ದಯವಿಟ್ಟು ನಿಮ್ಮ ಹೆಸರನ್ನು ನಮೂದಿಸಿ",
        "broadcast_enter_your_email" : "ದಯವಿಟ್ಟು ನಿಮ್ಮ ಇಮೇಲ್ ನಮೂದಿಸಿ",
        "broadcast_user_details" : "ಬಳಕೆದಾರರ ವಿವರಗಳು",
        "broadcast_submit_next" : "ಸಲ್ಲಿಸು",
        "Broadcast_Plz_enable_js": "ಈ ವೀಡಿಯೊವನ್ನು ವೀಕ್ಷಿಸಲು ದಯವಿಟ್ಟು ಜಾವಾಸ್ಕ್ರಿಪ್ಟ್ ಅನ್ನು ಸಕ್ರಿಯಗೊಳಿಸಿ, ಮತ್ತು ವೆಬ್ ಬ್ರೌಸರ್ಗೆ ಅಪ್ಗ್ರೇಡ್ ಮಾಡುವುದನ್ನು ಪರಿಗಣಿಸಿ",
        "broadcast_support_HTML5" :  " HTML5ವೀಡಿಯೊವನ್ನು ಬೆಂಬಲಿಸುತ್ತದೆ",
        "broadcast_steam_play_when_live" : "ವೀಡಿಯೊ ಸ್ಟೀಮ್ ಲೈವ್ ಆಗಿರುವಾಗ ಪ್ಲೇ ಆಗುತ್ತದೆ",
        // ಪ್ರಸಾರ ಕಾನ್ಫರೆನ್ಸ್
        "brdcstConf_whiteboard": "ವೈಟ್ಬೋರ್ಡ್",
        "brdcstConf_screen_share": "ಸ್ಕ್ರೀನ್ ಹಂಚಿಕೆ",
        // "brdcstConf_participants": "ಭಾಗವಹಿಸುವವರು",
        "brdcstConf_broadcast": "ಪ್ರಸಾರ",
        "brdcstConf_right": "ಸರಿ",
        // ಪ್ರಸಾರ - ಘಟಕ
        // ಬ್ರಾಡ್ಕಾಸ್ಟರ್ ಪ್ಯಾರಿಸಿಪೆಂಟ್ಸ್
        "brdcstPart_broadcast_list": "ಬ್ರಾಡ್ಕಾಸ್ಟರ್ ಪಟ್ಟಿ",
        // ಕಂಟೇನರ್ಗಳು - ಕ್ಯಾಲೆಂಡರ್
        // ಸೂಚ್ಯಂಕ
        "calender_scheduled_calendar": "ವೇಳಾಪಟ್ಟಿ ಕ್ಯಾಲೆಂಡರ್",
        "calender_select_all": "ಎಲ್ಲವನ್ನೂ ಆರಿಸಿ",
        "calender_calender" : "ಕ್ಯಾಲೆಂಡರ್",
        "calender_daily" : "ಡೈಲಿ",
        "calender_weekly" : "ಸಾಪ್ತಾಹಿಕ",
        "calender_month" :  "ತಿಂಗಳು",
        "calender_today" :  "ಇಂದು",
        // ಡ್ಯಾಶ್ಬೋರ್ಡ್ - ಅನುಪಾತ
        // ಮೀಟಿಂಗ್ ರಿಮೈಂಡರ್
        "meetReminder_scheduled_confirm": "ವೇಳಾಪಟ್ಟಿ ದೃಢೀಕರಣ",
        "meetReminder_meeting_has_been_scheduled": "ಕೆಳಗಿನ ಸಭೆಯನ್ನು ಈ ಕ್ಷಣದಲ್ಲಿ ನಿಗದಿಪಡಿಸಲಾಗಿದೆ",
        "meetReminder_start_meeting": "ಈ ಸಭೆಯನ್ನು ಪ್ರಾರಂಭಿಸಿ",
        "meetReminder_join_meeting": "ಈ ಸಭೆಯಲ್ಲಿ ಸೇರಿ",
        "meetReminder_quick_start_another_meeting": "ಮತ್ತೊಂದು ಸಭೆಯನ್ನು ತ್ವರಿತವಾಗಿ ಪ್ರಾರಂಭಿಸಿ",
        // MyMeetingItem
        "myMeetItem_start": "ಪ್ರಾರಂಭಿಸು",
        "myMeetItem_for": "ಗಾಗಿ",
        "myMeetItem_minutes": "ನಿಮಿಷಗಳು",
        "myMeetItem_host": "ಹೋಸ್ಟ್:",
        // ಮೈಮೀಟಿಂಗ್
        "myMeet_my_meetings": "ನನ್ನ ಸಭೆಗಳು",
        "myMeet_search_my_meetings": "ನನ್ನ ಸಭೆಗಳನ್ನು ಹುಡುಕಿ",
        // NoScheduledMeeting
        "noScheMeet_no_meeting_scheduled": "ಸಭೆಗಳಿಲ್ಲ",
        "noScheMeet_no_upcoming_meetings": "ನೀವು ಇನ್ನೂ ಮುಂಬರುವ ಸಭೆಗಳನ್ನು ನಿಗದಿಪಡಿಸಿಲ್ಲ. ನೀವು ಹೊಸ ವೇಳಾಪಟ್ಟಿಯನ್ನು ರಚಿಸಬಹುದು ಅಥವಾ ನಿಮ್ಮ ಸಮ್ಮೇಳನವನ್ನು ತ್ವರಿತವಾಗಿ ಪ್ರಾರಂಭಿಸಬಹುದು.",
        "noScheMeet_create_schedule": "ವೇಳಾಪಟ್ಟಿಯನ್ನು ರಚಿಸಿ",
        "noScheMeet_quick_start": "ತ್ವರಿತ ಪ್ರಾರಂಭ",
        "noScheMeet_or": "ಅಥವಾ",
        // ರೂಮ್ಸೆಟ್ಟಿಂಗ್ಗಳು
        "roomSet_alert_select_license": "ದಯವಿಟ್ಟು ಪರವಾನಗಿಯನ್ನು ಆರಿಸಿ",
        "roomSet_manage_licenses": "ಪರವಾನಗಿಗಳನ್ನು ನಿರ್ವಹಿಸಿ",
        "ರೂಮ್ಸೆಟ್_ಪ್ಯಾಕೇಜ್": "ಪ್ಯಾಕೇಜ್",
        "roomSet_no_of_rooms": "ಕೊಠಡಿಗಳ ಸಂಖ್ಯೆ",
        "roomSet_no_of_user": "ಬಳಕೆದಾರರ ಸಂಖ್ಯೆ",
        "roomSet_purchased_on": "ಖರೀದಿಸಲಾಗಿದೆ",
        "roomSet_expired_on": "ಅವಧಿ ಮೀರಿದೆ",
        "roomSet_create_room": "ಕೊಠಡಿ ರಚಿಸಿ",
        // ಸಮ್ಮೇಳನ - ಘಟಕ
        // ಆಡ್ಸಿಪ್ಡೆವಿಸ್
        "addSipDev_add_sip_details": "ಎಸ್‌ಐಪಿ ವಿವರಗಳನ್ನು ಸೇರಿಸಿ",
        "addSipDev_sip_address": "ಎಸ್‌ಐಪಿ ವಿಳಾಸ:",
        "addSipDev_connect": "ಸಂಪರ್ಕಿಸು",
        "addSipDev_enter_sip_address": "ಎಸ್‌ಐಪಿ ವಿಳಾಸವನ್ನು ನಮೂದಿಸಿ",
        // ಕಾನ್ಫ್ನೋಟಿಫಿಕೇಶನ್
        "confNotf_notification": "ಅಧಿಸೂಚನೆಗಳು",
        "confNotf_user_name": "ಬಳಕೆದಾರರ ಹೆಸರು",
        "confNotf_want_to_join": "ಈ ಸಭೆ ಕೊಠಡಿಗೆ ಸೇರಲು ಬಯಸಿದೆ.",
        "confNotf_allow": "ಅನುಮತಿಸು",
        "confNotf_deny": "ನಿರಾಕರಿಸು",
        "confNotf_ask_question": "ಒಂದು ಪ್ರಶ್ನೆಯನ್ನು ಕೇಳಿದೆ.",
        "confNotf_send_msg_lobby": "ಲಾಬಿಯಿಂದ ಸಂದೇಶವನ್ನು ಕಳುಹಿಸಲಾಗಿದೆ.",
        // ಲೋಡಿ
        "lobby_participants_loddy" : "ಲಾಬಿಯಲ್ಲಿ ಭಾಗವಹಿಸುವವರು",
        "lobby_pramote_all": "ಎಲ್ಲವನ್ನು ಪ್ರಚಾರ ಮಾಡಿ",
        "lobby_user_name": "ಬಳಕೆದಾರರ ಹೆಸರು",
        // RemoveUserDialog
        "removeUserDlg_manage_user_selecting": "ಈ ಯಾವುದೇ ಆಯ್ಕೆಗಳನ್ನು ಆರಿಸುವ ಮೂಲಕ ಈ ಬಳಕೆದಾರರನ್ನು ನಿರ್ವಹಿಸಿ:",
        "removeUserDlg_user_name": "ಬಳಕೆದಾರರ ಹೆಸರು",
        "removeUserDlg_block_participant": "ಭಾಗವಹಿಸುವವರನ್ನು ನಿರ್ಬಂಧಿಸಿ",
        "removeUserDlg_send_to_lobby": "ಲಾಬಿಗೆ ಕಳುಹಿಸಿ",
        "removeUserDlg_remote_participant": "ಭಾಗವಹಿಸುವವರನ್ನು ತೆಗೆದುಹಾಕಿ",
        "removeUserDlg_close": "ಮುಚ್ಚು",
        // ಭಾಗವಹಿಸುವವರ ಪಟ್ಟಿ
        "PartList_participants_in_lobby" : "ಲಾಬಿಯಲ್ಲಿ ಭಾಗವಹಿಸುವವರು",
        "PartList_alert_something_went_wrong" : "ಏನೋ ತಪ್ಪಾಗಿದೆ, ದಯವಿಟ್ಟು ಮತ್ತೆ ಪ್ರಯತ್ನಿಸಿ",
        "PartList_in_webinar" : "ವೆಬ್ನಾರ್ನಲ್ಲಿ",
        "PartList_promote_all" : "ಎಲ್ಲವನ್ನು ಪ್ರಚಾರ ಮಾಡಿ",
        // ಭಾಗವಹಿಸುವವರು 2020 ಮರುಪ್ರಯತ್ನಿಸಿ
        //ನಿರೀಕ್ಷಣಾ ಕೋಣೆ
        "waitRoom_nighting_room": "ಕಾಯುವ ಕೋಣೆ",
        "waitRoom_plz_night_host_allow": "ಸಮ್ಮೇಳನಕ್ಕೆ ಸೇರಲು ಹೋಸ್ಟ್ ನಿಮಗೆ ಅವಕಾಶ ನೀಡುವವರೆಗೆ ದಯವಿಟ್ಟು ಕಾಯಿರಿ.",
        "waitRoom_chat": "ಚಾಟ್",
        "waitRoom_mins": "ನಿಮಿಷಗಳು",
        "waitRoom_no_msg_yet": "ಯಾವುದೇ ಸಂದೇಶಗಳಿಲ್ಲ, ಇನ್ನೂ!",
        "waitRoom_no_msg_from_host": "ಹೋಸ್ಟ್ನಿಂದ ಯಾವುದೇ ಸಂದೇಶಗಳಿಲ್ಲ.",
        // ಬಳಕೆದಾರ ತೆಗೆದುಹಾಕಲಾಗಿದೆ
        "userRemoved_you_removed_by_host": "ನಿಮ್ಮನ್ನು ಭಾಗವಹಿಸುವವರ ಪಟ್ಟಿಯಿಂದ ಹೋಸ್ಟ್ನಿಂದ ತೆಗೆದುಹಾಕಲಾಗಿದೆ",
        // ಆಹ್ವಾನ ಸ್ಲೈಡ್
        "invitSlide_invite": "ಆಹ್ವಾನಿಸು",
        "invitSlide_add_email": "ಇಮೇಲ್ಗಳನ್ನು ಸೇರಿಸಿ",
        "invitSlide_add": "ಸೇರಿಸಿ",
        "invitSlide_broadcast_list": "ಪ್ರಸಾರ ಲಿಂಕ್",
        "invitSlide_invite_people_to_meeting": "ಈ ಸಭೆಗೆ ಜನರನ್ನು ಆಹ್ವಾನಿಸಿ. ಜನರನ್ನು ಅವರ ಇಮೇಲ್ ವಿಳಾಸವನ್ನು ಟೈಪ್ ಮಾಡುವ ಮೂಲಕ ಸೇರಿಸಿ ಮತ್ತು ಆಹ್ವಾನವನ್ನು ಕಳುಹಿಸಲು ಪಟ್ಟಿಗೆ ಸೇರಿಸಿ.",
        "invitSlide_err_invalid_id": "ಅಮಾನ್ಯ ಇಮೇಲ್ ಐಡಿ",
        // ಭಾಗವಹಿಸುವವರು ಚಾಟ್
        "particiChat_no_chat_msg": "ಇನ್ನೂ ಚಾಟ್ ಸಂದೇಶಗಳಿಲ್ಲ!",
        "particiChat_start_conversation": "ಇಲ್ಲಿ ಸಂದೇಶಗಳನ್ನು ನೋಡಲು ಸಂವಾದವನ್ನು ಪ್ರಾರಂಭಿಸಿ.",
        // ಘಟಕಗಳು - ಲಾಬಿಪಾರ್ಟಿಸಿಪಂಟ್ಸ್
        "lobbyPartici_no_participants" :"ಭಾಗವಹಿಸುವವರು ಇಲ್ಲ",
        "lobbyPartici_no_participants_lobby" : "ಲಾಬಿಯಲ್ಲಿ ಭಾಗವಹಿಸುವವರು ಯಾರೂ ಇಲ್ಲ.",
        // ಸಮ್ಮೇಳನ
        // ಸಿಮುಲ್ಕಾಸ್ಟ್
        "simulcast_alert_decline_access": "ಹೋಸ್ಟ್ ಪ್ರವೇಶವನ್ನು ನಿರಾಕರಿಸಿದೆ",
        "simulcast_invalid_url": "ಅಮಾನ್ಯ ಯೂ ರ್ ಲ್",
        "simulcast_no_host_available": "ಈ ಕ್ಷಣದಲ್ಲಿ ಯಾವುದೇ ಹೋಸ್ಟ್ ಲಭ್ಯವಿಲ್ಲ ಎಂದು ತೋರುತ್ತಿದೆ, ದಯವಿಟ್ಟು ಸ್ಕ್ರೀನ್ಯನ್ನು ಹಂಚಿಕೊಳ್ಳಲು ಹೋಸ್ಟ್ ಆಗಿ",
        // simulcastVAD & // Conference.js
        "conference_access_to_participants" : "ಭಾಗವಹಿಸುವವರಿಗೆ ಪ್ರವೇಶ",
        "conference_screen_share" : "ಸ್ಕ್ರೀನ್ ಶೇರ್",
        "conference_chat" : "ಚಾಟ್",
        "conference_lock_all" :  "ಎಲ್ಲವನ್ನೂ ಲಾಕ್ ಮಾಡಿ",
        "conference_lock_conf" : "ಲಾಕ್ ಕಾನ್ಫರೆನ್ಸ್",
        "conference_become_host" :"ಹೋಸ್ಟ್ ಆಗಿ",
        "conference_you_are_host" : "ನೀವು ಹೋಸ್ಟ್",
        "conference_share" :"ಹಂಚಿಕೊಳ್ಳಿ",
        "conference_document_share" :"ಡಾಕ್ಯುಮೆಂಟ್ ಶೇರ್",
        "conference_content_share" : "ವಿಷಯ ಹಂಚಿಕೆ",
        "conference_more" :"ಇನ್ನಷ್ಟು ...",
        "conference_become_host" :  "ಹೋಸ್ಟ್ ಆಗಿ",
        "conference_alert_no_host_aval_screen" :  "ಈ ಕ್ಷಣದಲ್ಲಿ ಯಾವುದೇ ಹೋಸ್ಟ್ ಲಭ್ಯವಿಲ್ಲ ಎಂದು ತೋರುತ್ತಿದೆ, ದಯವಿಟ್ಟು ಸ್ಕ್ರೀನ್ಯನ್ನು ಹಂಚಿಕೊಳ್ಳಲು ಹೋಸ್ಟ್ ಆಗಿ",
        "conference_alert_no_host_aval_doc" :  "ಈ ಕ್ಷಣದಲ್ಲಿ ಯಾವುದೇ ಹೋಸ್ಟ್ ಲಭ್ಯವಿಲ್ಲ ಎಂದು ತೋರುತ್ತಿದೆ, ದಯವಿಟ್ಟು ಡಾಕ್ಯುಮೆಂಟ್ ಹಂಚಿಕೊಳ್ಳಲು ಹೋಸ್ಟ್ ಆಗಿ",
        "conference_alert_err_sip_device" : "ಸಿಪ್ ಸಾಧನವನ್ನು ಸಂಪರ್ಕಿಸುವಾಗ ದೋಷ",
        "conference_alert_host_decline_access" : "ಹೋಸ್ಟ್ ಪ್ರವೇಶವನ್ನು ನಿರಾಕರಿಸಿದೆ",
        "conference_alert_invalid_url" :"ಅಮಾನ್ಯ URL",
        "conference_unmute_mic_start_talk" :"ಮಾತನಾಡಲು ಪ್ರಾರಂಭಿಸಲು ನಿಮ್ಮ ಮೈಕ್ರೊಫೋನ್ ಅನ್ಮ್ಯೂಟ್ ಮಾಡಿ",
        // ಉಪಕರಣಗಳು
        "confTools_New_whiteboard": "ನಿಮ್ಮ ಹೊಸ ವೈಟ್ಬೋರ್ಡ್ ಇಲ್ಲಿಗೆ ಬರುತ್ತದೆ",
        "confTools_video_sync": "ನಿಮ್ಮ ವೀಡಿಯೊ ಸಿಂಕ್",
        "confTools_microphone": "ಮೈಕ್ರೊಫೋನ್",
        "confTools_type_text_here": "ನಿಮ್ಮ ಪಠ್ಯವನ್ನು ಟೈಪ್ ಮಾಡಿ ...",
        "whiteboard" :  "ವೈಟ್ಬೋರ್ಡ್",

        // ಸಭೆ ರೆಕಾರ್ಡಿಂಗ್
        "meetRec_video_rec_meeting_name": "ಸಭೆಯ ಹೆಸರಿನ ವೀಡಿಯೊ ರೆಕಾರ್ಡಿಂಗ್",
        "meetRec_page_view": "ಪುಟ ವೀಕ್ಷಣೆ:",
        // ಸಭೆ ರೆಕಾರ್ಡಿಂಗ್- ರೆಕಾರ್ಡಿಂಗ್ ಲಿಸ್ಟ್ ವ್ಯೂ
        "recListView_title_name_rec": "ರೆಕಾರ್ಡಿಂಗ್ನ ಶೀರ್ಷಿಕೆ ಹೆಸರು",
        "recListView_name_user": "ಬಳಕೆದಾರರ ಹೆಸರು",
        // ////////////////////////////////////////// ////////////////////
        // ಎಸ್.ಆರ್.ಸಿ.
        // ಘಟಕ - ಸಾಮಾನ್ಯ - ಬ್ರೌಸರ್ ಅಪ್ಗ್ರೇಡ್
        "brwUpg_req_fun_not_avail": "ನಿಮ್ಮ ಬ್ರೌಸರ್ನಲ್ಲಿ ಅಗತ್ಯವಾದ ಕಾರ್ಯಗಳು ಲಭ್ಯವಿಲ್ಲ",
        "brwUpg_meeting_req_fun_sup": "ಈ ಸಭೆ ಸೇವೆಗೆ ನಿಮ್ಮ ಬ್ರೌಸರ್ ಬೆಂಬಲಿಸದ ಕ್ರಿಯಾತ್ಮಕವಾದಿಯ ಅಗತ್ಯವಿದೆ.",
        "brwUpg_plz_upgrade": "ದಯವಿಟ್ಟು ಅಪ್ಗ್ರೇಡ್ ಮಾಡಿ, ಬೇರೆ ಬ್ರೌಸರ್ಗೆ ಬದಲಾಯಿಸಿ, ಅಥವಾ ನಿಮ್ಮ ಸೆಟ್ಟಿಂಗ್ಗಳನ್ನು ಪರಿಶೀಲಿಸಿ. ಬೆಂಬಲಿತ ಬ್ರೌಸರ್ಗಳು:",
        // "ಸ್ಯಾಮ್ಸಂಗ್ ಇಂಟರ್ನೆಟ್
        // ಘಟಕ - ಸಾಮಾನ್ಯ - ಹೆಡರ್ - ಹೆಡರ್.ಜೆಎಸ್
        "header_content": "ವಿಷಯ (ಬೀಟಾ)",
        "header_loading" : "ಲೋಡ್ ಆಗುತ್ತಿದೆ ...",

        //containers/admin/plans/components/createPlan.js
        "crtePln_plz_enter_name": "ದಯವಿಟ್ಟು ಯೋಜನೆಯ ಹೆಸರನ್ನು ನಮೂದಿಸಿ",
        "crtePln_plz_amount_Plan": "ದಯವಿಟ್ಟು ಯೋಜನೆಯ ಮೊತ್ತವನ್ನು ನಮೂದಿಸಿ",
        "crtePln_plz_enter_des": "ದಯವಿಟ್ಟು ವಿವರಣೆಯನ್ನು ನಮೂದಿಸಿ",
        "crtePln_Plz_sel_product": "ದಯವಿಟ್ಟು ಉತ್ಪನ್ನವನ್ನು ಆರಿಸಿ",
        "crtePln_plz_sel_no_host": "ದಯವಿಟ್ಟು ಅತಿಥೇಯಗಳ ಸಂಖ್ಯೆಯನ್ನು ಆರಿಸಿ",
        "crtePln_plz_enter_no_participants": "ದಯವಿಟ್ಟು ಭಾಗವಹಿಸುವವರ ಸಂಖ್ಯೆಯನ್ನು ನಮೂದಿಸಿ",
        "crtePln_plz_enter_roomno": "ದಯವಿಟ್ಟು ಕೊಠಡಿಗಳ ಸಂಖ್ಯೆಯನ್ನು ನಮೂದಿಸಿ",
        "crtePln_select_period": "ದಯವಿಟ್ಟು ಅವಧಿಯನ್ನು ಆರಿಸಿ",
        "crtePln_sel_interval": "ದಯವಿಟ್ಟು ಮಧ್ಯಂತರವನ್ನು ಆರಿಸಿ",
        "crtePln_update_succ": "ಯಶಸ್ವಿಯಾಗಿ ನವೀಕರಿಸಲಾಗಿದೆ",
        "crtePln_err_creating_plan": "ಯೋಜನೆಯನ್ನು ರಚಿಸುವಲ್ಲಿ ದೋಷ",

        //containers/broadcast/components/BroadcastHandRaise.js
        "brdcRaise_alert_question_50_char": "ನಿಮ್ಮ ಪ್ರಶ್ನೆಗೆ ಕನಿಷ್ಠ 50 ಅಕ್ಷರಗಳ ಚಾಟ್ ಇರಬೇಕು",
        // ಪಾತ್ರೆಗಳು / ಸಮ್ಮೇಳನ / ಘಟಕಗಳು / ಘಟಕಗಳು
        "cofCom_no_part_lobby": "ಲಾಬಿಯಲ್ಲಿ ಭಾಗವಹಿಸುವವರು ಯಾರೂ ಇಲ್ಲ.",
        //containers/conference/components/ConfirmUserDetails.js
        "confmUser_plz_provide_name_email": "ದಯವಿಟ್ಟು ನಿಮ್ಮ ಹೆಸರು ಮತ್ತು ಇಮೇಲ್ ಒದಗಿಸಿ",
        "confmUser_notes": "ಟಿಪ್ಪಣಿಗಳು",
        //containers/conference/ConferenceSetup.js
        "confSetup_telepresence": "ಟೆಲಿಪ್ರೆಸೆನ್ಸ್",
        "confSetup_alert_not_generate_meetingID": "ಸಭೆ ಐಡಿ ರಚಿಸಲು ಸಾಧ್ಯವಿಲ್ಲ, ಸ್ವಲ್ಪ ಸಮಯದ ನಂತರ ಪ್ರಯತ್ನಿಸಿ",
        "confSetup_auth_part_can_join": "ಅಧಿಕೃತ ಭಾಗವಹಿಸುವವರು ಮಾತ್ರ ಸೇರಬಹುದು !.",
        "confSetup_invalid_link": "ಅಮಾನ್ಯ ಲಿಂಕ್",
        "confSetup_meeting_notyet_started": "ಈ ಸಭೆ ಇನ್ನೂ ಪ್ರಾರಂಭವಾಗಿಲ್ಲ. ದಯವಿಟ್ಟು ನಂತರ ಸೇರಿಕೊಳ್ಳಿ! ನೀವು ಹೋಸ್ಟ್ ಆಗಿದ್ದರೆ, ದಯವಿಟ್ಟು ಇನ್ಸ್ತ ವೀಸೀಗೆ ಲಾಗಿನ್ ಮಾಡಿ ಮತ್ತು ಸಭೆಯನ್ನು ಪ್ರಾರಂಭಿಸಿ",
        "confSetup_meeting_locked_byhost": "ಈ ಸಭೆಯನ್ನು ಹೋಸ್ಟ್ನಿಂದ ಲಾಕ್ ಮಾಡಲಾಗಿದೆ",
        "confSetup_meeting_notyet_started_night_host": "ಈ ಸಭೆ ಇನ್ನೂ ಪ್ರಾರಂಭವಾಗಿಲ್ಲ. ಸಭೆಯನ್ನು ಪ್ರಾರಂಭಿಸಲು ಹೋಸ್ಟ್ಗಾಗಿ ಕಾಯಿರಿ!",
        //containers/conference/components/NewChat.js ",
        "newChat_panel_chat": "ಪ್ಯಾನಲ್ ಚಾಟ್",
        //containers/conference/libs/InstaVC.js
        "instaVc_server_busy": "ಸರ್ವರ್ ಕಾರ್ಯನಿರತವಾಗಿದೆ ಎಂದು ತೋರುತ್ತಿದೆ! ಮತ್ತೊಂದು ಸರ್ವರ್ ಅನ್ನು ಸಂಪರ್ಕಿಸಲು ಪ್ರಯತ್ನಿಸುತ್ತಿದೆ ...",
        // "ಲೋಡ್-ಸಂದೇಶ",
        "instaVc_server_busy_reload_tojoin": "ಸರ್ವರ್ ಕಾರ್ಯನಿರತವಾಗಿದೆ ಎಂದು ತೋರುತ್ತಿದೆ! ಸಮ್ಮೇಳನಕ್ಕೆ ಸೇರಲು ಮರುಲೋಡ್ ಮಾಡಿ",
        "instaVc_broadcast_scr_failed": "ಪ್ರಸಾರ ಸ್ಕ್ರೀನ್ ವಿಫಲವಾಗಿದೆ",
        "instaVc_broadcast_failed": "ಪ್ರಸಾರ ವಿಫಲವಾಗಿದೆ",
        //containers/content/components/contentQuestionnaire/modal-create-quest-group.js
        "modlCreate_plz_enter_title": "ದಯವಿಟ್ಟು ಶೀರ್ಷಿಕೆಯನ್ನು ನಮೂದಿಸಿ",
        "modlCreate_poll": "ಪೋಲ್",
        //containers/content/components/contentQuestionnaire/modal-create-poll-question.js
        "mdlCretPoll_plz_enter_quest": "ದಯವಿಟ್ಟು ಪ್ರಶ್ನೆಯನ್ನು ನಮೂದಿಸಿ",
        "mdlCretPoll_option_should_not_same": "ಆಯ್ಕೆಗಳು ಒಂದೇ ಆಗಿರಬಾರದು",
        "mdlCretPoll_plz_enter_option": "ದಯವಿಟ್ಟು ಆಯ್ಕೆಗಳನ್ನು ನಮೂದಿಸಿ",
        "mdlCretPoll_plz_select_type_option": "ದಯವಿಟ್ಟು ಆಯ್ಕೆಗಳ ಪ್ರಕಾರವನ್ನು ಆರಿಸಿ",
        "alert_server_error": "ಆಂತರಿಕ ಸರ್ವರ್ ದೋಷ, ದಯವಿಟ್ಟು ಮತ್ತೆ ಪ್ರಯತ್ನಿಸಿ",
        "mdlCretPoll_update_ques": "ಪ್ರಶ್ನೆ ನವೀಕರಿಸಿ",
        "mdlCretPoll_create_ques": "ಪ್ರಶ್ನೆಯನ್ನು ರಚಿಸಿ",
        "mdlCretPoll_enter_que_here": "ನಿಮ್ಮ ಪ್ರಶ್ನೆಯನ್ನು ಇಲ್ಲಿ ನಮೂದಿಸಿ",
        "mdlCretPoll_end": "ಅಂತ್ಯ",

        //containers/content/components/contentQuestionnaire/viewQuestionnaire.js
        "delete_successfully": "ಯಶಸ್ವಿಯಾಗಿ ಅಳಿಸಲಾಗಿದೆ",

        //containers/content/components/hozContentNavBlock.js / managementcontent-index.js
        // "mngContent_mngContent_content": "ವಿಷಯ",
        // "mngContent_mngContent_participants": "ಭಾಗವಹಿಸುವವರು",
        "mngContent_mngContent_fav_prog_lang": "ನಿಮ್ಮ ನೆಚ್ಚಿನ ಪ್ರೋಗ್ರಾಮಿಂಗ್ ಭಾಷೆ ಯಾವುದು?",
        "mngContent_mngContent_pollings": "ಮತದಾನ",


        //containers/contentShare/showQuestions.js
        "showQue_obtained_marks": "ಪಡೆದ ಅಂಕಗಳು:",
        //containers/contentShare/viewUserScore.js
        "viewUser_your_grade": "ನಿಮ್ಮ ಗ್ರೇಡ್:",
        //containers/packages/Package.js
        "package_one_host": "1 ಹೋಸ್ಟ್ ಮತ್ತು",
        // "package_participants": "ಭಾಗವಹಿಸುವವರು",
        // ಸೊಹೊ
        // "ಎಸ್ಎಂಬಿ 300
        "package_concurrentUser_room2": "20 ಏಕಕಾಲೀನ ಬಳಕೆದಾರರು - 2 ಕೊಠಡಿಗಳು",
        "package_concurrentUser_room5": "30 ಏಕಕಾಲೀನ ಬಳಕೆದಾರರು -5 ಕೊಠಡಿಗಳು",
        "package_concurrentUser_room20": "100 ಏಕಕಾಲೀನ ಬಳಕೆದಾರರು - 20 ಕೊಠಡಿಗಳು",
        "package_concurrentUser_room30": "200 ಏಕಕಾಲೀನ ಬಳಕೆದಾರರು - 30 ಕೊಠಡಿಗಳು",
        "package_concurrentUser_room50": "500 ಏಕಕಾಲೀನ ಬಳಕೆದಾರರು - 50 ಕೊಠಡಿಗಳು",

        //containers/schedule/components/PastMeetingItem.js
        "pastMeeting_rn": "ಆರ್.ಎನ್",
        "pastMeeting_chat_history_deleted": "ಚಾಟ್ ಇತಿಹಾಸವನ್ನು ಯಶಸ್ವಿಯಾಗಿ ಅಳಿಸಲಾಗಿದೆ",
        "pastMeeting_past_meeting_dtls": "ಹಿಂದಿನ ಸಭೆಯ ವಿವರಗಳು",
        "pastMeeting_duration": "ಅವಧಿ:",
        "pastMeeting_download_parti_atten": "ಭಾಗವಹಿಸುವವರು ಮತ್ತು ಪಾಲ್ಗೊಳ್ಳುವವರನ್ನು ಡೌನ್ಲೋಡ್ ಮಾಡಿ",
        "pastMeeting_download_webinar": "ವೆಬ್ನಾರ್ ಡೌನ್ಲೋಡ್ ಮಾಡಿ",
        // "pastMeeting_participants": "ಭಾಗವಹಿಸುವವರು",
        "pastMeeting_attendees": "ಪಾಲ್ಗೊಳ್ಳುವವರು",
        "pastMeeting_chat_history": "ಚಾಟ್ ಇತಿಹಾಸ",
        "pastMeeting_recordings": "ರೆಕಾರ್ಡಿಂಗ್",
        "pastMeeting_webinar_user": "ವೆಬ್ನಾರ್ ಬಳಕೆದಾರರು",
        "pastMeeting_webinar_chat": "ವೆಬ್ನಾರ್ ಚಾಟ್",
        "pastMeeting_no_participants_in_meeting": "ಈ ಸಭೆಯಲ್ಲಿ ಭಾಗವಹಿಸುವವರು ಇಲ್ಲ!",
        "pastMeeting_no_parti_attended_meeting": "ಈ ಸಭೆಯಲ್ಲಿ ಭಾಗವಹಿಸಿದವರು ಯಾರೂ ಇರಲಿಲ್ಲ.",
        "pastMeeting_guest_list": "ಅತಿಥಿ ಪಟ್ಟಿ",
        "pastMeeting_no_guest_in_meeting": "ಈ ಸಭೆಯಲ್ಲಿ ಅತಿಥಿಗಳಿಲ್ಲ!",
        "pastMeeting_no_guests_were_invited": "ಈ ಸಭೆಯಲ್ಲಿ ಯಾವುದೇ ಅತಿಥಿಗಳು ಆಹ್ವಾನಿಸಲ್ಪಟ್ಟಿಲ್ಲ ಅಥವಾ ಭಾಗವಹಿಸಿಲ್ಲ.",
        "pastMeeting_meeting_chat_history": "ಮೀಟಿಂಗ್ ಚಾಟ್ ಇತಿಹಾಸ",
        "pastMeeting_delete_all": "ಎಲ್ಲವನ್ನೂ ಅಳಿಸಿ",
        "pastMeeting_no_chat_msg_inmeeting": "ಈ ಸಭೆಯಲ್ಲಿ ಚಾಟ್ ಸಂದೇಶಗಳಿಲ್ಲ!",
        "pastMeeting_no_conver_during_meeting": "ಸಭೆಯ ಸಮಯದಲ್ಲಿ ಚಾಟ್ನಲ್ಲಿ ಯಾವುದೇ ಸಂಭಾಷಣೆಗಳಿಲ್ಲ.",
        "pastMeeting_no_user_inwebinar": "ಈ ವೆಬ್ನಾರ್ನಲ್ಲಿ ಬಳಕೆದಾರರಿಲ್ಲ!",
        "pastMeeting_no_user_attand_webinar": "ಈ ವೆಬ್ನಾರ್ಗೆ ಹಾಜರಾದ ಯಾವುದೇ ಬಳಕೆದಾರರು ಇರಲಿಲ್ಲ.",
        "pastMeeting_webinar_chat_history": "ವೆಬ್ನಾರ್ ಚಾಟ್ ಇತಿಹಾಸ",
        "pastMeeting_no_chat_msg_inwebinar": "ಈ ವೆಬ್ನಾರ್ನಲ್ಲಿ ಚಾಟ್ ಸಂದೇಶಗಳಿಲ್ಲ!",
        "pastMeeting_no_conver_during_webinar": "ವೆಬ್ನಾರ್ ಸಮಯದಲ್ಲಿ ಚಾಟ್ನಲ್ಲಿ ಯಾವುದೇ ಸಂಭಾಷಣೆಗಳಿಲ್ಲ.",
        "pastMeeting_del_chat_history": "ಚಾಟ್ ಇತಿಹಾಸವನ್ನು ಅಳಿಸಿ",
        "pastMeeting_delete_all_chat_history": "ನಿಮಗೆ ಖಚಿತವಾಗಿದೆಯೇ, ಎಲ್ಲಾ ಚಾಟ್ ಇತಿಹಾಸವನ್ನು ಶಾಶ್ವತವಾಗಿ ಅಳಿಸಲು ನೀವು ಬಯಸುವಿರಾ?",
        "pastMeeting_delete": "ಅಳಿಸು",
        //containers/schedule/components/Schedules.js
        "schedul_webinar_description": "ವೆಬ್ನಾರ್ ವಿವರಣೆ",
        "schedul_upload_custom_banner": "ನಿಮ್ಮ ವೆಬ್ನಾರ್ ಈವೆಂಟ್ಗಾಗಿ ಕಸ್ಟಮ್ ಬ್ಯಾನರ್ ಅನ್ನು ಅಪ್ಲೋಡ್ ಮಾಡಿ.",
        "schedul_setting" : "ಸೆಟ್ಟಿಂಗ್ಸ್",
        //containers/schedule/components/SchedulesView.js
        "schedulView_time" :"ಸಮಯ",
        "schedulView_edit": "ತಿದ್ದು",
        "schedulView_enable_training_mode": "ತರಬೇತಿ ಮೋಡ್ ಅನ್ನು ಸಕ್ರಿಯಗೊಳಿಸಿ",
        "schedulView_audio_conference" : "ಆಡಿಯೋ ಕಾನ್ಫರೆನ್ಸ್",
        "schedulView_enable_mix_video": "ಪೂರ್ವನಿಯೋಜಿತವಾಗಿ ಮಿಕ್ಸ್ ವೀಡಿಯೊವನ್ನು ಸಕ್ರಿಯಗೊಳಿಸಿ",
        // ವರ್ಗ ಘಟಕಗಳು
        // ವಿಷಯ - ಘಟಕಗಳು - ಹೋಜ಼್ ಕಾಂಟೆಂಟ್ ನಾವ್ ಬ್ಲಾಕ್
        // "hozConNav_content": "ವಿಷಯ",
        // ವೇಳಾಪಟ್ಟಿ ಮೀಟಿಂಗ್
        "scheMeet_room_reserved_from": "ಕೊಠಡಿಯನ್ನು ಕಾಯ್ದಿರಿಸಲಾಗಿದೆ",
        "scheMeet_meeting_name": "ಸಭೆಯ ಹೆಸರಿನೊಂದಿಗೆ",
        // ಡ್ಯಾಶ್ಬೋರ್ಡ್ - ಘಟಕ-ಸಂಪರ್ಕ
        "contact_alert_already_in_call": "ನೀವು ಈಗಾಗಲೇ ಇನ್‌ಕಾಲ್ ಆಗಿರುವಾಗ ನೀವು ಇನ್ನೊಬ್ಬ ಬಳಕೆದಾರರನ್ನು ಕರೆಯಲು ಸಾಧ್ಯವಿಲ್ಲ",
        "contact_alert_user_offline": "ಬಳಕೆದಾರ ಆಫ್ಲೈನ್",
        // ಡ್ಯಾಶ್ಬೋರ್ಡ್ - ಡ್ಯಾಶ್ಬೋರ್ಡ್.ಜೆಎಸ್
        "dashboard_alert_cannot_start" :  "ನೀವು ಇತರ ಕರೆಯಲ್ಲಿರುವಾಗ ನೀವು ಸಮ್ಮೇಳನವನ್ನು ಪ್ರಾರಂಭಿಸಲು ಸಾಧ್ಯವಿಲ್ಲ",
        "dashboard_alert_cannot_join" : "ನೀವು ಇತರ ಕರೆಯಲ್ಲಿದ್ದಾಗ ನೀವು ಸಮ್ಮೇಳನಕ್ಕೆ ಸೇರಲು ಸಾಧ್ಯವಿಲ್ಲ",
        "dashboard_quick_start_conf" : "ತ್ವರಿತ ಪ್ರಾರಂಭ ಸಮ್ಮೇಳನ",
        "dashboard_maintenance_msg": "ವಾಡಿಕೆಯ ನಿರ್ವಹಣೆಯಿಂದಾಗಿ ನಾವು ಏಪ್ರಿಲ್ 22, 2020 ರಂದು 8.30 PM ಐ ಸ್ ಟೀ ರಿಂದ 9.00 PM ಐ ಸ್ ಟೀ ವರೆಗೆ ಸರ್ವರ್ ಅಲಭ್ಯತೆಯನ್ನು ಅನುಭವಿಸುತ್ತಿದ್ದೇವೆ ಎಂಬುದನ್ನು ದಯವಿಟ್ಟು ಗಮನಿಸಿ.",
        // ಸಹ ಬ್ರೌಸಿಂಗ್
        "coBrows_host_share-video": "ದಯವಿಟ್ಟು ನಿರೀಕ್ಷಿಸಿ! ಹೋಸ್ಟ್ ವೀಡಿಯೊವನ್ನು ಹಂಚಿಕೊಳ್ಳಲು ಹೊರಟಿದೆ",
        // ಹೆಚ್ಚುವರಿ ಕ್ಯಾಮೆರಾ
        "addCam_add_device": "ಸಾಧನವನ್ನು ಸೇರಿಸಿ",

        // ಸಾಮಾನ್ಯ ಲಾಂಗ್
        "answer_list": "ಉತ್ತರಗಳ ಪಟ್ಟಿ",
        "answer" : "ಉತ್ತರಗಳು",
        "answered" : "ಉತ್ತರಿಸಲಾಗಿದೆ",
        "correct_answer": "ಸರಿಯಾದ ಉತ್ತರ",
        "please_try_again" :  "ದಯವಿಟ್ಟು ಮತ್ತೆ ಪ್ರಯತ್ನಿಸಿ",
        "question" : "ಪ್ರಶ್ನೆ",
        "cancel" :  "ರದ್ದುಮಾಡು",
        "questionnaire" :"ಪ್ರಶ್ನಾವಳಿ",
        "content" : "ವಿಷಯ",
        "address_book" :"ವಿಳಾಸ ಪುಸ್ತಕ",
        "view" :  "ವೀಕ್ಷಿಸು",
        "rn": "ಆರ್.ಎನ್",

        // ಹೊಸ ಲ್ಯಾಂಗ್ಸ್
        "plz_enter_marks": "ದಯವಿಟ್ಟು ಪ್ರಶ್ನೆಯ ಗುರುತುಗಳನ್ನು ನಮೂದಿಸಿ",
        "plz_sel_crtans": "ದಯವಿಟ್ಟು ಸರಿಯಾದ ಉತ್ತರವನ್ನು ಆರಿಸಿ",
        "truefalse_choice": "ನಿಜ / ತಪ್ಪು ಆಯ್ಕೆ",
        "questionnarie" :"ಪ್ರಶ್ನಾವಳಿ",
        "content_title": "ವಿಷಯ ಶೀರ್ಷಿಕೆ",
        "media_title": "ಮಾಧ್ಯಮ_ಶೀರ್ಷಿಕೆ",
        "add_url_add": "ಯೂ ರ್ ಲ್ ವಿಳಾಸವನ್ನು ಸೇರಿಸಿ ...",
        "val_shuld_grtr_from_val": "ಮೌಲ್ಯಕ್ಕೆ ಮೌಲ್ಯಕ್ಕಿಂತ ದೊಡ್ಡದಾಗಿರಬೇಕು",
        "val_shuld_grtr_grade": "ಮೌಲ್ಯ ಗ್ರೇಡ್ಗಿಂತ ಹೆಚ್ಚಿರಬೇಕು",
        "to_val": "ಮೌಲ್ಯಕ್ಕೆ",
        "enable_hand_raise": "ವೆಬ್ನಾರ್ನಲ್ಲಿ ಕೈ ಎತ್ತುವ / ಪ್ರಶ್ನೆಯನ್ನು ಕೇಳಿ",
        "allow_only_invite": "ಸಮ್ಮೇಳನಕ್ಕೆ ಸೇರಲು ಆಹ್ವಾನಿತರನ್ನು ಮಾತ್ರ ಅನುಮತಿಸಿ",
        "guest_login_anonymous": "ಅತಿಥಿ ಅನಾಮಧೇಯವಾಗಿ ಲಾಗಿನ್ ಮಾಡಬಹುದು",
        "give_name_webinar": "ನಿಮ್ಮ ವೆಬ್ನಾರ್ಗೆ ಹೆಸರನ್ನು ನೀಡಿ",
        "Webinar" : "ವೆಬ್ನಾರ್",
        "video_syn": "ವೀಡಿಯೊ ಸಿಂಕ್",
        "notepad" : "ನೋಟ್ಪ್ಯಾಡ್",
        "enable_handraise": "ವೆಬ್ನಾರ್ನಲ್ಲಿ ಕೈ ಎತ್ತುವಿಕೆಯನ್ನು ಸಕ್ರಿಯಗೊಳಿಸಿ",
        "pastMeeting_notes": "ಟಿಪ್ಪಣಿಗಳು",
        // ಹೊಸ ಒಂದು ವೆಂಕಟೇಶ್
        "polls_list" : "ಮತದಾನ ಪಟ್ಟಿ",
        "no_poll_assign": "ಇನ್ನೂ ಯಾವುದೇ ಸಮೀಕ್ಷೆಯನ್ನು ನಿಯೋಜಿಸಲಾಗಿಲ್ಲ!",
        "poll_view" : "ಪೋಲ್ ವ್ಯೂ",

        // ಹೊಸ ಪ್ರುಧ್ವಿ
        "filter_block": "ಫಿಲ್ಟರ್ ಬ್ಲಾಕ್",
        "file_size": "ಫೈಲ್ ಗಾತ್ರ",
        "select_room": "ದಯವಿಟ್ಟು ಒಂದು ಕೊಠಡಿಯನ್ನು ಆರಿಸಿ",
        "provide_event_name": "ದಯವಿಟ್ಟು ಈವೆಂಟ್ ಹೆಸರನ್ನು ಒದಗಿಸಿ",
        "end_time_greater_start_time": "ಅಂತಿಮ ಸಮಯವು ಪ್ರಾರಂಭದ ಸಮಯಕ್ಕಿಂತ ಹೆಚ್ಚಾಗಿರಬೇಕು!",
        "invite_people_meeting": "ಈ ಸಭೆಗೆ ಜನರನ್ನು ಆಹ್ವಾನಿಸಿ",
        "download_ical": "ಐಕಾಲ್ ಡೌನ್ಲೋಡ್ ಮಾಡಿ",
        "download": "ಡೌನ್ಲೋಡ್",
        "delete_meeting": "ಈ ಸಭೆಯನ್ನು ಅಳಿಸಿ",
        "room":  "ಕೊಠಡಿ",
        "new_event": "ಹೊಸ ಈವೆಂಟ್",
        "end_repeat": "ಎಂಡ್ ರಿಪೀಟ್",
        "invite_users_timezone": "ಕೆಳಗಿನ ಸಮಯವಲಯದೊಂದಿಗೆ ಬಳಕೆದಾರರನ್ನು ಆಹ್ವಾನಿಸಿ",
        "update_event": "ಈವೆಂಟ್ ನವೀಕರಿಸಿ",
        "create_event": "ಈವೆಂಟ್ ರಚಿಸಿ",
        "wrong_password":"ತಪ್ಪಾದ ಪಾಸ್ವರ್ಡ್",
        "college": "ಕಾಲೇಜು",
        "university":"ವಿಶ್ವವಿದ್ಯಾಲಯ",
        "country": "ದೇಶ",
        "time_period": "ಸಮಯದ ಅವಧಿ:",
        "currently_working_here": "ಪ್ರಸ್ತುತ ಇಲ್ಲಿ ಕಾರ್ಯನಿರ್ವಹಿಸುತ್ತಿದೆ",
        "from": "ಇಂದ:",
        "to": "ಗೆ:",
        "graduated":  "ಪದವಿ",
        "enter_description": "ನಿಮ್ಮ ವಿವರಣೆಯನ್ನು ಇಲ್ಲಿ ನಮೂದಿಸಿ ...",
        "concentration": "ಏಕಾಗ್ರತೆ",
        "school": "ಶಾಲೆ",
        "poll_question": "ಸಮೀಕ್ಷೆ ಪ್ರಶ್ನೆ",
        "create_poll_ques": "ಪೋಲ್ ಪ್ರಶ್ನೆಯನ್ನು ರಚಿಸಿ",
        "options":  "ಆಯ್ಕೆಗಳು",
        "no_ques_assigned_yet": "ಇನ್ನೂ ಯಾವುದೇ ಪ್ರಶ್ನೆಗಳನ್ನು ನಿಯೋಜಿಸಲಾಗಿಲ್ಲ!",
        "create_new_ques_click_create_ques": "ಹೊಸ ಪ್ರಶ್ನೆಗಳನ್ನು ರಚಿಸಿ, ಮೇಲಿನ ಕ್ಲಿಕ್ ಬಟನ್ ಕ್ಲಿಕ್ ಮಾಡಲು ಕ್ಲಿಕ್ ಮಾಡಿ",
        "enter_room_name": "ದಯವಿಟ್ಟು ಕೋಣೆಯ ಹೆಸರನ್ನು ನಮೂದಿಸಿ",
        "billed_annually": "* ವಾರ್ಷಿಕವಾಗಿ ಬಿಲ್ ಮಾಡಲಾಗಿದೆ",
        "subscribe_now": "ಈಗ ಚಂದಾದಾರರಾಗಿ",
        "group": "ಗುಂಪು",
        "sample_webinar":"ಸ್ಯಾಂಪಲ್ ವೆಬ್ನಾರ್",
        "webinar_affiliate": "ಅಂಗಸಂಸ್ಥೆಗಳ ಬಗ್ಗೆ ವೆಬ್ನಾರ್",
        "webinar_one": "ವೆಬ್ನಾರ್ ಒನ್",
        "workspace":"ಕಾರ್ಯಕ್ಷೇತ್ರ",
        "company": "ಕಂಪನಿ",
        "add_another": "ಇನ್ನೊಂದನ್ನು ಸೇರಿಸಿ",

        // missing translations, adding english for now, need to convert
        "instavc_conference_picturesmode": "ಈ ವೀಡಿಯೊ ಪಿಕ್ಚರ್-ಇನ್-ಪಿಕ್ಚರ್ ಮೋಡ್‌ನಲ್ಲಿ ಪ್ಲೇ ಆಗುತ್ತಿದೆ",
        "insta_conference_outgoingvideocall": "ಹೊರಹೋಗುವ ವೀಡಿಯೊ ಕರೆ",
        "instavc_meetinglist_pastchedule": "ಹಿಂದಿನ ವೇಳಾಪಟ್ಟಿ",
        "instavc_commercetype": "ವಾಣಿಜ್ಯ ಪ್ರಕಾರ",
        "instavc_commerce": "ವಾಣಿಜ್ಯ",
        "instavc_ontime": "ಒಂದು ಬಾರಿ",
        "instavc_night_for_host": "ದಯವಿಟ್ಟು ಈ ಸಭೆಯನ್ನು ಪ್ರಾರಂಭಿಸಲು ಹೋಸ್ಟ್ ಗಾಗಿ ಕಾಯಿರಿ",
        "instavc_please_wait": "ದಯವಿಟ್ಟು ನಿರೀಕ್ಷಿಸಿ",
        "instavc_nighting_msg": "ಕಾಯುತ್ತಿದ್ದಕ್ಕಾಗಿ ಧನ್ಯವಾದಗಳು. ಹೋಸ್ಟ್ ಸೇರಿದಾಗ ನಾವು ಸಭೆಯನ್ನು ಪ್ರಾರಂಭಿಸುತ್ತೇವೆ",
        "payment_fee": "ಪಾವತಿ ಶುಲ್ಕ",
        "request_withdraw": "ವಿನಂತಿಸಿದ ಮೊತ್ತವನ್ನು ಹಿಂತೆಗೆದುಕೊಳ್ಳಲಾಗಿದೆ",
        "crteContent_create_New_content": "ಹೊಸ ವಿಷಯವನ್ನು ರಚಿಸಿ",
        "viewUserScore_ans Answer": "ಉತ್ತರಿಸಲಾಗಿದೆ",
        "permDocShr_permit_doc_share_access": "ಡಾಕ್ಯುಮೆಂಟ್ ಹಂಚಿಕೆ ಪ್ರವೇಶವನ್ನು ಅನುಮತಿಸಿ",
        "permDocShr_req_permission_doc_share": "ಡಾಕ್ಯುಮೆಂಟ್ ಹಂಚಿಕೆಯನ್ನು ಪ್ರವೇಶಿಸಲು ಅನುಮತಿಯನ್ನು ಕೋರಿದೆ.",
        "permDocShr_deny": "ನಿರಾಕರಿಸು",
        "permitDocShr_allow": "ಅನುಮತಿಸು",
        "reqDocShr_plz_wait": "ದಯವಿಟ್ಟು ಇದಕ್ಕಾಗಿ ಕಾಯಿರಿ",
        "broadcast_alert_unsupported": "ಬೆಂಬಲಿಸದ ಪ್ಲೇ ಆದೇಶವನ್ನು ವಿನಂತಿಸಲಾಗಿದೆ. ಬೆಂಬಲಿತ ಸ್ವರೂಪಗಳು ವೆಬ್‌ಆರ್‌ಟಿಸಿ ಮತ್ತು ಎಚ್‌ಎಲ್‌ಎಸ್. ಪ್ಲೇಓರ್ಡರ್ = ವೆಬ್‌ಆರ್ಟಿಸಿ, ಎಚ್‌ಎಲ್‌ಎಸ್",
       "broadcast_alert_no_stream_spec": "ಯಾವುದೇ ಸ್ಟ್ರೀಮ್ ಅನ್ನು ನಿರ್ದಿಷ್ಟಪಡಿಸಲಾಗಿಲ್ಲ. ದಯವಿಟ್ಟು ಯೂ ರ್ ಲ್ಗ ಸೇರಿಸಿ? ಐ ಡೀ = {ಸ್ಟ್ರೀಮ್_ಐಡ್ ಆಡ್ ಅನ್ನು ಸೇರಿಸಿ",
        "Broadcast_Plz_enable_js": "ಈ ವೀಡಿಯೊವನ್ನು ವೀಕ್ಷಿಸಲು ದಯವಿಟ್ಟು ಜಾವಾಸ್ಕ್ರಿಪ್ಟ್ ಅನ್ನು ಸಕ್ರಿಯಗೊಳಿಸಿ, ಮತ್ತು ವೆಬ್ ಬ್ರೌಸರ್‌ಗೆ ಅಪ್‌ಗ್ರೇಡ್ ಮಾಡುವುದನ್ನು ಪರಿಗಣಿಸಿ",
       "roomSet_package": "ಪ್ಯಾಕೇಜ್",
        "waitRoom_nighting_room": "ಕಾಯುವ ಕೋಣೆ",
        "waitRoom_plz_night_host_allow": "ಸಮ್ಮೇಳನಕ್ಕೆ ಸೇರಲು ಹೋಸ್ಟ್ ನಿಮಗೆ ಅವಕಾಶ ನೀಡುವವರೆಗೆ ದಯವಿಟ್ಟು ಕಾಯಿರಿ.",
        "waitRoom_chat": "ಚಾಟ್",
        "waitRoom_mins": "ನಿಮಿಷಗಳು",
        "waitRoom_no_msg_yet": "ಸಂದೇಶಗಳಿಲ್ಲ, ಇನ್ನೂ!",
        "waitRoom_no_msg_from_host": "ಹೋಸ್ಟ್‌ನಿಂದ ಯಾವುದೇ ಸಂದೇಶಗಳಿಲ್ಲ.",
        "confTools_New_whiteboard": "ನಿಮ್ಮ ಹೊಸ ವೈಟ್‌ಬೋರ್ಡ್ ಇಲ್ಲಿಗೆ ಬರುತ್ತದೆ",
        "confSetup_meeting_notyet_started_night_host": "ಈ ಸಭೆ ಇನ್ನೂ ಪ್ರಾರಂಭವಾಗಿಲ್ಲ. ದಯವಿಟ್ಟು ಸಭೆಯನ್ನು ಪ್ರಾರಂಭಿಸಲು  ಹೋಸ್ಟ್ ಗಾಗಿ ಕಾಯಿರಿ!",
        "instaVc_waiting_for_host": "ಹೋಸ್ಟ್ ವೀಡಿಯೊಗಾಗಿ ಕಾಯಲಾಗುತ್ತಿದೆ",
        "pastMeeting_no_guests_were_invited": "ಈ ಸಭೆಯಲ್ಲಿ ಯಾವುದೇ ಅತಿಥಿಗಳು ಆಹ್ವಾನಿಸಲ್ಪಟ್ಟಿಲ್ಲ ಅಥವಾ ಭಾಗವಹಿಸಿಲ್ಲ.",
        "enable_waiting_room": "ಕಾಯುವ ಕೋಣೆಯನ್ನು ಸಕ್ರಿಯಗೊಳಿಸಿ",
        "assignment": "ನಿಯೋಜನೆ",
        "assignments": "ನಿಯೋಜನೆಗಳು",
        "create_new_poll": "ನಿಯೋಜಿಸಲು ಪ್ರಾರಂಭಿಸಲು ಹೊಸ ಸಮೀಕ್ಷೆಯ ಪ್ರಶ್ನೆಯನ್ನು ರಚಿಸಿ.",
        "plz_title_url": "ಪ್ಲೇಸ್ ಶೀರ್ಷಿಕೆ ಮತ್ತು  ಯೂ ರ್ ಲ್ ಅನ್ನು ನಮೂದಿಸಿ",
        "votes": "ಮತಗಳು",
        "enter_content_title": "ದಯವಿಟ್ಟು ವಿಷಯದ ಶೀರ್ಷಿಕೆಯನ್ನು ನಮೂದಿಸಿ",
        "failed_result": "ವಿಫಲ ಫಲಿತಾಂಶ",
        "removed_successfully":"ಯಶಸ್ವಿಯಾಗಿ ತೆಗೆದುಹಾಕಲಾಗಿದೆ",
        "enter_duration": "ದಯವಿಟ್ಟು ಅವಧಿಯನ್ನು ನಮೂದಿಸಿ",
        "select_questionnarie": "ದಯವಿಟ್ಟು ಪ್ರಶ್ನಾವಳಿಯನ್ನು ಆರಿಸಿ",
        "no_assignments": "ನಿಯೋಜನೆಗಳು ಇಲ್ಲ",
        "create_new_assignment": "ಹೊಸ ನಿಯೋಜನೆಯನ್ನು ರಚಿಸಿ, ರಚಿಸಲು ಮೇಲಿನದನ್ನು ಕ್ಲಿಕ್ ಮಾಡಿ ಅಸೈನ್ಮೆಂಟ್ ಬಟನ್ ಕ್ಲಿಕ್ ಮಾಡಿ",
        "create_assignment": "ನಿಯೋಜನೆಯನ್ನು ರಚಿಸಿ",
        "assignments_list": "ನಿಯೋಜನೆಗಳ ಪಟ್ಟಿ",
        "assignment_description": "ನಿಯೋಜನೆ ವಿವರಣೆ",
        "assignment_name": "ನಿಯೋಜನೆ ಹೆಸರು",
        "update_assignment": "ನಿಯೋಜನೆಯನ್ನು ನವೀಕರಿಸಿ",
        "add_new_assignment": "ಹೊಸ ನಿಯೋಜನೆಯನ್ನು ಸೇರಿಸಿ",
        "assignment_list": "ನಿಯೋಜನೆ ಪಟ್ಟಿ",
        "assign_assignments": "ನಿಯೋಜನೆಗಳನ್ನು ನಿಯೋಜಿಸಿ",
        "assigned_assignments_list": "ನಿಯೋಜಿಸಲಾದ ನಿಯೋಜನೆಗಳ ಪಟ್ಟಿ",
        "assignment_answer": "ನಿಯೋಜನೆ ಉತ್ತರ",
        "no_assig_submitted": "ಇನ್ನೂ ಯಾವುದೇ ಕಾರ್ಯಯೋಜನೆಗಳನ್ನು ಸಲ್ಲಿಸಲಾಗಿಲ್ಲ.",
        "no_assig_submitted_participants": "ಯಾವುದೇ ಭಾಗವಹಿಸುವವರಿಂದ ಇನ್ನೂ ಯಾವುದೇ ಕಾರ್ಯಯೋಜನೆಗಳನ್ನು ಸಲ್ಲಿಸಲಾಗಿಲ್ಲ.",
        "view_assignment": "ನಿಯೋಜನೆಯನ್ನು ವೀಕ್ಷಿಸಿ",
        "assigned_participants": "ನಿಯೋಜಿತ ಭಾಗವಹಿಸುವವರು",
        "select_assignment": "ನಿಯೋಜನೆಯನ್ನು ಆರಿಸಿ",
        "fill_your_assignment": "ನಿಮ್ಮ ನಿಯೋಜನೆಯನ್ನು ಭರ್ತಿ ಮಾಡಿ",
        "submit_assignment": "ನಿಯೋಜನೆಯನ್ನು ಸಲ್ಲಿಸಿ",
        "assignment_details": "ನಿಯೋಜನೆ ವಿವರಗಳು",
        "assignment_submit_success": "ನಿಯೋಜನೆಯನ್ನು ಯಶಸ್ವಿಯಾಗಿ ಸಲ್ಲಿಸಲಾಗಿದೆ",
        "assignment_saved_success" : "ನಿಯೋಜನೆಯನ್ನು ಯಶಸ್ವಿಯಾಗಿ ಉಳಿಸಲಾಗಿದೆ",
        "how_to_get_started": "ಹೇಗೆ ಪ್ರಾರಂಭಿಸುವುದು.",
        "create_New_room": "ಹೊಸ ಕೊಠಡಿ ರಚಿಸಿ",
        "create_room_add_participants": "ಹೊಸ ಕೋಣೆಯನ್ನು ರಚಿಸಿ ಮತ್ತು ಭಾಗವಹಿಸುವವರನ್ನು ಕೋಣೆಗೆ ಸೇರಿಸಿ.",
        "repeats_every": "ಪ್ರತಿಯೊಂದನ್ನು ಪುನರಾವರ್ತಿಸುತ್ತದೆ",
        "now": "ಈಗ",
        "Plz_enter_title_meeting": "ದಯವಿಟ್ಟು ಸಭೆಯ ಶೀರ್ಷಿಕೆಯನ್ನು ನಮೂದಿಸಿ",
        "no_start_time": "ಪ್ರಾರಂಭ ಸಮಯ ಕಂಡುಬಂದಿಲ್ಲ",
        "no_end_time": "ಅಂತಿಮ ಸಮಯ ಕಂಡುಬಂದಿಲ್ಲ",
        "item_id_not_found": "ಐಟಂ ಐ ಡೀ ಕಂಡುಬಂದಿಲ್ಲ",
        "msg_title_not_found": "ಸಂದೇಶ ಶೀರ್ಷಿಕೆ ಕಂಡುಬಂದಿಲ್ಲ",
        "plz_join_conf_clicking_link": "ದಯವಿಟ್ಟು ಕೆಳಗಿನ ಲಿಂಕ್ ಕ್ಲಿಕ್ ಮಾಡುವ ಮೂಲಕ ಸಮ್ಮೇಳನಕ್ಕೆ ಸೇರಿಕೊಳ್ಳಿ",
        "hi_there": "ಹಾಯ್ ದೇರ್",
        "room_permanently": "ಕೊಠಡಿ ಶಾಶ್ವತವಾಗಿ?",
        "sure_want_to_delete_participants": "ಈ ಭಾಗವಹಿಸುವವರನ್ನು ಅಳಿಸಲು ನೀವು ಖಚಿತವಾಗಿ ಬಯಸುವಿರಾ?",
        "delete_participant": "ಭಾಗವಹಿಸುವವರನ್ನು ಅಳಿಸಿ",
        "add_email": "ಇಮೇಲ್ ಸೇರಿಸಿ",
        "add_participants_to_the_room": "ಭಾಗವಹಿಸುವವರನ್ನು ಅವರ ಇಮೇಲ್ ವಿಳಾಸವನ್ನು ಕೆಳಗಿನ ಇನ್ಪುಟ್ ಪೆಟ್ಟಿಗೆಯಲ್ಲಿ ಟೈಪ್ ಮಾಡುವ ಮೂಲಕ ಈ ಕೋಣೆಗೆ ಸೇರಿಸಿ.",
        "no_of_users": "ಬಳಕೆದಾರರ ಸಂಖ್ಯೆ",
        "edit_the_name": "ನೀವು ಹೆಸರನ್ನು ಮತ್ತು ಈ ಕೋಣೆಯ ಬಳಕೆದಾರರ ಸಂಖ್ಯೆಯನ್ನು ಸಂಪಾದಿಸಬಹುದು.",
        "delete_room": "ಕೊಠಡಿಯನ್ನು ಅಳಿಸಿ",
        "are_you_sure_delete": "ನಿಮಗೆ ಖಚಿತವಾಗಿದೆಯೇ, ನೀವು ಅಳಿಸಲು ಬಯಸುವಿರಾ",
        "delete_this_room": "ಈ ಕೊಠಡಿಯನ್ನು ಅಳಿಸಿ",
        "delete_room_will_parmanently": "ಅಳಿಸು ಕ್ಲಿಕ್ ಮಾಡುವ ಮೂಲಕ, ಈ ಕೊಠಡಿಯನ್ನು ಸಮಾನವಾಗಿ ಅಳಿಸಲಾಗುತ್ತದೆ.",
        "enable_storage": "ಸಂಗ್ರಹಣೆಯನ್ನು ಸಕ್ರಿಯಗೊಳಿಸಿ",
        "enable_recordings": "ರೆಕಾರ್ಡಿಂಗ್‌ಗಳನ್ನು ಸಕ್ರಿಯಗೊಳಿಸಿ",
        "enable_SIP": "ಎಸ್‌ಐಪಿ ಅನ್ನು ಸಕ್ರಿಯಗೊಳಿಸಿ",
        "addons": "ಆಡ್ಸಾನ್ಗ",
        "expires_on": "ಮುಕ್ತಾಯಗೊಳ್ಳುತ್ತದೆ",
        "purchased_on": "ಖರೀದಿಸಲಾಗಿದೆ",
        "more_storage": "ಹೆಚ್ಚಿನ ಸಂಗ್ರಹಣೆ",
        "total_storage": "ಒಟ್ಟು ಸಂಗ್ರಹಣೆ",
        "Storage_occupied": "ಸಂಗ್ರಹಣೆ ಆಕ್ರಮಿಸಿಕೊಂಡಿದೆ",
        "added": "ಸೇರಿಸಲಾಗಿದೆ",
        "open_graphs":"ಓಪನ್ ಗ್ರಾಫ್ಸ್",
        "participant_controls" : "ಭಾಗವಹಿಸುವವರ ನಿಯಂತ್ರಣಗಳು",
        "dashboard_controls ": "ಡ್ಯಾಶ್‌ಬೋರ್ಡ್ ನಿಯಂತ್ರಣಗಳು",
        "start_meeting": "ಸಭೆಯನ್ನು ಪ್ರಾರಂಭಿಸಿ",
        "join_a_meeting": "ಸಭೆಗೆ ಸೇರಿ",
        "meeting_settings": "ಸಭೆ ಸೆಟ್ಟಿಂಗ್‌ಗಳು",
        "videos_to_get_started": "ಪ್ರಾರಂಭಿಸಲು ವೀಡಿಯೊಗಳು",
        "if_you_are_host": "ನೀವು ಆತಿಥೇಯರಾಗಿದ್ದರೆ, ಸಭೆಯನ್ನು ಪ್ರಾರಂಭಿಸಲು ಕೆಳಗಿನ ಬಟನ್ ಕ್ಲಿಕ್ ಮಾಡಿ",
        "guest_link":"ಅತಿಥಿ ಲಿಂಕ್",
        "pay_now": "ಈಗ ಪಾವತಿಸಿ",
        "promo_code_apply_here": "ಪ್ರೋಮೋ ಕೋಡ್ ಇದೆಯೇ? ಇಲ್ಲಿ ಅನ್ವಯಿಸಿ",
        "per_month": "ತಿಂಗಳಿಗೆ",
        "billed_for": "ಇದಕ್ಕಾಗಿ ಬಿಲ್ ಮಾಡಲಾಗಿದೆ",
        "gst_applicable": "ಸರ್ಕಾರದ ಮಾನದಂಡಗಳ ಅನುಸಾರವಾಗಿ, ಹೆಚ್ಚುವರಿ 18% ಜಿಎಸ್ಟಿ ಭಾರತದಲ್ಲಿ ಗ್ರಾಹಕರಿಗೆ ಅನ್ವಯವಾಗುತ್ತದೆ.",
        "select_country_code": "ಕಂಟ್ರಿ ಕೋಡ್ ಆಯ್ಕೆಮಾಡಿ",
        "country_code": "ಕಂಟ್ರಿ ಕೋಡ್",
        "enter_email_id": "ಇಮೇಲ್ ಐಡಿ ನಮೂದಿಸಿ ...",
        "downLoad_chat": "ಡೌನ್‌ಲೋಡ್ ಚಾಟ್",
        "allow_guest_control_their": "ಅತಿಥಿಗೆ ಅವರ ವೀಡಿಯೊ / ಆಡಿಯೊವನ್ನು ನಿಯಂತ್ರಿಸಲು ಅನುಮತಿಸಿ",
        "below_list_people_invited": "ಆಹ್ವಾನಿತ ಜನರ ಪಟ್ಟಿ ಕೆಳಗೆ ಇದೆ",
        "verification_code": "ಪರಿಶೀಲನೆ ಕೋಡ್",
        "open_link_enter_verify_code": "ಕೆಳಗಿನ ಯೂ ರ್ ಲ್  ಲಿಂಕ್ ತೆರೆಯಿರಿ, ಮತ್ತು ಏಕೀಕರಣಕ್ಕಾಗಿ ನಿಮ್ಮ ಪರಿಶೀಲನಾ ಕೋಡ್ ಅನ್ನು ನಮೂದಿಸಿ",
        "social_media_integration": "ಸೋಷಿಯಲ್ ಮೀಡಿಯಾ ಇಂಟಿಗ್ರೇಷನ್",
        "integrate_social_media_platform": "ನೀವು ಸಾಮಾಜಿಕ ಮಾಧ್ಯಮ ಪ್ಲಾಟ್‌ಫಾರ್ಮ್‌ಗಳನ್ನು ಸಂಯೋಜಿಸಬಹುದು, ಒಂದು ಗುಂಡಿಯನ್ನು ಕ್ಲಿಕ್ ಮಾಡುವುದರ ಮೂಲಕ, ನೀವು ಪರಿಶೀಲನಾ ಕೋಡ್ ಅನ್ನು ಪಡೆಯುತ್ತೀರಿ, ಅದನ್ನು ಏಕೀಕರಣಕ್ಕಾಗಿ ಬಳಸಿ.",
        "plz_enter_val_email": "ದಯವಿಟ್ಟು ಮಾನ್ಯ ಇಮೇಲ್ ನಮೂದಿಸಿ",
        "record": "ರೆಕಾರ್ಡ್",
        "in_conference": "ಸಮ್ಮೇಳನದಲ್ಲಿ",
        "password_if_any": "ಪಾಸ್ವರ್ಡ್ (ಯಾವುದಾದರೂ ಇದ್ದರೆ)",
        "stop_send": "ನಿಲ್ಲಿಸಿ ಮತ್ತು ಕಳುಹಿಸಿ",
        "broadcast_not_enabled_meeting": "ಈ ಸಭೆಗೆ ಪ್ರಸಾರವನ್ನು ಸಕ್ರಿಯಗೊಳಿಸಲಾಗಿಲ್ಲ",
        "facebook_url": "ಫೇಸ್ಬುಕ್ ಯೂ ರ್ ಲ್ ",
        "enter_facebook_url": "ಫೇಸ್‌ಬುಕ್ ಆರ್‌ಟಿಎಂಬಿ ಯೂ ರ್ ಲ್  ಅನ್ನು ನಮೂದಿಸಿ",
        "add_facebook_url": "ಫೇಸ್‌ಬುಕ್ ಆರ್‌ಟಿಎಂಪಿ ಯೂ ರ್ ಲ್  ಸೇರಿಸಿ",
        "youtube_url": "ಯುಟ್ಯೂಬ್ ಯೂ ರ್ ಲ್ ",
        "enter_youtube_url": "ಯುಟ್ಯೂಬ್ ಆರ್ಟಿಎಂಬಿ ಯೂ ರ್ ಲ್  ಅನ್ನು ನಮೂದಿಸಿ",
        "add_youtube_url": "ಯುಟ್ಯೂಬ್ ಆರ್ಟಿಎಂಪಿ ಯೂ ರ್ ಲ್  ಸೇರಿಸಿ",
        "register": "ರಿಜಿಸ್ಟರ್",
        "time_of_program": "ಕಾರ್ಯಕ್ರಮದ ಸಮಯ",
        "date_of_program": "ಕಾರ್ಯಕ್ರಮದ ದಿನಾಂಕ",
        "name_program_interested": "ಕಾರ್ಯಕ್ರಮದ ಹೆಸರು ಆಸಕ್ತಿ",
        "email_id": "ಇಮೇಲ್ ಐಡಿ",
        "dob": "ಹುಟ್ಟಿದ ದಿನಾಂಕ",
        "applicant_address": "ಅರ್ಜಿದಾರರ ವಿಳಾಸ",
        "qualification": "ಅರ್ಹತೆ",
        "designation": "ಹುದ್ದೆ",
        "org_name_address": "ಸಂಸ್ಥೆಯ ಹೆಸರು ಮತ್ತು ವಿಳಾಸ",
        "fullname_participant": "ಭಾಗವಹಿಸುವವರ ಪೂರ್ಣ ಹೆಸರು",
        "registration_form": "ನೋಂದಣಿ ಫಾರ್ಮ್",
        "thanks_submitting_data": "ನಿಮ್ಮ ಡೇಟಾವನ್ನು ಸಲ್ಲಿಸಿದ್ದಕ್ಕಾಗಿ ಧನ್ಯವಾದಗಳು",
        "management_content": "ವಿಷಯವನ್ನು ನಿರ್ವಹಿಸಿ",
        "API_settings": "ಏ ಪೀ ಐಸೆಟ್ಟಿಂಗ್‌ಗಳು",
        "schedule_API": "ವೇಳಾಪಟ್ಟಿ ಏ ಪೀ ಐ",
        "image_upload_success": "ಚಿತ್ರವನ್ನು ಯಶಸ್ವಿಯಾಗಿ ಅಪ್‌ಲೋಡ್ ಮಾಡಲಾಗಿದೆ",
        "less_than_10MB": "ದಯವಿಟ್ಟು 10ಎಮ್ ಬೀ ಗಿಂತ ಕಡಿಮೆ ಫೈಲ್ ಅನ್ನು ಅಪ್‌ಲೋಡ್ ಮಾಡಿ",
        "at_time_of_event": "ಈವೆಂಟ್ ಸಮಯದಲ್ಲಿ",
        "min_5": "5 ನಿಮಿಷಗಳ ಮೊದಲು",
        "min_10": "10 ನಿಮಿಷಗಳ ಮೊದಲು",
        "min_15": "15 ನಿಮಿಷಗಳ ಮೊದಲು",
        "min_30": "30 ನಿಮಿಷಗಳ ಮೊದಲು",
        "hrs_1": "1 ಗಂಟೆ ಮೊದಲು",
        "hrs_2": "2 ಗಂಟೆ ಮೊದಲು",
        "day_1":"1 ದಿನ ಮೊದಲು",
        "day_2": "2 ದಿನಗಳ ಮೊದಲು",
        "jan": "ಜನ",
        "feb": "ಫೆಬ್ರವರಿ",
        "mar":"ಮಾರ್",
        "apr": "ಎಪ್ರಿಲ್",
        "may": "ಮೇ",
        "jun": "ಜೂನ್",
        "jul": "ಜುಲೈ",
        "aug": "ಆಗಸ್ಟ್",
        "sep": "ಸೆಪ್ಟೆಂಬರ್",
        "oct": "ಅಕ್ಟೋಬರ್",
        "nov": "ನವೆಂಬರ್",
        "dec": "ಡಿಸೆಂಬರ್",
        "mon": "ಸೋಮ",
        "tue": "ಮಂಗಳ",
        "wed": "ಬುಧ",
        "thu": "ಗುರು",
        "fri":"ಶುಕ್ರ",
        "sat": "Sat",
        "sun": "ಸೂರ್ಯ",
        "all_day": "ಇಡೀ ದಿನ",
        "begin_ddmmyyyy": "ಪ್ರಾರಂಭವಾಗುತ್ತದೆ (ದ್‌ದ್ / ಮಮ್ / ಯಯಯ್)",
        "end_ddmmyyyy": "ತುದಿಗಳು (ದ್‌ದ್ / ಮಮ್ / ಯಯಯ್)",
        "ddmmyyyy": "(ದ್‌ದ್ / ಮಮ್ / ಯಯಯ್)",
        "by_dayweek": "ದಿನ / ವಾರದಿಂದ",
        "never": "ಎಂದಿಗೂ",
        "on_date": "ದಿನಾಂಕ",
        "alert": "ಎಚ್ಚರಿಕೆ",
        "multi_factor_auth": "ಬಹು ಫ್ಯಾಕ್ಟರ್ ದೃಢೀಕರಣ ಸಕ್ರಿಯಗೊಳಿಸಿ(ಎಂಎಫ್‌ಎ)",
        "advanced_settings" : "ಸುಧಾರಿತ ಸೆಟ್ಟಿಂಗ್‌ಗಳು",
        "verify_Otp": "ಒ ಟ್ ಪೀ ಅನ್ನು ಪರಿಶೀಲಿಸಿ",
        "resend_Otp" : "ಒಟ್ಪ್ ಅನ್ನು ಮರುಹೊಂದಿಸಿ",
        "otp_sent_mobile": "ನಿಮ್ಮ ಮೊಬೈಲ್ ಸಂಖ್ಯೆಗೆ ಕಳುಹಿಸಲಾದ ಒ ಟ್ ಪೀ ಅನ್ನು ನಮೂದಿಸಿ",
        "update_mobile": "ಮೊಬೈಲ್ ನವೀಕರಿಸಿ",
        "verify_mobile": "ಮೊಬೈಲ್ ಪರಿಶೀಲಿಸಿ",
        "mob_verfi_pending": "ನಿಮ್ಮ ಮೊಬೈಲ್ ಪರಿಶೀಲನೆ ಬಾಕಿ ಇದೆ.",
        "mobile_number" : "ಮೊಬೈಲ್ ಸಂಖ್ಯೆ",
        "enter_Otp": "ಒ ಟ್ ಪೀ ನಮೂದಿಸಿ",
        "enter_mob_no": "ದಯವಿಟ್ಟು ಮೊಬೈಲ್ ಸಂಖ್ಯೆಯನ್ನು ನಮೂದಿಸಿ",
        "sure_want_to_delete_rec": "ನೀವು ಖಚಿತವಾಗಿ ರೆಕಾರ್ಡಿಂಗ್ ಅಳಿಸಲು ಬಯಸುವಿರಾ",
        "delete_recording": "ರೆಕಾರ್ಡಿಂಗ್ ಅಳಿಸು",
        "invalid_credentials" : "ಅಮಾನ್ಯ ರುಜುವಾತುಗಳು",
        "join_conf_by_clicking_link": "ದಯವಿಟ್ಟು ಈ ಕೆಳಗಿನ ಲಿಂಕ್ ಕ್ಲಿಕ್ ಮಾಡುವ ಮೂಲಕ ಸಮ್ಮೇಳನಕ್ಕೆ ಸೇರಿಕೊಳ್ಳಿ",
        "hi_there": "ಹಾಯ್ ದೇರ್,",
        "valid_room_name": "ದಯವಿಟ್ಟು ಮಾನ್ಯ ಕೋಣೆಯ ಹೆಸರನ್ನು ನಮೂದಿಸಿ",
        "internal_server_error": "ಆಂತರಿಕ ಸರ್ವರ್ ದೋಷ, ದಯವಿಟ್ಟು ಮತ್ತೆ ಪ್ರಯತ್ನಿಸಿ",
        "room_limit_excend": "ಕೊಠಡಿ ಮಿತಿ ಮೀರಿದೆ",
        "cant_start_meeting_already_goingon": "ಸಭೆ ಈಗಾಗಲೇ ನಡೆಯುತ್ತಿರುವುದರಿಂದ ನೀವು ಸಭೆಯನ್ನು ಪ್ರಾರಂಭಿಸಲು ಸಾಧ್ಯವಿಲ್ಲ.",

        //new
        "social_integration" : "ಸಾಮಾಜಿಕ ಏಕೀಕರಣ",
        "advanced" : "ಸುಧಾರಿತ",
        "add_youtube" : "ಯುಟ್ಯೂಬ್ ಸೇರಿಸಿ",
        "plugins" : "ಪ್ಲಗಿನ್‌ಗಳು",
        "subtitles" : "ಉಪಶೀರ್ಷಿಕೆಗಳು",
        "view_local" : "ಸ್ಥಳೀಯ ವೀಕ್ಷಿಸಿ",
        "hide_local" : "ಸ್ಥಳೀಯವನ್ನು ಮರೆಮಾಡಿ",
        "switch_conf_mode" : "ಕಾನ್ಫರೆನ್ಸ್ ಮೋಡ್‌ಗೆ ಬದಲಿಸಿ",
        "switch_pres_mode" : "ಪ್ರೆಸೆಂಟರ್ ಮೋಡ್‌ಗೆ ಬದಲಿಸಿ",
        "conference_locked" : "ಕಾನ್ಫರೆನ್ಸ್ ಲಾಕ್ ಮಾಡಲಾಗಿದೆ",
        "conference_unlocked" : "ಕಾನ್ಫರೆನ್ಸ್ ಅನ್ಲಾಕ್ ಮಾಡಲಾಗಿದೆ",
        "sharing_tools" : "ಹಂಚಿಕೆ ಪರಿಕರಗಳು",
        "record" : "ರೆಕಾರ್ಡ್ ಮಾಡಿ",
        "recording" : "ರೆಕಾರ್ಡಿಂಗ್",
        "plz_wait_host_shr_video" : "ದಯಮಾಡಿ ನಿರೀಕ್ಷಿಸಿ! ಹೋಸ್ಟ್ ವೀಡಿಯೊವನ್ನು ಹಂಚಿಕೊಳ್ಳಲು ಹೊರಟಿದೆ",
        "supported_sources_include" : "ಬೆಂಬಲಿತ ಮೂಲಗಳು ಸೇರಿವೆ",

        "team_plugins" : "ತಂಡದ ಪ್ಲಗಿನ್‌ಗಳು",
        "open" : "ತೆರೆಯಿರಿ",
        "click" : "ಕ್ಲಿಕ್",
        "more_app" : "ಹೆಚ್ಚು ಅಪ್ಲಿಕೇಶನ್ಗಳು",
        "upload_custom_app" : "ಕಸ್ಟಮ್ ಅಪ್ಲಿಕೇಶನ್ ಅನ್ನು ಅಪ್‌ಲೋಡ್ ಮಾಡಿ",
        "download_team_plugin" : "ತಂಡದ ಪ್ಲಗಿನ್ ಡೌನ್‌ಲೋಡ್ ಮಾಡಿ",
        "install_mng_app_microsoft_team" : "ಮೈಕ್ರೋಸಾಫ್ಟ್ ತಂಡಗಳಲ್ಲಿ ಅಪ್ಲಿಕೇಶನ್ ಅನ್ನು ಹೇಗೆ ಸ್ಥಾಪಿಸುವುದು ಮತ್ತು ನಿರ್ವಹಿಸುವುದು",
        "microsoft_step1" : "ಹಂತ 1: ಮೈಕ್ರೋಸಾಫ್ಟ್ ತಂಡಗಳನ್ನು ತೆರೆಯಿರಿ",
        "microsoft_step1_para1" : "ಪ್ರಾರಂಭಿಸಲು, ಮೊದಲು ನೀವು ಈ ಪುಟದ ಮೇಲ್ಭಾಗದಲ್ಲಿ ಲಭ್ಯವಿರುವ ನಿಮ್ಮ ಸಿಸ್ಟಮ್‌ಗೆ ತಂಡದ ಪ್ಲಗ್‌ಇನ್ ಅನ್ನು ಡೌನ್‌ಲೋಡ್ ಮಾಡಬೇಕಾಗುತ್ತದೆ. ನಂತರ ನಿಮ್ಮ ಮೈಕ್ರೋಸಾಫ್ಟ್ ತಂಡಗಳನ್ನು ತೆರೆಯಿರಿ ಮತ್ತು ಆಯ್ಕೆಮಾಡಿ",
        "microsoft_step1_para2" : " ತಂಡದ ಅಪ್ಲಿಕೇಶನ್‌ಗಳನ್ನು ವೀಕ್ಷಿಸಲು ಸೈಡ್ ನ್ಯಾವಿಗೇಷನ್‌ನಿಂದ ಆಯ್ಕೆಗಳು.",
        "microsoft_step2" : "ಹಂತ 2: ಹೆಚ್ಚಿನ ಅಪ್ಲಿಕೇಶನ್‌ಗಳಿಗೆ ಹೋಗಿ",
        "microsoft_step2_para1" : "ಇನ್ನಷ್ಟು ಅಪ್ಲಿಕೇಶನ್‌ಗಳ ಹೆಸರಿನ ಬಟನ್‌ನೊಂದಿಗೆ ಕೆಲವು ಅಪ್ಲಿಕೇಶನ್‌ಗಳನ್ನು ಇಲ್ಲಿ ನೀವು ಕಾಣಬಹುದು. ಕ್ಲಿಕ್ ಮಾಡಿ",
        "microsoft_step2_para2" : "ಕಸ್ಟಮ್ ಅಪ್‌ಲೋಡ್ ಆಯ್ಕೆ ಮತ್ತು ಇತರ ಅಂಗಡಿ ಆಯ್ಕೆಗಳಿಗಾಗಿ ಮತ್ತಷ್ಟು ಪರಿಶೀಲಿಸಲು.",
        "microsoft_step3" : "ಹಂತ 3: ಅಪ್ಲಿಕೇಶನ್ ಅಪ್‌ಲೋಡ್ ಮಾಡಿ",
        "microsoft_step3_para1" : "ಒಮ್ಮೆ ನೀವು ಅಂಗಡಿಯನ್ನು ತೆರೆದರೆ, ನೀವು ಒಂದು ಅನ್ನು ಕಾಣಬಹುದು",
        "microsoft_step3_para2" : " ಎಡ ಸಂಚರಣೆಯಲ್ಲಿ ಆಯ್ಕೆ. ಅದರ ಮೇಲೆ ಕ್ಲಿಕ್ ಮಾಡಿ ಮತ್ತು ನಿಮ್ಮ ಡೌನ್‌ಲೋಡ್ ಮಾಡಿದ ಪ್ಲಗಿನ್ ಅಪ್ಲಿಕೇಶನ್ ಅನ್ನು ಇಲ್ಲಿ ಅಪ್‌ಲೋಡ್ ಮಾಡಿ.",
        "microsoft_step4" : "ಹಂತ 4: ಸಂಗ್ರಹಣೆಯಿಂದ InstaVC ಅಪ್ಲಿಕೇಶನ್ ಆಯ್ಕೆಮಾಡಿ",
        "microsoft_step4_para1" : "ವಿಂಡೋ ಕೇಳಿದಾಗ, (ಹಂತ 1) ಡೌನ್‌ಲೋಡ್ ಮಾಡಲಾದ ನಿಮ್ಮ ಸಿಸ್ಟಮ್‌ನಿಂದ InstaVC ಪ್ಲಗಿನ್ ಅಪ್ಲಿಕೇಶನ್ ಆಯ್ಕೆಮಾಡಿ ಮತ್ತು ಕ್ಲಿಕ್ ಮಾಡಿ",
        "microsoft_step5" : "ಹಂತ 5: ಮೈಕ್ರೋಸಾಫ್ಟ್ ತಂಡಗಳಲ್ಲಿ ಅಪ್‌ಲೋಡ್ ಮಾಡಿದ ಅಪ್ಲಿಕೇಶನ್",
        "microsoft_step5_para1" : "ಫೈಲ್ ಅನ್ನು ಅಪ್‌ಲೋಡ್ ಮಾಡಿದ ನಂತರ, ಅದನ್ನು ಮೈಕ್ರೋಸಾಫ್ಟ್ ತಂಡದ ಅಪ್ಲಿಕೇಶನ್‌ಗಳ ಪಟ್ಟಿಯಲ್ಲಿ ಅಪ್‌ಲೋಡ್ ಮಾಡಲಾಗುತ್ತದೆ. ನಂತರ ನೀವು ವೀಕ್ಷಿಸಲು ಅಪ್ಲಿಕೇಶನ್ ಅನ್ನು ಕ್ಲಿಕ್ ಮಾಡಬಹುದು ಮತ್ತು ಅದನ್ನು ತಂಡಗಳಿಗೆ ಸೇರಿಸಬಹುದು.",
        "microsoft_step6" : "ಹಂತ 6: InstaVC ಅಪ್ಲಿಕೇಶನ್ ತೆರೆಯಿರಿ",
        "microsoft_step6_para1" : "ಒಮ್ಮೆ ನೀವು InstaVC ಅಪ್ಲಿಕೇಶನ್ ಅನ್ನು ಕ್ಲಿಕ್ ಮಾಡಿದರೆ, ನೀವು ಈಗ ಪ್ಲಗಿನ್ ಅಪ್ಲಿಕೇಶನ್‌ನ ಸಂಪೂರ್ಣ ವಿವರಗಳನ್ನು ಒಂದು ಬಟನ್‌ನೊಂದಿಗೆ ವೀಕ್ಷಿಸಬಹುದು",
        "microsoft_step6_para2" : "ಮೈಕ್ರೋಸಾಫ್ಟ್ ತಂಡಗಳಿಗೆ ಈ ಅಪ್ಲಿಕೇಶನ್ ಸೇರಿಸಲು ಬಟನ್.",
        "microsoft_step7" : "ಹಂತ 7: ಮೈಕ್ರೋಸಾಫ್ಟ್ ತಂಡಗಳಿಗೆ ಇನ್‌ಸ್ಟಾವಿಸಿ ಸೇರಿಸಲಾಗಿದೆ",
        "microsoft_step7_para1" : "ಸುಲಭ ಮತ್ತು ಗ್ರಾಹಕೀಯಗೊಳಿಸಬಹುದಾದ ಬಳಕೆಗಾಗಿ ಈಗ ನಿಮ್ಮ ಅಪ್ಲಿಕೇಶನ್ ಅನ್ನು ಎಡಭಾಗದ ನ್ಯಾವಿಗೇಷನ್‌ನಲ್ಲಿರುವ ಮೈಕ್ರೋಸಾಫ್ಟ್ ತಂಡಗಳಿಗೆ ಸೇರಿಸಲಾಗುತ್ತದೆ.",

        "ddyymm": "ಡಿಡಿ / ಎಂಎಂ / ವೈವೈ",
        "fill_details_for_webinar": "ದಯವಿಟ್ಟು ವೆಬ್‌ನಾರ್‌ಗಾಗಿ ನಿಮ್ಮ ನೋಂದಣಿ ವಿವರಗಳನ್ನು ಇಲ್ಲಿ ಭರ್ತಿ ಮಾಡಿ",
        "microsoft_teams":"ಮೈಕ್ರೋಸಾಫ್ಟ್ ತಂಡಗಳು",
        "microsoft_outlook" : "ಮೈಕ್ರೋಸಾಫ್ಟ್ ಔಟ್‌ಲುಕ್",
        "select_the_plan": "ದಯವಿಟ್ಟು ಯೋಜನೆಯನ್ನು ಆರಿಸಿ",
        "enter_company_code": "ದಯವಿಟ್ಟು ಕಂಪನಿ ಕೋಡ್ ಅನ್ನು ನಮೂದಿಸಿ",
        "enter_code": "ದಯವಿಟ್ಟು ಕೋಡ್ ನಮೂದಿಸಿ",
        "enter_valid_coupon_code": "ದಯವಿಟ್ಟು ಮಾನ್ಯವಾದ ಕೂಪನ್ ಕೋಡ್ ಅನ್ನು ನಮೂದಿಸಿ",
        "coupon_alreadt_taken" : "ಈ ಕೂಪನ್ ಕೋಡ್ ಅನ್ನು ಈಗಾಗಲೇ ತೆಗೆದುಕೊಳ್ಳಲಾಗಿದೆ",
        "error_updating_plan": "ಯೋಜನೆಯನ್ನು ನವೀಕರಿಸುವಲ್ಲಿ ದೋಷ",
        "unit" : "ಯುನಿಟ್",
        "referrals" : "ಉಲ್ಲೇಖಗಳು",
        "sel_coupon": "ದಯವಿಟ್ಟು ಕೂಪನ್ ಆಯ್ಕೆಮಾಡಿ",
        "share_val_0_99": "ಷೇರು ಮೌಲ್ಯವು 0 ರಿಂದ 99 ರ ನಡುವೆ ಇರಬೇಕು",
        "enter_share_val": "ದಯವಿಟ್ಟು ಹಂಚಿಕೆ ಮೌಲ್ಯವನ್ನು ನಮೂದಿಸಿ",
        "valid_commission_per": "ದಯವಿಟ್ಟು ಮಾನ್ಯ ಆಯೋಗದ ಶೇಕಡಾವಾರು ನಮೂದಿಸಿ",
        "enter_commission_per": "ದಯವಿಟ್ಟು ಆಯೋಗದ ಶೇಕಡಾವಾರು ನಮೂದಿಸಿ",
        "enter_commission_name": "ದಯವಿಟ್ಟು ಆಯೋಗದ ಹೆಸರನ್ನು ನಮೂದಿಸಿ",
        "sync_successfully": "ಬಳಕೆದಾರರು ಯಶಸ್ವಿಯಾಗಿ ಸಿಂಕ್ ಮಾಡುತ್ತಾರೆ",
        "room_deleted_suc": "ಕೊಠಡಿ ಯಶಸ್ವಿಯಾಗಿ ಅಳಿಸಲಾಗಿದೆ",
        "lic_deleted_suc": "ಪರವಾನಗಿ ಯಶಸ್ವಿಯಾಗಿ ಅಳಿಸಲಾಗಿದೆ",
        "female" : "ಸ್ತ್ರೀ",
        "male" : "ಪುರುಷ",
        "insta_conference": "ಇನ್ಸ್ಟಾ ಕಾನ್ಫರೆನ್ಸ್",
        "quick_meeting_by" :  "ತ್ವರಿತ ಸಭೆ ಮೂಲಕ",
        "in_lobby": "ಲಾಬಿಯಲ್ಲಿ",
        "switch_to_broadcast" : "ಪ್ರಸಾರಕ್ಕೆ ಬದಲಿಸಿ",
        "Broadcasters_5" :"ಬ್ರಾಡ್‌ಕಾಸ್ಟರ್ಸ್ (5)",
        "Participants_5" : "ಭಾಗವಹಿಸುವವರು (5)",
        "search_participants": "ಭಾಗವಹಿಸುವವರನ್ನು ಹುಡುಕಿ",
        "host_controls" : "ಹೋಸ್ಟ್ ನಿಯಂತ್ರಣಗಳು",
        "deleteroom" :"ಕೊಠಡಿಯನ್ನು ಅಳಿಸು",
        "pm": "ಪಿ.ಎಂ.",
        "am": "ಎಎಮ್",
        "email_exist_inroom": "ಇಮೇಲ್ ಈ ಕೋಣೆಯಲ್ಲಿ ಈಗಾಗಲೇ ಅಸ್ತಿತ್ವದಲ್ಲಿದೆ",
        "type_a_message": "ಸಂದೇಶವನ್ನು ಟೈಪ್ ಮಾಡಿ ...",
        "please_enter_user_limit" : "ದಯವಿಟ್ಟು ಬಳಕೆದಾರರ ಮಿತಿಯನ್ನು ನಮೂದಿಸಿ",
        "user_limit_excended": "ಬಳಕೆದಾರರ ಮಿತಿಯನ್ನು ಮೀರಿದೆ",
        "sel_country_code": "ದಯವಿಟ್ಟು ದೇಶದ ಕೋಡ್ ಆಯ್ಕೆಮಾಡಿ",
        "available_storage" : "ಲಭ್ಯವಿರುವ ಸಂಗ್ರಹಣೆ",
        "enter_phone_number": "ಫೋನ್ ಸಂಖ್ಯೆಯನ್ನು ನಮೂದಿಸಿ",
        "startdate_less_enddate": "ದಯವಿಟ್ಟು ಪ್ರಾರಂಭ ದಿನಾಂಕವನ್ನು ಅಂತಿಮ ದಿನಾಂಕಕ್ಕಿಂತ ಕಡಿಮೆ ಆಯ್ಕೆಮಾಡಿ",
        "havent_add_data": "ನೀವು ಇನ್ನೂ ಯಾವುದೇ ಡೇಟಾವನ್ನು ಸೇರಿಸಿಲ್ಲ, ದಯವಿಟ್ಟು ಡೇಟಾವನ್ನು ಸೇರಿಸಿ.",
        "professional_skills": "ವೃತ್ತಿಪರ ಕೌಶಲ್ಯಗಳು",
        "enter_prof_skills": "ವೃತ್ತಿಪರ ಕೌಶಲ್ಯಗಳನ್ನು ನಮೂದಿಸಿ",
        "Present_Invitations" :"ಪ್ರಸ್ತುತ ಆಮಂತ್ರಣಗಳು",
        "sending" :"ಕಳುಹಿಸಲಾಗುತ್ತಿದೆ ...",
        "sent" :  "ಕಳುಹಿಸಲಾಗಿದೆ",
        "invite_10ppl_only": "ನೀವು 10 ಜನರನ್ನು ಮಾತ್ರ ಆಹ್ವಾನಿಸಬಹುದು",
        "join_meeting": "ಸಭೆಗೆ ಸೇರಿ",
        "enter_doc_title": "ಡಾಕ್ಯುಮೆಂಟ್ ಶೀರ್ಷಿಕೆಯನ್ನು ನಮೂದಿಸಿ",
        "meeting_name": "ಸಭೆಯ ಹೆಸರು",
        "select_the_weeks": "ದಯವಿಟ್ಟು ವಾರಗಳನ್ನು ಆರಿಸಿ",
        "grade" : "ಗ್ರೇಡ್",
        "coference_ID": "ಉಲ್ಲೇಖ ಐಡಿ...",
        "dont_find_room_meetingid": "ಈ ಸಭೆ ಐಡಿಯೊಂದಿಗೆ ಸಂಯೋಜಿತವಾಗಿರುವ ಯಾವುದೇ ಕೋಣೆಯನ್ನು ನಾವು ಕಾಣುವುದಿಲ್ಲ",
        "wireless_share" : "ವೈರ್‌ಲೆಸ್ ಶೇರ್",
        "video_layout": "ವೀಡಿಯೊ ವಿನ್ಯಾಸ",
        "speaker_screen" : "ಸ್ಪೀಕರ್ ಸ್ಕ್ರೀನ್",
        "presentation_screen" :"ಪ್ರಸ್ತುತಿ ಪರದೆ",
        "multiple_display" :  "ಬಹು ಪ್ರದರ್ಶನ",
        "hellow" : "ಹಲೋ",
        "enter_passcode": "ಪಾಸ್ಕೋಡ್ ಅನ್ನು ನಮೂದಿಸಿ",
        "another_meeting_stillon": "ಮತ್ತೊಂದು ಸಭೆ ಇನ್ನೂ ನಡೆಯುತ್ತಿದೆ, ನೀವು ಇದೀಗ ಈ ಸಭೆಯನ್ನು ಪ್ರಾರಂಭಿಸಲು ಸಾಧ್ಯವಿಲ್ಲ",
        "SIP_device": "ಎಸ್‌ಐಪಿ ಸಾಧನ",
        "instavc_whiteBoard": "ಇನ್ಸ್ತಾವೀಸೀ ವೈಟ್‌ಬೋರ್ಡ್",
        "speaker" :"ಸ್ಪೀಕರ್",
        "instavc_notepad": "ಇನ್ಸ್ತಾ ವೀ ಸೀ ನೋಟ್‌ಪ್ಯಾಡ್",
        "promote_in" : "ಪ್ರಚಾರ ಮಾಡಿ",
        "guest" : "ಅತಿಥಿ",
        "breakout_rooms" : "ಬ್ರೇಕೌಟ್ ರೂಮ್ಸ್",
        "stop_broadcast": "ಪ್ರಸಾರವನ್ನು ನಿಲ್ಲಿಸಿ",
        "noise_suppress" : "ಶಬ್ದ ನಿಗ್ರಹ",
        "echo_cancel": "ಪ್ರತಿಧ್ವನಿ ರದ್ದತಿ:",
        "enter_name_here": "ಹೆಸರನ್ನು ಇಲ್ಲಿ ನಮೂದಿಸಿ",
        "Viewer" : "ವೀಕ್ಷಕ",
        "SIP_user": "ಎಸ್‌ಐಪಿ ಬಳಕೆದಾರ",
        "remove_participants": "ಭಾಗವಹಿಸುವವರನ್ನು ತೆಗೆದುಹಾಕಿ",
        "disable_audio_video": "ರಿಮೋಟ್ ಆಡಿಯೋ ಮತ್ತು ವೀಡಿಯೊವನ್ನು ನಿಷ್ಕ್ರಿಯಗೊಳಿಸಿ",
        "disable_audio": "ಆಡಿಯೊವನ್ನು ನಿಷ್ಕ್ರಿಯಗೊಳಿಸಿ",
        "enable_audio": "ಆಡಿಯೊವನ್ನು ಸಕ್ರಿಯಗೊಳಿಸಿ",
        "disable_video": "ವೀಡಿಯೊವನ್ನು ನಿಷ್ಕ್ರಿಯಗೊಳಿಸಿ",
        "enable_video": "ವೀಡಿಯೊವನ್ನು ಸಕ್ರಿಯಗೊಳಿಸಿ",
        "audio_video" : "ಆಡಿಯೋ ಮತ್ತು ವಿಡಿಯೋ",
        "audio_only": "ಆಡಿಯೋ ಮಾತ್ರ",
        "video_only": "ವೀಡಿಯೊ ಮಾತ್ರ",
        "outlook_addins" : "ಔಟ್‌ಲುಕ್_ಅಡ್ಡಿನ್ಸ್",
        "install_microsoft": "ಮೈಕ್ರೋಸಾಫ್ಟ್ ಔಟ್‌ಲುಕ್ನಲ್ಲಿ ಆಡ್-ಇನ್‌ಗಳನ್ನು ಹೇಗೆ ಸ್ಥಾಪಿಸುವುದು ಮತ್ತು ನಿರ್ವಹಿಸುವುದು",
        "outlook_step1" : "ಹಂತ 1: ಲಿಂಕ್ ನಕಲಿಸಿ ಮತ್ತು ಔಟ್‌ಲುಕ್ ತೆರೆಯಿರಿ",
        "first_copy_link": "ಮೊದಲು ಲಿಂಕ್ ಅನ್ನು ನಕಲಿಸಿ",
        "add_plugin_oulook": "ನಿಮ್ಮ ದೃಷ್ಟಿಕೋನಕ್ಕೆ ಪ್ಲಗಿನ್ ಸೇರಿಸಲು ಇಲ್ಲಿಂದ.",
        "outlook_step2" :  "ಹಂತ 2: ಆಡ್-ಇನ್‌ಗಳನ್ನು ಪಡೆಯಿರಿ",
        "outlook_step2_para" : "ಈಗ ಮೇಲ್ನೋಟವನ್ನು ತೆರೆಯಿರಿ ಮತ್ತು ಹೋಮ್ ಟ್ಯಾಬ್ ಅಡಿಯಲ್ಲಿ ನೀವು ಆಡ್-ಇನ್‌ಗಳನ್ನು ಪಡೆಯಿರಿ. ಆಡ್-ಇನ್‌ಗಳು ಮತ್ತು ಇತರ ಕಸ್ಟಮ್ ಆಯ್ಕೆಗಳನ್ನು ವೀಕ್ಷಿಸಲು ಅದರ ಮೇಲೆ ಕ್ಲಿಕ್ ಮಾಡಿ.",
        "outlook_step3" : "ಹಂತ 3: ನನ್ನ ಆಡ್-ಇನ್‌ಗಳು",
        "outlook_step3_para": "ನೀವು ಈಗ ಎಡ ನ್ಯಾವಿಗೇಷನ್‌ನೊಂದಿಗೆ ಆಡ್-ಇನ್ ಪುಟವನ್ನು ವೀಕ್ಷಿಸಬಹುದು. ನಿಮ್ಮ ಆಡ್-ಇನ್‌ಗಳನ್ನು ನಿರ್ವಹಿಸಲು ನನ್ನ ಆಡ್-ಇನ್‌ಗಳಿಗೆ ಹೋಗಿ.",
        "outlook_step4": "ಹಂತ 4: ಕಸ್ಟಮ್ ಆಡ್-ಇನ್‌ಗಳನ್ನು ಸೇರಿಸಿ",
        "outlook_step4_para": "ಇಲ್ಲಿ ನೀವು ನನ್ನ ಆಡ್-ಇನ್ ಪುಟದಲ್ಲಿ ಕಸ್ಟಮ್ ಆಡ್-ಇನ್ಗಳ ಅಡಿಯಲ್ಲಿ ಕಸ್ಟಮ್ ಆಡ್-ಇನ್ ಸೇರಿಸಿ ಡ್ರಾಪ್ಡೌನ್ ಅನ್ನು ಕಾಣಬಹುದು. ಡ್ರಾಪ್ ಡೌನ್ ನಿಂದ ಯೂ ಆರ್ ಲ್  ನಿಂದ ಸೇರಿಸು ಆಯ್ಕೆಮಾಡಿ.",
        "outlook_step5": "ಹಂತ 5: ಯೂ ಆರ್ ಲ್  ನಿಂದ ಖಾಸಗಿ ಆಡ್-ಇನ್ ಸೇರಿಸಿ",
        "outlook_step5_para": "ನೀವು ಈಗ ಯೂ ಆರ್ ಲ್ ನಿಂದ ಖಾಸಗಿ ಆಡ್-ಇನ್ ಅನ್ನು ಸೇರಿಸಲು ಕೇಳುವ ಪಾಪ್ ಅಪ್ ಅನ್ನು ನೋಡಬಹುದು. ಈಗ ನೀವು ಇನ್ಪುಟ್ ಕ್ಷೇತ್ರದಲ್ಲಿ (ಹಂತ 1) ನಕಲಿಸಿದ ಲಿಂಕ್ ಅನ್ನು ಅಂಟಿಸಿ ಮತ್ತು ಸರಿ ಕ್ಲಿಕ್ ಮಾಡಿ, ಅದು ಆಡ್-ಇನ್ ಅನ್ನು ಮೇಲ್ನೋಟಕ್ಕೆ ಸ್ಥಾಪಿಸುತ್ತದೆ. ",
        "lolook_step6": "ಹಂತ 6: ನನ್ನ ಆಡ್-ಇನ್‌ಗಳಲ್ಲಿ ಇನ್ಸ್ತಾವೀಸೀ ಸೇರಿಸಲಾಗಿದೆ",
        "outlook_step6_para": "ಸೇರಿಸಿದ ನಂತರ, ನಿಮ್ಮ ಆಡ್-ಇನ್ಗಳ ಪಟ್ಟಿಗೆ ಸೇರಿಸಲಾದ ಆಡ್ ಇನ್ ಅನ್ನು ನೀವು ಪರಿಶೀಲಿಸಬಹುದು. ಇಲ್ಲಿಂದ ನಿಮ್ಮ ಆಡ್-ಇನ್‌ಗಳನ್ನು ಮತ್ತಷ್ಟು ನಿರ್ವಹಿಸಬಹುದು.",
        "lo ಟ್‌ಲುಕ್_ಸ್ಟೆಪ್ 7": "ಹಂತ 7: lo ಟ್‌ಲುಕ್ ಮುಚ್ಚಿ ಮತ್ತು ಮತ್ತೆ ತೆರೆಯಿರಿ",
        "outlook_step7_para": "ಸ್ಥಾಪಿಸಿದ ನಂತರ, ನೀವು ಸಂಪೂರ್ಣ ದೃಷ್ಟಿಕೋನವನ್ನು ಒಮ್ಮೆ ಮುಚ್ಚಿರುವುದನ್ನು ಖಚಿತಪಡಿಸಿಕೊಳ್ಳಿ ಮತ್ತು ಆಡ್-ಇನ್ ನೋಡಲು ಮತ್ತೆ ತೆರೆಯಿರಿ.",
        "outlook_step8": "ಹಂತ 8: ಹೊಸ ಐಟಂಗಳಿಗೆ ಹೋಗಿ",
        "lo ಟ್‌ಲುಕ್_ಸ್ಟೆಪ್ 8_ಪಾರಾ": "ಮೇಲ್ನೋಟವನ್ನು ತೆರೆದ ನಂತರ, ನೀವು ಈಗ ಹೊಸ ಸಭೆಗಳಿಗೆ ಹೋಗಬಹುದು & # 62; ಇನ್‌ಸ್ಟಾವಿಸಿ ಮೇಲ್ನೋಟಕ್ಕೆ ಸೇರಿಸುವುದನ್ನು ನೋಡಲು ಸಭೆ.",
        "outlook_step9": "ಹಂತ 9: ಇನ್ಸ್ತಾವೀಸೀ ಸಭೆ ತೆರೆಯಿರಿ",
        "outlook_step9_para" :"ಒಮ್ಮೆ ನೀವು ಸಭೆಗಳನ್ನು ತೆರೆದರೆ, ಸಭೆಗಳ ಟ್ಯಾಬ್‌ನ ಅಡಿಯಲ್ಲಿ ಮೇಲಿನ ಪಟ್ಟಿಯಲ್ಲಿ ಸ್ಥಾಪಿಸಲಾದ ಇನ್‌ಸ್ಟಾವಿಸಿ ಮೀಟಿಂಗ್ ಆಡ್-ಇನ್ ಜೊತೆಗೆ ಕಂಪೋಸ್ ಮೇಲ್ ವಿಂಡೋದೊಂದಿಗೆ ನಿಮ್ಮನ್ನು ತೆರೆಯಲಾಗುತ್ತದೆ.",
        "outlook_step10": "ಹಂತ 10: ವೇಳಾಪಟ್ಟಿಯನ್ನು ರಚಿಸಿ",
        "outlook_step10_para": "ಸಂಯೋಜನೆ ಮೇಲ್ ವಿನ್ಯಾಸದಿಂದ, ಹೊಸ ವೇಳಾಪಟ್ಟಿಯನ್ನು ರಚಿಸಲು ಇನ್ಸ್ತಾವೀಸೀ ಸಭೆಗಳ ಮೇಲೆ ಕ್ಲಿಕ್ ಮಾಡಿ. ಇದು ಮೊದಲ ಬಾರಿಗೆ ಇದ್ದರೆ ಬಲಭಾಗದಲ್ಲಿರುವ ಇನ್ಸ್ತಾವೀಸೀ ಮೀಟಿಂಗ್ ಲಾಗಿನ್‌ನೊಂದಿಗೆ ನಿಮ್ಮನ್ನು ತೆರೆಯಲಾಗುತ್ತದೆ. ಈಗಾಗಲೇ ಲಾಗಿನ್ ಆಗಿರುವ ಬಳಕೆದಾರರಿಗೆ, ಅವರು ಕೊಠಡಿಗಳ ಪಟ್ಟಿಗೆ ನಿರ್ದೇಶಿಸಲಾಗಿದೆ ಮತ್ತು ವೇಳಾಪಟ್ಟಿಯನ್ನು ರಚಿಸಬಹುದು. ",
        "outlook_step11": "ಹಂತ 11: ಇನ್ಸ್ತಾವೀಸೀ ಸಭೆ ತೆರೆಯಿರಿ",
        "outlook_step11_para": "ನೀವು ಒಂದು ನಿರ್ದಿಷ್ಟ ಕೋಣೆಯಲ್ಲಿ ಸಭೆಯನ್ನು ನಿಗದಿಪಡಿಸಲು ಎಡಭಾಗದಲ್ಲಿ ಒಂದು ವೇಳಾಪಟ್ಟಿಯನ್ನು ರಚಿಸಬಹುದು ಮತ್ತು ಬಲಭಾಗದಲ್ಲಿ ಒಂದು ಕೋಣೆಯನ್ನು ಆಯ್ಕೆ ಮಾಡಬಹುದು. ಒಮ್ಮೆ ನೀವು ವೇಳಾಪಟ್ಟಿಯನ್ನು ರಚಿಸಿದ ನಂತರ, ನೀವು ಈಗ ಪ್ರಾರಂಭ ಸಭೆ ಗುಂಡಿಯನ್ನು ನೋಡಬಹುದು. ಇಲ್ಲಿಂದ ನೀವು ಕ್ಲಿಕ್ ಮಾಡಬಹುದು ಮತ್ತು ಸಭೆಯನ್ನು ಪ್ರಾರಂಭಿಸಿ. ",
        "outlook_step12" :  "ಹಂತ 12: ಕ್ಯಾಲೆಂಡರ್‌ನಲ್ಲಿ ವೇಳಾಪಟ್ಟಿಯನ್ನು ವೀಕ್ಷಿಸಿ",
        "outlook_step12_para": "ಒಮ್ಮೆ ನೀವು ವೇಳಾಪಟ್ಟಿಯನ್ನು ರಚಿಸಿದ ನಂತರ, ಮುಂದಿನ ಬಾರಿ ನೀವು ಕ್ಯಾಲೆಂಡರ್ ತೆರೆದಾಗ, ನಿಮ್ಮ ವೇಳಾಪಟ್ಟಿಗಳನ್ನು ಕ್ಯಾಲೆಂಡರ್‌ನಲ್ಲಿ ಸಹ ವೀಕ್ಷಿಸಬಹುದು.",
        "outlook_step13": "ಹಂತ 13: ವೇಳಾಪಟ್ಟಿಯನ್ನು ರಚಿಸಲಾಗಿದೆ",
        "outlook_step13_para": "ಒಮ್ಮೆ ನೀವು ವೇಳಾಪಟ್ಟಿಯನ್ನು ರಚಿಸಿದ ನಂತರ, ನೀವು ಸಂಯೋಜಿಸಿದ ಮೇಲ್ ಅನ್ನು ಬಲಭಾಗದಲ್ಲಿ ಪ್ರಾರಂಭ ಸಭೆ ಬಟನ್ ಜೊತೆಗೆ ನೋಡಬಹುದು.",
        "sel_declaration": "ದಯವಿಟ್ಟು ಘೋಷಣೆಯನ್ನು ಆರಿಸಿ",
        "enter_company_code": "ದಯವಿಟ್ಟು ಕಂಪನಿ ಕೋಡ್ ನಮೂದಿಸಿ",
        "invalid_company_code" :  "ಅಮಾನ್ಯ ಕಂಪನಿ ಕೋಡ್",
        "affiliate_acc" :  "ನಿಮ್ಮ ಅಂಗ ಖಾತೆಯು ಅನುಮೋದನೆಗೆ ಬಾಕಿ ಇದೆ.",
        "aff_acc_approved": "ನಿಮ್ಮ ಅಂಗ ಖಾತೆಯನ್ನು ಅನುಮೋದಿಸಲಾಗಿದೆ.",
        "aff_acc_rej": "ನಿಮ್ಮ ಅಂಗ ಖಾತೆಯನ್ನು ತಿರಸ್ಕರಿಸಲಾಗಿದೆ.",
        "aff_TC": "ಅಂಗಸಂಸ್ಥೆ ನಿಯಮಗಳು ಮತ್ತು ಷರತ್ತುಗಳು",
        "ref_par_agreement": "ರೆಫರಲ್ ಪಾರ್ಟ್‌ನರ್ ಒಪ್ಪಂದ",
        "aff_partner_agreement": 'ಈ ಕವರ್ ಪೇಜ್ ಮತ್ತು ಲಗತ್ತಿಸಲಾದ ವ್ಯಾಪಾರ ನಿಯಮಗಳನ್ನು ಒಳಗೊಂಡಿರುವ ಈ ಪಾಲುದಾರ ಒಪ್ಪಂದವನ್ನು (ಒಟ್ಟಾರೆಯಾಗಿ, ಈ "ಒಪ್ಪಂದ") ಪೀಪಲ್‌ಲಿಂಕ್ ಯೂನಿಫೈಡ್ ಕಮ್ಯುನಿಕೇಷನ್ಸ್ ಪ್ರೈವೇಟ್ ಲಿಮಿಟೆಡ್ (ಪೀಪಲ್‌ಲಿಂಕ್ ಎಂದು ಕರೆಯಲಾಗುತ್ತದೆ) ಮತ್ತು ಬಿ ಪಾರ್ಟ್‌ನರ್‌ಬ್ ಅಥವಾ ಬಿ ಯೂಬ್. "ಪಾಲುದಾರ" ಅಥವಾ "ನೀವು" ಎಂದರೆ ಸಲ್ಲಿಸಿದ ಫಾರ್ಮ್‌ನಲ್ಲಿ ವಿವರಿಸಲಾದ ವ್ಯಕ್ತಿ ಅಥವಾ ಕಂಪನಿ (ಕಂಪನಿಯ ಹೆಸರು ಮತ್ತು ಇತರ ಮಾಹಿತಿಯನ್ನು ಒಳಗೊಂಡಂತೆ). ಈ ಒಪ್ಪಂದವನ್ನು ನೀವು ಒಪ್ಪಿಕೊಂಡಿರುವುದನ್ನು ಸೂಚಿಸಲು ನೀವು ರೆಫರಲ್ ಪಾಲುದಾರ ಪ್ರೋಗ್ರಾಂ ಫಾರ್ಮ್ ("ಫಾರ್ಮ್") ಅನ್ನು ಪೂರ್ಣಗೊಳಿಸಿದ ನಂತರ ಸಲ್ಲಿಸುವ ಮೂಲಕ ಒಪ್ಪಂದವು ಬಂಧಗೊಳ್ಳುತ್ತದೆ. ಪೀಪಲ್‌ಲಿಂಕ್ ಮತ್ತು ಪಾಲುದಾರರನ್ನು ಕೆಲವೊಮ್ಮೆ "ಪಾರ್ಟಿ" ಎಂದು ಕರೆಯಲಾಗುತ್ತದೆ ಮತ್ತು ಒಟ್ಟಿಗೆ "ಪಕ್ಷಗಳು" ಎಂದು ಕರೆಯಲಾಗುತ್ತದೆ.',
        "background" : "ಹಿನ್ನೆಲೆ",
        "aff_market_advertise": 'ಪೀಪಲ್‌ಲಿಂಕ್ ಇನ್ಸ್ತಾವೀಸೀ ಏಕೀಕೃತ ಸಂವಹನ ಸೇವೆಗಳು ಮತ್ತು ಪರಿಹಾರಗಳನ್ನು ನೀಡುತ್ತದೆ. ಈ ಒಪ್ಪಂದಕ್ಕೆ ಅನುಸಾರವಾಗಿ ಪೀಪಲ್‌ಲಿಂಕ್ ಉತ್ಪನ್ನಗಳಿಗೆ ಮತ್ತು ಸಂಭಾವ್ಯ ಪೀಪಲ್‌ಲಿಂಕ್ ಗ್ರಾಹಕರಿಗೆ ("ರೆಫರಲ್ಸ್") ತನ್ನ ವೆಬ್‌ಸೈಟ್ (ಗಳು) ಮತ್ತು ಇತರ ಮಾರ್ಕೆಟಿಂಗ್ ಚಾನೆಲ್‌ಗಳ ಮೂಲಕ ಪ್ರಚಾರ ಮಾಡಲು, ಮಾರಾಟ ಮಾಡಲು ಮತ್ತು ಪ್ರಚಾರ ಮಾಡಲು ಪಾಲುದಾರ ಬಯಸುತ್ತಾನೆ. ',
        "agreement" : "ಒಪ್ಪಂದ",
        "aff_parties_agree": "ಪಕ್ಷಗಳು ಈ ಕೆಳಗಿನಂತೆ ಒಪ್ಪುತ್ತವೆ:",
        "heading1" : "ಪ್ರೋಗ್ರಾಂ ಸಮಿತಿಗಳು",
        "heading2" : "ಅರ್ಹ ಉಲ್ಲೇಖಗಳು, ಆಯೋಗಗಳು.",
        "heading3" : "ನಿಯಮ ಮತ್ತು ನಿಯಮ.",
        "heading4" : "ಸಾಮಾನ್ಯ",
        "the_program": "ಪ್ರೋಗ್ರಾಂ.",
        "to_participate_program_partner": 'ಪ್ರೋಗ್ರಾಂ ಪಾಲುದಾರದಲ್ಲಿ ಭಾಗವಹಿಸಲು ಪೀಪಲ್‌ಲಿಂಕ್ ಅಥವಾ ಅದರ ಸಂಬಂಧಿತ ವೆಬ್‌ಸೈಟ್‌ಗಳಲ್ಲಿ ("ಸೈಟ್") ಕಂಡುಬರುವ ಪ್ರೋಗ್ರಾಂನಲ್ಲಿ ಭಾಗವಹಿಸಲು ಆನ್‌ಲೈನ್ ಅರ್ಜಿಯನ್ನು ಪೂರ್ಣಗೊಳಿಸಬೇಕು ಮತ್ತು ಈ ಒಪ್ಪಂದವನ್ನು ನಮೂದಿಸಬೇಕು. ಪೀಪಲ್‌ಲಿಂಕ್ ಯಾವುದೇ ಅರ್ಜಿಯನ್ನು ಅದರ ಸ್ವಂತ ವಿವೇಚನೆಯಿಂದ ಸ್ವೀಕರಿಸಬಹುದು ಅಥವಾ ತಿರಸ್ಕರಿಸಬಹುದು. ',
        "aff_str11": "ಕಾನೂನು ಒಪ್ಪಂದಗಳು.",
        "aff_str12": "ಪ್ರಚಾರ, ಉಲ್ಲೇಖಿತ ಚಟುವಟಿಕೆಗಳು:",
        "aff_str13": "ನಿಷೇಧಿತ ಚಟುವಟಿಕೆಗಳು.",
        "aff_str14": "ಪೀಪಲ್‌ಲಿಂಕ್ ಮಾರ್ಕ್‌ಗಳ ಅನುಮತಿಸುವ ಬಳಕೆ",
        "aff_str15": "ಹೊಣೆಗಾರಿಕೆಗಳು.",
        "aff_str16": "ಗ್ರಾಹಕ ಸಂಬಂಧಗಳು.",
        "aff_str11_para": "ಪ್ರೋಗ್ರಾಂನಲ್ಲಿ ಭಾಗವಹಿಸುವಿಕೆಯ ಭಾಗವಾಗಿ ಮತ್ತು ಪೀಪಲ್‌ಲಿಂಕ್‌ನ ಪಾಲುದಾರನಾಗಿ ಕಾರ್ಯನಿರ್ವಹಿಸುವಾಗ, ಪಾಲುದಾರನು ಈ ಒಪ್ಪಂದದ ನಿಯಮಗಳು ಮತ್ತು ಪ್ರೋಗ್ರಾಂ, ಮಾರ್ಗಸೂಚಿಗಳು ಮತ್ತು ಪೀಪಲ್‌ಲಿಂಕ್ ಸಮಯದಿಂದ ನಿಗದಿಪಡಿಸಿದ ಯಾವುದೇ ವಿನಂತಿಗಳು ಮತ್ತು ನಿಯಮಗಳನ್ನು ಒಪ್ಪುತ್ತಾನೆ ಮತ್ತು ಒಪ್ಪುತ್ತಾನೆ. ಕಾಲಕಾಲಕ್ಕೆ, ಅದರ ಸಮಂಜಸವಾದ ವಿವೇಚನೆಯಿಂದ, ಪೀಪಲ್‌ಲಿಂಕ್ ಉತ್ಪನ್ನಗಳು, ಪರಿಹಾರಗಳು ಮತ್ತು ರೆಫರಲ್‌ಗಳಿಗೆ ಸೇವೆಯ ಪ್ರಚಾರದಲ್ಲಿ ಪಾಲುದಾರರ ನಿರಂತರ ಭಾಗವಹಿಸುವಿಕೆಗೆ ಸಂಬಂಧಿಸಿದಂತೆ. ಈ ಒಪ್ಪಂದದ ಅಡಿಯಲ್ಲಿನ ಎಲ್ಲಾ ಚಟುವಟಿಕೆಗಳಲ್ಲಿ, ಮತ್ತು ಪಾಲುದಾರರ ಪೀಪಲ್‌ಲಿಂಕ್, ಪಾಲುದಾರರ ಪ್ರಚಾರಕ್ಕೆ ಸಂಬಂಧಿಸಿದ ನಿರ್ದಿಷ್ಟ ಚಟುವಟಿಕೆಗಳು ಪೀಪಲ್‌ಲಿಂಕ್‌ನೊಂದಿಗೆ ಸಹಕರಿಸಬೇಕು ಮತ್ತು ಉತ್ತಮ ನಂಬಿಕೆಯಿಂದ ವರ್ತಿಸಬೇಕು. ಈ ಒಪ್ಪಂದವನ್ನು ನಮೂದಿಸುವ ಮೂಲಕ ಪೀಪಲ್‌ಲಿಂಕ್‌ನ ಸೇವಾ ನಿಯಮಗಳಲ್ಲಿ ನಿಗದಿಪಡಿಸಿರುವ ನಿಯಮಗಳು ಮತ್ತು ನಿಯಮಗಳನ್ನು ಪಾಲುದಾರ ಮತ್ತಷ್ಟು ಗುರುತಿಸುತ್ತಾನೆ ಮತ್ತು ಸ್ವೀಕರಿಸುತ್ತಾನೆ ",
        "aff_str12_para": "ಪರವಾನಗಿ ಪಡೆದ ಗುರುತುಗಳು ಮತ್ತು ಮಾರ್ಕೆಟಿಂಗ್ ಸಾಮಗ್ರಿಗಳನ್ನು ಬಳಸಿಕೊಂಡು ವಿವಿಧ ಮಾರ್ಕೆಟಿಂಗ್ ಚಾನೆಲ್‌ಗಳಲ್ಲಿ ಪೀಪಲ್‌ಲಿಂಕ್ ಉತ್ಪನ್ನಗಳು ಮತ್ತು ಪರಿಹಾರಗಳ ಮುಂದುವರಿದ, ಸಕ್ರಿಯ ಪ್ರಚಾರದಲ್ಲಿ ತೊಡಗಿಸಿಕೊಳ್ಳಲು ಪಾಲುದಾರ ಒಪ್ಪುತ್ತಾನೆ, ಮತ್ತು ಈ ಒಪ್ಪಂದದ ನಿಯಮಗಳಿಗೆ ಅನುಸಾರವಾಗಿ ಹಾಗೆ ಮಾಡಿ.",
        "aff_str13_para" : 'ಮಾರ್ಕೆಟಿಂಗ್ ಮೆಟೀರಿಯಲ್‌ಗಳನ್ನು ಯಾವುದೇ ರೀತಿಯಲ್ಲಿ ಕಾನೂನುಬಾಹಿರ, ಅಥವಾ ಹಾನಿಕಾರಕ, ಬೆದರಿಕೆ, ಮಾನಹಾನಿಕರ, ಅಶ್ಲೀಲ, ಆಕ್ರಮಣಕಾರಿ, ಕಿರುಕುಳ, ಲೈಂಗಿಕವಾಗಿ ಸ್ಪಷ್ಟ, ಹಿಂಸಾತ್ಮಕ, ತಾರತಮ್ಯ ಅಥವಾ ಪೀಪಲ್‌ಲಿಂಕ್‌ಬಿಯ ಏಕೈಕ ವಿವೇಚನೆಯಲ್ಲಿ ಆಕ್ಷೇಪಾರ್ಹ ವಿಷಯದೊಂದಿಗೆ ಸಂಯೋಜಿಸದಿರಲು ಪಾಲುದಾರ ಒಪ್ಪುತ್ತಾನೆ. ಪೀಪಲ್‌ಲಿಂಕ್ ಸೇವೆಗಳು ಮತ್ತು ಪರಿಹಾರಗಳನ್ನು ಉತ್ತೇಜಿಸುವಲ್ಲಿ ಅನೇಕ ಸಂಬಂಧವಿಲ್ಲದ ಸ್ವೀಕರಿಸುವವರಿಗೆ ("ಸ್ಪ್ಯಾಮಿಂಗ್") ಅಪೇಕ್ಷಿಸದ ಎಲೆಕ್ಟ್ರಾನಿಕ್ ಸಂದೇಶಗಳನ್ನು ಕಳುಹಿಸದಿರಲು ಪಾಲುದಾರನು ಒಪ್ಪುತ್ತಾನೆ, ಇಲ್ಲದಿದ್ದರೆ ಈ ಒಪ್ಪಂದದ ಅಡಿಯಲ್ಲಿ ಆಲೋಚಿಸಿದ ಚಟುವಟಿಕೆಗಳಿಗೆ ಸಂಬಂಧಿಸಿದಂತೆ ಕಾನೂನಿನಿಂದ ನಿಷೇಧಿಸಲ್ಪಟ್ಟ ಯಾವುದೇ ರೀತಿಯ ಸಾಮೂಹಿಕ ಎಲೆಕ್ಟ್ರಾನಿಕ್ ಸಂವಹನಗಳಲ್ಲಿ ತೊಡಗಿಸಿಕೊಳ್ಳಲು.',
        "aff_str14_para1": "ಪರವಾನಗಿ ಪಡೆದ ಗುರುತುಗಳನ್ನು ಬಳಸುವಾಗ ಮತ್ತು ಮಾರ್ಕೆಟಿಂಗ್ ವಸ್ತುಗಳನ್ನು ರಚಿಸುವಲ್ಲಿ ಪಾಲುದಾರನು ಇಲ್ಲಿರುವ ಎಲ್ಲಾ ನಿಯಮಗಳನ್ನು ಅನುಸರಿಸಲು ಸ್ಪಷ್ಟವಾಗಿ ಒಪ್ಪುತ್ತಾನೆ.",
        "aff_str14_para2": "ಮಾರ್ಗಸೂಚಿಗಳ ಮೂಲಕ ಮತ್ತು ಇಲ್ಲದಿದ್ದರೆ, ಮಾರ್ಕೆಟಿಂಗ್ ಮೆಟೀರಿಯಲ್‌ಗಳನ್ನು ರಚಿಸುವಲ್ಲಿ ಮತ್ತು ಪೀಪಲ್‌ಲಿಂಕ್ ಸೇವೆಯನ್ನು ಉತ್ತೇಜಿಸುವಲ್ಲಿ ಪಾಲುದಾರರ ಪರವಾನಗಿ ಪಡೆದ ಮಾರ್ಕ್‌ಗಳನ್ನು ಕಾಲಕಾಲಕ್ಕೆ ನಿರ್ದಿಷ್ಟಪಡಿಸುವಿಕೆಗಳು ಮತ್ತು ಇತರ ಸೂಚನೆಗಳನ್ನು ಪೀಪಲ್‌ಲಿಂಕ್ ಒದಗಿಸುತ್ತದೆ. ಮತ್ತು ಸೂಚನೆಗಳು. ",
        "aff_str14_para3": "ಪಾಲುದಾರನು ತನ್ನ ಮಾರ್ಕೆಟಿಂಗ್ ಮೆಟೀರಿಯಲ್‌ಗಳಲ್ಲಿ ಕಾಣಿಸಿಕೊಳ್ಳುವ ಎಲ್ಲಾ ಪರವಾನಗಿ ಪಡೆದ ಗುರುತುಗಳು ಮಾರ್ಗಸೂಚಿಗಳಲ್ಲಿ ಪೀಪಲ್‌ಲಿಂಕ್ ಅನುಮೋದಿಸಿದ ರೂಪದಲ್ಲಿವೆ ಎಂದು ಖಚಿತಪಡಿಸಿಕೊಳ್ಳಬೇಕು ಅಥವಾ ಇಲ್ಲದಿದ್ದರೆ, ಯಾವುದೇ ಪೀಪಲ್‌ಲಿಂಕ್ ಮಾರ್ಕ್‌ಗಳನ್ನು ಮಾರ್ಪಡಿಸುವುದಿಲ್ಲ ಅಥವಾ ಪೀಪಲ್‌ಲಿಂಕ್ ಒದಗಿಸಿದ ಸಮಂಜಸವಾದ ಸೂಚನೆಗಳಿಗೆ ವಿರುದ್ಧವಾಗಿ ಇತರ ಮಾರ್ಕೆಟಿಂಗ್ ವಸ್ತುಗಳನ್ನು ಗಣನೀಯವಾಗಿ ಮಾರ್ಪಡಿಸುವುದಿಲ್ಲ. , ಮತ್ತು ಮಾರ್ಕೆಟಿಂಗ್ ಮೆಟೀರಿಯಲ್‌ಗಳ ರೂಪ, ವಿಷಯ ಮತ್ತು ಪ್ರದರ್ಶನಕ್ಕೆ ಸಂಬಂಧಿಸಿದಂತೆ ಪೀಪಲ್‌ಲಿಂಕ್‌ನಿಂದ ಸಮಂಜಸವಾದ ಸೂಚನೆಗಳನ್ನು ಅನುಸರಿಸಬೇಕು. ಯಾವುದೇ ಕಾರಣಕ್ಕೂ ಈ ಒಪ್ಪಂದವನ್ನು ಮುಕ್ತಾಯಗೊಳಿಸಿದ ನಂತರ ಅಥವಾ ಪೀಪಲ್‌ಲಿಂಕ್‌ನ ಲಿಖಿತ ಕೋರಿಕೆಯ ಮೇರೆಗೆ, ಇಲ್ಲಿ ನೀಡಲಾದ ಪರವಾನಗಿ ಅವಧಿ ಮುಗಿಯುತ್ತದೆ ಮತ್ತು ಪಾಲುದಾರ ತಕ್ಷಣವೇ ನಿಲ್ಲುತ್ತದೆ ಈ ಒಪ್ಪಂದದ ಅಡಿಯಲ್ಲಿ ಅದರ ಎಲ್ಲಾ ಚಟುವಟಿಕೆಗಳು. ",
        "aff_str15_para": "ಈ ಒಪ್ಪಂದದ ಅಡಿಯಲ್ಲಿ ರಚಿಸಲಾದ ಮತ್ತು ಬಳಸಿದ ಪಾಲುದಾರರ ಕಾರ್ಯಾಚರಣೆಗಳು ಮತ್ತು ಸಾಮಗ್ರಿಗಳ ಕಾನೂನುಬದ್ಧತೆಯನ್ನು ಒಳಗೊಂಡಂತೆ ಈ ಒಪ್ಪಂದದ ಅಡಿಯಲ್ಲಿ ಕಾರ್ಯನಿರ್ವಹಿಸುವಲ್ಲಿ ಪಾಲುದಾರನು ಅದರ ಕಾರ್ಯಾಚರಣೆಗಳಿಗೆ ಮಾತ್ರ ಜವಾಬ್ದಾರನಾಗಿರುತ್ತಾನೆ. ಪೀಪಲ್‌ಲಿಂಕ್ ಗುರುತು ಎಂದು ಆರೋಪಿಸುವ ಹಕ್ಕನ್ನು ಹೊರತುಪಡಿಸಿ ಮೂರನೇ ವ್ಯಕ್ತಿಯ ಟ್ರೇಡ್‌ಮಾರ್ಕ್ ಹಕ್ಕುಗಳನ್ನು ಉಲ್ಲಂಘಿಸುತ್ತದೆ, ಪಾಲುದಾರರ ಮಾರ್ಕೆಟಿಂಗ್ ಮೆಟೀರಿಯಲ್‌ಗಳ ಅಭಿವೃದ್ಧಿ, ಕಾರ್ಯಾಚರಣೆ ಅಥವಾ ವಿಷಯಕ್ಕೆ ಪೀಪಲ್‌ಲಿಂಕ್ ಜವಾಬ್ದಾರನಾಗಿರುವುದಿಲ್ಲ ಮತ್ತು ಯಾವುದೇ ಹಕ್ಕುಗಳು, ಕಾರ್ಯಗಳು, ಕ್ರಿಯೆಯ ಕಾರಣಗಳು, ಹಾನಿಗಳು ಅಥವಾ ಖರ್ಚುಗಳ ವಿರುದ್ಧ ಪೀಪಲ್‌ಲಿಂಕ್ ಅನ್ನು ಹಾನಿಯಾಗದಂತೆ ರಕ್ಷಿಸಲು, ನಷ್ಟವನ್ನುಂಟುಮಾಡಲು ಮತ್ತು ಹಿಡಿದಿಡಲು ಪಾಲುದಾರ ಒಪ್ಪುತ್ತಾನೆ (ವಕೀಲರು ಸೇರಿದಂತೆ ಶುಲ್ಕಗಳು) ಪಾಲುದಾರರ ಮಾರ್ಕೆಟಿಂಗ್ ಸಾಮಗ್ರಿಗಳ ಅಭಿವೃದ್ಧಿ, ಕಾರ್ಯಾಚರಣೆ, ವಿಷಯ ಮತ್ತು ನಿರ್ವಹಣೆಗೆ ಸಂಬಂಧಿಸಿದ. ",
        "aff_str16_para" : 'ಅವಧಿಯ ಸಮಯದಲ್ಲಿ ಮತ್ತು ನಂತರ, ಪೀಪಲ್‌ಲಿಂಕ್ ಸೇವೆಯ ಬಳಕೆಗಾಗಿ ಪೀಪಲ್‌ಲಿಂಕ್‌ನೊಂದಿಗೆ ಒಪ್ಪಂದ ಮಾಡಿಕೊಳ್ಳುವ ಯಾವುದೇ ಮತ್ತು ಎಲ್ಲಾ ಮಾಹಿತಿಯನ್ನು ಒಳಗೊಂಡಂತೆ ಪೀಪಲ್‌ಲಿಂಕ್ ಸೇವೆಗೆ ಸಂಬಂಧಿಸಿದಂತೆ ಪೀಪಲ್‌ಲಿಂಕ್ ಮತ್ತು ರೆಫರಲ್‌ಗಳ ನಡುವೆ ಪಾಲುದಾರರ ಮೂಲಕ ರಚಿಸಲಾದ ಎಲ್ಲಾ ಸಂಬಂಧಗಳ ಪ್ರತ್ಯೇಕ ಮಾಲೀಕರಾಗಿ ಪೀಪಲ್‌ಲಿಂಕ್ ಇರುತ್ತದೆ. ಪೀಪಲ್‌ಲಿಂಕ್ ಸೇವೆಗಾಗಿ ನಿಯಮಗಳು, ಗೌಪ್ಯತೆ ನೀತಿ ಮತ್ತು ಪೀಪಲ್‌ಲಿಂಕ್‌ನ ನಿಯಮಗಳು ಮತ್ತು ಕಾರ್ಯವಿಧಾನಗಳು ಈ ರೆಫರಲ್‌ಗಳಿಗೆ ಅನ್ವಯವಾಗುತ್ತವೆ ಮತ್ತು ಪಾಲುದಾರರಿಗೆ ಪೂರ್ವಾನುಮತಿ ನೀಡದೆ ಪೀಪಲ್‌ಲಿಂಕ್‌ನಿಂದ ಬದಲಾಯಿಸಬಹುದು, ಮತ್ತು ನಿಯಮಗಳ ಅಡಿಯಲ್ಲಿ ಪೀಪಲ್‌ಲಿಂಕ್‌ನೊಂದಿಗಿನ ಅವರ ಸಂಬಂಧಗಳ ಸ್ವರೂಪವನ್ನು ರೆಫರಲ್‌ಗಳಿಗೆ ತಿಳಿಸಲು ಪಾಲುದಾರ ಒಪ್ಪುತ್ತಾನೆ.', 
        "aff_str20_para1": "ಪೀಪಲ್‌ಲಿಂಕ್‌ಗೆ ಪಾಲುದಾರರಿಂದ ಉಲ್ಲೇಖಿಸಲ್ಪಟ್ಟಿದೆ ಮತ್ತು ಕೆಳಗಿನ ವಿಭಾಗ 3 (ಬಿ) ನಲ್ಲಿ ವಿವರಿಸಿದ ಕಾರ್ಯವಿಧಾನಕ್ಕೆ ಅನುಗುಣವಾಗಿ ಸೈನ್ ಅಪ್ ಕಾರ್ಯವಿಧಾನವನ್ನು ಪೂರ್ಣಗೊಳಿಸಿದವರು;",
        "aff_str20_para2": "ಪೀಪಲ್‌ಲಿಂಕ್ ಸೇವೆಗೆ ಸಂಬಂಧಿಸಿದಂತೆ ಪೀಪಲ್‌ಲಿಂಕ್‌ಗೆ ಯಾವುದೇ ದಾಖಲೆಗಳಿಲ್ಲ, ಅಥವಾ ಪೀಪಲ್‌ಲಿಂಕ್ ಅನ್ನು ಪಾಲುದಾರರಿಂದ ಉಲ್ಲೇಖಿಸಲ್ಪಟ್ಟ ಸಮಯದಲ್ಲಿ, ಯಾವುದೇ ಒಪ್ಪಂದದ ಸಂಬಂಧಗಳಲ್ಲಿ ಅಥವಾ ಪೀಪಲ್‌ಲಿಂಕ್ ಸೇವೆಯೊಂದಿಗೆ ಪೀಪಲ್‌ಲಿಂಕ್‌ನೊಂದಿಗೆ ನಡೆಯುತ್ತಿರುವ ಮಾತುಕತೆಗಳಲ್ಲಿ ಯಾರು ಇಲ್ಲ;",
        "aff_str20_para3" : 'ಅವರು ನಿಯಮಗಳನ್ನು ಸ್ವೀಕರಿಸುತ್ತಾರೆ ಮತ್ತು ರೆಫರಲ್‌ನ ಸ್ವಂತ ವಿವೇಚನೆಯಿಂದ ಮತ್ತು ಪಾಲುದಾರರಿಂದ ಯಾವುದೇ ವಿತ್ತೀಯ ಅಥವಾ ಇನ್ನೊಂದು ಪ್ರೋತ್ಸಾಹವನ್ನು ಪಡೆಯದೆ, ಪೀಪಲ್‌ಲಿಂಕ್ ವೆಬ್‌ಸೈಟ್‌ಗಳಲ್ಲಿ ಪಟ್ಟಿ ಮಾಡಲಾದ ಈ ಕೆಳಗಿನ ಯಾವುದೇ ಪೀಪಲ್‌ಲಿಂಕ್ ಸೇವಾ ಯೋಜನೆ ಕಟ್ಟುಗಳ ಕನಿಷ್ಠ ವಾರ್ಷಿಕ ಚಂದಾದಾರಿಕೆಗಳನ್ನು ಅಥವಾ ಇಲ್ಲದಿದ್ದರೆ (iv) ತಿರಸ್ಕರಿಸದವರು ಪೀಪಲ್‌ಲಿಂಕ್, ಮತ್ತು ಪೀಪಲ್‌ಲಿಂಕ್ ಸೇವೆಯನ್ನು ಸ್ವೀಕರಿಸಲು ಕನಿಷ್ಠ ಒಂದು ಪಾವತಿ (ವಾರ್ಷಿಕ ಪೂರ್ವಪಾವತಿ) ಅಥವಾ ಮೂರು ಪಾವತಿಗಳನ್ನು (ವಾರ್ಷಿಕ ಅವಧಿ, ಮಾಸಿಕ ಬಿಲ್ಲಿಂಗ್) ಮಾಡಿ.',
        "aff_str21": "ಉಲ್ಲೇಖಿತ ವಿಧಾನ.",
        "aff_str22": "ಆಯೋಗಗಳು. ಜವಾಬ್ದಾರಿಗಳು.",
        "aff_str221": "ರೆಫರಲ್ ಶುಲ್ಕ.",
        "aff_str222": "ಒಂದು ಉಲ್ಲೇಖದಿಂದ ನಡೆಯುತ್ತಿರುವ ಮಾರಾಟಗಳು",
        "aff_str223": "ಸಂಯೋಜಿತ ಶುಲ್ಕಗಳು.",
        "aff_str23": "ಮಾರಾಟ / ಆಯೋಗಗಳ ವರದಿಗಳು.",
        "aff_str21_para" : 'ಪೀಪಲ್‌ಲಿಂಕ್‌ನಿಂದ ಪಾಲುದಾರರಿಗೆ ಒದಗಿಸಲಾದ ಆನ್‌ಲೈನ್ ಯು ಆರ್ ಎಲ್ ಮೂಲಕ ಪ್ರತಿ ರೆಫರಲ್ ಅನ್ನು ಪೀಪಲ್‌ಲಿಂಕ್‌ಗೆ ಉಲ್ಲೇಖಿಸಲಾಗುತ್ತದೆ, ಮಾರಾಟ ಪ್ರಕ್ರಿಯೆಯನ್ನು ರೆಫರಲ್‌ಗೆ ಉತ್ತೇಜಿಸುವಲ್ಲಿ ಪಕ್ಷಗಳ ಮುಂದುವರಿದ ಉತ್ತಮ-ನಂಬಿಕೆಯ ಸಹಕಾರಕ್ಕೆ ಒಳಪಟ್ಟು ಎಲ್ಲಾ ರೆಫರಲ್‌ಗಳಿಗೆ ಮಾರಾಟ ಪ್ರಕ್ರಿಯೆಗೆ ಪೀಪಲ್‌ಲಿಂಕ್ ಜವಾಬ್ದಾರವಾಗಿರುತ್ತದೆ.',
        "aff_str22_para": "ಪೀಪಲ್‌ಲಿಂಕ್ ಸೇವೆಗಾಗಿ ರೆಫರಲ್‌ಗಳಿಂದ ಪೀಪಲ್‌ಲಿಂಕ್ ಎಲ್ಲಾ ಶುಲ್ಕಗಳನ್ನು ನೇರವಾಗಿ ರೆಫರಲ್‌ಗಳಿಂದ ಸಂಗ್ರಹಿಸುತ್ತದೆ.",
        "aff_str22_para1": "ರೆಫರಲ್ ಅರ್ಹ ರೆಫರಲ್ ಆದ ನಂತರ, ಪೀಪಲ್‌ಲಿಂಕ್ ಬಿ ನಲ್ಲಿರುವ ಪಟ್ಟಿಮಾಡಿದ ಶುಲ್ಕದ ಆಧಾರದ ಮೇಲೆ ಪಾಲುದಾರ ಉಲ್ಲೇಖಿತ ಶುಲ್ಕವನ್ನು ಬಾಕಿ ಪಾವತಿಸುತ್ತದೆ",
        "aff_str22_para12": "(ಯಾವುದೇ ರಿಯಾಯಿತಿಗಳನ್ನು ಹೊರತುಪಡಿಸಿ) ಅರ್ಹ ರೆಫರಲ್ ಪಾವತಿಸಬೇಕಾಗುತ್ತದೆ. ಅಂತಹ ರೆಫರಲ್ ಶುಲ್ಕಗಳು ಪಾವತಿಸಲ್ಪಡುತ್ತವೆ ಮತ್ತು ಪಾವತಿಸಿದ ಸೇವೆಯ ಪ್ರಾರಂಭದ ದಿನಾಂಕದ ಸುಮಾರು (<ಸೇರಿಸಿ) ತೊಂಬತ್ತು (90) ದಿನಗಳಲ್ಲಿ ಪಾಲುದಾರರಿಗೆ ಪಾವತಿಸಲಾಗುವುದು. ",
        "aff_str22_para2": "- ಉಲ್ಲೇಖಿತ ಆರಂಭದಲ್ಲಿ ಸಲ್ಲಿಸಿದ ದಿನಾಂಕದ ಮೊದಲ 90 ದಿನಗಳಲ್ಲಿ ನಡೆಯುವ ಅರ್ಹ ರೆಫರಲ್‌ನಿಂದ ಹೆಚ್ಚುವರಿ ಮಾರಾಟಕ್ಕಾಗಿ ಪಾಲುದಾರರು ಉಲ್ಲೇಖಿತ ಶುಲ್ಕವನ್ನು ಸ್ವೀಕರಿಸುತ್ತಾರೆ.",
        "aff_str22_para3" : "ರೆಫರಲ್ ಶುಲ್ಕದ ಮೇಲೆ ವಿಧಿಸಲಾಗುವ ಎಲ್ಲಾ ತೆರಿಗೆಗಳು, ಕರ್ತವ್ಯಗಳು, ಸರ್ಕಾರಿ ಶುಲ್ಕಗಳು ಮತ್ತು ಇತರ ಶುಲ್ಕಗಳ ಪಾವತಿಗೆ ಬಿ ಪಾಲುದಾರನು ಜವಾಬ್ದಾರನಾಗಿರುತ್ತಾನೆ, ಮತ್ತು ಪಾಲುದಾರನು ಪೀಪಲ್‌ಲಿಂಕ್ ಅನ್ನು ಯಾವುದೇ ಹಕ್ಕುಗಳಿಂದ ಅಥವಾ ವಿರುದ್ಧವಾಗಿ ಉಂಟಾಗುವ ಅಥವಾ ವಿರುದ್ಧವಾಗಿ ಉಂಟಾಗುವ ಎಲ್ಲ ಹಕ್ಕುಗಳಿಗೆ ವಿರುದ್ಧವಾಗಿ ಮತ್ತು ವಿರುದ್ಧವಾಗಿ ಪೀಪಲ್‌ಲಿಂಕ್‌ಗೆ ನಷ್ಟವನ್ನುಂಟುಮಾಡುತ್ತದೆ, ರಕ್ಷಿಸುತ್ತದೆ ಮತ್ತು ಹಿಡಿದಿಟ್ಟುಕೊಳ್ಳುತ್ತದೆ. ಪೀಪಲ್‌ಲಿಂಕ್‌ನ ರೆಫರಲ್ ಶುಲ್ಕದ ಪಾವತಿ. ",
        "aff_str23_para" : "ಪೀಪಲ್‌ಲಿಂಕ್ ತಮ್ಮ ಆನ್‌ಲೈನ್ ಡ್ಯಾಶ್‌ಬೋರ್ಡ್ ವರದಿಯಲ್ಲಿ ಪಾಲುದಾರರ ಮಾರಾಟ ಚಟುವಟಿಕೆಗಳನ್ನು ಮತ್ತು ರೆಫರಲ್‌ಗಳಿಂದ ಪಡೆದ ಅರ್ಹ ರೆಫರಲ್‌ಗಳಿಗಾಗಿ ಅದರ ಆಯೋಗಗಳನ್ನು ಸಾರಾಂಶಗೊಳಿಸುತ್ತದೆ. ಪೀಪಲ್‌ಲಿಂಕ್ ರೆಫರಲ್‌ಗಳು ಮತ್ತು ಅರ್ಹ ರೆಫರಲ್‌ಗಳ ಹೆಸರುಗಳು ಅಥವಾ ಇತರ ವೈಯಕ್ತಿಕ ಮಾಹಿತಿಯನ್ನು ಬಹಿರಂಗಪಡಿಸುವುದಿಲ್ಲ.",
        "aff_str31": "ಆರಂಭಿಕ ಅವಧಿ.",
        "aff_str32": "ನವೀಕರಣ ಅವಧಿ.",
        "aff_str33": "ಆರಂಭಿಕ ಮುಕ್ತಾಯ. ಕಾರಣವಿಲ್ಲದೆ.",
        "aff_str34": "ಕಾರಣಕ್ಕಾಗಿ.",
        "aff_str35": "ಮುಕ್ತಾಯದ ಪರಿಣಾಮ.",
        "aff_str31_para": 'ಈ ಒಪ್ಪಂದವು ಪರಿಣಾಮಕಾರಿ ದಿನಾಂಕದಂದು ಪರಿಣಾಮಕಾರಿಯಾಗಲಿದೆ ಮತ್ತು ಅದರ ನಂತರ ಹನ್ನೆರಡು (12) ತಿಂಗಳುಗಳವರೆಗೆ ("ಆರಂಭಿಕ ಅವಧಿ") ಮುಂದುವರಿಯುತ್ತದೆ, ಕಾರ್ಯಕ್ರಮದಲ್ಲಿ ಭಾಗವಹಿಸಲು ಪೀಪಲ್‌ಲಿಂಕ್ ಪಾಲುದಾರರ ಅರ್ಜಿಯನ್ನು ತಿರಸ್ಕರಿಸದ ಹೊರತು',
        "aff_str32_para": 'ಆರಂಭಿಕ ಅವಧಿಯ ಮುಕ್ತಾಯದ ನಂತರ, ಒಂದು ಪಕ್ಷವು ಇತರ ಪಕ್ಷಕ್ಕೆ ಮುಕ್ತಾಯದ ಬಗ್ಗೆ ಲಿಖಿತ ಸೂಚನೆ ನೀಡದ ಹೊರತು, ಸತತ ಹನ್ನೆರಡು (12) ತಿಂಗಳುಗಳವರೆಗೆ (ಪ್ರತಿಯೊಂದೂ, "ನವೀಕರಣ ಅವಧಿ") ಈ ಒಪ್ಪಂದವನ್ನು ಸ್ವಯಂಚಾಲಿತವಾಗಿ ನವೀಕರಿಸಲಾಗುತ್ತದೆ. ಆರಂಭಿಕ ಅವಧಿ ಅಥವಾ ಯಾವುದೇ ನವೀಕರಣ ಅವಧಿಯ ಅಂತ್ಯಕ್ಕೆ ಕನಿಷ್ಠ ಮೂವತ್ತು (30) ದಿನಗಳ ಮೊದಲು. ',
        "aff_str33_para": "ಪಾಲುದಾರನಿಗೆ ಐದು (5) ದಿನಗಳ ಮುಂಚಿತವಾಗಿ ಲಿಖಿತ ಸೂಚನೆಯನ್ನು ನೀಡುವ ಮೂಲಕ ಯಾವುದೇ ಅಥವಾ ಯಾವುದೇ ಕಾರಣಕ್ಕೂ ಈ ಒಪ್ಪಂದವನ್ನು ಯಾವುದೇ ಸಮಯದಲ್ಲಿ ಕೊನೆಗೊಳಿಸುವ ಹಕ್ಕನ್ನು ಪೀಪಲ್‌ಲಿಂಕ್ ಹೊಂದಿರುತ್ತದೆ.",
        "aff_str34_para": "ಈ ಒಪ್ಪಂದವನ್ನು ಭೌತಿಕವಾಗಿ ಉಲ್ಲಂಘಿಸಿದ ಇತರ ಪಕ್ಷಕ್ಕೆ ಲಿಖಿತ ಸೂಚನೆಯ ಮೇರೆಗೆ ಯಾವುದೇ ಪಕ್ಷವು ಈ ಒಪ್ಪಂದವನ್ನು ಯಾವುದೇ ಸಮಯದಲ್ಲಿ ಕೊನೆಗೊಳಿಸಬಹುದು, ಈ ಒಪ್ಪಂದವನ್ನು ಮುಕ್ತಾಯಗೊಳಿಸುವ ಮೊದಲು ಮುಕ್ತಾಯಗೊಳ್ಳುವ ಪಕ್ಷವು ಅಂತಹ ವಸ್ತು ಉಲ್ಲಂಘನೆಯ ಲಿಖಿತ ಸೂಚನೆಯನ್ನು ಒದಗಿಸುತ್ತದೆ ಮತ್ತು ಅಂತಹ ಉಲ್ಲಂಘನೆಯನ್ನು ಗುಣಪಡಿಸಲು ಉಲ್ಲಂಘಿಸುವ ಪಕ್ಷಕ್ಕೆ ಮೂವತ್ತು (30) ದಿನಗಳ ಅವಕಾಶ. ",
        "aff_str35_para": "ಈ ಒಪ್ಪಂದದ ಮುಕ್ತಾಯದ ದಿನಾಂಕದಿಂದ ಮತ್ತು ನಂತರ ಈ ಒಪ್ಪಂದದ ಅಡಿಯಲ್ಲಿ ಪಾಲುದಾರರ ಹಕ್ಕುಗಳು ಕೊನೆಗೊಳ್ಳುತ್ತವೆ, ಮತ್ತು ಈ ಒಪ್ಪಂದದ ಅಡಿಯಲ್ಲಿ ಯಾವುದೇ ರೆಫರಲ್ ಶುಲ್ಕಗಳು ಅಥವಾ ಇತರ ಯಾವುದೇ ಪಾವತಿಗಳನ್ನು ಸ್ವೀಕರಿಸಲು ಪಾಲುದಾರನಿಗೆ ಅರ್ಹತೆ ಇರುವುದಿಲ್ಲ. ಈ ಒಪ್ಪಂದದ ಮುಕ್ತಾಯಕ್ಕೆ. ",
        "aff_str41": "ನಿಯೋಜನೆ.",
        "aff_str42": "ಬೌದ್ಧಿಕ ಆಸ್ತಿ ಹಕ್ಕುಗಳು.",
        "aff_str43": "ಮನ್ನಾ ಇಲ್ಲ.",
        "aff_str44": "ಸೀಮಿತ ಖಾತರಿ.",
        "aff_str45": "ಖಾತರಿ ನಿರಾಕರಣೆ.",
        "aff_str46": "ಹೊಣೆಗಾರಿಕೆಯ ಮಿತಿ.",
        "aff_str47": "ಸ್ವತಂತ್ರ ಗುತ್ತಿಗೆದಾರರು.",
        "aff_str48": "ನಷ್ಟ ಪರಿಹಾರ.",
        "aff_str49": "ಫೋರ್ಸ್ ಮಜೂರ್.",
        "aff_str410": "ಸಂಪೂರ್ಣ ಒಪ್ಪಂದ; ತೀವ್ರತೆ.",
        "aff_str411": "ಕೌಂಟರ್‌ಪಾರ್ಟ್‌ಗಳು; ಸೂಚನೆಗಳು.",
        "aff_str412": "ಆಡಳಿತ ಕಾನೂನು; ನ್ಯಾಯವ್ಯಾಪ್ತಿ; ವಿವಾದ ಪರಿಹಾರ.",
        "aff_str41_para": "ಪೀಪಲ್‌ಲಿಂಕ್ ಈ ಒಪ್ಪಂದವನ್ನು ಯಾವುದೇ ಸಮಯದಲ್ಲಿ ನಿಯೋಜಿಸಬಹುದು. ಪೀಪಲ್‌ಲಿಂಕ್‌ನ ಪೂರ್ವ ಲಿಖಿತ ಒಪ್ಪಿಗೆಯಿಲ್ಲದೆ ಪಾಲುದಾರನು ಈ ಒಪ್ಪಂದವನ್ನು ನಿಯೋಜಿಸಲು ಅಥವಾ ವರ್ಗಾಯಿಸಲು ಸಾಧ್ಯವಿಲ್ಲ, ಅಂತಹ ಒಪ್ಪಿಗೆಯನ್ನು ಅಸಮಂಜಸವಾಗಿ ತಡೆಹಿಡಿಯಬಾರದು.",
        "aff_str42_para": "ಪೀಪಲ್‌ಲಿಂಕ್ ಮಾರ್ಕ್ಸ್, ಪೀಪಲ್‌ಲಿಂಕ್ ಸೇವೆ ಮತ್ತು ಪ್ರಪಂಚದಾದ್ಯಂತದ ಸಂಬಂಧಿತ ವಿಷಯ ಮತ್ತು ತಂತ್ರಜ್ಞಾನದಲ್ಲಿನ ಎಲ್ಲಾ ಬೌದ್ಧಿಕ ಆಸ್ತಿ ಹಕ್ಕುಗಳು (ಟ್ರೇಡ್‌ಮಾರ್ಕ್‌ಗಳು, ವ್ಯಾಪಾರ ಹೆಸರುಗಳು, ಲೋಗೊಗಳು, ಪೇಟೆಂಟ್‌ಗಳು, ಹಕ್ಕುಸ್ವಾಮ್ಯಗಳು, ಡೊಮೇನ್ ಹೆಸರುಗಳು ಮತ್ತು ಉತ್ಪನ್ನ ಹಕ್ಕುಗಳಿಗೆ ಸೀಮಿತವಾಗಿಲ್ಲ) ಐಪಿ ಹಕ್ಕುಗಳು) ಪೀಪಲ್‌ಲಿಂಕ್ ಮತ್ತು ಅದರ ಅಂಗಸಂಸ್ಥೆ ಕಂಪನಿಗಳ ಪ್ರತ್ಯೇಕ ಆಸ್ತಿಯಾಗಿರುತ್ತವೆ ಮತ್ತು ಉಳಿಯುತ್ತವೆ. ಪರವಾನಗಿ ಪಡೆದ ಗುರುತುಗಳನ್ನು ಬಳಸುವ ಪಾಲುದಾರನ ಹಕ್ಕು ಪೀಪಲ್‌ಲಿಂಕ್‌ನ ವಿವೇಚನೆಗೆ ಒಳಪಟ್ಟಿರುತ್ತದೆ ಮತ್ತು ಈ ಒಪ್ಪಂದ, ಮಾರ್ಗಸೂಚಿಗಳು ಮತ್ತು ಅನ್ವಯವಾಗುವ ಎಲ್ಲಾ ಕಾನೂನುಗಳೊಂದಿಗೆ ಪಾಲುದಾರರ ಅನುಸರಣೆಗೆ ಒಳಪಟ್ಟಿರುತ್ತದೆ. ಮತ್ತು ನಿಯಮಗಳು. (ಎ) ಈ ಒಪ್ಪಂದವನ್ನು ಉಲ್ಲಂಘಿಸುವ ಯಾವುದೇ ರೀತಿಯಲ್ಲಿ ಯಾವುದೇ ಪೀಪಲ್‌ಲಿಂಕ್ ಐಪಿ ಹಕ್ಕುಗಳನ್ನು ಸಮಂಜಸವಾಗಿ ಬಳಸದಿರಲು ಪಾಲುದಾರ ಒಪ್ಪುತ್ತಾನೆ; (ಬಿ) ಯಾವುದೇ ಪೀಪಲ್‌ಲಿಂಕ್ ಐಪಿ ಹಕ್ಕುಗಳನ್ನು ಸ್ಪರ್ಧಿಸುವ ಅಥವಾ ದುರ್ಬಲಗೊಳಿಸುವ ಯಾವುದನ್ನೂ ಮಾಡಬೇಡಿ; (ಸಿ) ಯಾವುದೇ ಬೌದ್ಧಿಕ ಆಸ್ತಿ ಹಕ್ಕುಗಳನ್ನು ರಚಿಸುವುದು ಅಥವಾ ಪಡೆಯುವುದು (ಉದಾಹರಣೆಗೆ ಟ್ರೇಡ್‌ಮಾರ್ಕ್‌ಗಳು, ವ್ಯಾಪಾರ ಹೆಸರುಗಳು, ಲೋಗೊಗಳು, ಪೇಟೆಂಟ್‌ಗಳು, ಹಕ್ಕುಸ್ವಾಮ್ಯಗಳು, ಡೊಮೇನ್ ಹೆಸರುಗಳು ಮತ್ತು ವ್ಯುತ್ಪನ್ನ ಹಕ್ಕುಗಳು) ಯಾವುದೇ ಪೀಪಲ್‌ಲಿಂಕ್ ಐಪಿ ಹಕ್ಕುಗಳಿಗೆ ಹೋಲುತ್ತದೆ ; (ಡಿ) ಪಾಲುದಾರನಿಗೆ ನಿಜವಾದ ಜ್ಞಾನವಿರುವ ಯಾವುದೇ ಪೀಪಲ್‌ಲಿಂಕ್ ಐಪಿ ಹಕ್ಕುಗಳ ಅನಧಿಕೃತ ಬಳಕೆಯ ಬಗ್ಗೆ ಪೀಪಲ್‌ಲಿಂಕ್‌ಗೆ ತಕ್ಷಣ ತಿಳಿಸಿ; ಮತ್ತು (ಇ) ಯಾವಾಗಲೂ ಮಾರ್ಗಸೂಚಿಗಳಿಗೆ ಅನುಸಾರವಾಗಿ ಪರವಾನಗಿ ಪಡೆದ ಗುರುತುಗಳು ಮತ್ತು ಇತರ ಯಾವುದೇ ಪೀಪಲ್‌ಲಿಂಕ್ ಗುರುತುಗಳನ್ನು ಬಳಸಿ. ಪೀಪಲ್‌ಲಿಂಕ್ ಪಾಲುದಾರರಿಂದ ಪ್ರಸ್ತುತಪಡಿಸಲಾದ ಯಾವುದೇ ಮಾರ್ಕೆಟಿಂಗ್ ಮೆಟೀರಿಯಲ್‌ಗಳ ಆವರ್ತಕ ವಿಮರ್ಶೆಗಳನ್ನು ಮಾಡಬಹುದು, ಮತ್ತು ಪಾಲುದಾರರಿಂದ ಪ್ರಸ್ತುತಪಡಿಸಲಾದ ಯಾವುದೇ ಮಾರ್ಕೆಟಿಂಗ್ ಮೆಟೀರಿಯಲ್‌ಗಳನ್ನು ತೆಗೆದುಹಾಕಲು ಮತ್ತು / ಅಥವಾ ತಿದ್ದುಪಡಿ ಮಾಡಲು ಆದೇಶಿಸುವ ವಿಶೇಷ ಅಧಿಕಾರ ಮತ್ತು ವಿವೇಚನೆಯನ್ನು ಹೊಂದಿರುತ್ತದೆ. ",
        "aff_str43_para": "ಈ ಒಪ್ಪಂದದ ಯಾವುದೇ ನಿಬಂಧನೆಯ ಇತರ ಪಕ್ಷದ ಕಟ್ಟುನಿಟ್ಟಿನ ಕಾರ್ಯಕ್ಷಮತೆಯನ್ನು ಜಾರಿಗೊಳಿಸುವಲ್ಲಿ ಪಕ್ಷದ ವೈಫಲ್ಯವು ಅಂತಹ ನಿಬಂಧನೆ ಅಥವಾ ಈ ಒಪ್ಪಂದದ ಯಾವುದೇ ನಿಬಂಧನೆಯನ್ನು ಜಾರಿಗೆ ತರುವ ಮೊದಲ ಪಕ್ಷದ ಹಕ್ಕನ್ನು ತ್ಯಜಿಸುವುದಿಲ್ಲ.",
        "aff_str44_para": "ಎರಡೂ ಪಕ್ಷಗಳು ಎಲ್ಲಾ ಸಮಯದಲ್ಲೂ ಅವರು ಅನ್ವಯವಾಗುವ ಎಲ್ಲಾ ಕಾನೂನುಗಳು, ನಿಯಮಗಳು, ಅಭ್ಯಾಸದ ಸಂಕೇತಗಳು, ಹಾಗೆಯೇ ಈ ಒಪ್ಪಂದ, ನಿಯಮಗಳು, ಗೌಪ್ಯತೆ ನೀತಿ ಮತ್ತು ಮಾರ್ಗಸೂಚಿಗಳನ್ನು ಅನುಸರಿಸುತ್ತವೆ ಎಂದು ಭರವಸೆ ನೀಡುತ್ತವೆ. ಅವಧಿಯ ಸಮಯದಲ್ಲಿ ಮತ್ತು ಅದರ ಮುಕ್ತಾಯದ ನಂತರ ಯಾವುದೇ ಕಾರಣಕ್ಕಾಗಿ, ಪೀಪಲ್‌ಲಿಂಕ್‌ನ ವ್ಯವಹಾರ, ಆಸಕ್ತಿಗಳು ಅಥವಾ ಪ್ರತಿಷ್ಠೆಗೆ ಹಾನಿಯಾಗಬಹುದೆಂದು ಸಮಂಜಸವಾಗಿ ನಿರೀಕ್ಷಿಸಬಹುದಾದ ಯಾವುದನ್ನೂ ಮಾಡಬಾರದೆಂದು ಪಾಲುದಾರನು ಸ್ಪಷ್ಟವಾಗಿ ಕೈಗೊಳ್ಳುತ್ತಾನೆ ಮತ್ತು ಪೀಪಲ್‌ಲಿಂಕ್, ಅದರ ಪ್ರತಿನಿಧಿಗಳು ಅಥವಾ ಯಾವುದೇ ಅವಮಾನಕರ ಟೀಕೆಗಳನ್ನು ಮಾಡಲು, ಪ್ರಕಟಿಸಲು ಅಥವಾ ಮಾಡಲು ಅಥವಾ ಪ್ರಕಟಿಸಲು ಅನುಮತಿಸುವುದಿಲ್ಲ. ಪೀಪಲ್‌ಲಿಂಕ್ ಸೇವೆ. ",
        "aff_str45_para": "ಹಿಂದಿನ ಉಪವಿಭಾಗ (ಇ) ಅಡಿಯಲ್ಲಿ ಪೀಪಲ್‌ಲಿಂಕ್‌ನ ಎಕ್ಸ್‌ಪ್ರೆಸ್ ಖಾತರಿಯ ಹೊರತಾಗಿ, ಪೀಪಲ್‌ಲಿಂಕ್ ಯಾವುದೇ ರೀತಿಯ ಖಾತರಿ ನೀಡುವುದಿಲ್ಲ, ವ್ಯಕ್ತಪಡಿಸುವುದಿಲ್ಲ ಅಥವಾ ಸೂಚಿಸುವುದಿಲ್ಲ, ಮತ್ತು ಪೀಪಲ್‌ಲಿಂಕ್ ಯಾವುದೇ ಖಾತರಿ ಕರಾರುಗಳನ್ನು ಮತ್ತು ಷರತ್ತುಗಳನ್ನು ಸ್ಪಷ್ಟವಾಗಿ ನಿರಾಕರಿಸುತ್ತದೆ, ಆದರೆ ವ್ಯಾಪಾರದ ಯಾವುದೇ ಖಾತರಿ ಖಾತರಿ ಸೇರಿದಂತೆ; , ನಿರ್ದಿಷ್ಟ ಉದ್ದೇಶಕ್ಕಾಗಿ ಫಿಟ್‌ನೆಸ್, ಲಭ್ಯತೆ, ಸುರಕ್ಷತೆ, ಶೀರ್ಷಿಕೆ ಮತ್ತು / ಅಥವಾ ಈ ಒಪ್ಪಂದದ ವಿಷಯದ ಉಲ್ಲಂಘನೆಯಾಗುವುದಿಲ್ಲ. ",
        "aff_str46_para": "ಪೀಪಲ್‌ಲಿಂಕ್ ಅಥವಾ ಯಾವುದೇ ಅಧಿಕಾರಿ, ಉದ್ಯೋಗಿ, ನಿರ್ದೇಶಕರು ಅಥವಾ ಪೀಪಲ್‌ಲಿಂಕ್‌ನ ಯಾವುದೇ ಪ್ರತಿನಿಧಿಗಳು ಈ ಒಪ್ಪಂದದ ಅಡಿಯಲ್ಲಿ ಅಥವಾ ಅದರ ಮುಕ್ತಾಯದ ಅಡಿಯಲ್ಲಿ ಅಥವಾ ಒಪ್ಪಂದದಲ್ಲಿ, ಒಪ್ಪಂದಕ್ಕೆ ಮುಂಚಿತವಾಗಿ, ಒಪ್ಪಂದಕ್ಕೆ ಮುಂಚಿತವಾಗಿ, ಪಾಲುದಾರ ಅಥವಾ ಯಾವುದೇ ಮೂರನೇ ವ್ಯಕ್ತಿಯ ಕಡೆಗೆ ಜವಾಬ್ದಾರರಾಗಿರುವುದಿಲ್ಲ. ಅಥವಾ ಇಲ್ಲದಿದ್ದರೆ (i) ಯಾವುದೇ ಆರ್ಥಿಕ ನಷ್ಟ (ಆದಾಯ, ಲಾಭ, ಒಪ್ಪಂದಗಳು, ವ್ಯವಹಾರ ಅಥವಾ ನಿರೀಕ್ಷಿತ ಉಳಿತಾಯ ಸೇರಿದಂತೆ) ಅಥವಾ (ii) ಯಾವುದೇ ಅಭಿಮಾನ ಅಥವಾ ಖ್ಯಾತಿಯ ನಷ್ಟ. ಅಂತಹ ನಷ್ಟಗಳು ಯಾವುದೇ ವಿಶೇಷ, ಪರೋಕ್ಷ, ಪ್ರಾಸಂಗಿಕ, ಶಾಸನಬದ್ಧ , ದಂಡನಾತ್ಮಕ ಅಥವಾ ಪರಿಣಾಮಕಾರಿ ನಷ್ಟಗಳು ಅಥವಾ ಹಾನಿಗಳು ಮತ್ತು ಕಾರ್ಯಾಚರಣೆಗಳ ಅಡಚಣೆಯಿಂದ ಉಂಟಾಗುವ ಯಾವುದೇ ನಷ್ಟಗಳು ಅಥವಾ ಹಾನಿಗಳು. ಪಕ್ಷಗಳ ನಡುವಿನ ಯಾವುದೇ ಸಂಬಂಧಗಳನ್ನು ಸುತ್ತುವರೆದಿರುವ ಯಾವುದೇ ಸಂದರ್ಭಗಳು ಅಥವಾ ತಿಳುವಳಿಕೆಗಳ ಹೊರತಾಗಿಯೂ, ಈ ಒಪ್ಪಂದದ ಅಡಿಯಲ್ಲಿ ಪೀಪಲ್‌ಲಿಂಕ್‌ನ ಪಾಲುದಾರನಿಗೆ ಸಂಪೂರ್ಣ ಹೊಣೆಗಾರಿಕೆ ಇನ್‌ರ್ ಅನ್ನು ಮೀರಬಾರದು (ಭಾರತೀಯ ರೂಪಾಯಿಗಳು ಒಂದು ಸಾವಿರ ಮಾತ್ರ) ಈ ಒಪ್ಪಂದದ ಅಡಿಯಲ್ಲಿ ಪಾಲುದಾರನು ಮಾಡಿದ ಯಾವುದೇ ರೀತಿಯ ಹಾನಿಗಳಿಗೆ ಯಾವುದೇ ಮತ್ತು ಎಲ್ಲಾ ಹಕ್ಕುಗಳಿಗೆ, ಮತ್ತು ಈ ಒಪ್ಪಂದವನ್ನು ನಮೂದಿಸುವ ಮೂಲಕ ಪಾಲುದಾರನು ಗುರುತಿಸುತ್ತಾನೆ ಪೀಪಲ್‌ಲಿಂಕ್‌ನ ಹೊಣೆಗಾರಿಕೆಯ ಮೇಲೆ ಇಲ್ಲಿ ಅನುಕರಣೆಗಳು. ",
        "aff_str47_para": "ಇಲ್ಲಿರುವ ಪಕ್ಷಗಳು ಸ್ವತಂತ್ರ ಗುತ್ತಿಗೆದಾರರಾಗಿ ತಮ್ಮ ಪರವಾಗಿ ಕಾರ್ಯನಿರ್ವಹಿಸುತ್ತವೆ. ಈ ಒಪ್ಪಂದದಲ್ಲಿ ಯಾವುದೂ ಈ ಜಂಟಿ ಉದ್ಯಮ, ಏಜೆನ್ಸಿ, ಫ್ರ್ಯಾಂಚೈಸ್, ಮಾರಾಟ ಪ್ರತಿನಿಧಿ, ಉದ್ಯೋಗ ಅಥವಾ ಈ ಒಪ್ಪಂದದಲ್ಲಿ ಸೂಚಿಸಲಾದ ಸಂಬಂಧಗಳನ್ನು ಮೀರಿ ಪಕ್ಷಗಳ ನಡುವೆ ಯಾವುದೇ ಸಂಬಂಧವನ್ನು ಸೃಷ್ಟಿಸುವುದಿಲ್ಲ. , ಮತ್ತು ಪಾಲುದಾರನನ್ನು ಪೀಪಲ್‌ಲಿಂಕ್ ಪರವಾಗಿ ಕಾರ್ಯನಿರ್ವಹಿಸುವುದನ್ನು ಸ್ಪಷ್ಟವಾಗಿ ನಿರ್ಬಂಧಿಸಲಾಗಿದೆ. ಈ ಒಪ್ಪಂದದ ಅಡಿಯಲ್ಲಿ ಪಾಲುದಾರರ ಪರವಾನಗಿ ಪಡೆದ ಗುರುತುಗಳ ಪ್ರದರ್ಶನ, ಪಾಲುದಾರನು ಪ್ರಸ್ತುತಪಡಿಸಿದ ಇತರ ವಿಷಯಗಳು, ಅಥವಾ ಪಾಲುದಾರ ಮತ್ತು ಮೂರನೇ ವ್ಯಕ್ತಿಗಳ ನಡುವಿನ ಸಂಪರ್ಕವು ಇಲ್ಲಿ ವಿವರಿಸಿದ ಸಂಬಂಧಗಳನ್ನು ತಪ್ಪಾಗಿ ನಿರೂಪಿಸುವುದಿಲ್ಲ. ",
        "aff_str48_para": 'ಪಾಲುದಾರನು ಪೀಪಲ್‌ಲಿಂಕ್ ಮತ್ತು ಅದರ ಅಂಗಸಂಸ್ಥೆಗಳು, ಅಂಗಸಂಸ್ಥೆಗಳು, ಅಧಿಕಾರಿಗಳು ಮತ್ತು ನೌಕರರನ್ನು ("ಪೀಪಲ್‌ಲಿಂಕ್ ನಷ್ಟ ಪರಿಹಾರದ ಪಕ್ಷಗಳು") ಯಾವುದೇ ವೆಚ್ಚಗಳು, ಹೊಣೆಗಾರಿಕೆಗಳು, ನಷ್ಟಗಳು ಮತ್ತು ವೆಚ್ಚಗಳಿಂದ (ಮತ್ತು ಸಮಂಜಸವಾದ ವಕೀಲರಿಗೆ ಸೇರಿದಂತೆ ಸೀಮಿತವಾಗಿಲ್ಲ) ನಷ್ಟವನ್ನುಂಟುಮಾಡುತ್ತದೆ, ರಕ್ಷಿಸುತ್ತದೆ ಮತ್ತು ಹಿಡಿದಿಟ್ಟುಕೊಳ್ಳುತ್ತದೆ. ಶುಲ್ಕಗಳು) ಈ ಕೆಳಗಿನವುಗಳಿಂದ ಉಂಟಾಗುವ ಪೀಪಲ್‌ಲಿಂಕ್ ನಷ್ಟ ಪರಿಹಾರದ ಪಕ್ಷಗಳ ವಿರುದ್ಧ ಯಾವುದೇ ಮೂರನೇ ವ್ಯಕ್ತಿಯು ತಂದ ಯಾವುದೇ ಹಕ್ಕು, ಮೊಕದ್ದಮೆ, ಕ್ರಮ, ಬೇಡಿಕೆ ಅಥವಾ ಮುಂದುವರಿಯುವಿಕೆಯಿಂದ ಉಂಟಾಗುವ ಫಲಿತಾಂಶಗಳು: (i) ಪಾಲುದಾರರಿಂದ ಒಪ್ಪಂದದ ಉಲ್ಲಂಘನೆ; (ii) ಪಾಲುದಾರ ಅಥವಾ ಅದರ ನೌಕರರು, ಏಜೆಂಟರು ಅಥವಾ ಗುತ್ತಿಗೆದಾರರ ನಿರ್ಲಕ್ಷ್ಯ, ಸಂಪೂರ್ಣ ನಿರ್ಲಕ್ಷ್ಯ ಅಥವಾ ಉದ್ದೇಶಪೂರ್ವಕ ದುಷ್ಕೃತ್ಯ; ಅಥವಾ (iii) ಇಲ್ಲಿ ಉಲ್ಲೇಖಿಸಲಾದ ಕಾನೂನು ಮತ್ತು ನಿಬಂಧನೆಗಳನ್ನು ಅನುಸರಿಸಲು ಪಾಲುದಾರ ಅಥವಾ ಅದರ ಉದ್ಯೋಗಿಗಳು, ಏಜೆಂಟರು, ಗುತ್ತಿಗೆದಾರರು ಅಥವಾ ಆಹ್ವಾನಿತರು ವಿಫಲರಾಗಿದ್ದಾರೆ. ',
        "aff_str49_para": 'ಒಂದು ಪಕ್ಷವು ತನ್ನ ಯಾವುದೇ ಕಟ್ಟುಪಾಡುಗಳನ್ನು ಇಲ್ಲಿ ನಿರ್ವಹಿಸಲು ನಿರ್ಬಂಧವನ್ನು ಹೊಂದಿರುವುದಿಲ್ಲ, ಅದು ಬಲವಂತದ ಸನ್ನಿವೇಶದಿಂದ ಅದನ್ನು ಮಾಡುವುದನ್ನು ತಡೆಯುತ್ತದೆ. "ಫೋರ್ಸ್ ಮಜೂರ್" ಘಟನೆಗಳು ದೇವರ ಕಾರ್ಯಗಳು, ಸರ್ಕಾರದ ಕಾರ್ಯಗಳು, ಪ್ರಕೃತಿಯ ಕಾರ್ಯಗಳು, ಮುಷ್ಕರಗಳು ಅಥವಾ ಗಲಭೆಗಳು ಸೇರಿದಂತೆ ಪಕ್ಷಗಳ ಸಮಂಜಸವಾದ ನಿಯಂತ್ರಣವನ್ನು ಮೀರಿದ ಘಟನೆಗಳನ್ನು ಒಳಗೊಂಡಿರುತ್ತವೆ, ಜೊತೆಗೆ ಪೀಪಲ್‌ಲಿಂಕ್ಸ್ ಪೂರೈಕೆದಾರರ ಅಸಮರ್ಪಕ ಕಾರ್ಯಕ್ಷಮತೆ ಅಥವಾ ವಸ್ತುಗಳು, ವಸ್ತುಗಳು ಅಥವಾ ಸಾಫ್ಟ್‌ವೇರ್‌ನಲ್ಲಿನ ದೋಷಗಳು ಮೂರನೇ ವ್ಯಕ್ತಿಗಳು. ಬಲವಂತದ ಪರಿಸ್ಥಿತಿಯು ಮೂವತ್ತು (30) ದಿನಗಳಿಗಿಂತ ಹೆಚ್ಚು ಕಾಲ ಇದ್ದರೆ, ಇತರ ಪಕ್ಷಕ್ಕೆ ಲಿಖಿತ ಸೂಚನೆಯ ಮೇರೆಗೆ ಪಕ್ಷವು ಈ ಒಪ್ಪಂದವನ್ನು ಕೊನೆಗೊಳಿಸಬಹುದು. ',
        "aff_str410_para": "ಈ ಒಪ್ಪಂದವು ಅದರ ವಿಷಯ ಮತ್ತು ಪಕ್ಷಗಳ ಸಂಬಂಧಿತ ಕಟ್ಟುಪಾಡುಗಳು ಮತ್ತು ಬದ್ಧತೆಗಳಿಗೆ ಸಂಬಂಧಿಸಿದ ಪಕ್ಷಗಳ ನಡುವಿನ ಸಂಪೂರ್ಣ ಒಪ್ಪಂದವನ್ನು ಪ್ರತಿನಿಧಿಸುತ್ತದೆ. ಇತರ ಯಾವುದೇ ದಾಖಲೆಗಳು, ಅಥವಾ ಪಕ್ಷಗಳ ನಡುವೆ ಮೌಖಿಕ ಅಥವಾ ಲಿಖಿತ ಒಪ್ಪಂದಗಳು ಯಾವುದೇ ರೀತಿಯಲ್ಲಿ ಪ್ರತಿಪಾದಿಸಿದ ಒಪ್ಪಂದಗಳ ಬಗ್ಗೆ ಪ್ರತಿಬಿಂಬಿಸುವುದಿಲ್ಲ ಈ ಒಪ್ಪಂದದಲ್ಲಿ, ಮತ್ತು ಈ ಒಪ್ಪಂದವನ್ನು ಎರಡೂ ಪಕ್ಷಗಳು ಕಾರ್ಯಗತಗೊಳಿಸಿದ ಬರವಣಿಗೆಯನ್ನು ಹೊರತುಪಡಿಸಿ ಮಾರ್ಪಡಿಸಲಾಗುವುದಿಲ್ಲ. ಸಾಧ್ಯವಾದಾಗಲೆಲ್ಲಾ, ಈ ಒಪ್ಪಂದದ ಪ್ರತಿಯೊಂದು ನಿಬಂಧನೆಯನ್ನು ಅನ್ವಯವಾಗುವ ಕಾನೂನಿನಡಿಯಲ್ಲಿ ಪರಿಣಾಮಕಾರಿ ಮತ್ತು ಮಾನ್ಯವಾಗಿರುವ ರೀತಿಯಲ್ಲಿ ವ್ಯಾಖ್ಯಾನಿಸಲಾಗುತ್ತದೆ, ಆದರೆ ಯಾವುದೇ ನಿಬಂಧನೆ ಇದ್ದರೆ ಈ ಒಪ್ಪಂದದ ಅನ್ವಯವಾಗುವ ಕಾನೂನಿನಡಿಯಲ್ಲಿ ನಿಷೇಧಿಸಲಾಗಿದೆ ಅಥವಾ ಅಮಾನ್ಯವಾಗಿದೆ, ಅಂತಹ ನಿಬಂಧನೆಯು ಅಂತಹ ನಿಷೇಧ ಅಥವಾ ಅಮಾನ್ಯತೆಯ ಮಟ್ಟಿಗೆ ಮಾತ್ರ ನಿಷ್ಪರಿಣಾಮಕಾರಿಯಾಗಿರುತ್ತದೆ, ಅಂತಹ ನಿಬಂಧನೆಯ ಉಳಿದ ಭಾಗವನ್ನು ಅಥವಾ ಈ ಒಪ್ಪಂದದ ಉಳಿದ ನಿಬಂಧನೆಗಳನ್ನು ಅಮಾನ್ಯಗೊಳಿಸದೆ. ",
        "aff_str411_para": "ಈ ಒಪ್ಪಂದವನ್ನು ಪ್ರತಿರೂಪಗಳಲ್ಲಿ ಸಹಿ ಮಾಡಬಹುದು ಮತ್ತು ಅಂತಹ ಪ್ರತಿರೂಪಗಳು ಮಾನ್ಯವಾಗಿರುತ್ತವೆ ಮತ್ತು ಮೂಲ ಸಹಿಗಳನ್ನು ವಿನಿಮಯ ಮಾಡಿಕೊಂಡಂತೆಯೇ ಅದೇ ಪರಿಣಾಮದೊಂದಿಗೆ ಪಕ್ಷಗಳ ಮೇಲೆ ಬಂಧಿಸಲ್ಪಡುತ್ತವೆ.",
        "aff_str412_para": "ಈ ಒಪ್ಪಂದವನ್ನು ಕಾನೂನಿನ ಸಂಘರ್ಷಗಳ ಯಾವುದೇ ತತ್ವಗಳಿಗೆ ಪರಿಣಾಮ ಬೀರದೆ ಹೈದರಾಬಾದ್, ತೆಲಂಗಾಣ, ಭಾರತದ ನ್ಯಾಯವ್ಯಾಪ್ತಿಯ ಕಾನೂನುಗಳಿಂದ ನಿಯಂತ್ರಿಸಲಾಗುತ್ತದೆ. ನ್ಯಾಯವ್ಯಾಪ್ತಿ ಪ್ರತ್ಯೇಕವಾಗಿ ಹೈದರಾಬಾದ್, ತೆಲಂಗಾಣ, ಭಾರತದ ಜಿಲ್ಲಾ ನ್ಯಾಯಾಲಯಗಳಲ್ಲಿ ಇರುತ್ತದೆ. ಈ ಒಪ್ಪಂದದಿಂದ ಉದ್ಭವಿಸುವ ಯಾವುದೇ ಮೊಕದ್ದಮೆಗೆ ಏಕೈಕ ಮತ್ತು ವಿಶೇಷ ನ್ಯಾಯವ್ಯಾಪ್ತಿ ಮತ್ತು ಸ್ಥಳವು ಹೈದರಾಬಾದ್, ತೆಲಂಗಾಣ, ಭಾರತದಲ್ಲಿರುವ ಸೂಕ್ತ ಜಿಲ್ಲೆ ಅಥವಾ ರಾಜ್ಯ ನ್ಯಾಯಾಲಯವಾಗಿರಬೇಕು ಮತ್ತು ಪಕ್ಷಗಳು ಸ್ಥಳಾವಕಾಶ ಅಥವಾ ಯಾವುದೇ ಆಕ್ಷೇಪಣೆಗಳು ಅಥವಾ ರಕ್ಷಣೆಗಳನ್ನು ಹೆಚ್ಚಿಸಲು ಒಪ್ಪುವುದಿಲ್ಲ, ಮತ್ತು ಮನ್ನಾ ಮಾಡುತ್ತವೆ. ಈ ಒಪ್ಪಂದದ ಅಡಿಯಲ್ಲಿ ಅಥವಾ ಅದಕ್ಕೆ ಸಂಬಂಧಿಸಿದ ಯಾವುದೇ ಕಾನೂನು ಕ್ರಮವನ್ನು ಪ್ರಾರಂಭಿಸುವ ಮೊದಲು, ಒಂದು ಪಕ್ಷವು ವಿವಾದದ ಬಗ್ಗೆ ಇತರ ಪಕ್ಷದ ಲಿಖಿತ ಸೂಚನೆಯನ್ನು ಒದಗಿಸುತ್ತದೆ ಮತ್ತು ಪಕ್ಷಗಳು ಸಕ್ರಿಯವಾಗಿ ಮತ್ತು ಉತ್ತಮ ನಂಬಿಕೆಯಿಂದ ಅಂತಹ ವಿವಾದವನ್ನು ತ್ವರಿತವಾಗಿ ಪರಿಹರಿಸುವ ಉದ್ದೇಶದಿಂದ ಮಾತುಕತೆ ನಡೆಸುತ್ತವೆ. ಅಂತಹ ಸೂಚನೆ ಬಂದ ಮೂವತ್ತು (30) ವ್ಯವಹಾರ ದಿನಗಳು. ",
        "aff_str40": "ಒಪ್ಪಂದದ ಮಾರ್ಪಾಡು.",
        "aff_str40_para": "ಸೈಟ್‌ನಲ್ಲಿ ಬದಲಾವಣೆಯನ್ನು ಪೋಸ್ಟ್ ಮಾಡುವ ಮೂಲಕ (atB www.peoplelinkvc.com/affiliatestermsofservice) ಅಥವಾ ಪಾಲುದಾರರಿಗೆ ಇಮೇಲ್ ಮೂಲಕ ತಿಳಿಸುವ ಮೂಲಕ ಪೀಪಲ್‌ಲಿಂಕ್ ಈ ಒಪ್ಪಂದವನ್ನು ಕಾಲಕಾಲಕ್ಕೆ ಅದರ ಸಮಂಜಸವಾದ ವಿವೇಚನೆಯಿಂದ ಮಾರ್ಪಡಿಸಬಹುದು. , ಪಾಲುದಾರನು ಈ ಒಪ್ಪಂದವನ್ನು ಕಾರಣಕ್ಕಾಗಿ ಕೊನೆಗೊಳಿಸಬಹುದು. ಈ ಒಪ್ಪಂದದ ಬದಲಾವಣೆಗಳ ಬಗ್ಗೆ ನೋಟಿಸ್ ಸ್ವೀಕರಿಸಿದ ನಂತರ ಪಾಲುದಾರನು ಕಾರ್ಯಕ್ರಮದಲ್ಲಿ ನಿರಂತರವಾಗಿ ಭಾಗವಹಿಸುವುದರಿಂದ ಈ ಒಪ್ಪಂದವನ್ನು ತಿದ್ದುಪಡಿ ಮಾಡಿದಂತೆ ಒಪ್ಪಿಕೊಳ್ಳಬಹುದು. ",
        "qualified_ref" : "ಅರ್ಹ ಉಲ್ಲೇಖಗಳು",
        "mean_referrals": "ಸರಾಸರಿ ಉಲ್ಲೇಖಗಳು",
        "apply" : "ಅನ್ವಯಿಸು",
        "company_code_validate": "ಮೌಲ್ಯೀಕರಿಸಲು ದಯವಿಟ್ಟು ಕಂಪನಿ ಕೋಡ್ ಅನ್ನು ನಮೂದಿಸಿ",
        "golive_company_code": "ಗೋಲಿವ್ ಕಂಪನಿ ಕೋಡ್",
        "accept_TC" : "ಮೇಲಿನ ನಿಯಮಗಳು ಮತ್ತು ಷರತ್ತುಗಳನ್ನು ನಾನು ಒಪ್ಪುತ್ತೇನೆ",
        "by_sub_referral": "ರೆಫರಲ್ ಪಾಲುದಾರ ಅರ್ಜಿಯನ್ನು ಸಲ್ಲಿಸುವ ಮೂಲಕ, ಪಾಲುದಾರನು ಈ ಒಪ್ಪಂದವನ್ನು ಓದಿದ್ದಾನೆ, ಅರ್ಥಮಾಡಿಕೊಂಡಿದ್ದಾನೆ ಮತ್ತು ಸ್ವೀಕರಿಸುತ್ತಾನೆ ಎಂದು ಪ್ರತಿನಿಧಿಸುತ್ತಾನೆ ಮತ್ತು ಖಾತರಿಪಡಿಸುತ್ತಾನೆ.",
        "term" :"ನಿಯಮಗಳು",
        "found_at": "ನಲ್ಲಿ ಕಂಡುಬಂದಿದೆ",
        "our_privacy_policy" :"ಮತ್ತು ನಮ್ಮ ಗೌಪ್ಯತೆ ನೀತಿ",
        "privacy_policy" :"ಗೌಪ್ಯತೆ ನೀತಿ",
        "as_applicable": "ಅನ್ವಯವಾಗುವಂತೆ.",
        "screen-sharing" : "ಪರದೆ ಹಂಚಿಕೆ",
        "whiteboard_access" : "ವೈಟ್‌ಬೋರ್ಡ್ ಪ್ರವೇಶ",
        "Document_access" : "ಡಾಕ್ಯುಮೆಂಟ್ ಪ್ರವೇಶ",
        "share_the_screen" : "ಪರದೆಯನ್ನು ಹಂಚಿಕೊಳ್ಳಿ!",
        "to_collaborate" : "ಸಹಯೋಗಿಸಲು!",
        "share_document" : "ಡಾಕ್ಯುಮೆಂಟ್ ಹಂಚಿಕೊಳ್ಳಿ!",

        "exit_or_end" : "Exit or End Meeting?",
        "exit_from_meeting" : "Exit from Meeting?",
        "are_sure_exit_meeting_everyone" : "Are you sure you want to exit from the meeting? You can either end the meeting for everyone or you can exit from the meeting.",
        "are_sure_exit_meeting" : "Are you sure you want to exit from the meeting?",
        "exit_meeting" : "Exit Meeting",
        "end_for_all" : "End Meeting for all",
        "end_meeting" : "End Meeting",
        "will_let_alone_exit" : "will let you alone exit or leave from the meeting.",
        "will_end_for_everyone" : "will end the meeting for everyone in the conference (All participants & attendees).",
        "user_already_exists" : "Users Already Exists",
        "already_user_avail" : "There are already some users available in the conference. ",
        "if_like_continue" : "If you would like to continue click on ",
        "force_start_meetinh" : "Force Start Another Meeting ",
        "otherwise_click" : "otherwise click on ",
        "to_go_back" : "to go back. ",

        //New by Keerthi - 17th Sep 2020
        "lang_settings" : "Language Settings",
        "lang_info" : "Choose your preferred language to use the application.",
        "select_language" : "Select Language",
        "settings_languages" : "Languages",

        "rec_plugin" : "Recording Plugin",
        "rec_heading1" : "How to install and manage InstaVC Screen-Video Recorder with the plugin",
        "rec_step1" : "Step 1: Copy & open Link in Chrome",
        "rec_step1_para" : "First copy the link ",
        "rec_step1_para_br" : "from here and open it in chrome to add the plugin to your browser. Click on ",
        "rec_step1_para_bold" : "Add to Chrome",
        "rec_step1_para_ct" : "to add this extension.",

        "rec_step2" : "Step 2: Pop Up for Permission",
        "rec_step2_para_br" : "When you click on Add to chrome, here appears a popup asking for permission to display notification access your content. Click on ",
        "rec_step2_para_bold" : "Add Extension",
        "rec_step2_para_ct" : "to proceed.",

        "rec_step3" : "Step 3: Extension Added to Chrome",
        "rec_step3_para" : "When the extension is added to chrome, it shows a window giving you an information with a plugin icon and how to manage this plugin from here.",

        "rec_step4" : "Step 4: Pin the plugin on the toolbar",
        "rec_step4_para_br" : "To pin the plugin to your toolbar, you need to click on manage extensions, go to ",
        "rec_step4_para_bold" : "InstaVC Screen-Recording",
        "rec_step4_para_ct" : "and click on the pin icon to add.",

        "rec_step5" : "Step 5: Extension/Plugin Pinned to Toolbar",
        "rec_step5_para" : "Once the extension is pinned, you can now see an instavc recording icon in your browser toolbar and start using it for easy access." ,

        "rec_step6" : "Step 6: InstVC Recorder Setup",
        "rec_step6_para_br" : "Once you have installed the plugin and the next time when you open it, you can now see the ",
        "rec_step6_para_bold" : "InstaVC Recorder Setup",
        "rec_step6_para_ct" : "page to enable or disable the recording tools. By default both the options will be enabled. Click on ",
        "rec_step6_para_bold1" : "Next",
        "rec_step6_para_ct1" : "to continue.",

        "rec_step7" : "Step 7: Additional Permissions",
        "rec_step7_para_br" : "Once the Next button is clicked, system will then show you a popup asking for additional permissions to read and change your data. Click ",
        "rec_step7_para_bold" : "Allow",
        "rec_step7_para_ct" : "to continue.",

        "rec_step8" : "Step 8: Permissions Allowed",
        "rec_step8_para" : "After allowing the permission, this page now gets frozen or in a disabled mode from where you can now start exploring recording options now.",

        "rec_heading2" : "Desktop Screen-Recording Plugin",

        "rec_step9" : "Step 9: Desktop Screen-Recording",
        "rec_step9_para_br" : "After allowing all permissions, you can now access recording menus from the plugin extension in your toolbar. Click on it to see further options. Here we have selected ",
        "rec_step9_para_bold" : "Desktop Screen Recording",
        "rec_step9_para_ct" : "and click on the",
        "rec_step9_para_bold1" : "Record",
        "rec_step9_para_ct1" : "button to start.",

        "rec_step9a" : "Step 9(a): Share your Screen Popup",
        "rec_step9a_para_br" : "Now the system shows up this popup asking to select the contents of your screen, whether its an Entire Screen or only application window. Click on the tab which you want to share and click on ",
        "rec_step9a_para_bold" : "Share",
        "rec_step9a_para_ct" : "button and go to that screen which you want to start recording.",

        "rec_step9b" : "Step 9(b): Desktop Screen Recording Started",
        "rec_step9b_para_br" : "The Desktop Screen recording is now started and you can see a blink in the toolbar while its in recording mode. Also, you can see a tab at the bottom showing buttons for ",
        "rec_step9b_para_bold" : "Stop Sharing",
        "rec_step9b_para_ct" : "or",
        "rec_step9b_para_bold1" : "Hide",
        "rec_step9b_para_ct1" : ". You can see the bottom message on any screen you are opening until you are in the desktop screen recording mode.",

        "rec_step9c" : "Step 9(c): Restart / Pause or Stop Desktop Screen Recording",
        "rec_step9c_para_br" : "Once you want to stop Recording. Click on the plugin in the toolbar and here you can see the options to ",
        "rec_step9c_para_bold" : "Restart, Pause",
        "rec_step9c_para_ct" : "and",
        "rec_step9c_para_bold1" : "Stop",
        "rec_step9c_para_ct1" : "buttons. You can click any of those accordingly.",

        "rec_step9d" : "Step 9(d):Recent Recording View",
        "rec_step9d_para_br" : "Once you stop the recording from the toolbar, the recent recording will now automatically open the recording in a new tab along with Title and ",
        "rec_step9d_para_bold" : "Download",
        "rec_step9d_para_ct" : "option in the top and the recording details in the right column.",
        
        "rec_heading3" : "Browser Tab Screen-Recording Plugin",

        "rec_step10" : "Step 10: Browser Tab Screen-Recording",
        "rec_step10_para_br" : "When we want to select ",
        "rec_step10_para_bold" : "Browser Tab",
        "rec_step10_para_ct" : "option for recording your browser screen. First open your screen(url) in chrome whichever you want to record and then open the plugin and click on Browser Tab, adjust microphone options and then click",
        "rec_step10_para_bold1" : "Record",
        "rec_step10_para_ct1" : "button to start recording.",

        "rec_step10a" : "Step 10(a): Browser Tab is being Recorded",
        "rec_step10a_para" : "Once the Browser tab is started recording, you can see a red dot blinking in your toolbar which indicates the tab is being recorded and also a blue box blinking in your browser title bar",
        
        "rec_step10b" : "Step 10(b): Record another tab",
        "rec_step10b_para_br" : "At the time of current screen recording, if you open another url and open the plugin, it will show you the recording status along with an option",
        "rec_step10b_para_bold" : "Record This Tab",
        "rec_step10b_para_ct" : "if you want to change the recording scree to the new url. Meanwhile the blue box blinking in the title bar of the browser indicates the tab that is being recorded at the moment.",

        "rec_step10c" : "Step 10(C): Stop and View recording",
        "rec_step10c_para_br" : "Later, when you stop the recording, the browser itself opens the recording in a new tab along with Title and",
        "rec_step10c_para_bold" : "Download",
        "rec_step10c_para_ct" : "Option at the top and the recording details in the right column.",

        "rec_heading4" : "Webcam Recording",

        "rec_step11" : "Step 11: Start Webcam Screen Recording",
        "rec_step11_para_br" : "When you start with Webcam screen recording, make sure to select the microphone & camera settings among the devices detected by the plugin. and then click on the",
        "rec_step11_para_bold" : "Record",
        "rec_step11_para_ct" : "button to start with.",

        "rec_step11a" : "Step 11(a): Webcam opens Self Video and starts Recording",
        "rec_step11a_para_br" : "The recording opens a web page with yourself video with",
        "rec_step11a_para_bold" : "Pause",
        "rec_step11a_para_ct" : "and",
        "rec_step11a_para_bold1" : "Stop",
        "rec_step11a_para_ct1" : "recording options at the bottom.",

        "rec_step11b" : "Step 11(b): View Webcam Recorded Video",
        "rec_step11b_para" : "When you stop the recording in the previous screen, the browser then opens the recording in a new tab to view and download along with the recording details.",
        
        "rec_heading5" : "Top Menus in Recording Plugin",

        "rec_step12" : "Step 12: Navigation Menus",
        "rec_step12_para_br" : "The plugin has few navigation menus to fetch your data as well as manage different actions related to the plugin. One of them is a",
        "rec_step12_para_bold" : "Hamburger Menu",
        "rec_step12_para_ct" : "Click on it to open.",

        "rec_step12a" : "Step 12(a): Open Hamburger Menu",
        "rec_step12a_para_br" : "On click of",
        "rec_step12a_para_bold" : "Hamburger Menu",
        "rec_step12a_para_ct" : ", you can find 2 tabs named",
        "rec_step12a_para_bold1" : "My Recordings",
        "rec_step12a_para_ct1" : "and",
        "rec_step12a_para_bold2" : "Options",
        "rec_step12a_para_ct2" : "which manages all the data you have been recording and options you have enabled or disabled for that plugin. Click on",
        "rec_step12a_para_bold3" : "My Recordings",
        "rec_step12a_para_ct3" : "to see the videos you have recorded till date.",

        "rec_step12b" : "Step 12(b): Access My Recordings",
        "rec_step12b_para_br" : "There is another way of accessing",
        "rec_step12b_para_bold" : "My Recordings",
        "rec_step12b_para_ct" : ", page from the top menu in the plugin which can be considered as a shortcut to navigate.",
        
        "rec_step12c" : "Step 12(c): My Recordings",
        "rec_step12c_para" : "Here will be the detailed list of videos(recordings) you have recorded till date. Each video contains the date, duration, size of the video along with delete icon in the thumbnail view. When you click on any video it opens the details in the view recording page. Note that all the videos will be stored locally here.",

        "rec_step12d" : "Step 12(d): Delete All recordings",
        "rec_step12d_para_br" : "Looking at My recordings Page, there is a more icon in the top right corner which opens the",
        "rec_step12d_para_bold" : "Delete All",
        "rec_step12d_para_ct" : "option to easily delete all recordings with a single click.",
        
        "rec_step12e" : "Step 12(e): Side Navigation",
        "rec_step12e_para_br" : "Instead of opening the plugin again and change, You can directly navigate to another tab from here using the Hamburger Menu in the top left corner of the page that opens the navigation to navigate to the",
        "rec_step12e_para_bold" : "Options",
        "rec_step12e_para_ct" : "page",

        "rec_heading6" : "Plugin Options",

        "rec_step13" : "Step 13: Plugin Options",
        "rec_step13_para_br" : "On click on Hamburger Menu, you can find another tab named Options which manages all the options you have enabled or disabled for that plugin. Click on",
        "rec_step13_para_bold" : "Options",
        "rec_step13_para_ct" : "to see the options that are enabled for you.",

        "rec_step13a" : "Step 13(a): Recorder Options",
        "rec_step13a_para" : "Recorder Options ask you for various options like video storage, Notifications, Keyboard Shortcuts",

        "rec_step13b" : "Step 13(b): Recorder Options",
        "rec_step13b_para" : "Recorder Options contain various other options like Recording Settings and advanced.",

        "rec_heading7" : "Plugin Notifications",

        "rec_step14" : "Step 14: Plugin Notifications",
        "rec_step14_para" : "On the top navigation part, you can find a bell icon for notifications if any related to instavc screen recording plugin.",

        "rec_step14a" : "Step 14(a): Open Notifications",
        "rec_step14a_para" : "On click on the notification icon, you can find the list of notifications if any or it shows an empty slide in.",

        "rec_heading8" : "Recording Settings",

        "rec_step15" : "Step 15: Settings",
        "rec_step15_para_br" : "Then comes the last navigation menu on the top right corner named",
        "rec_step15_para_bold" : "Settings",
        "rec_step15_para_ct" : "where you can open and manage the recording settings accordingly.",

        "rec_step15a" : "Step 15(a): Advanced Settings Options",
        "rec_step15a_para" : "Here you can adjust the settings based on the Resize tab, Limit resolution and maximum frame rate which are given by plugin.",

        "crteContent_upload_medialist" : "Uploaded Media List",
        "content_upld_desc_txt" : "The files you upload here will be available to users who view content.",
        "content_browse_txt" : "Browse Files to Upload",
        "content_upld_types" : "Files with only .jpg, .jpeg, .png, and .pdf are allowed limiting the max size upto 15MB",

        "video_qlty": "ವೀಡಿಯೊ ಗುಣಮಟ್ಟ",
        "audio_qlty": "ಆಡಿಯೋ ಗುಣಮಟ್ಟ",
        "cntnt_shrng": "ವಿಷಯ ಹಂಚಿಕೆ",
        "fdb_poor": "ಕಳಪೆ",
        "fdb_good": "ಒಳ್ಳೆಯದು",
        "fdb_avg": "ಸರಾಸರಿ",
        "fdb_excellent": "ಅತ್ಯುತ್ತಮ",
        "share_feedback": "ನಿಮ್ಮ ಫೀಡ್‌ಬ್ಯಾಕ್ ಹಂಚಿಕೊಳ್ಳಿ",
        "ovrl_rating": "ಒಟ್ಟಾರೆ ಅರ್ಹತೆ",
        "fdb_cmnts": "ನಿಮ್ಮ ಪ್ರತಿಕ್ರಿಯೆಗಳು ಹೆಚ್ಚು ಮೆಚ್ಚುಗೆ ಪಡೆದಿವೆ",
        "no_thnks": "ಬೇಡ ಧನ್ಯವಾದಗಳು",
        "upload_size_max_15mb": "ನೀವು ಅಪ್‌ಲೋಡ್ ಮಾಡಬಹುದು ಗರಿಷ್ಠ ಗಾತ್ರದ ಮಿತಿ 15MB",

        "pastMeeting_feedback" : "ಪ್ರತಿಕ್ರಿಯೆ",
        "pastMeeting_comments" : "ಪ್ರತಿಕ್ರಿಯೆಗಳು",
        
        "microsoft_webplugin" : "ಮೈಕ್ರೋಸಾಫ್ಟ್ lo ಟ್ಲುಕ್ ವೆಬ್ ಪ್ಲಗಿನ್",
        "microsoft_installable" : "ಮೈಕ್ರೋಸಾಫ್ಟ್ lo ಟ್‌ಲುಕ್ ಸ್ಥಾಪಿಸಬಹುದಾದ ಪ್ಲಗಿನ್",
        "outlook_installable": "Lo ಟ್‌ಲುಕ್ ಸ್ಥಾಪಿಸಬಹುದಾಗಿದೆ",
        "customization_installer": "ಗ್ರಾಹಕೀಕರಣ ಸ್ಥಾಪಕವನ್ನು ಹೇಗೆ ಪ್ರವೇಶಿಸುವುದು",
        "plugin_step1" : "ಹಂತ 1: ಫೈಲ್ ಡೌನ್‌ಲೋಡ್ ಮಾಡಲು ಲಿಂಕ್ ಕ್ಲಿಕ್ ಮಾಡಿ",
        "click_link_download": "ಫೈಲ್ ಡೌನ್‌ಲೋಡ್ ಮಾಡಲು ಲಿಂಕ್ ಕ್ಲಿಕ್ ಮಾಡಿ",
        "first_click_link": "ಮೊದಲು ಕೆಳಗಿನ ಲಿಂಕ್ ಅನ್ನು ಕ್ಲಿಕ್ ಮಾಡಿ",
        "to_download_file": "ನಿಮ್ಮ ಸಿಸ್ಟಮ್‌ಗೆ ಫೈಲ್ ಡೌನ್‌ಲೋಡ್ ಮಾಡಲು. ನಂತರ ಅನುಸ್ಥಾಪನೆಯನ್ನು ಪ್ರಾರಂಭಿಸಲು ಡೌನ್‌ಲೋಡ್ ಮಾಡಿದ ಫೈಲ್ ಅನ್ನು ತೆರೆಯಿರಿ ಮತ್ತು ಕ್ಲಿಕ್ ಮಾಡಿ",
        "install_txt": "ಸ್ಥಾಪಿಸಿ",
        "plugin_step2" : "ಹಂತ 2: ಗ್ರಾಹಕೀಕರಣವನ್ನು ಸ್ಥಾಪಿಸಲಾಗಿದೆ",
        "plugin_step2_para":"Once you start installing, wait untill the file gets installed and you get a popup showing successfully Installed and then close.",
        "plugin_step3" : "ಹಂತ 3: Out ಟ್‌ಲುಕ್ ತೆರೆಯಿರಿ ಮತ್ತು ಸಭೆಗಳಿಗೆ ಹೋಗಿ",
        "plugin_step3_para" : "ಸ್ಥಾಪನೆಯ ನಂತರ, ಮೈಕ್ರೋಸಾಫ್ಟ್ lo ಟ್‌ಲುಕ್ ತೆರೆಯಿರಿ ಮತ್ತು ಸಭೆಗಳಿಗೆ ಹೋಗಿ.",
        "plugin_step3_para1" : "ಹೊಸ ಇಮೇಲ್> ಸಭೆಗಳಿಗೆ ಹೋಗಿ",
        "plugin_step4" : "ಹಂತ 4: ಮುಕ್ತ ಸಭೆಗಳು",
        "plugin_step4_para" : "ಒಮ್ಮೆ ಸಭೆಗಳ ವಿಂಡೋ ಮೇಲಿನ ಟ್ಯಾಬ್‌ಗಳ ಪಟ್ಟಿಯಲ್ಲಿ ಮುಕ್ತ ಚಲನೆ ಪಡೆದರೆ ಮತ್ತು ನೀವು ಟ್ಯಾಬ್ ಕ್ಲಿಕ್ ಮಾಡುವುದನ್ನು ಮುಂದುವರಿಸಬಹುದು",
        "plugin_step4_para1": "ಪೀಪಲ್‌ಲಿಂಕ್",
        "plugin_step5": "ಹಂತ 5: ವೇಳಾಪಟ್ಟಿ ಸಮಾವೇಶ",
        "plugin_step5_para": "ಪೀಪಲ್‌ಲಿಂಕ್ ಅಡಿಯಲ್ಲಿ ನೀವು ಹೆಸರಿನ ಉಪ ಟ್ಯಾಬ್ ಅನ್ನು ಹೊಂದಿದ್ದೀರಿ",
        "plugin_step5_para1": "ವೇಳಾಪಟ್ಟಿ ಸಮಾವೇಶ.",
        "plugin_step5_para2": "ಅದರ ಮೇಲೆ ಕ್ಲಿಕ್ ಮಾಡಿ ಮತ್ತು ವಿಂಡೋದ ಬಲಭಾಗದಲ್ಲಿ ವೇಳಾಪಟ್ಟಿ ಆಯ್ಕೆಗಳನ್ನು ನೀವು ನೋಡಬಹುದು. ಇಲ್ಲಿ ನೀವು ಇನ್ ವಿಸಿ ವೇಳಾಪಟ್ಟಿಗಳನ್ನು ನಿರ್ವಹಿಸಬಹುದು.",
        "plugin_step6": "ಹಂತ 6: ವೇಳಾಪಟ್ಟಿಗಳನ್ನು ನಿರ್ವಹಿಸಿ ಅಥವಾ ಕಸ್ಟಮೈಸ್ ಮಾಡಿ",
        "plugin_step6_para": "ಇಲ್ಲಿ ನೀವು ಕೊಠಡಿಗಳು, ಸಮಯಗಳ ಪಟ್ಟಿಯಿಂದ ವೇಳಾಪಟ್ಟಿಗಳನ್ನು ನಿರ್ವಹಿಸಬಹುದು ಅಥವಾ ಕಸ್ಟಮೈಸ್ ಮಾಡಬಹುದು ಮತ್ತು ಇಲ್ಲಿಂದ ಹೊಸ ವೇಳಾಪಟ್ಟಿಯನ್ನು ರಚಿಸಬಹುದು ಅದು ನಿಮ್ಮನ್ನು ಬ್ರೌಸರ್‌ಗೆ ಮರುನಿರ್ದೇಶಿಸುತ್ತದೆ ಮತ್ತು ದೃಷ್ಟಿಕೋನಕ್ಕೆ ಮರಳುತ್ತದೆ.",
        "plugin_step6_para1": "ವೇಳಾಪಟ್ಟಿಯೊಂದಿಗೆ ನೀವು ಸರಿಹೊಂದಿದ ನಂತರ ನೀವು ಕ್ಲಿಕ್ ಮಾಡಬಹುದು",
        "plugin_step6_para2": "ಲಿಂಕ್ ಪಡೆಯಿರಿ",
        "plugin_step7": "ಲಿಂಕ್ ರಚಿಸಲಾಗಿದೆ",
        "plugin_step7_para": "ನಂತರ ಇಲ್ಲಿ ಆನ್‌ಲೈನ್‌ನಲ್ಲಿ ಹಂಚಿಕೊಳ್ಳಲು ಅಥವಾ ಮುಂದೆ ಮುಂದುವರಿಯಲು ನೀವು ಬಳಸಬಹುದಾದ ಮೇಲ್‌ನಲ್ಲಿ ರಚಿಸಲಾದ ಮತ್ತು ಸಂಯೋಜಿಸಿದ ಲಿಂಕ್ ಅನ್ನು ಪಡೆಯುತ್ತದೆ.",
    }
}